/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 648);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(45);


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_store__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_get_query_variable_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_is_touch_device_js__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__audio_audio_localstorage_operations__ = __webpack_require__(130);
function getInitialGameArea(){//Straight to Online play if specified in URL
if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_get_query_variable_js__["a" /* getQueryVariable */])("online")){return"arena";}//Straight to a quick battle
if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_get_query_variable_js__["a" /* getQueryVariable */])("quick")){return"arena";}//Default to Home
return"b5-home-screen";//"battle", "b5-offline-battle-over", "b5-online-battle-over, "b5-records-screen"
}function getCreateRoomType(){if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_get_query_variable_js__["a" /* getQueryVariable */])("open")){return"open";}return"fullteam";//default.
}var store=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__create_store__["a" /* default */])({global:{audioMode:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__audio_audio_localstorage_operations__["a" /* getAudioPreferenceFromLocalstorage */])(),//"full" | "off" //TODO: I recently removed "sfx", but functionality is still there.
//Viewport stuff
vW:0,viewportWidth:0,viewportHeight:0,//viewportMode: Desktop/Mobile layout. Automatically set by GameFrame.js
viewportMode:"portrait",//"portrait" or "landscape"
//TouchMode: NOT FOR desktop/mobile layout! Only knowing if this device requires touch to play.
isTouchMode:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_is_touch_device_js__["a" /* default */])(),//This will eventually include Pause, Overworld, etc in the full game
gameArea:getInitialGameArea(),isHomeEmailModalOpen:false},battle:{battlePlayerId:null,//[] //ARRAY - combatants that are controlled by the player
//populated by firebase anon auth
isMultiplayerMode:Boolean(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_get_query_variable_js__["a" /* getQueryVariable */])("online")),// false, //true, //false
//launch reporting mode if URL has it
battleViewMode:Boolean(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_get_query_variable_js__["a" /* getQueryVariable */])("reporting"))?"reporting":"arena",//"arena", //"console", "arena", "reporting"
isMultiplayerMasterClient:false,//starts as false for everybody
//hasBattleStarted from server
hasBattleStarted:false,// starts false until all players are connected and ready.
//"battleState" values from server
combatantSelectingAction:"",//must be a string of a combatant ID
seriesTurnOrder:[// "a", "c", "b". //Master will set this and send out to all clients.
],//Reset on end of every series? Ordered by speed. Yep. this is what Mario RPG does.
seriesTurnsSubmitters:[],//Always is a copy of seriesTurnOrder, but items get deleted as user goes.
combatants:{},teams:{},//"rollout"
//Rollout. Communicate what it is and if we've seen it.
hasRolloutBeenSeen:true,rolloutId:"initial",rolloutData:[],rolloutExecutingIndex:0,//Set and changed by `handle-new-rollout` and `handle-rollout-step`
lastSeenTextMessage:{content:[],key:"initial"},rolloutHistory:[],//Report of everything that has happened (for Reporting and debugging)
//Cloud Queue
cloudQueue:[],//Arena specific stateful pieces
arenaSubmissionMenuAction:null,// {}
//arenaSubmissionMenuCaster: null, // {} //can be computed
arenaSubmissionMenuTargets:null,//[ {} ]
arenaSubmissionIsSubmitted:false,arenaSubmissionMenuCombatantIdLock:null,//keeps track of receiving and passing off the Submission Menu
arenaAnimationComponent:null,arenaBackgroundStyle:"rgba(0,0,0,0)",arenaMenuSnapshot:{},arenaTransitionOverlay:null,//{transition: "fadeIn" | "fadeOut", callback: function }
//arenaTaunt: null, //populated by Firebase
// arenaTaunt: "Taunter: YOU SUCK!",
serverRoomConnections:{},//Reporting Data
hpRatingsOfTeamsPerTurnSeries:[],//array of arrays [teamOneHp, teamTwoHp]
turnReporting:{},//built by turn-reporting.js
//Optional settings "ff = Feature Flag"
ff_IsTeamItemsOn:true,ff_IsRejoiningOn:true//Allowing People to rejoin battles after leaving
},matchmaking:{initialCombatantData:{},//Lobby dataset
crewNames:{},readyClients:{},isLobbyInviteModalOpen:false,isCrewNameModalOption:false,userDataState:"Loading",// "Loading", "Success"
currentRoomId:null,currentRoomType:null,//set by joining room
redirectToRoom:null,isDuplicateEntryScreen:false,//Blocks users from connecting to the same room twice
createRoomType:getCreateRoomType(),//"fullteam" or "open"
errorMessage:{status:"None",message:""},matchResult:"win",// "unknown" | "win" | "lose"
//Editing a combatant with the modal.
// editingCombatantProperties: {
//   isActivated: true,
//   editingId: "",
//   combatantName: "Jerry",
//   combatantSkin: "skin_f1",
//   combatantLoadoutId: "dpsA",
// }
//default:
editingCombatantProperties:{isActivated:false}},crew:{name:"Default Crew Name",//populated by b5LoadCrew
record:{//populated by b5LoadCrew
},members:{//populated by b5LoadCrew
},logggedInUserId:null//assume not logged in. b5LoadCrew will set this this (also need to set any other time you are logging in)
}});/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setBattleValue;
/* harmony export (immutable) */ __webpack_exports__["c"] = setCombatantValue;
/* harmony export (immutable) */ __webpack_exports__["b"] = setMatchmakingValue;
/* harmony export (immutable) */ __webpack_exports__["d"] = setMatchmakingError;
/* harmony export (immutable) */ __webpack_exports__["e"] = setCrewValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store__ = __webpack_require__(1);
function setBattleValue(){var changes=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};__WEBPACK_IMPORTED_MODULE_0__init_store__["a" /* default */].dispatch({type:"SET_BATTLE_VALUE",payload:{changes:Object.assign({},changes)}});}function setCombatantValue(key){var changes=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};__WEBPACK_IMPORTED_MODULE_0__init_store__["a" /* default */].dispatch({type:"SET_BATTLE_COMBATANT_VALUE",payload:{key:key,changes:Object.assign({},changes)}});}//Matchmaking
function setMatchmakingValue(){var changes=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};__WEBPACK_IMPORTED_MODULE_0__init_store__["a" /* default */].dispatch({type:"SET_MATCHMAKING_VALUE",payload:{changes:Object.assign({},changes)}});}function setMatchmakingError(payload){setMatchmakingValue({errorMessage:payload});}//Crew
function setCrewValue(){var changes=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};__WEBPACK_IMPORTED_MODULE_0__init_store__["a" /* default */].dispatch({type:"SET_CREW_VALUE",payload:{changes:Object.assign({},changes)}});}

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(602);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(22);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  (function () {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  })();
}

module.exports = warning;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var DOMProperty = __webpack_require__(43);
var ReactDOMComponentFlags = __webpack_require__(186);

var invariant = __webpack_require__(4);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_howler__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_howler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_howler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__music__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sfx__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__init_store_js__ = __webpack_require__(1);
var sfxHowls={};Object.keys(__WEBPACK_IMPORTED_MODULE_2__sfx__["a" /* default */]).forEach(function(key){sfxHowls[key]=new __WEBPACK_IMPORTED_MODULE_0_howler__["Howl"](__WEBPACK_IMPORTED_MODULE_2__sfx__["a" /* default */][key]);});/* harmony default export */ __webpack_exports__["a"] = ({//SFX
currentSong:null,isFirstSongTrigger:false,//default to false
currentSongKey:"",playSong:function playSong(songKey){//If this song is already playing, bail out so it doesnt start over!
if(this.currentSongKey===songKey){return;}//Stop any old song that is playing
if(this.currentSong){this.currentSong.stop();this.currentSong=null;//delete it!
}//Play the new one!
this.currentSongKey=songKey;this.currentSong=new __WEBPACK_IMPORTED_MODULE_0_howler__["Howl"](__WEBPACK_IMPORTED_MODULE_1__music__["a" /* default */][songKey]);//We might be muted, so maybe shut off the volume. (we still want the song to play in the background)
if(__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().global.audioMode!=="full"){this.currentSong.volume(0);}//Play the song!
this.currentSong.play();},stopSong:function stopSong(){if(this.currentSong){this.currentSong.stop();}},changeSongVolume:function changeSongVolume(status){if(this.currentSong){if(status==="off"){this.currentSong.volume(0);}if(status==="on"){//NOTE: need to remember old song's initial volume!
this.currentSong.volume(__WEBPACK_IMPORTED_MODULE_1__music__["a" /* default */][this.currentSongKey].volume||1);}}},sfxHowls:sfxHowls,//SFX bank
playSfx:function playSfx(sfxKey){//Play if mode is set to `sfx` or `full`
if(__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().global.audioMode!=="off"){sfxHowls[sfxKey].play();}}});

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = randomFromArray;
function randomFromArray(array){return array[Math.floor(Math.random()*array.length)];}/* unused harmony default export */ var _unused_webpack_default_export = (randomFromArray);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(645);


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(129);
var isBuffer = __webpack_require__(423);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_ActionModel_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__supers__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__specials__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__items__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__naturals__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_rollout_message_text_helpers_js__ = __webpack_require__(27);
//TODO: Break this out into different files. Just getting it wired up for now.
/* harmony default export */ __webpack_exports__["a"] = (Object.assign({"attack_generic-attack":Object.assign({},__WEBPACK_IMPORTED_MODULE_0__models_ActionModel_js__["a" /* default */],{name:"Attack",description:"Standard thwack with a chance for bonus damage",category:"offense",affectTargetHpPoints:-1,ppCost:0,increaseDangerMeterOnUse:26,//bump for regular Attack on raising Danger Meter
hasTimedHitBonusAvailable:true,getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];return[// getUseLine(casterModel.name, actionModel.name, ""),
{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),' attacks ',__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),'!']},{type:"animation",animationKey:"AnimationAttack",animationData:{casterId:casterModel.id,targetIds:targetModels.map(function(t){return t.id;})}}];},getMissStep:function getMissStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),' attacks ',__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),'!']},{type:"message",content:['...but it missed!']}];}})},__WEBPACK_IMPORTED_MODULE_1__supers__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2__specials__["a" /* default */],__WEBPACK_IMPORTED_MODULE_3__items__["a" /* default */],__WEBPACK_IMPORTED_MODULE_4__naturals__["a" /* default */]));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(9);

var CallbackQueue = __webpack_require__(184);
var PooledClass = __webpack_require__(35);
var ReactFeatureFlags = __webpack_require__(189);
var ReactReconciler = __webpack_require__(44);
var Transaction = __webpack_require__(78);

var invariant = __webpack_require__(4);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCombatantIdFromSelectingString;
/** Take in selectingString and return a raw combatantID (like, checking for Deadline) */function getCombatantIdFromSelectingString(selectingString){//Extract ID out of a `deadline::` string
if(selectingString.match(/^deadline::/)){return selectingString.replace("deadline::","");}if(selectingString.match(/^cloudQueueAction::/)){var dataFromString=selectingString.split("::");//see `cloud-queue-decode` for reference
return dataFromString[2];//casterId segment
}return selectingString;}

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = modelsFromObject;
function modelsFromObject(){var structure=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return Object.keys(structure).map(function(id){return Object.assign({_id:id},structure[id]);});}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(171);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(9);

var PooledClass = __webpack_require__(35);

var emptyFunction = __webpack_require__(22);
var warning = __webpack_require__(6);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {

  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
    } else if (typeof event.returnValue !== 'unknown') {
      // eslint-disable-line valid-typeof
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
    } else if (typeof event.cancelBubble !== 'unknown') {
      // eslint-disable-line valid-typeof
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }

});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {

  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null

};

module.exports = ReactCurrentOwner;

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sampleLoadouts; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getLoadout;
/* harmony export (immutable) */ __webpack_exports__["a"] = getRandomLoadout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__ = __webpack_require__(34);
var skinAndNameCombos=[{skinId:"skin_f1",name:"Mary"},{skinId:"skin_f1",name:"Georgia"},{skinId:"skin_f1",name:"Heather"},{skinId:"skin_f1",name:"Lynn"},{skinId:"skin_f1",name:"Sarah"},{skinId:"skin_f2",name:"Betty Sue"},{skinId:"skin_f2",name:"Samantha"},{skinId:"skin_f2",name:"Barb"},{skinId:"skin_f2",name:"Susanna"},{skinId:"skin_f2",name:"Natalia"},{skinId:"skin_f3",name:"Rebecca"},{skinId:"skin_f3",name:"Ronna"},{skinId:"skin_f3",name:"Sabella"},{skinId:"skin_f3",name:"Daniella"},{skinId:"skin_f3",name:"Evette"},{skinId:"skin_m1",name:"Oliver"},{skinId:"skin_m1",name:"Sid"},{skinId:"skin_m1",name:"Jed"},{skinId:"skin_m1",name:"Tommy"},{skinId:"skin_m1",name:"Sebastian"},{skinId:"skin_m2",name:"Jerry"},{skinId:"skin_m2",name:"Alex"},{skinId:"skin_m2",name:"Sai"},{skinId:"skin_m2",name:"Reyansh"},{skinId:"skin_m2",name:"Parth"},{skinId:"skin_m3",name:"Harold"},{skinId:"skin_m3",name:"Biff"},{skinId:"skin_m3",name:"Don"},{skinId:"skin_m3",name:"Jeremiah"},{skinId:"skin_m3",name:"Barry"},{skinId:"skin_m4",name:"Bengi"},{skinId:"skin_m4",name:"Daniel"},{skinId:"skin_m4",name:"Nick"},{skinId:"skin_m4",name:"Frank"},{skinId:"skin_m4",name:"Dominic"},{skinId:"skin_bonus1",name:"Sunny"},{skinId:"skin_bonus1",name:"Big D"},{skinId:"skin_bonus2",name:"Nicky"},{skinId:"skin_bonus2",name:"Joey"}];var sampleLoadouts=[{name:"DPS A",loadoutId:"dpsA",loadoutTitle:"Hackalete",class:"dps",level:5,attacks:[{actionId:"special_promise"},{actionId:"special_foreach"},{actionId:"special_curl"},{actionId:"special_headphones"},{actionId:"special_team-slice"//super
}],items:[{actionId:"item_danger-boost",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false},{actionId:"item_honeypot-trap",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false}],computerAiPersonality:{default:{regular:2,vicious:5,recovering:2,cursing:0,cleaning:0,boosting:1,thief:1}}},{name:"DPS B",loadoutId:"dpsB",loadoutTitle:"Artisian",class:"dps",level:5,attacks:[{actionId:"special_slice"},{actionId:"special_screen-crack"},{actionId:"special_troll"},{actionId:"special_clean"},{actionId:"special_team-foreach"//super
}],items:[{actionId:"item_attack-sticker-i",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false},{actionId:"item_breakpoint",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false}],computerAiPersonality:{default:{regular:2,vicious:5,recovering:2,cursing:0,cleaning:0,boosting:3,thief:0}}},{name:"DPS C",loadoutId:"dpsC",loadoutTitle:"Bitslinger",class:"dps",level:5,attacks:[{actionId:"special_slice"},{actionId:"special_sql-injection"},{actionId:"special_deadline"},{actionId:"special_troll"},{actionId:"special_team-foreach"//super
}],items:[{actionId:"item_attack-sticker-i",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false},{actionId:"item_attack-sticker-i",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false},{actionId:"item_speed-sticker-i",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false}],computerAiPersonality:{default:{regular:2,vicious:6,recovering:0,cursing:0,cleaning:0,boosting:3,thief:0}}},{name:"DISRUPT A",loadoutId:"disruptA",loadoutTitle:"Quality Assurance",class:"disrupt",level:5,attacks:[//{actionId: "special_foreach"},
{actionId:"special_bug"},{actionId:"special_garbage-jammer"},{actionId:"special_headphones"},{actionId:"special_wildfire"//super
}],items:[{actionId:"item_network-reset-code",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false},{actionId:"item_defense-sticker-i",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false}],computerAiPersonality:{default:{regular:2,vicious:1,recovering:2,cursing:5,cleaning:2,boosting:3,thief:1}}},{name:"DISRUPT B",loadoutId:"disruptB",loadoutTitle:"Operator",class:"disrupt",level:5,attacks:[{actionId:"special_ddos"},{actionId:"special_copy-paste"},{actionId:"special_troll"},{actionId:"special_thrash"},{actionId:"special_commit"},//super
{actionId:"special_revert"//super
}],items:[{actionId:"item_honeypot-trap",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false},{actionId:"item_defense-sticker-i",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false}],computerAiPersonality:{default:{regular:2,vicious:1,recovering:2,cursing:5,cleaning:2,boosting:3,thief:3}}},{name:"DISRUPT C",loadoutId:"disruptC",loadoutTitle:"Infiltrator",class:"disrupt",level:5,attacks:[{actionId:"special_ddos"},{actionId:"special_copy-paste"},{actionId:"special_scope-bomb"},{actionId:"special_firewall"},{actionId:"special_sql-drop"//super
}],items:[{actionId:"item_max-danger-boost",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false}],computerAiPersonality:{default:{regular:2,vicious:1,recovering:2,cursing:5,cleaning:2,boosting:3,thief:3}}},{name:"SUPPORT A",loadoutId:"supportA",loadoutTitle:"Scrum Master",class:"support",level:5,attacks:[{actionId:"special_scrum"},{actionId:"special_deadline"},{actionId:"special_headphones"},{actionId:"special_scope-bomb"},{actionId:"special_team-clean"//super
}],items:[{actionId:"item_mini-battery-pack",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false},{actionId:"item_defense-sticker-i",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false},{actionId:"item_revive",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false}],computerAiPersonality:{default:{regular:2,vicious:2,recovering:6,cursing:3,cleaning:2,boosting:6,thief:2}}},{name:"SUPPORT B",loadoutId:"supportB",loadoutTitle:"Security Engineer",class:"support",level:5,attacks:[{actionId:"special_slice"},{actionId:"special_firewall"},{actionId:"special_curl-mk2"},{actionId:"special_clean"},{actionId:"special_team-revive"//super
}],items:[{actionId:"item_mini-battery-pack",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false},{actionId:"item_team-danger-boost",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false},{actionId:"item_speed-sticker-i",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false}],computerAiPersonality:{default:{regular:2,vicious:2,recovering:6,cursing:3,cleaning:2,boosting:6,thief:2}}},{name:"SUPPORT C",loadoutId:"supportC",loadoutTitle:"Help Desk",class:"support",level:5,attacks:[{actionId:"special_scrum"},{actionId:"special_firewall"},{actionId:"special_sql-injection"},{actionId:"special_clean"},{actionId:"special_team-revive"//super
}],items:[{actionId:"item_mini-battery-pack",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false},{actionId:"item_mini-battery-pack",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false},{actionId:"item_team-danger-boost",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false},{actionId:"item_full-revive",instanceId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("itemInstance",10),isStolen:false}],computerAiPersonality:{default:{regular:2,vicious:2,recovering:6,cursing:3,cleaning:2,boosting:6,thief:2}}}];function getLoadout(id){return sampleLoadouts.find(function(loadout){return loadout.loadoutId===id;});}/** Return one of the sample loadouts */function getRandomLoadout(){var combatantData=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__["a" /* randomFromArray */])(sampleLoadouts);return Object.assign({},combatantData,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__["a" /* randomFromArray */])(skinAndNameCombos),{//Adding this property here because it seems more in line with building your character.
//Team object will be built from `wantsToJoinTeam` properties (when master sends out `isBattleInit`)
wantsToJoinTeam:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__["a" /* randomFromArray */])(["one","two"])});}

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleAnimationEnd;
/* harmony export (immutable) */ __webpack_exports__["c"] = clearArenaAnimations;
/* harmony export (immutable) */ __webpack_exports__["b"] = timeout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lifecycle_handle_new_rollout_js__ = __webpack_require__(32);
/** Moves on to next rollout step */function handleAnimationEnd(){//Fire the "next step" thing to tell rollout to move on.
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["a" /* setBattleValue */])({arenaAnimationComponent:null,//Clear the animation component (otherwise it will remain mounted)
rolloutExecutingIndex:__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.rolloutExecutingIndex+1});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lifecycle_handle_new_rollout_js__["b" /* handleRolloutStep */])();}function clearArenaAnimations(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["a" /* setBattleValue */])({arenaAnimationComponent:null,arenaBackgroundStyle:"rgba(0,0,0,0)"});}function timeout(ms){return new Promise(function(resolve){return setTimeout(resolve,ms);});}

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getRandomInt */
/* harmony export (immutable) */ __webpack_exports__["c"] = getRandomInRange;
/* harmony export (immutable) */ __webpack_exports__["a"] = coinToss;
/* unused harmony export baseRoll */
/* harmony export (immutable) */ __webpack_exports__["b"] = percentChance;
function getRandomInt(min,max){return Math.floor(Math.random()*(max-min))+min;}function getRandomInRange(min,max){return Math.floor(Math.random()*(max-min+1))+min;}function coinToss(){return Math.floor(Math.random()*2)===0;}function baseRoll(){return getRandomInRange(2,8);}function percentChance(percent){//usage: percentChance(15) //There is a 15 percent chance this will return true;
return percent>=getRandomInRange(1,100);}

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getColoredUseLine;
/* harmony export (immutable) */ __webpack_exports__["a"] = getColoredNameById;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
function getColoredUseLine(){var combatantId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var actionName=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";var article=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"";var shouldPause=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;//Create a space if there is a word before the actionName
var space=article.length?" ":"";if(shouldPause){return{type:"message",content:[getColoredNameById(combatantId)," uses ","@@pause_300@@","[FAST]"+article+space+actionName+"!"]};}//No pause
return{type:"message",content:[getColoredNameById(combatantId)," uses ",""+article+space+actionName+"!"]};}//Get colored name. Red for enemy, Blue for friendly
//For Battle // TODO: future uses of this might need some more customization
function getColoredNameById(combatantId){var _store$getState$battl=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle,combatants=_store$getState$battl.combatants,battlePlayerId=_store$getState$battl.battlePlayerId;//In cases where no human player is playing, just return the name with no color!
if(!Object.keys(combatants).find(function(combId){return combId===battlePlayerId[0];})){return combatants[combatantId].name;}//Encode a string that has the combatant's teamId baked in.
// `convert-speech-to-textLine-array` will handle decoding `COLORVAR_NAME_FROM_TEAM::XXXXX` strings.
var colorPresetString="COLORVAR_NAME_FROM_TEAM::"+combatants[combatantId].belongsToTeam;return"@@color_"+colorPresetString+"@@"+combatants[combatantId].name.toUpperCase();}

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setGlobalValue;
/* harmony export (immutable) */ __webpack_exports__["b"] = setViewportSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store__ = __webpack_require__(1);
function setGlobalValue(){var changes=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};__WEBPACK_IMPORTED_MODULE_0__init_store__["a" /* default */].dispatch({type:"SET_GLOBAL_VALUE",payload:{changes:Object.assign({},changes)}});}//Abstraction for setting Viewport W and H
function setViewportSize(width,height){var mode=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"portrait";__WEBPACK_IMPORTED_MODULE_0__init_store__["a" /* default */].dispatch({type:"SET_GLOBAL_VALUE",payload:{changes:{vW:Math.round(width/100),vH:Math.round(height/100),viewportMode:mode,viewportWidth:width,viewportHeight:height}}});}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(123);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  (function () {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  })();
}

module.exports = warning;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = changeEditingCombatantValue;
/* harmony export (immutable) */ __webpack_exports__["d"] = getNextSkin;
/* harmony export (immutable) */ __webpack_exports__["c"] = getNextLoadout;
/* harmony export (immutable) */ __webpack_exports__["a"] = handleEditingDone;
/* harmony export (immutable) */ __webpack_exports__["f"] = launchEditModal;
/* harmony export (immutable) */ __webpack_exports__["g"] = editCrewName;
/* harmony export (immutable) */ __webpack_exports__["e"] = getSafeCombatantName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_Skins_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Fixture_combatants_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_get_sibling_in_array_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__battle_connection_firebase_rooms_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__battle_connection_firebase_users_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__b5_unlocks_getUserUnlocks_js__ = __webpack_require__(37);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//Update only the Name field of `editingCombatantProperties`
function changeEditingCombatantValue(property,newValue){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__["b" /* setMatchmakingValue */])({editingCombatantProperties:Object.assign({},__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().matchmaking.editingCombatantProperties,_defineProperty({},property,newValue))});}//Provide next or previous resources from lists
function getNextSkin(currentSkinId,direction){var allSkins=Object.keys(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__data_Skins_js__["a" /* default */])());var unlocks=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__b5_unlocks_getUserUnlocks_js__["a" /* getUserUnlocks */])();//Filter skins for only available ones (based on unlock, or just things we shouldn't allow you to select)
var availableSkins=allSkins.filter(function(skinId){if(skinId==="skin_mystery"){return false;}if(skinId==="skin_bonus1"){return unlocks["unlockC"].isComplete;}if(skinId==="skin_bonus2"){return unlocks["unlockD"].isComplete;}//Default to true
return true;});var currentIndex=availableSkins.indexOf(currentSkinId);return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_get_sibling_in_array_js__["a" /* getSiblingInArray */])(availableSkins,currentIndex,direction);}function getNextLoadout(currentLoadoutId,direction){//Filter available ids by unlocks
var unlocks=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__b5_unlocks_getUserUnlocks_js__["a" /* getUserUnlocks */])();var allLoadouts=[{id:"dpsA",test:function test(){return true;}},{id:"dpsB",test:function test(){return true;}},{id:"dpsC",test:function test(){return unlocks["unlockA"].isComplete;}},{id:"disruptA",test:function test(){return true;}},{id:"disruptB",test:function test(){return true;}},{id:"disruptC",test:function test(){return unlocks["unlockB"].isComplete;}},{id:"supportA",test:function test(){return true;}},{id:"supportB",test:function test(){return true;}},{id:"supportC",test:function test(){return unlocks["unlockE"].isComplete;}}].filter(function(loadout){return loadout.test();}).map(function(loadout){return loadout.id;});//["dpsA", "dpsB" ...], etc
var currentIndex=allLoadouts.indexOf(currentLoadoutId);return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_get_sibling_in_array_js__["a" /* getSiblingInArray */])(allLoadouts,currentIndex,direction);}//Do something with the finished result.
//Use this to set values on an existing character config somewhere.
function handleEditingDone(){//Get the finished config.
var _store$getState$match=__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().matchmaking.editingCombatantProperties,editingId=_store$getState$match.editingId,combatantName=_store$getState$match.combatantName,combatantSkin=_store$getState$match.combatantSkin,combatantLoadoutId=_store$getState$match.combatantLoadoutId;//Lookup the loadout to use.
var myLoadoutData=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Fixture_combatants_js__["c" /* getLoadout */])(combatantLoadoutId);//Edit local Crew state with my changes
var currentCrew=__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().crew.members;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__["e" /* setCrewValue */])({members:Object.assign({},currentCrew,_defineProperty({},editingId,Object.assign({},currentCrew[editingId],myLoadoutData,{//Merge in my new loadout data
name:combatantName,//and any updates that would have been done in the modal...
skinId:combatantSkin,loadoutId:combatantLoadoutId})))});//Close the modal
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__["b" /* setMatchmakingValue */])({//Default "not active" model.
editingCombatantProperties:{isActivated:false}});//If we are in a firebase room, update the edited combatant in `initialCombatantData`
if(window.roomRef){//NOTE: This check for roomRef could *portentially* cause issues if you WERE in a room, and now you're not. (window.roomRef still defined)
//Keep an eye out for that. You might be editing a room that you're not in anymore.
var currentRoomCombatantData=__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().matchmaking.initialCombatantData;var updatedCrewMembers=__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().crew.members;var combatantUpdate={};var firebaseCombatantKey=null;Object.keys(currentRoomCombatantData).forEach(function(key){var memberId=currentRoomCombatantData[key].memberId;if(memberId===editingId){firebaseCombatantKey=key;combatantUpdate=Object.assign({},updatedCrewMembers[memberId]);}});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__battle_connection_firebase_rooms_js__["c" /* setInitialCombatantData */])(firebaseCombatantKey,combatantUpdate);}//Now we also need to send this to the user's account. window.roomRef does not matter, but being logged in does.
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__battle_connection_firebase_users_js__["a" /* setUserCrewMemberInFirebase */])(__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().crew.members);}function launchEditModal(combatantId){//Populate the modal with exising data from local Crew
var currentCombatantModel=__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().crew.members[combatantId];__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__["b" /* setMatchmakingValue */])({editingCombatantProperties:{isActivated:true,editingId:combatantId,combatantName:currentCombatantModel.name,combatantSkin:currentCombatantModel.skinId,combatantLoadoutId:currentCombatantModel.loadoutId}});}function editCrewName(newCrewName){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__["e" /* setCrewValue */])({name:newCrewName});//Update my account with crewname.
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__battle_connection_firebase_users_js__["b" /* setUserCrewName */])();//(Checks if logged in)
//If in multiplayer mode, write crew to our name!
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__battle_connection_firebase_rooms_js__["d" /* updateCrewNameInRoom */])();//(Checks if in a multiplayer room)
}function getSafeCombatantName(inputName){//Remove anything but letters, numbers, and spaces
var safeString=inputName.replace(/[^\w\s!?]/g,'');//iOS can auto suggest your name which is super long.
if(safeString.length>10){}if(inputName.length<=1||inputName.match(/^[0-9]/)){return"Mister QA";}return safeString;}

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleNewRollout;
/* harmony export (immutable) */ __webpack_exports__["b"] = handleRolloutStep;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lifecycle_handle_seen_rollout_js__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__text_convert_speech_array_to_textLine_array_js__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ArenaView_animation_components_getAnimation_js__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__handle_state_change__ = __webpack_require__(372);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/** Receive a new rollout. Put it in state and update the log. */function handleNewRollout(rollout){if(!rollout.submitterCombatantId){console.warn('no submitter',rollout);}__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__["a" /* setBattleValue */])({rolloutId:rollout.rolloutId,rolloutData:rollout.rolloutPayload,//This is the array of Rollout Step models
rolloutExecutingIndex:0,//this property is only used by `handleRolloutStep`
//Multiplayer specific: clear out the battle taunt
arenaTaunt:null,//   //Record the person that submitted this (so we can visualize)
// seriesTurnsSubmitters: [
//   ...store.getState().battle.seriesTurnsSubmitters,
//   rollout.submitterCombatantId
// ],
//NOTE: Moved this to the END of the rollout ("handle-seen-rollout"). Keeping this here until that change is baked in my brain.
//Save a copy at the top of `history`
rolloutHistory:[{//Only save the properties we care about. (not `seenBy` or `submittedBy`)
submitterCombatantId:rollout.submitterCombatantId,rolloutId:rollout.rolloutId,rolloutPayload:rollout.rolloutPayload,timestamp:rollout.timestamp}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().battle.rolloutHistory)),arenaIsRolloutShowing:true//Toggle ON visibility of the rollout message area
});//Handle the first step:
handleRolloutStep();}//Used by "handleNewRollout" and Arena's "RolloutMessageBox" (for message done callbacks)
function handleRolloutStep(){//Get the current rollout array, and the current index. (rolloutExecutingIndex)
var _store$getState$battl=__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().battle,rolloutExecutingIndex=_store$getState$battl.rolloutExecutingIndex,rolloutData=_store$getState$battl.rolloutData;var currentStep=rolloutData[rolloutExecutingIndex];// Does this blip node exist (haven't made it through the array yet)
if(!currentStep){//We are done with this rollout. Call the "seen" step.
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lifecycle_handle_seen_rollout_js__["a" /* handleSeenRollout */])();//TODO: May need to move around the ConsoleView implementation of this fn because of this call?
return;}//TODO: Ran into a problem where messages were starting on 1 because of the "always uptick".
//Now upticking right before recalling
//---------------------
//CASE 1: Message is showing. We wait for the View Layer to call this function again.
if(currentStep.type==="message"){//Get the player's team so we can populate it in our data object
var playerId=__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().battle.battlePlayerId[0];var playerModel=__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().battle.combatants[playerId];var playerTeam=playerModel?playerModel.belongsToTeam:"reporting";//set the last known message!
//We don't want the views to compute the text to say, because index is always changing. (need to keep the text up through animations and such)
//Let's explicitly remember the text line we want on screen.
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__["a" /* setBattleValue */])({lastSeenTextMessage:{key:String(Date.now()),//Provide a key so we can force remounts through keys
content:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__text_convert_speech_array_to_textLine_array_js__["a" /* convertSpeechArrayToTextLineArray */])(currentStep.content,{playerTeamId:playerTeam,defaultTextColor:"#fff"//Sort of a weird mixed concern here. This sets the color of battle text. Seems weird to define style here
})}});//if arena mode, wait for the View Layer to call `handleRolloutStep` again
//otherwise, this can be called again right away (Console and Reporting modes)
if(__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().battle.battleViewMode!=="arena"){//console.log('auto calling for non-arena mode');
//console.warn('note to dev: end of battle is still calling "seen" directly. Need to adjust.')
//Uptick the executingIndex (for the View Layer, because we don't have a View Layer in these modes)
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__["a" /* setBattleValue */])({rolloutExecutingIndex:rolloutExecutingIndex+1});//Note: both Console and Reporting view automatically hit PLAY
//Console View: bit of a delay
//Reporting View: automatic (ms = 0)
var timeoutMs=__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().battle.battleViewMode==="console"?500:0;setTimeout(function(){handleRolloutStep();},timeoutMs);//This takes the place of the old waiting Rollout Button thing
}}//CASE 2: gradually increment state changes -> This allows us to play with lifebar animation and "getting attacked" post-animation stuff
if(currentStep.type==="stateChange"){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__handle_state_change__["a" /* handleStateChange */])(currentStep);}//CASE 3: cloudQueue changes are executed right now, then call for the next step
if(currentStep.type==="cloudQueue"){// console.log('handle cloudQueue');
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__["a" /* setBattleValue */])({cloudQueue:currentStep.payload||[]//latest version of payload
});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__["a" /* setBattleValue */])({rolloutExecutingIndex:rolloutExecutingIndex+1});handleRolloutStep();//move on to the next step
}//CASE 4: Animations
//setBattleValue `arenaAnimationComponent` to an animation component so it mounts
if(currentStep.type==="animation"){if(__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().battle.battleViewMode==="arena"){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__["a" /* setBattleValue */])({arenaAnimationComponent:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__ArenaView_animation_components_getAnimation_js__["a" /* getAnimation */])(currentStep.animationKey,currentStep.animationData)});}else{//Just move on if this is Console or Reporting
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__["a" /* setBattleValue */])({rolloutExecutingIndex:rolloutExecutingIndex+1});handleRolloutStep();//move on to the next step
}//TODO: What if state change was bundled with the animation somehow?
//  -> Would love to have more control over the timeline of state/animation changes
}}

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getQueryVariable;
function getQueryVariable(variable){var query=window.location.search.substring(1);var vars=query.split("&");for(var i=0;i<vars.length;i++){var pair=vars[i].split("=");if(pair[0]===variable){return pair[1];}}return false;}

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(prefix,length){prefix=prefix||"";length=length||10;var text="";var possible="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";for(var i=0;i<length;i++){text+=possible.charAt(Math.floor(Math.random()*possible.length));}return prefix+"_"+text;});

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(4);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//TODO: We're not using spritesheets at the moment, so this could all totally change. Really not sure yet.
//This is built in a way where the data could be extracted in a different file (like, if we need to load it)
// type skinSchema = {
//   frontViewSrc: "/path/to/front.svg",
//   backViewSrc: "/path/to/back.svg",
// };
var skins={skin_mystery:{frontViewSrc:"/images/skins/mystery-front.svg",backViewSrc:"/images/skins/mystery-front.svg"//duplicate for now
},skin_f1:{frontViewSrc:"/images/skins/f-1-front.svg",backViewSrc:"/images/skins/f-1-back.svg"},skin_f2:{frontViewSrc:"/images/skins/f-2-front.svg",backViewSrc:"/images/skins/f-2-back.svg"},skin_f3:{frontViewSrc:"/images/skins/f-3-front.svg",backViewSrc:"/images/skins/f-3-back.svg"},skin_m1:{frontViewSrc:"/images/skins/m-1-front.svg",backViewSrc:"/images/skins/m-1-back.svg"},skin_m2:{frontViewSrc:"/images/skins/m-2-front.svg",backViewSrc:"/images/skins/m-2-back.svg"},skin_m3:{frontViewSrc:"/images/skins/m-3-front.svg",backViewSrc:"/images/skins/m-3-back.svg"},skin_m4:{frontViewSrc:"/images/skins/m-4-front.svg",backViewSrc:"/images/skins/m-4-back.svg"},//BONUS:
skin_bonus1:{frontViewSrc:"/images/skins/bonus1-front.svg",//TODO:
backViewSrc:"/images/skins/bonus1-back.svg"//TODO:
},skin_bonus2:{frontViewSrc:"/images/skins/bonus2-front.svg",//TODO:
backViewSrc:"/images/skins/bonus2-back.svg"//TODO:
}};//or EX: window.skinsLoadedFromElsewhere {}
//In any case, use this function to get the list of all possible skins
/* harmony default export */ __webpack_exports__["a"] = (function(){return skins;});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return unlocks; });
/* harmony export (immutable) */ __webpack_exports__["a"] = getUserUnlocks;
/* harmony export (immutable) */ __webpack_exports__["b"] = getUserUnlocksCompletedKeys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getUserBattleRecord__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__battle_ArenaView_SubmissionMenu_icon_svg_getters_icon_folder__ = __webpack_require__(66);
var unlocks=[{id:"unlockA",icon:__WEBPACK_IMPORTED_MODULE_1__battle_ArenaView_SubmissionMenu_icon_svg_getters_icon_folder__["a" /* getOffenseIcon */],name:"Bitslinger Class",requirementText:"Win 1 battle",completedText:"Won a battle!",getAcquiredNumber:function getAcquiredNumber(record){return record.totalWins;},requiredNumber:1,test:function test(record){//Returns a 0 to 1 complete.
return record.totalWins/1;}},{id:"unlockB",icon:__WEBPACK_IMPORTED_MODULE_1__battle_ArenaView_SubmissionMenu_icon_svg_getters_icon_folder__["c" /* getDisruptIcon */],name:"Infiltrator Class",requirementText:"Win 6 battles",completedText:"Won 6 battles!",getAcquiredNumber:function getAcquiredNumber(record){return record.totalWins;},requiredNumber:6,test:function test(record){return record.totalWins/6;}},{id:"unlockC",icon:__WEBPACK_IMPORTED_MODULE_1__battle_ArenaView_SubmissionMenu_icon_svg_getters_icon_folder__["h" /* unlockSkin1Icon */],name:"Sunshine Skin",requirementText:"Win 3 Versus battles",completedText:"Won 3 Versus battles!",getAcquiredNumber:function getAcquiredNumber(record){return record.fullteamBattleWins;},requiredNumber:3,test:function test(record){return record.fullteamBattleWins/3;}},{id:"unlockD",icon:__WEBPACK_IMPORTED_MODULE_1__battle_ArenaView_SubmissionMenu_icon_svg_getters_icon_folder__["i" /* unlockSkin2Icon */],name:"Hoodie Punk Skin",getAcquiredNumber:function getAcquiredNumber(record){return record.openBattleWins;},requiredNumber:3,requirementText:"Win 3 Rally battles",completedText:"Won 3 Rally battles!",test:function test(record){return record.openBattleWins/3;}},{id:"unlockE",icon:__WEBPACK_IMPORTED_MODULE_1__battle_ArenaView_SubmissionMenu_icon_svg_getters_icon_folder__["b" /* getSupportIcon */],name:"Help Desk Class",requirementText:"Lose 3 battles",completedText:"Lost 3 battles!",getAcquiredNumber:function getAcquiredNumber(record){return record.totalLosses;},requiredNumber:3,test:function test(record){return record.totalLosses/3;}}];/** Return an array of IDs that you've unlocked */function getUserUnlocks(){var record=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getUserBattleRecord__["a" /* getRecord */])();// return unlocks.filter(unlock => {
//   return unlock.test(record) >= 1 //EX: 6 wins / 5 needed = 1.2
// }).map(unlock => {unlock.id}); //["unlockA", "unlockB"] etc
var progressArray=unlocks.map(function(unlock){var progress=unlock.test(record);if(progress>1){progress=1;//max out at 1
}return{id:unlock.id,acquiredNumber:unlock.getAcquiredNumber(record),requiredNumber:unlock.requiredNumber,progressPercent:Math.floor(progress*100)+"%",isComplete:progress>=1};});var payload={};progressArray.forEach(function(progModel){payload[progModel.id]=Object.assign({},progModel);});return payload;}//Get only the keys that I've completed
function getUserUnlocksCompletedKeys(){var userUnlocks=getUserUnlocks();return Object.keys(userUnlocks).filter(function(key){var model=userUnlocks[key];return model.isComplete;});}

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return pairPlayerWithRoom; });
/* unused harmony export validateThatRoomIsValid */
/* unused harmony export createNewRoom */
/* unused harmony export connectToRoom */
/* harmony export (immutable) */ __webpack_exports__["c"] = setInitialCombatantData;
/* unused harmony export rejoinRoom */
/* unused harmony export addBuddy */
/* harmony export (immutable) */ __webpack_exports__["e"] = addBot;
/* unused harmony export getNewBotData */
/* harmony export (immutable) */ __webpack_exports__["f"] = removeBot;
/* unused harmony export getStaleRoomsFromFirebase */
/* unused harmony export deleteRoomsFromFirebase */
/* harmony export (immutable) */ __webpack_exports__["a"] = recordTurnActivityInRoom;
/* harmony export (immutable) */ __webpack_exports__["b"] = writeTauntToRoom;
/* harmony export (immutable) */ __webpack_exports__["d"] = updateCrewNameInRoom;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Fixture_combatants_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PlayerFixture_combatant_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_models_from_object_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_CombatantModel_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lifecycle_team_utilities_js__ = __webpack_require__(40);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/** Decide which room to connect to */var pairPlayerWithRoom=function(){var _ref=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var playerCombatantData,redirectToRoom,validationResult,newRoomId,_newRoomId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0://
playerCombatantData=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__PlayerFixture_combatant_js__["a" /* getPlayerLoadout */])();//Case 1: I have a room in mind (through the URL) and I want to join that one:
redirectToRoom=__WEBPACK_IMPORTED_MODULE_2__init_store_js__["a" /* default */].getState().matchmaking.redirectToRoom;if(!redirectToRoom){_context.next=23;break;}_context.next=5;return validateThatRoomIsValid(redirectToRoom);case 5:validationResult=_context.sent;if(!(validationResult.type==="Error")){_context.next=16;break;}//Maybe throw an error if we have one.
//Show an error if this is the full one
if(validationResult.code==="error/full"||validationResult.code==="error/started"){//Originally, all of these Error cases would show errors. They aren't really errors though,
//But, removing this logic broke stuff. So only show this one possible error
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__redux_actions_battle_actions_js__["d" /* setMatchmakingError */])({//requires MatchmakingErrorMessage type
status:"Error",code:validationResult.code,message:validationResult.message});}if(!(validationResult.code==="error/doesnt-exist")){_context.next=13;break;}_context.next=11;return createNewRoom(redirectToRoom);case 11:newRoomId=_context.sent;connectToRoom(newRoomId,playerCombatantData);case 13:if(!(validationResult.code==="error/duplicate-entry")){_context.next=16;break;}//Force to "NOPE" screen. This user already is active in this room.
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__redux_actions_battle_actions_js__["b" /* setMatchmakingValue */])({//requires MatchmakingErrorMessage type
isDuplicateEntryScreen:true});return _context.abrupt("return");case 16:if(!(validationResult.type==="Success")){_context.next=21;break;}if(!(validationResult.code==="success/rejoining-room")){_context.next=20;break;}rejoinRoom(redirectToRoom,playerCombatantData);return _context.abrupt("return");case 20://Go ahead and connect to that room.
//console.log('found the desired room', redirectToRoom);
connectToRoom(redirectToRoom,playerCombatantData);case 21:_context.next=27;break;case 23:_context.next=25;return createNewRoom();case 25:_newRoomId=_context.sent;// console.log('newRoom', newRoomId);
connectToRoom(_newRoomId,playerCombatantData);case 27:case"end":return _context.stop();}}},_callee,this);}));return function pairPlayerWithRoom(){return _ref.apply(this,arguments);};}();/** Check this roomID to see if there is room for me */var validateThatRoomIsValid=function(){var _ref2=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(roomId){var desiredRoomSnapshot,desiredRoom,myPlayerId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return window.firebase.database().ref("rooms/"+roomId).once("value");case 2:desiredRoomSnapshot=_context2.sent;desiredRoom=desiredRoomSnapshot.val();myPlayerId=__WEBPACK_IMPORTED_MODULE_2__init_store_js__["a" /* default */].getState().battle.battlePlayerId[0];//possible fail: this room doesn't exist
if(desiredRoom){_context2.next=7;break;}return _context2.abrupt("return",{type:"Error",code:"error/doesnt-exist",message:"Room does not exist. Creating a new one!"});case 7:if(!(desiredRoom.roomType==="fullteam"&&desiredRoom.connections&&Object.keys(desiredRoom.connections).length>=2)){_context2.next=9;break;}return _context2.abrupt("return",{type:"Error",code:"error/full",message:"Full Team battle already has two players."});case 9:if(!(desiredRoom.initialCombatantData&&//combatants exist inside here
!desiredRoom.initialCombatantData[myPlayerId]&&//I'm not a founding member of the room (in other words, allow founder to rejoin)
Object.keys(desiredRoom.initialCombatantData).length>=6//Room isn't full
)){_context2.next=11;break;}return _context2.abrupt("return",{type:"Error",code:"error/full",message:"Room is full."});case 11:if(!(desiredRoom.connections&&desiredRoom.connections[myPlayerId])){_context2.next=13;break;}return _context2.abrupt("return",{type:"Error",code:"error/duplicate-entry",message:"You are already in this room."});case 13:if(!desiredRoom.hasBattleStarted){_context2.next=21;break;}if(!(desiredRoom.bots&&desiredRoom.bots[myPlayerId])){_context2.next=20;break;}if(!__WEBPACK_IMPORTED_MODULE_2__init_store_js__["a" /* default */].getState().battle.ff_IsRejoiningOn){_context2.next=19;break;}return _context2.abrupt("return",{type:"Success",code:"success/rejoining-room"});case 19:return _context2.abrupt("return",{type:"Error",code:"error/started",message:"Battle has already started. Rejoining is not available at this time!"});case 20:return _context2.abrupt("return",{type:"Error",code:"error/started",message:"Battle has already started!"});case 21:return _context2.abrupt("return",{type:"Success",//Note: this pre-dates the Flow type with "Success" as a status.
code:"success/validate-room"});case 22:case"end":return _context2.stop();}}},_callee2,this);}));return function validateThatRoomIsValid(_x){return _ref2.apply(this,arguments);};}();/** Creates a new room and return the ID so it can be connected to. */var createNewRoom=function(){var _ref3=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(desiredId){var newRoomId,myId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0://TODO: Should `desiredId` be validated? Don't want people writing naughty things
//Establish the new room's Id.
newRoomId=desiredId||__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("",7).replace("_","");//Set the values in the new room
myId=__WEBPACK_IMPORTED_MODULE_2__init_store_js__["a" /* default */].getState().battle.battlePlayerId[0];_context3.next=4;return window.firebase.database().ref("rooms/"+newRoomId).set({hasBattleStarted:false,createdTimestamp:Date.now(),createdByClientId:myId,//This will never change. This marks who created the room. It helps with knowing acquisition for people who get invited here
roomType:__WEBPACK_IMPORTED_MODULE_2__init_store_js__["a" /* default */].getState().matchmaking.createRoomType,//"fullteam" or "open"
masterCombatantId:myId,//Set master to my playerID (from Firebase login) This value can CHANGE if the master leaves!
initialCombatantData:{},//Note: firebase won't write these. Just a reminder that they start fresh
initialTeamData:{}//Note: firebase won't write these. Just a reminder that they start fresh
});case 4:return _context3.abrupt("return",newRoomId);case 5:case"end":return _context3.stop();}}},_callee3,this);}));return function createNewRoom(_x2){return _ref3.apply(this,arguments);};}();/** Set our global variable then connect */function connectToRoom(roomId){window.roomRef=window.firebase.database().ref("rooms/"+roomId);var battlePlayerId=__WEBPACK_IMPORTED_MODULE_2__init_store_js__["a" /* default */].getState().battle.battlePlayerId;//TODO: make sure crew.members always has the loadouts merged in (attacks, items, etc)
var crewMembers=__WEBPACK_IMPORTED_MODULE_2__init_store_js__["a" /* default */].getState().crew.members;var mainMember=crewMembers[Object.keys(crewMembers)[0]];var memberTwo=crewMembers[Object.keys(crewMembers)[1]];var memberThree=crewMembers[Object.keys(crewMembers)[2]];window.roomRef.child('roomType').once("value",function(snap){var roomType=snap.val();__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__redux_actions_battle_actions_js__["b" /* setMatchmakingValue */])({currentRoomId:roomId,currentRoomType:roomType});//Set combatantData
window.roomRef.child("initialCombatantData").child(battlePlayerId[0]).set(mainMember);if(roomType==="fullteam"){//Create first buddy
if(memberTwo){addBuddy(memberTwo);}//Create second buddy
if(memberThree){addBuddy(memberThree);}}//Add crew name
updateCrewNameInRoom();//Init firebase listeners!
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__firebase_js__["d" /* initFirebaseBattleBindings */])();//[Side Effect] at this point, go ahead and scan firebase for old rooms. It's okay to delete them.
getStaleRoomsFromFirebase([roomId],function(staleRoomsIdArray){deleteRoomsFromFirebase(staleRoomsIdArray);});});}function setInitialCombatantData(id,characterData,callback){//Sets it in "initialCombatantData" node. (for use in setting up a non-started battle)
window.roomRef.child("initialCombatantData").child(id).update(characterData).then(callback);}/** Set our global variable then rejoin the room (copy of connectToRoom, but with some specifics for rejoining) */function rejoinRoom(roomId,characterData){window.roomRef=window.firebase.database().ref("rooms/"+roomId);//Get the 'rejoiner' combatants and then connect
window.roomRef.child('rejoinCombatantState').once("value",function(combatantsSnap){//Get the teams, too
window.roomRef.child('rejoinTeams').once("value",function(teamsSnap){var rejoinerCombatants=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lifecycle_team_utilities_js__["d" /* addTeamReferencesAndIdsToCombatants */])(combatantsSnap.val(),teamsSnap.val());//console.log('rejoin!', rejoinerCombatants);
//Rectify my local state of combatants/teams before actually rejoining the battle
//NOTE: copied from `battleState/isBattleInit` tree in firebase.js
//Set the combatants
var combatantModels={};Object.keys(rejoinerCombatants).forEach(function(key){combatantModels[key]=Object.assign({},new __WEBPACK_IMPORTED_MODULE_8__models_CombatantModel_js__["a" /* default */](rejoinerCombatants[key]));});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__redux_actions_battle_actions_js__["a" /* setBattleValue */])({combatants:combatantModels,//set the combatants
teams:teamsSnap.val()//and the teams
});//////--------------------------------------------------
//Set this id to local state so I know what it is
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__redux_actions_battle_actions_js__["b" /* setMatchmakingValue */])({currentRoomId:roomId});//When rejoining, dont forget to set the roomtype
window.roomRef.child('roomType').once("value",function(snap){var roomType=snap.val();__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__redux_actions_battle_actions_js__["b" /* setMatchmakingValue */])({currentRoomId:roomId,currentRoomType:roomType});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__firebase_js__["d" /* initFirebaseBattleBindings */])();});});});}/* Buddy */function addBuddy(characterData){var battlePlayerId=__WEBPACK_IMPORTED_MODULE_2__init_store_js__["a" /* default */].getState().battle.battlePlayerId;//[]
var buddyId=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("buddy",10);var buddyLoadout=Object.assign({},characterData,{isBuddy:true,//This lets us auto mark the "viewed"
belongsToClient:battlePlayerId[0]//link to my client so we can team match later
});//Mark me as controlling that buddy.
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__redux_actions_battle_actions_js__["a" /* setBattleValue */])({battlePlayerId:[].concat(_toConsumableArray(battlePlayerId),[buddyId])});//Send that buddy up to Firebase
window.roomRef.child("initialCombatantData").child(buddyId).set(buddyLoadout);}/** Add a bot to the room */function addBot(botData){var botId=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_make_id_js__["a" /* default */])("bot",10);botData=botData||getNewBotData();window.roomRef.child("initialCombatantData").child(botId).set(botData);}//Just get bot data
function getNewBotData(){return Object.assign({},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Fixture_combatants_js__["a" /* getRandomLoadout */])(),{isBot:true//TODO: take this out. For testing, make bots stupid fast (or slow)
// hp: 1,
//speedModifier: -9
});}/** Remove a bot from the room */function removeBot(botId){window.roomRef.child("initialCombatantData").child(botId).remove();}/** Get rooms that can be deleted. Exclude the roomId (or more in the future? It's an array) that the player is connected to  */function getStaleRoomsFromFirebase(excludeIds,callback){var roomsRef=window.firebase.database().ref("rooms");roomsRef.once("value",function(snapshot){var rooms=snapshot.val()||{};//let destroyIdsList = [];
var now=Date.now();var destroyIdsList=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_models_from_object_js__["a" /* modelsFromObject */])(rooms).filter(function(roomModel){return isRoomOkayToDelete(roomModel,excludeIds,now);}).map(function(roomModel){return roomModel._id;});callback(destroyIdsList);});}function isRoomOkayToDelete(roomModel,excludeIds,now){//Do not delete if we're excluding this id
if(excludeIds.includes(roomModel._id)){return false;}//Delete if created more than 2 hours ago (7200000ms))
if(now-roomModel.createdTimestamp>7200000){return true;}//Delete if we have no more connections
return!roomModel.connections;}/** Take in a list of roomIds and destroy them all */function deleteRoomsFromFirebase(roomIdsToDestroy){roomIdsToDestroy.forEach(function(roomId){//console.log('deleting for real', roomId)
//Create ref and destroy each in the list
var roomToDeleteRef=window.firebase.database().ref("rooms/"+roomId);roomToDeleteRef.remove();});}/* Track turn activity in each room */function recordTurnActivityInRoom(turnKey,turnReport){if(!turnReport.actionId){console.warn('actionId not defined in turnReport',turnReport);}var useTurnReport=Object.assign({},turnReport,{actionId:turnReport.actionId||"unknown!"});window.roomRef.child("turnReporting").child(turnKey).set(useTurnReport);}function writeTauntToRoom(tauntString){if(window.roomRef){//This is only available in Online play
window.roomRef.child("taunt").set({timestamp:Date.now(),message:tauntString});}}function updateCrewNameInRoom(){if(window.roomRef){//Set my crew name
window.roomRef.child("crewNames").child(__WEBPACK_IMPORTED_MODULE_2__init_store_js__["a" /* default */].getState().battle.battlePlayerId[0]).set(__WEBPACK_IMPORTED_MODULE_2__init_store_js__["a" /* default */].getState().crew.name);}}

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDeadTeams;
/* harmony export (immutable) */ __webpack_exports__["c"] = isBattleOver;
/* harmony export (immutable) */ __webpack_exports__["b"] = getWinningTeam;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__team_utilities__ = __webpack_require__(40);
/** Return if either team is all the way dead */function getDeadTeams(){var useCombatants=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;//Default to store, but allow user to pass in combatants object (for theoretical calculation)
var allCombatants=useCombatants||__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatants;var isTeamOneDead=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__team_utilities__["c" /* getAllCombatantsOfTeam */])("one",allCombatants).every(function(comb){return!comb.isAlive();});var isTeamTwoDead=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__team_utilities__["c" /* getAllCombatantsOfTeam */])("two",allCombatants).every(function(comb){return!comb.isAlive();});return[isTeamOneDead?"one":null,isTeamTwoDead?"two":null].filter(function(d){return Boolean(d);});}//Return if one team is completely dead
//Slight abstraction of `getDeadTeams`
function isBattleOver(){var useCombatants=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;//Default to store, but allow user to pass in combatants object (for theoretical calculation)
var combatants=useCombatants||__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatants;//Return if one team is completely dead
return getDeadTeams(combatants).length>0;}function getWinningTeam(){//Hardcoded to two teams
var deadTeams=getDeadTeams();return["one","two"].filter(function(teamId){return!deadTeams.includes(teamId);})[0]||"bothTeamsDead";//Return the first entry of one,two that is NOT included in deadTeams
}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = addTeamReferencesAndIdsToCombatants;
/* harmony export (immutable) */ __webpack_exports__["a"] = getAllTeammateModels;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAllEnemyModels;
/* harmony export (immutable) */ __webpack_exports__["c"] = getAllCombatantsOfTeam;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_models_from_object_js__ = __webpack_require__(18);
/** Return a copy of combatants where each combatant has a `belongsToTeam` value according to `teams` object *///Also adds ID
function addTeamReferencesAndIdsToCombatants(){var combatants=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var teams=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var payload=Object.assign({},combatants);Object.keys(teams).forEach(function(teamId){(teams[teamId].combatantIds||[]).forEach(function(combatantId){payload[combatantId].id=combatantId;payload[combatantId].belongsToTeam=teamId;});});return Object.assign({},payload);}/* take in caster and return all teammate models as an ARRAY */function getAllTeammateModels(casterModel,allCombatantModels){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_models_from_object_js__["a" /* modelsFromObject */])(allCombatantModels).filter(function(combModel){return combModel.belongsToTeam===casterModel.belongsToTeam;});}function getAllEnemyModels(casterModel,allCombatantModels){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_models_from_object_js__["a" /* modelsFromObject */])(allCombatantModels).filter(function(combModel){return combModel.belongsToTeam!==casterModel.belongsToTeam;});}/* Return combatants of one team (provided by teamId) */function getAllCombatantsOfTeam(){var teamId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var allCombatantModels=arguments[1];return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_models_from_object_js__["a" /* modelsFromObject */])(allCombatantModels).filter(function(combModel){return combModel.belongsToTeam===teamId;});}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(444),
    getValue = __webpack_require__(471);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(104);
var setInnerHTML = __webpack_require__(80);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(112);
var setTextContent = __webpack_require__(201);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(4);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {

  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(561);
var ReactInstrumentation = __webpack_require__(15);

var warning = __webpack_require__(6);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
  ) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }

};

module.exports = ReactReconciler;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(81);

var ReactChildren = __webpack_require__(622);
var ReactComponent = __webpack_require__(121);
var ReactPureComponent = __webpack_require__(627);
var ReactClass = __webpack_require__(623);
var ReactDOMFactories = __webpack_require__(624);
var ReactElement = __webpack_require__(46);
var ReactPropTypes = __webpack_require__(625);
var ReactVersion = __webpack_require__(628);

var onlyChild = __webpack_require__(629);
var warning = __webpack_require__(29);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;

if (false) {
  var warned = false;
  __spread = function () {
    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
    warned = true;
    return _assign.apply(null, arguments);
  };
}

var React = {

  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactComponent,
  PureComponent: ReactPureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: ReactClass.createClass,
  createFactory: createFactory,
  createMixin: function (mixin) {
    // Currently a noop. Will be used to validate and trace mixins.
    return mixin;
  },

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

module.exports = React;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(81);

var ReactCurrentOwner = __webpack_require__(23);

var warning = __webpack_require__(29);
var canDefineProperty = __webpack_require__(216);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(214);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_global_actions_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__audio_manager__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_get_sibling_in_array_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__audio_localstorage_operations_js__ = __webpack_require__(130);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AudioControl=function(_React$Component){_inherits(AudioControl,_React$Component);function AudioControl(){_classCallCheck(this,AudioControl);return _possibleConstructorReturn(this,(AudioControl.__proto__||Object.getPrototypeOf(AudioControl)).apply(this,arguments));}_createClass(AudioControl,[{key:"componentWillUpdate",/* Listen for incoming prop to interact with the audioManager */value:function componentWillUpdate(newProps){if(newProps.audioMode==="full"){//Handle Audio is now ON
__WEBPACK_IMPORTED_MODULE_3__audio_manager__["a" /* default */].changeSongVolume("on");}else{//Handle Audio is now OFF
__WEBPACK_IMPORTED_MODULE_3__audio_manager__["a" /* default */].changeSongVolume("off");}}/* Toggle handle audio off */},{key:"handleToggleClick",value:function handleToggleClick(){//const audioModes = ["full", "sfx", "off"]; //TODO: Taking out SFX option to keep it simple
var audioModes=["full","off"];var nextMode=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_get_sibling_in_array_js__["a" /* getSiblingInArray */])(audioModes,audioModes.indexOf(this.props.audioMode),"next");__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_global_actions_js__["a" /* setGlobalValue */])({audioMode:nextMode});//Save this preference in localstorage
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__audio_localstorage_operations_js__["b" /* setAudioPreferenceInLocalstorage */])(nextMode);//Don't allow browser to focus on this button
this.refs.button.blur();}},{key:"getButtonText",value:function getButtonText(){if(this.props.audioMode==="full"){return"Audio On";}if(this.props.audioMode==="sfx"){return"SFX Only";}return"Audio Off";}},{key:"render",value:function render(){var style={position:"absolute",zIndex:2,right:0,top:0,outline:0,background:"rgba(255,255,255,0.1)",border:0,// borderBottom: "2px solid rgba(0,0,0,0.3)",
padding:10,WebkitUserSelect:"none"};var buttonStyle={display:"block",width:25,height:25,background:"url(/images/misc/audio-states.svg)",backgroundSize:"cover",backgroundPosition:this.props.audioMode==="full"?"0% 0%":"24px 0%"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"pointer-on-hover",ref:"button",tabIndex:"-1",style:style,onClick:this.handleToggleClick.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:buttonStyle}));}}]);return AudioControl;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{audioMode:state.global.audioMode};})(AudioControl));

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LobbyCTA=function(_React$Component){_inherits(LobbyCTA,_React$Component);function LobbyCTA(){_classCallCheck(this,LobbyCTA);return _possibleConstructorReturn(this,(LobbyCTA.__proto__||Object.getPrototypeOf(LobbyCTA)).apply(this,arguments));}_createClass(LobbyCTA,[{key:"handleClick",value:function handleClick(e){e.preventDefault();//Fire the handler if we're not disabled!
if(!this.props.isDisabled){this.props.handler();}}},{key:"getCategoryClass",value:function getCategoryClass(){if(this.props.isDisabledAppearance){return"is-disabled";}if(this.props.isRedHot){return"red-hot";}if(this.props.isReadyPressed){return"ready-pressed";}if(this.props.isPrimary){return"primary";}return"";}/* eslint jsx-a11y/href-no-hash: "off" */},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#",className:"pointer-on-hover button block large "+this.getCategoryClass(),onClick:this.handleClick.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"button--text"},this.props.text));}}]);return LobbyCTA;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (LobbyCTA);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = goToQuickBattle;
/* harmony export (immutable) */ __webpack_exports__["d"] = goToFullTeamMultiplayerBattle;
/* harmony export (immutable) */ __webpack_exports__["e"] = goToOpenBattle;
/* harmony export (immutable) */ __webpack_exports__["b"] = goToRecordScreen;
/* harmony export (immutable) */ __webpack_exports__["a"] = goToHomeScreen;
/* harmony export (immutable) */ __webpack_exports__["f"] = goToArenaFromInvite;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_global_actions_js__ = __webpack_require__(28);
//import { MenuOption } from "../menu-engine/MenuOption";
function goToQuickBattle(){//Set to single player mode and change to Battle arena
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions__["a" /* setBattleValue */])({isMultiplayerMode:false});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_global_actions_js__["a" /* setGlobalValue */])({gameArea:"arena"});}function goToFullTeamMultiplayerBattle(){//Set to multiplayer mode and change to Battle arena
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions__["b" /* setMatchmakingValue */])({createRoomType:"fullteam"});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions__["a" /* setBattleValue */])({isMultiplayerMode:true});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_global_actions_js__["a" /* setGlobalValue */])({gameArea:"arena"});}function goToOpenBattle(){//Set to multiplayer mode and change to Battle arena
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions__["b" /* setMatchmakingValue */])({createRoomType:"open"});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions__["a" /* setBattleValue */])({isMultiplayerMode:true});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_global_actions_js__["a" /* setGlobalValue */])({gameArea:"arena"});}function goToRecordScreen(){//Transition To Record Screen
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_global_actions_js__["a" /* setGlobalValue */])({gameArea:"b5-records-screen"});}function goToHomeScreen(){//Transition To Home Screen
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_global_actions_js__["a" /* setGlobalValue */])({gameArea:"b5-home-screen"});}function goToArenaFromInvite(){//Transition To Arena
//unopinionated of which roomtype, because is used when you've been invited to a specific room.
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_global_actions_js__["a" /* setGlobalValue */])({gameArea:"arena"});}// export function getHomeMenuOptions() {
//   return {
//     views: {
//       homeView: {
//         viewBag: {},
//         getMenuOptions() {
//           return {
//             quickBattle: MenuOption({
//               label: "Quick Battle",
//               handleOptionEnter() {
//                 goToQuickBattle();
//               }
//             }),
//             onlineTeamBattle: MenuOption({
//               label: "Multiplayer Crew Battle",
//               handleOptionEnter() {
//                 goToFullTeamMultiplayerBattle();
//               }
//             }),
//             onlineOpenBattle: MenuOption({
//               label: "Multiplayer Open Battle",
//               handleOptionEnter() {
//                 goToOpenBattle();
//               }
//             }),
//             stayUpdated: MenuOption({
//               label: "Stay Updated",
//               handleOptionEnter(menuModel) {
//                 console.log("handle this one - Stay Updated");
//
//                 //Lock the menu
//                 menuModel.lock();
//
//                 //Open the modal
//                 setGlobalValue({ isHomeEmailModalOpen: true });
//               }
//             })
//           };
//         },
//         getMenuOptionsLayout() {
//           return [
//             ["quickBattle"],
//             ["onlineTeamBattle"],
//             ["onlineOpenBattle"],
//             ["stayUpdated"]
//           ]; //the only option
//         }
//       }
//     }
//   };
// }

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSubmissionMenuOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_combatant_id_from_selecting_string_js__ = __webpack_require__(17);
function isSubmissionMenuOpen(){var _store$getState$battl=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle,combatantSelectingAction=_store$getState$battl.combatantSelectingAction,battlePlayerId=_store$getState$battl.battlePlayerId,arenaSubmissionMenuCombatantIdLock=_store$getState$battl.arenaSubmissionMenuCombatantIdLock;if(!arenaSubmissionMenuCombatantIdLock){//Do not show if this person's ID has already been nulled out after submitting
//(see `arenaSubmitFinalAction`)
return false;}//Show nothing if this person currently selecting person is not displayed.
var useCombId=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_combatant_id_from_selecting_string_js__["a" /* getCombatantIdFromSelectingString */])(combatantSelectingAction);if(!battlePlayerId.includes(useCombId)){return false;}return true;}

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getTeamHpRating;
/* harmony export (immutable) */ __webpack_exports__["b"] = getTeamStatusRating;
/* unused harmony export getCriticalHpCombatants */
/* harmony export (immutable) */ __webpack_exports__["a"] = getCombatantsWithStatus;
/* Analyze team for stats, etc */function getTeamHpRating(){var teamCombatantModels=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var currentTeamHp=teamCombatantModels.map(function(c){return c.hp||0;}).reduce(function(a,b){return a+b;});var currentTeamMaxHp=teamCombatantModels.map(function(c){return c.maxHp||0;}).reduce(function(a,b){return a+b;});return Math.round(currentTeamHp/currentTeamMaxHp*100);//100 = All Full //0 = All Empty
}function getTeamStatusRating(){var teamCombatantModels=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var statusMap={"normal":50,//Negative statuses
"lag":0,"fire":0,"memory-leak":0,//Positive statuses
"focus":100,"fury":100,"deadline":100};//Default to 50 if status string is unknown
var aliveCombatants=teamCombatantModels.filter(function(c){return c.hp>0;});var statusTotalRating=aliveCombatants.map(function(c){if(statusMap[c.status]==="undefined"){console.warn('NO STATUS VALUE DEFINED IN `getTeamStatusRating`:',c.status);return 50;}return statusMap[c.status];}).reduce(function(a,b){return a+b;});return Math.round(statusTotalRating/aliveCombatants.length);}/** Take in a list of combatants and only return ones who have a HP percentage less than or equal to the `thresholdPercent` *///EX: get the critical people on my team, or on the enemy team
function getCriticalHpCombatants(){var thresholdPercent=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var combatantModels=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var userOptions=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var options=Object.assign({sortHpLowToHigh:true},userOptions);return combatantModels.filter(function(combModel){var percent=combModel.hp/combModel.maxHp*100;return percent<=thresholdPercent;}).sort(function(a,b){//Sort order option
if(options.sortHpLowToHigh){return a.hp>=b.hp?1:-1;}else{return a.hp<b.hp?1:-1;}});}/** Return the ALIVE combatants that have any of these statuses */function getCombatantsWithStatus(){var combatantModels=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var statusNames=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];return combatantModels.filter(function(combModel){return statusNames.indexOf(combModel.status)>-1&&combModel.isAlive();});}

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getUserDataFromFirebase; });
/* unused harmony export setUserDataInFirebase */
/* harmony export (immutable) */ __webpack_exports__["a"] = setUserCrewMemberInFirebase;
/* harmony export (immutable) */ __webpack_exports__["b"] = setUserCrewName;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return userRecordsSchema; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getUserRecord;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateUserRecord;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return addAcquisitionTypeToUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_get_query_variable_js__ = __webpack_require__(33);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/** Look up a user's data */var getUserDataFromFirebase=function(){var _ref=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(userId){var userDataSnapshot;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return window.firebase.database().ref('users/'+userId).once("value");case 2:userDataSnapshot=_context.sent;return _context.abrupt('return',userDataSnapshot.val());case 4:case'end':return _context.stop();}}},_callee,this);}));return function getUserDataFromFirebase(_x){return _ref.apply(this,arguments);};}();/** Set user data */function setUserDataInFirebase(userId,payload){window.firebase.database().ref('users/'+userId).update(payload);}/** Set user crewMembers */function setUserCrewMemberInFirebase(crewData){var user=window.firebase.auth().currentUser;if(user){// User is signed in.
//Set crewMembers and crewName
window.firebase.database().ref('users/client_'+user.uid).child('crewMembers').set(crewData);}else{// No user is signed in.
}}/** Set user Crew name */function setUserCrewName(){var user=window.firebase.auth().currentUser;if(user){// User is signed in.
//Set crewMembers and crewName
window.firebase.database().ref('users/client_'+user.uid).child('crewName').set(__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().crew.name);}else{// No user is signed in.
}}var userRecordsSchema={quickBattleWins:0,quickBattleLosses:0,fullteamBattleWins:0,fullteamBattleLosses:0,openBattleWins:0,openBattleLosses:0};/** Get result my user results */function getUserRecord(callback){var localData=__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().crew.record;//Start with local data, then merge in truth from Firebase (if we're logged in)
var user=window.firebase.auth().currentUser;if(user){// User is signed in.
//Get my battle record.
var userRef=window.firebase.database().ref('users/client_'+user.uid).child('battleRecord');userRef.once("value",function(snap){var userRecord=snap.val()||{};//Fire the callback with the user's data. Merge in the defaults if no record exists.
callback(Object.assign({},userRecordsSchema,localData,userRecord));});}else{// No user is signed in. Return the basic schema.
//TODO: this is misleading. This will always return a blank record even if you've managed to do a few battles without logging in.
//The big question: Do we log you in when you finish a battle? If so, everybody should be logged in, and this would be a mega response-timeout edge case
callback(Object.assign({},userRecordsSchema,localData));}}//winOrLose: "win" | "lose"
//battleType: "quick" | "fullteam" | "open"
function updateUserRecord(existingRecord){var winOrLose=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";var battleType=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"";var callback=arguments[3];var editingKey=getEditingRecordKey(winOrLose,battleType);var newRecord=Object.assign({},existingRecord,_defineProperty({},editingKey,existingRecord[editingKey]!=="undefined"?existingRecord[editingKey]+1:0));//Write this to firebase. Return a status and resulting payload to the client.
var user=window.firebase.auth().currentUser;if(user){window.firebase.database().ref('users/client_'+user.uid).child('battleRecord').update(newRecord).then(function(){callback({status:"user-record-updated",payload:newRecord});});}else{//User not logged in. Return a modified submission anyway, but note that it won't be saved.
callback({status:"user-not-logged-in",payload:newRecord});}}//Quick tool for generating the correct key of userRecordsSchema model to edit
function getEditingRecordKey(winOrLose,battleType){var end="unknown";if(winOrLose==="win"){end="BattleWins";}if(winOrLose==="lose"){end="BattleLosses";}return battleType+end;}var addAcquisitionTypeToUser=function(){var _ref2=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(userId){var userRef,userDataSnapshot,userData,roomInviteId,roomRef,roomDataSnapshot,roomData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0://Get the user from Firebase
userRef=window.firebase.database().ref('users/client_'+userId);_context2.next=3;return userRef.once("value");case 3:userDataSnapshot=_context2.sent;userData=userDataSnapshot.val();//If user already has an aquisition model, bail here. Never want to override this!
if(!userData["acquisitionModel"]){_context2.next=7;break;}return _context2.abrupt('return');case 7://Otherwise, we know we need an aquisition model.
roomInviteId=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_get_query_variable_js__["a" /* getQueryVariable */])("p");if(roomInviteId){_context2.next=11;break;}//Case 1: No invite link. This person is organic.
userRef.child("acquisitionModel").set({type:"organic"});return _context2.abrupt('return');case 11://We were invited to a room. We need to know who the room belongs to.
roomRef=window.firebase.database().ref('rooms/'+roomInviteId);_context2.next=14;return roomRef.once("value");case 14:roomDataSnapshot=_context2.sent;roomData=roomDataSnapshot.val();//If this room exists & it has a creator, use that!
if(!(roomData&&roomData.createdByClientId)){_context2.next=19;break;}userRef.child("acquisitionModel").set({type:"invite",invitedBy:roomData.createdByClientId});return _context2.abrupt('return');case 19://Otherwise, default to organic.
userRef.child("acquisitionModel").set({type:"organic"});case 20:case'end':return _context2.stop();}}},_callee2,this);}));return function addAcquisitionTypeToUser(_x4){return _ref2.apply(this,arguments);};}();

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = initFirebaseBattleBindings;
/* harmony export (immutable) */ __webpack_exports__["c"] = sendBattleStateToServer;
/* unused harmony export destroyServerRollout */
/* unused harmony export sendNotificationOfBotCombatants */
/* harmony export (immutable) */ __webpack_exports__["a"] = sendRolloutStepsToServer;
/* harmony export (immutable) */ __webpack_exports__["b"] = sendPresetRolloutModelToServer;
/* harmony export (immutable) */ __webpack_exports__["e"] = sendViewConfirmationToServer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lifecycle_start_turn_series_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_get_object_key_diff_js__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_CombatantModel_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lifecycle_handle_new_rollout_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_make_id_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lifecycle_has_logged_rollout_by_id_js__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lifecycle_submit_battle_over_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__get_combatant_id_from_selecting_string_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lifecycle_master_submits_actions_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__audio_audio_manager_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__firebase_start_battle__ = __webpack_require__(347);
function initFirebaseBattleBindings(){if(!window.firebase){console.warn('Firebase not defined');return;}//Check our room to see which ID is the master. If that is me, do the inital kickoff stuff.
var masterId=void 0;window.roomRef.child('masterCombatantId').once("value",function(snapshot){masterId=snapshot.val();if(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.battlePlayerId[0]===masterId){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["a" /* setBattleValue */])({isMultiplayerMasterClient:true});//Master does a clean init of server state
window.roomRef.child('hasBattleStarted').set(false);window.roomRef.child('rollout').set(null);window.roomRef.child('selectingCombatant').set(null);window.roomRef.child('bots').set(null);}});//Set up ref to me
var presenceRef=window.roomRef.child('connections/'+__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.battlePlayerId[0]);// Bind listener to go OFFLINE when browser is closed.
presenceRef.onDisconnect().set(null);//Set my connection presence to my local player ID on the server
presenceRef.set({//Store something to hold presence in firebase
isHere:true}).then(function(){//I am online!
//console.log('I am set to online');
//----------- SUBSCRIBING TO CHANGES---------------------------
// Subscribe to changes on hasBattleStarted
window.roomRef.child('hasBattleStarted').on("value",function(snapshot){if(snapshot.val()){//true or false
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["a" /* setBattleValue */])({hasBattleStarted:true//Transitions me (the client) to arena mode (see render of OnlineLoginWall)
});//If I had an editing window open, please close it!
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["b" /* setMatchmakingValue */])({editingCombatantProperties:{isActivated:false}});}});//Subscribe to initialCombatantData so lobby knows who is here (and their current loadout)
window.roomRef.child('initialCombatantData').on("value",function(snapshot){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["b" /* setMatchmakingValue */])({initialCombatantData:snapshot.val()});});//Subscribe to crewNames so lobby knows when names are changed
window.roomRef.child('crewNames').on("value",function(snapshot){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["b" /* setMatchmakingValue */])({crewNames:snapshot.val()});});//Subscribe to crewNames so lobby knows when names are changed
window.roomRef.child('readyClients').on("value",function(snapshot){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["b" /* setMatchmakingValue */])({readyClients:snapshot.val()||{}});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__firebase_start_battle__["a" /* masterChecksForAllClientsReady */])();});//Subscribe to the taunt message
window.roomRef.child('taunt').on("value",function(snapshot){if(snapshot.val()){//play the voice sfx
__WEBPACK_IMPORTED_MODULE_11__audio_audio_manager_js__["a" /* default */].playSfx("sfx_taunt");//extract the text message
var tauntModel=snapshot.val();//{message, timstamp}
//set text message to state
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["a" /* setBattleValue */])({arenaTaunt:tauntModel.message});setTimeout(function(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["a" /* setBattleValue */])({arenaTaunt:null});},3000);//Clear it out in 3 seconds
// (TODO: This will be problematic if multiple taunts are coming through. Another problem for another day)
}});// Subscribe to changes on connections
window.roomRef.child('connections').on("value",function(snapshot){//console.log('handle new connections', snapshot.val() );
var newConnections=snapshot.val();var oldConnections=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.serverRoomConnections;// console.log('here are the connections', newConnections)
//Set local connections
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["a" /* setBattleValue */])({serverRoomConnections:newConnections});//Lobby Leavers!
//If battle has NOT STARTED YET, take note that somebody left
if(!__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.hasBattleStarted){//Master
if(Object.keys(newConnections).length<Object.keys(oldConnections).length){var lobbyLeaverObject=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_get_object_key_diff_js__["a" /* getObjectKeyDiff */])(newConnections,oldConnections);//Master notices somebody left. Remove them from firebase!
if(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.isMultiplayerMasterClient){// console.log('MASTER says: somebody left the lobby!', newConnections);
//We need to figure out who left, remove their initialCombatantData from Firebase,
// then the `initialCombatantData` listener will fire again on all clients
Object.keys(lobbyLeaverObject).forEach(function(key){var lobbyLeaverRef=window.roomRef.child('initialCombatantData').child(key);lobbyLeaverRef.remove();//Also delete this person's Buddies.
Object.keys(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().matchmaking.initialCombatantData).forEach(function(id){// console.log('id', id)
var model=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().matchmaking.initialCombatantData[id];if(model.isBuddy&&model.belongsToClient===key){var lobbyLeaverBuddyRef=window.roomRef.child('initialCombatantData').child(id);lobbyLeaverBuddyRef.remove();}});});}//When anybody leaves, non-masters check if the leaver was the master (NOTE: this block is only for the lobby)
if(!__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.isMultiplayerMasterClient){//If that leaver was the Master, create a new master!
//Master left the lobby!
if(Object.keys(lobbyLeaverObject).find(function(key){return masterId;})){//check if masterId is in the leaver object
//all connected non-master realize the master has left.
//Use the first remaining person as the new master.
//If that is me, set me to master and delete the old master
var connectedKeys=Object.keys(newConnections)||[];if(connectedKeys.length&&connectedKeys[0]===__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.battlePlayerId[0]){//console.log('I am the new master!');
window.roomRef.child("masterCombatantId").set(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.battlePlayerId[0]);//Remove the old master:
var lobbyMasterLeaverRef=window.roomRef.child('initialCombatantData').child(masterId);lobbyMasterLeaverRef.remove();//Also delete the old master's Buddies.
Object.keys(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().matchmaking.initialCombatantData).forEach(function(id){var model=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().matchmaking.initialCombatantData[id];if(model.isBuddy&&model.belongsToClient===masterId){var lobbyLeaverBuddyRef=window.roomRef.child('initialCombatantData').child(id);lobbyLeaverBuddyRef.remove();}});//Set my local value as being the new master
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["a" /* setBattleValue */])({isMultiplayerMasterClient:true});}}}}}//If the battle has already started, watch for people leaving:
if(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.hasBattleStarted){// Don't mix this up with "lobby bots". This is only for in-battle people dropping out.
//Connection count has gone down...
if(Object.keys(newConnections).length<Object.keys(oldConnections).length){//Diff here to figure out who left
var newlyBotCombatants=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_get_object_key_diff_js__["a" /* getObjectKeyDiff */])(newConnections,oldConnections);//console.warn('non-master client(s) has left!', newlyBotCombatants);
//If I'm the master, send notification that these combatants are now bots.
if(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.isMultiplayerMasterClient){//TODO: This is totally automatic right now. give a forgiving ms timeout chance for people to reconnect?
//TODO: ^^ This could be wrapped in a timeout or something.
sendNotificationOfBotCombatants(Object.keys(newlyBotCombatants));}//if I'm NOT the master, and the master left. Ruh Roh.
if(!__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.isMultiplayerMasterClient){if(Object.keys(newlyBotCombatants).find(function(key){return masterId;})){//masterId is the playerId ID of the master
//console.log('crap. the master left.'); //all connected clients do this.
//Check if I am the first combatant in the updated keys after master left.
var _connectedKeys=Object.keys(newConnections)||[];//array of the connected keys
if(_connectedKeys.length&&_connectedKeys[0]===__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.battlePlayerId[0]){// console.log('I am the new master!');
window.roomRef.child("masterCombatantId").set(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.battlePlayerId[0]);//Set my local value as being the new master
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["a" /* setBattleValue */])({isMultiplayerMasterClient:true});//I'm the new master now, so send out this notification of the old master being a bot now.
sendNotificationOfBotCombatants(Object.keys(newlyBotCombatants));}}}}//Rejoining!
//If connections have gone UP, see if this person is already listed as a Bot
if(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.isMultiplayerMasterClient){//Only master checks
if(Object.keys(newConnections).length>Object.keys(oldConnections).length){//Diff here to figure out who joined.
var rejoiningCombatants=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_get_object_key_diff_js__["b" /* getObjectAdditions */])(newConnections,oldConnections);//Turn bots back to humans (local state)
Object.keys(rejoiningCombatants).forEach(function(id){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(id,{isBot:false});});//Turn rejoiner's Buddies to bots too.
Object.keys(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatants).forEach(function(id){var model=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatants[id];if(model.isBuddy){//If I'm a buddy, see if my Client has rejoined
if(Object.keys(rejoiningCombatants).includes(model.belongsToClient)){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(id,{isBot:false});}}});//Master updates server bot states
sendNotificationOfBotCombatants([]);//Sort of hack. This fn looks at store.getState which we just set
}}}});//Subscribe to changes on rollout.
//Handle a new rollout when it comes in. This will send a "viewed" message after the client has seen the animations
window.roomRef.child('rollout').on("value",function(snapshot){//console.log('new rollout value', snapshot.val());
var newRollout=snapshot.val();if(newRollout){//Log this rollout if it's the first time we've seen it.
if(!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lifecycle_has_logged_rollout_by_id_js__["a" /* hasLoggedRolloutById */])(newRollout.rolloutId)){// console.log('online play handling new Rollout', newRollout.rolloutId);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lifecycle_handle_new_rollout_js__["a" /* handleNewRollout */])(newRollout);}//Master waits to hear that the last person has viewed the rollout.
if(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.isMultiplayerMasterClient){//Get the number of human players. We do not need to count "Viewed" notifications from Bots or Buddies.
//(Buddies already 'view' by their belongsToClient person)
var combatants=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatants;var humanPlayerCount=Object.keys(combatants).map(function(combatantId){return combatants[combatantId];}).filter(function(combatantModel){return!combatantModel.isBot&&!combatantModel.isBuddy;}).length;if(newRollout.seenBy&&Object.keys(newRollout.seenBy).length===humanPlayerCount){//We are ready to continue. Master figures out the next submitter and sends it to everybody.
//Master destroy server rollout, then set next person to Selecting
destroyServerRollout(function(){var nextBattleState=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lifecycle_start_turn_series_js__["b" /* getUpdatedBattleState */])();sendBattleStateToServer(nextBattleState);});}//TODO: This test case may be causing the problems:
if(newRollout.seenBy&&Object.keys(newRollout.seenBy).length>humanPlayerCount){console.warn('RUH ROH - more seen than human count');//NOTE: this log happened on a KICKED OUT person's console
}}}else{if(newRollout===null){//Master says the rollout should be cleared.
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["a" /* setBattleValue */])({rolloutData:[]});}}});//Subscribe to bots. New bot data coming in!
window.roomRef.child('bots').on("value",function(snapshot){var serverBots=snapshot.val();var serverBotIds=Object.keys(serverBots||{});//empty object if no bots
//Master has told us (and him/herself) that these people have left. So mark them as Bots
serverBotIds.forEach(function(newBotCombId){//Mark these leaver combatants as `isBot`
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(newBotCombId,{isBot:true});//If I am the master, I may need to submit for this new Bot if he is the one that's up.
//Otherwise we'd all be waiting for an offline person to submit something.
if(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.isMultiplayerMasterClient){//Find out who is supposed to submit right now. If it's the person who just left, submit for them.
var combatantSelectingAction=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__get_combatant_id_from_selecting_string_js__["a" /* getCombatantIdFromSelectingString */])(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatantSelectingAction);if(combatantSelectingAction===newBotCombId){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lifecycle_master_submits_actions_js__["a" /* masterSelectsActionForBot */])(newBotCombId);}}});//Mark the NON-server bots as humans! - this will turn back the rejoining people that are no longer bots
var combatants=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatants;Object.keys(combatants).forEach(function(key){if(!serverBotIds.includes(key)){//console.log('setting to human', combatants[key].name)
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(key,{isBot:false//Turn back to human
});}});});//Subscribe to battleState (which is all of our local combatants and stuff)
window.roomRef.child('battleState').on("value",function(snapshot){var battleState=snapshot.val();if(battleState){//check that its not null.
//Now check and apply explicit properties that we received
//This is the `isBattleInit` notification
if(battleState.isBattleInit){//Set the combatants //We received combatants (I think just for initing, can't store model methods in Firebase)
var combatantModels={};Object.keys(battleState.combatants).forEach(function(key){combatantModels[key]=new __WEBPACK_IMPORTED_MODULE_4__models_CombatantModel_js__["a" /* default */](battleState.combatants[key]);});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["a" /* setBattleValue */])({combatants:combatantModels,//set the combatants
teams:battleState.teams//and the teams
});//Master now starts the first series.
if(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.isMultiplayerMasterClient){//NEW: Master sets this specific battle-starting preset rollout
sendPresetRolloutModelToServer({submitterCombatantId:"BATTLE-SYSTEM",rolloutId:"rollout_battle-starting",rolloutPayload:[{type:"message",content:['An enemy crew approaches for battle!'//TODO Not doing dynamic Online intros at the moment.
// Not sure what those should say
]}]});}}//Set seriesTurnOrder if we receive it
if(battleState.seriesTurnOrder){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["a" /* setBattleValue */])({seriesTurnOrder:battleState.seriesTurnOrder});}//Set seriesTurnsSubmitters if we receive it
if(battleState.seriesTurnsSubmitters){//Convert back to empty array if the placeholder value "empty" is present
//because Firebase eats empty arrays...
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["a" /* setBattleValue */])({seriesTurnsSubmitters:battleState.seriesTurnsSubmitters==="empty"?[]:battleState.seriesTurnsSubmitters});}//Set combatantSelectingAction if we receive it
if(battleState.combatantSelectingAction){var nextCombatantId=battleState.combatantSelectingAction;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["a" /* setBattleValue */])({combatantSelectingAction:nextCombatantId,arenaSubmissionMenuCombatantIdLock:nextCombatantId.match(/cloudQueueAction::/)?null:nextCombatantId//This should never have "cloudQueueAction" in it, but if it does, it should be `null` here instead.
//See `start-turn-series` for ternary examples
});//Master might need to auto submit for a bot or cloudQueue
if(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.isMultiplayerMasterClient){//Check if this is the battle "battle over" submission
if(battleState.combatantSelectingAction==="battle-over"){// console.log('multiplayer battle over');
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lifecycle_submit_battle_over_js__["a" /* submitBattleOver */])();return;}//Check if it's a cloud deal.
if(battleState.combatantSelectingAction.match(/^cloudQueueAction/)){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lifecycle_master_submits_actions_js__["b" /* masterSubmitsQueuedAction */])(battleState.combatantSelectingAction);return;}//Check if the newSelectingPerson is a bot. (//isBot check handled within that function.)
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lifecycle_master_submits_actions_js__["a" /* masterSelectsActionForBot */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__get_combatant_id_from_selecting_string_js__["a" /* getCombatantIdFromSelectingString */])(battleState.combatantSelectingAction));//ai handled deeper within this function
}}//Receive a new cloudQueue, or a specific `false` value that specifies that new cloudQueue is empty. (Firebase eats empty things)
if(battleState.cloudQueue||battleState.cloudQueue===false){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["a" /* setBattleValue */])({cloudQueue:battleState.cloudQueue||[]});}}});});}// --------- SENDING as the Master //
/** Send new battleState to the clients (only master does this) */function sendBattleStateToServer(battleState){//Make sure data is clean. Convert anything that needs to be converted.
var cleanPayload=null;if(battleState.seriesTurnsSubmitters&&battleState.seriesTurnsSubmitters.length===0){cleanPayload=Object.assign({},battleState,{seriesTurnsSubmitters:"empty"//Transform empty array into "empty" placeholder string for Firebase
});}window.roomRef.child('battleState').set(cleanPayload?cleanPayload:battleState);}/** Clear out the rollout in multiplayer state (Only master does this) */function destroyServerRollout(){var callback=arguments.length>0&&arguments[0]!==undefined?arguments[0]:function(){};window.roomRef.child('rollout').set(null).then(callback);}// /** Master notifies all clients that number of connections is correct and we're ready (Only master does this) */
// export function sendNotificationOfBattleStarting() {
//   //The battle state should be totally reset and clear.
//   //Time to notify people that the battle is starting!
//   window.roomRef.child('hasBattleStarted').set(true);
// }
/** Let clients know that these combatants {} are now BOTS. (Only master does this) */function sendNotificationOfBotCombatants(){var newlyBotCombatantIds=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var combatants=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatants;var bots={};Object.keys(combatants).forEach(function(id){var model=combatants[id];if(model.isBot||newlyBotCombatantIds.includes(id)){bots[id]={//This is a bot model.. saved in Firebase in the `bots` object
name:model.name};}//Also make Buddies bots if their client is in the newlyBotCombatantIds list.
if(model.isBuddy&&newlyBotCombatantIds.includes(model.belongsToClient)){bots[id]={name:model.name//Same as above
};}});window.roomRef.child('bots').set(bots);//server `bots` is now all bots that exist in the match, including both client Bots and lifetime Bots.
}// ---------------- SENDING that EVERYBODY does (including Master) //
/** Tell the server that we have seen the rollout (ALL clients do this after completing their turn) */function sendRolloutStepsToServer(rollout,submitterCombatantId){//In the future, the client can just send their SUBMISSION to a satellite node server that will run the probabilities and stuff.
//This will help protect against cheating, because right now you could send up whatever you want.
var now=Date.now();var rolloutUpdateModel={submitterCombatantId:submitterCombatantId,rolloutId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_make_id_js__["a" /* default */])("rollout",10)+('_'+String(now)),//create an ID that can be used to track if client has seen this rollout before,
timestamp:now,seenBy:[],//New rollout.. nobody has completed the viewing.
submittedBy:__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.battlePlayerId,rolloutPayload:rollout};window.roomRef.child('rollout').set(rolloutUpdateModel);}/* Give explicit rollout to server (for known events, like battle-end and battle-start) */function sendPresetRolloutModelToServer(rolloutModel){window.roomRef.child('rollout').set(Object.assign({submittedBy:__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.battlePlayerId,seenBy:[],timestamp:Date.now()},rolloutModel)//includes `rolloutPayload`, and `rolloutId`
);}/** Tell the server that we have seen the rollout (ALL clients do this) */function sendViewConfirmationToServer(){var clientId=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.battlePlayerId[0];//This used to be just 1 string, but now it's an array. Send the first string for online mode.
//window.roomRef.child('rollout').child("seenBy").push(clientId); //THIS IS THE OLD WAY
//Try to manage duplicates by setting exact keys
window.roomRef.child('rollout').child("seenBy").child(clientId).set(true);//Note: Only humans send this. Not bots.
//If master, update the latest combatant state for rejoiners
if(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.isMultiplayerMasterClient){//Note: the only people who "request" this are people who are rejoining
window.roomRef.child('rejoinCombatantState').update(getSafeCombatantsForFirebase(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatants));window.roomRef.child('rejoinTeams').update(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.teams);}}//Strip functions from combatant models so we can store them in firebase
function getSafeCombatantsForFirebase(){var combatantModels=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var payload={};Object.keys(combatantModels).forEach(function(combId){var model=combatantModels[combId];var safeCombatant={};Object.keys(model).forEach(function(key){if(typeof model[key]!=="function"){safeCombatant[key]=model[key];}});payload[combId]=Object.assign({},safeCombatant);});return payload;}

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_rollout_message_text_helpers_js__ = __webpack_require__(27);
/* harmony default export */ __webpack_exports__["a"] = ({name:"[Name Needed]",description:"[Description Needed]",//animation: "tada", //Hmm. Will PROBABLY keep this, but not totally sure.
category:"none",//for iconography
//Cost
ppCost:0,//Danger Meter
increaseDangerMeterOnUse:15,affectTargetDangerMeter:0,//HP
affectTargetHpPoints:0,affectTargetHpPointsByPercent:0,affectCasterHpPoints:0,affectCasterHpPointsByPercent:0,hasTimedHitBonusAvailable:false,//TimedHitBonus
//TODO:
// This feature was removed during b5 testing because it felt like a tacked on mini game.
//HOWEVER, we can still use this flag as a potential damage bonus when adding Character Upgrades.
//For example, any action that has `hasTimedHitBonusAvailable:true` may have a chance of tacking on extra damage
//Based on a % of character stats/upgrades. You should probably rename it to something like "isBonusDamageEligible"
//PP Increase
affectTargetPpPoints:0,//ForEach and other loops
affectTargetHpPointsInRepetitions:null,//{min:1, max: 4, affectTargetHpPoints: -4}
affectTargetAttackModifier:0,affectTargetDefenseModifier:0,affectTargetSpecialModifier:0,affectTargetSpeedModifier:0,affectTargetAccuracyModifier:0,affectCasterAttackModifier:0,affectCasterDefenseModifier:0,// affectCasterSpecialModifier: 0,
affectCasterSpeedModifier:0,bypassCasterAttackStats:false,//Don't let move use the Attack stat, like "Insult" //TODO: not used yet, but should be used for Promise (first hit)
//Many targets, but randomly select one at runtime (EX: Promise resolve)
selectRandomTargetForSingleHit:false,//Status multiplier
statusMultiplier:null,//[status, rate] EX: ["deadline", 1.5]
//Item stats
itemValue:0,//This could be used to determine "worth", like which items are worth more. Maybe it's market cost? IDK
//TODO: at any rate, it's not being used yet.
//statuses
affectTargetStatus:null,//"normal", "memory-leak", "lag", "fury", "zen", "fire// array?
affectCasterStatus:null,//"normal", "memory-leak", "lag", "fury", "zen", "fire
//["from","to"]["mustBeThisStatus", "toBecomeThisStatus"]... or "["*", "canChangeToThisFromAnyStatus"]
statusTurnCount:[],/* [min, max] */isImmuneFromLag:false,//This move never gets "lost in lag".
//Theft
theftQuantity:0,//theftQuality: "random", /* best, worst */
//targetResistanceNeeded: 0, /* target needs defense roll higher than this (?), or it will fail */
stealAndUseItem:false,//Sabotage Item (EX: Bug)
sabotageItemQuantity:0,//Delete Item (EX: SQL Injection)
deleteItemQuantity:0,//Turn status
speedModifier:0,//TODO: analyze useages of this (at the ACTION level). This isn't really relevant anymore, right?
//Accuracy
accuracyModifier:0,/* 1 = 1%... -15 = 15% chance it will miss. (not factoring Combatant's accuracyModifier too) */canMiss:true,//Automatic option for shutting off potential misses.
//Time Travel
changeCasterCommittedData:false,useCasterCommittedData:false,clearTargetCommittedData:false,//Targeting
targetType:"single-opponent",//"single-opponent", "opponent-team", "single-ally", "ally-team", "only-me"
targetMustBeDead:false,targetCanBeDead:false,//This works on either dead or alive people
ignoreCasterDieResult:false,//Bypass annoucement that caster is dead (like, if a Promise resolves but the original caster is already dead)
ignoreTargetDieResult:false,//Bypass annoucement that target is dead
// (like, if an Item stealing or deleting thing is used on the whole team, but this person dead)
//
getValidity:function getValidity(actionModel,casterModel,targetModels){//Return whether this will be an auto fail
/*
     EX:
     if (targetCombatantModel.status !== "lag") {
     return {
     isValid: false,
     invalidReasons: ["Target is not lagging!"]
     }
     */return{isValid:true,invalidReasons:[]};},//Type
isItem:false,isSuper:false,// isSpecialAttack: false,
//Canceling
canBeReplaced:true,//If this needs to be more advanced ever, consider replacing this with a function that evaluates to true or false
//Rollout Messages
shouldFail:function shouldFail(actionModel,casterModel,targetModels){return false;//Return boolean
},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,"")];},getFailStep:function getFailStep(actionModel,casterModel,targetModels,descriptionObject){return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),{type:"message",content:["...but it failed!"]}];},getMissStep:function getMissStep(actionModel,casterModel,targetModels,descriptionObject){return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),{type:"message",content:["but it missed!"]}];},getFollowupActions:function getFollowupActions(actionModel,casterModel,targetModels,descriptionObject){return[// {
//     action: {
//         id: "the-action-id",
//         casterId: casterModel.id,
//         targetIds: [casterModel.id] //just the IDs of targets
//              Or something like targetIds: targetModels.map(targetModel => targetModel.id)
//     },
//     turnRange: [2, 5]
// }
];},getBuggedStep:function getBuggedStep(){return[];},//Meta
actionMeta:{//libraryId, isStolen, timed bonus, etc.
//Other flags that describe this exact instance of the submitted action
}});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__battle_data_battle_actions_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_Combatant_growth_pattern__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_random_from_array_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__init_store_js__ = __webpack_require__(1);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/* Return a Combatant with all of our battle properties */var combatantModelDefaults={name:"Combatant Name",loadoutTitle:"Default",//b5 specific. 1.0 will not be so boxed
level:1,xp:0,class:"dps",//dps | disrupt | support
skinId:"skin_m1",//Lookup in Skin assets
characterUpgrades:[// FOR EXAMPLE:
// {
//   libraryId: "character-upgrade-001-i",
//   instanceId: "upgrade_2347283746",
//   isEquipped: true,
//   acquiredTimestamp: 1495729113173 //timestamp when this item was acquired by Player
// }
],animationCssRule:"none",attacks:[],items:[//These items are "brought to the table" when assembling a team
//{actionId: "item_fake", instanceId: "itemInstance1", isStolen: true},
],///////////////////////////////////
hp:50,maxHp:50,pp:50,maxPp:50,//maxDangerMeter: 100,
dangerMeter:0,// 0 to 100
committedTurnData:false,//object or false
status:"normal",/* normal, memory-leak, lag, fire */healthStatPoints:0,//Static Stat value of character (in battle)
attackStatPoints:0,//(attack + defense)
// specialStatPoints: 0,
speedStatPoints:0,attackModifier:0,//Adjustable modifiers
defenseModifier:0,//specialModifier: 0,
speedModifier:0,accuracyModifier:0,//PERCENT. 1 = 1%. (Not actual fraction percent)
isBot:false,//same idea as "isComputerControlled". new name.
isChallenger:false,//Lagging
laggingOutProbability:60,//When status is "lag", % that the action will lag out. (Higher number = more likely to lag)
//AI:
isSelfServing:true,//false = teamServing
personalitySmartAttempts:2,//higher = more likely to make a personality based decision rather than falling back to regular
personalityObviousOpportunityRating:75,//0 to 100. higher = more likely to take advantage of obvious opportunities
// (like weakness multiplayers EX: Scope Bomb -> on a Deadline enemy)
computerAiPersonality:{default:{"regular":1,//Plain Attack
"vicious":1,//Most damaging
"recovering":1,//Recover numbers
"cursing":1,//Offensive apply negative status
"cleaning":1,//Defense heal negative statuses
"boosting":1,//Defensive boost with positive statuses
"slowing":1,//Offensively decreasing enemy stats
"thief":1//Anything dealing with affecting (or taking) enemy items
},goodTimes:{"regular":1,"vicious":1,"recovering":1,"cursing":1,"cleaning":1,"boosting":1,"thief":1,"slowing":1},badTimes:{"regular":1,"vicious":1,"recovering":1,"cursing":1,"cleaning":1,"boosting":1,"thief":1,"slowing":1}},goodTimes:[75,100],//min and max % of team HP
badTimes:[0,25]//min and max % of team HP
};/* harmony default export */ __webpack_exports__["a"] = (function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};//Combine overrides with defaults
var properties=Object.assign({},combatantModelDefaults,data);//Check that all items have an instanceId.
//(We could really just place the instanceIds here? Isn't that cleaner?)
if(data.items){data.items.forEach(function(item){if(!item.instanceId){console.warn('NO INSTANCE ID FOUND',item,data.name||"Unkown");}});}//Add stats
var growthPatterns=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_Combatant_growth_pattern__["a" /* getGrowthPatterns */])(properties.class);var maxHp=growthPatterns.hpGrowthPattern[properties.level];var maxPp=growthPatterns.ppGrowthPattern[properties.level];//Get all of my attacks that are not generic (in case that was passed in here... like Rejoiners)
//or default to an empty array.
var attacks=(data.attacks||[]).filter(function(a){return a.actionId!=="attack_generic-attack";});//NOTE: we will re-add "attack_generic-attack" when returning the payload
return Object.assign({},properties,{//Stats based on level
maxHp:maxHp,hp:data.hp===0?0:data.hp||maxHp,//support actual 0 value (watch out, it's falsy!)
maxPp:maxPp,pp:data.pp===0?0:data.pp||maxPp,speedStatPoints:growthPatterns.spdGrowthPattern[properties.level],attackStatPoints:growthPatterns.atkGrowthPattern[properties.level],attacks:[{actionId:"attack_generic-attack"}].concat(_toConsumableArray(attacks)),//Intro text will randomly choose from this array of strings:
introMessages:properties.introMessages||[properties.name+' is picking a fight!'//default
],//Methods....
isAlive:function isAlive(){return this.hp>0;},getTotalSpeed:function getTotalSpeed(){return this.speedStatPoints+this.speedModifier;},getTotalAttack:function getTotalAttack(){var statusBonus=0;if(this.status==="fury"){statusBonus=5;//TODO: balance this! might need to be a percentage, or related to level. Just like "focus" status
}return this.attackStatPoints+this.attackModifier+statusBonus;},getTotalDefense:function getTotalDefense(){//Note: no "defense" stat in b5. Just per-battle bonuses
var focusBonus=this.status==="focus"?3:0;//TODO: Balance this? 3 seems kinda random. Should it be a point per level or something?
return this.defenseModifier+focusBonus;},/** Consider other factors when deciding how much damage to dish out */getAttackCalc:function getAttackCalc(){var actionAffectTargetHpPoints=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var targetModel=arguments[1];var actionStatusMultiplier=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var hasTimedHitBonus=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var bypassCasterAttackStats=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;if(bypassCasterAttackStats){return actionAffectTargetHpPoints;}var attackDamage=this.getTotalAttack()*-1+actionAffectTargetHpPoints;//negative number
//Potentially apply a Timed Hit bonus
if(hasTimedHitBonus){attackDamage-=1;//Add 1 extra attack stat point (this feels a little better)
//TODO: well, idk. What about later in the game? This bonus means pretty close to nothing.
}var defenseOffset=Math.round(targetModel.getTotalDefense()/2);//status damage multiplayer (EX: Scope Bomb vs Deadline)
if(actionStatusMultiplier&&targetModel.status===actionStatusMultiplier[0]){//format = [status, rate]
attackDamage=Math.round(attackDamage*actionStatusMultiplier[1]);//should be a rate, like 1.5
}//Throttle defenseOffset - don't let it be higher than the attack damage.
//(defenseOffset higher than attackDamage can cause moves to do 0 damage or REVERSE damage which HEALS the target!!!)
if(Math.abs(defenseOffset)>=Math.abs(attackDamage)){// console.log('over', defenseOffset, attackDamage)
//Just do 1 hp point of damage.
return-1;}var total=attackDamage+defenseOffset;//bring attackDamage closer to 0 (because it's a negative number)
// console.log('tot:', total, 'atk:', attackDamage, 'target def:', defenseOffset);
return total;},/* This is referenced on every repetition to add a bit of Caster's attack rating */getRepetitionHitCalc:function getRepetitionHitCalc(){var repDmg=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;//Beef up each repetition with a fraction of attack stat
var buffAmount=Math.round(this.getTotalAttack()/-4);//negative number, because hp damage numbers are negative
//NOTE: target defense is NOT considered in this equation. TODO: [BALANCE] Consider if target's defense should be here.
return repDmg+buffAmount;},/** Returns a Number that represents a percent */getTotalAccuracy:function getTotalAccuracy(actionModel){//If nailed the timed hit, return 100
if(actionModel.actionMeta.hasTimedHitBonus){return 100;}//If "focus" status, return automatic 100
if(this.status==="focus"){return 100;}if(this.status==="fury"){return 86;}//Floor accuracyModifier at -50. Don't let somebody get lower accuracy than that
var useAccuracyModifier=this.accuracyModifier<-50?-50:this.accuracyModifier;//start X%, then modify from there.
return 97+useAccuracyModifier+actionModel.accuracyModifier;},getLaggingProbability:function getLaggingProbability(actionModel){//NOTE: in the future, we can add character upgrades (or actionModel dependencies) that affect this number.
//For now, just return it
return this.laggingOutProbability;//high number = more likely to lag out.
},/** Get list of team items by combining all combatants's items on my team */getTeamItems:function getTeamItems(){//In the future, if we want to go back to "individual items" just return my own items here.
var combatants=__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().battle.combatants;var teams=__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().battle.teams;var teamItems=[];(teams[this.belongsToTeam].combatantIds||[]).forEach(function(combId){var model=combatants[combId];teamItems=[].concat(_toConsumableArray(teamItems),_toConsumableArray(model.items||[]));});return[].concat(_toConsumableArray(teamItems));},getAvailableActions:function getAvailableActions(){var _this=this;var userOptions=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var options=Object.assign({//defaults
filterForPp:true},userOptions);var attacks=[].concat(_toConsumableArray(this.attacks)).filter(function(atk){var actionModel=__WEBPACK_IMPORTED_MODULE_0__battle_data_battle_actions_js__["a" /* default */][atk.actionId];//Check PP (unless we've opted out of PP check via userOptions object)
if(options.filterForPp&&actionModel.ppCost>_this.pp){//return false or whatever. Haven't balanced PP yet
return false;}//If I have commited data, let the Revert move be available (it's a super)
if(actionModel.useCasterCommittedData){return _this.committedTurnData;//return true if we have committed data, or false if there is no commit to use
}//Next, check supers against danger meter
if(actionModel.isSuper&&!_this.isDangerMeterReady()){return false;//This action is a super but our danger meter is not ready
}return true;});//TODO: also filter out Supers when Danger Meter is not ready
var items=this.getTeamItems();//In the future, maybe change this to only "my" items (use the feature flag?)
return[].concat(_toConsumableArray(attacks),_toConsumableArray(items));},/* Filter Available Actions for only the supers */getAvailableSupers:function getAvailableSupers(){return this.getAvailableActions().filter(function(atk){var actionModel=__WEBPACK_IMPORTED_MODULE_0__battle_data_battle_actions_js__["a" /* default */][atk.actionId];return actionModel.isSuper;});},//Return all supers whether they are available or not.
getAllSupers:function getAllSupers(){return this.attacks.filter(function(atk){var actionModel=__WEBPACK_IMPORTED_MODULE_0__battle_data_battle_actions_js__["a" /* default */][atk.actionId];return actionModel.isSuper;});},//Used for the Submission menu. Return the name of my Super (first one if I have a lot)
getSuperAction:function getSuperAction(){// const firstSuper = [...this.attacks].find(atk => {
//   const actionModel = BattleActions[atk.actionId];
//   return actionModel.isSuper
// });
var firstSuper=this.getAllSupers()[0];if(firstSuper){return __WEBPACK_IMPORTED_MODULE_0__battle_data_battle_actions_js__["a" /* default */][firstSuper.actionId];}return null;//I'd hope you never see this
},isDangerMeterReady:function isDangerMeterReady(){return this.dangerMeter===100;},// getDangerMeterIncreaseBonus() { //TODO ? Maybe Combatants get a little boost for each DM increase?
//   //return this.
// },
getIntroMessage:function getIntroMessage(){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_random_from_array_js__["a" /* randomFromArray */])(this.introMessages);}});});

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(70),
    getRawTag = __webpack_require__(468),
    objectToString = __webpack_require__(496);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 59 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var EventPluginRegistry = __webpack_require__(105);
var EventPluginUtils = __webpack_require__(106);
var ReactErrorUtils = __webpack_require__(110);

var accumulateInto = __webpack_require__(195);
var forEachAccumulated = __webpack_require__(196);
var invariant = __webpack_require__(4);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {

  /**
   * Methods for injecting dependencies.
   */
  injection: {

    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName

  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }

};

module.exports = EventPluginHub;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(61);
var EventPluginUtils = __webpack_require__(106);

var accumulateInto = __webpack_require__(195);
var forEachAccumulated = __webpack_require__(196);
var warning = __webpack_require__(6);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {

  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }

};

module.exports = ReactInstanceMap;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(21);

var getEventTarget = __webpack_require__(115);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint jsx-a11y/href-no-hash: "off" */var LobbyModal=function(_React$Component){_inherits(LobbyModal,_React$Component);function LobbyModal(){_classCallCheck(this,LobbyModal);return _possibleConstructorReturn(this,(LobbyModal.__proto__||Object.getPrototypeOf(LobbyModal)).apply(this,arguments));}_createClass(LobbyModal,[{key:"handleClose",value:function handleClose(e){if(e){e.preventDefault();}this.props.handleCloseCallback();}},{key:"getDesktopStyle",value:function getDesktopStyle(){var vW=this.props.vW;return{maxWidth:vW*40,fontSize:"0.5em",//padding: "3em",
left:"50%",top:"50%",transform:"translate(-50%,-50%)"};}},{key:"getMobileStyle",value:function getMobileStyle(){//const {vW} = this.props;
return{fontSize:"0.7em",top:"2%"};}},{key:"render",value:function render(){var viewportMode=this.props.viewportMode;var modalStyle=Object.assign({margin:"0 auto",position:"absolute",left:"5%",right:"5%",borderLeft:"0.4em solid #200535",borderRight:"0.4em solid #200535"},viewportMode==="landscape"?this.getDesktopStyle():this.getMobileStyle());return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ModalOverlay"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Modal",style:modalStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Modal--top-bar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"Modal--close",href:"#",onClick:this.handleClose.bind(this)},"\xD7"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Modal--content-container"},this.props.children)));}}]);return LobbyModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{vW:state.global.vW,viewportMode:state.global.viewportMode};})(LobbyModal));

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = getFolderIcon;
/* harmony export (immutable) */ __webpack_exports__["a"] = getOffenseIcon;
/* harmony export (immutable) */ __webpack_exports__["b"] = getSupportIcon;
/* harmony export (immutable) */ __webpack_exports__["d"] = getItemIcon;
/* harmony export (immutable) */ __webpack_exports__["e"] = getStolenItemIcon;
/* harmony export (immutable) */ __webpack_exports__["c"] = getDisruptIcon;
/* harmony export (immutable) */ __webpack_exports__["j"] = getLockIcon;
/* harmony export (immutable) */ __webpack_exports__["g"] = getSpeechIcon;
/* harmony export (immutable) */ __webpack_exports__["h"] = unlockSkin1Icon;
/* harmony export (immutable) */ __webpack_exports__["i"] = unlockSkin2Icon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function getFolderIcon(width){var style=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{style:Object.assign({minWidth:"16px"},style),width:width,height:width,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 16"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#156a7d",d:"M0 0h16M0 1h16M0 2h16M0 3h16M0 4h3M8 4h8M0 5h3M8 5h8M0 6h3M13 6h3M0 7h3M13 7h3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#6de4ff",d:"M3 4h3M3 5h3M3 6h10M3 7h10M3 8h10M3 9h10M3 10h10M3 11h10"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#0c404c",d:"M6 4h2M6 5h2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#013d4b",d:"M0 8h3M13 8h3M0 9h3M13 9h3M0 10h3M13 10h3M0 11h3M13 11h3M0 12h16M0 13h16M0 14h16M0 15h16"}));}function getOffenseIcon(width){var style=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{style:Object.assign({minWidth:"16px"},style),width:width,height:width,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 16"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{style:{fill:"#81455b"},d:"M0 8h16v8H0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{style:{fill:"#e9735f"},d:"M0 0h16v8H0z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{style:{fill:"#f0b07"},d:"M14 2h-2v1h-1v1h-1v1H9v1H8v1H7v1H6V7H4v1h1v2H4v1H3v1H2v2h2v-1h1v-1h1v-1h2v1h1v-2H8V9h1V8h1V7h1V6h1V5h1V4h1V2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{style:{fill:"#f0b07"},d:"M12 2h1v1h-1zM11 3h1v1h-1zM10 4h1v1h-1zM9 5h1v1H9zM8 6h1v1H8zM7 7h1v1H7z"}));}function getSupportIcon(width){var style=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{style:Object.assign({minWidth:"16px"},style),width:width,height:width,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 16"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#e9e15f",d:"M0 0h16M0 1h16M0 2h4M6 2h10M0 3h5M7 3h9M0 4h2M3 4h2M7 4h9M0 5h2M7 5h9M0 6h3M8 6h8M0 7h6M9 7h7"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#4a2d0a",d:"M4 2h2M5 3h2M2 4h1M6 4h1M2 5h2M5 5h2M3 6h5M6 7h3M7 8h3M8 9h5M9 10h5M9 11h2M13 11h1M9 12h2M10 13h2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#865419",d:"M5 4h1M4 5h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#e9aa5f",d:"M0 8h7M10 8h6M0 9h8M13 9h3M0 10h9M14 10h2M0 11h9M11 11h2M14 11h2M0 12h9M11 12h5M0 13h10M12 13h4M0 14h16M0 15h16"}));}function getItemIcon(width){var style=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{style:Object.assign({minWidth:"16px"},style),width:width,height:width,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 16"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#d77bba",d:"M0 0h16M0 1h16M0 2h7M8 2h8M0 3h8M9 3h7M0 4h7M8 4h8M0 5h4M11 5h5M0 6h4M13 6h3M0 7h4M11 7h1M13 7h3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#a86b95",d:"M7 2h1M8 3h1M7 4h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#1a0513",d:"M4 5h1M4 6h1M4 7h1M4 8h1M4 9h1M11 9h1M4 10h1M4 11h1M5 12h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#510f3c",d:"M5 5h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#370828",d:"M6 5h5M5 6h8M5 7h6M12 7h1M5 8h6M12 8h1M5 9h6M12 9h1M5 10h8M5 11h6M6 12h4"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#a05ab8",d:"M0 8h4M11 8h1M13 8h3M0 9h4M13 9h3M0 10h4M13 10h3M0 11h4M11 11h5M0 12h5M10 12h6M0 13h16M0 14h16M0 15h16"}));}function getStolenItemIcon(width){var style=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{style:Object.assign({minWidth:"16px"},style),width:width,height:width,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 16"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#767b72",d:"M0 0h16M0 1h16M0 2h16M0 3h16M0 4h5M10 4h6M0 5h4M13 5h3M0 6h4M11 6h1M13 6h3M0 7h4M11 7h1M13 7h3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#f1dbf9",d:"M5 4h5M4 5h9M4 6h1M7 6h1M10 6h1M12 6h1M4 7h1M6 7h3M10 7h1M12 7h1M4 8h3M8 8h3M12 8h1M4 9h9M5 10h5M6 11h3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#1a0513",d:"M5 6h2M8 6h2M5 7h1M9 7h1M7 8h1M11 8h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#414a3c",d:"M0 8h4M13 8h3M0 9h4M13 9h3M0 10h5M10 10h6M0 11h5M10 11h6M0 12h16M0 13h16M0 14h16M0 15h16"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#292e26",d:"M5 11h1M9 11h1"}));}function getDisruptIcon(width){var style=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{style:Object.assign({minWidth:"16px"},style),width:width,height:width,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 -0.5 16 16"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#639bff",d:"M0 0h16M0 1h16M0 2h16M0 3h3M5 3h2M9 3h2M13 3h3M0 4h2M7 4h2M14 4h2M0 5h2M6 5h4M14 5h2M0 6h3M5 6h6M13 6h3M0 7h4M5 7h6M12 7h4"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#040e4c",d:"M3 3h2M7 3h2M11 3h2M2 4h1M5 4h1M10 4h1M13 4h1M2 5h1M5 5h1M10 5h1M13 5h1M3 6h2M11 6h2M7 10h2M6 11h1M9 11h1M6 12h1M9 12h1M7 13h2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#7266d1",d:"M3 4h1M11 4h1M3 5h1M11 5h1M7 11h1M7 12h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#463d8b",d:"M4 4h1M6 4h1M9 4h1M12 4h1M4 5h1M12 5h1M4 7h1M11 7h1M5 8h1M10 8h1M6 9h1M9 9h1M8 11h1M8 12h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#6378ff",d:"M0 8h4M6 8h4M12 8h4M0 9h5M7 9h2M11 9h5M0 10h7M9 10h7M0 11h6M10 11h6M0 12h6M10 12h6M0 13h7M9 13h7M0 14h16M0 15h16"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#251f55",d:"M4 8h1M11 8h1M5 9h1M10 9h1"}));}function getLockIcon(width){var style=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{style:Object.assign({minWidth:"16px"},style),width:width,height:width,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 -0.5 16 16"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#dbe2f5",d:"M0 0h16M0 1h16M0 2h16M0 3h16M0 4h7M9 4h7M0 5h6M7 5h2M10 5h6M0 6h6M7 6h2M10 6h6M0 7h6M7 7h2M10 7h6"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#576798",d:"M7 4h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#4e5d89",d:"M8 4h1M6 5h1M9 5h1M6 6h1M9 6h1M6 7h1M9 7h1M5 8h6M5 9h6M5 10h6"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#cad1e5",d:"M0 8h5M11 8h5M0 9h5M11 9h5M0 10h5M11 10h5M0 11h5M11 11h5M0 12h16M0 13h16M0 14h16M0 15h16"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#435281",d:"M5 11h6"}));}function getSpeechIcon(width){var style=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{style:Object.assign({minWidth:"16px"},style),width:width,height:width,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 16"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#e9735f",d:"M0 0h16M0 1h16M0 2h16M0 3h16M0 4h3M13 4h3M0 5h2M14 5h2M0 6h2M14 6h2M0 7h2M14 7h2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#000000",d:"M3 4h10M2 5h1M13 5h1M2 6h1M13 6h1M2 7h1M13 7h1M2 8h1M13 8h1M2 9h1M13 9h1M3 10h7M12 10h1M9 11h1M11 11h1M9 12h2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#ffffff",d:"M3 5h3M3 6h2M3 7h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#f6f2f2",d:"M6 5h7M5 6h8M4 7h9M3 8h10M3 9h10M10 10h2M10 11h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#81455b",d:"M0 8h2M14 8h2M0 9h2M14 9h2M0 10h3M13 10h3M0 11h9M12 11h4M0 12h9M11 12h5M0 13h16M0 14h16M0 15h16"}));}function unlockSkin1Icon(width){var style=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{style:Object.assign({minWidth:"16px"},style),width:width,height:width,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 -0.5 26 26",shapeRendering:"crispEdges"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#eff0f3",d:"M0 0h26M0 1h26M0 2h11M12 2h14M0 3h9M13 3h13M0 4h7M19 4h7M0 5h6M20 5h6M0 6h5M21 6h5M0 7h4M22 7h4M0 8h4M22 8h4M0 9h4M22 9h4M0 10h3M23 10h3M0 11h3M23 11h3M0 12h2M24 12h2M0 13h2M24 13h2M0 14h2M24 14h2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#222034",d:"M11 2h1M9 3h2M12 3h1M7 4h2M13 4h6M6 5h1M19 5h1M5 6h1M20 6h1M4 7h1M21 7h1M4 8h1M21 8h1M4 9h1M21 9h1M3 10h2M21 10h2M3 11h1M22 11h1M2 12h2M22 12h2M2 13h2M22 13h2M2 14h2M22 14h2M2 15h3M8 15h3M15 15h3M21 15h3M3 16h3M7 16h1M11 16h1M14 16h1M18 16h1M20 16h1M22 16h1M3 17h2M6 17h2M11 17h4M18 17h2M21 17h2M4 18h2M7 18h1M11 18h1M14 18h1M18 18h1M20 18h2M4 19h2M8 19h3M15 19h3M20 19h2M5 20h2M19 20h2M5 21h4M17 21h4M5 22h1M7 22h1M9 22h8M18 22h1M20 22h1M5 23h1M7 23h1M18 23h1M20 23h1M5 24h1M7 24h12M20 24h1M6 25h2M18 25h2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#e5dc20",d:"M11 3h1M9 4h4M7 5h2M11 5h7M20 8h1M5 9h1M20 9h1M5 10h1M20 10h1M4 11h2M20 11h2M4 12h2M21 12h1M4 13h1M21 13h1M4 14h1M6 14h1M16 14h1M21 14h1M13 15h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#f3eb33",d:"M9 5h2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#fbf236",d:"M18 5h1M6 6h14M5 7h3M10 7h3M14 7h7M5 8h2M11 8h1M15 8h5M6 9h1M11 9h2M14 9h4M19 9h1M6 10h2M10 10h5M16 10h3M6 11h10M17 11h2M6 12h11M18 12h1M20 12h1M5 13h12M18 13h3M7 14h3M12 14h2M17 14h1M19 14h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#fffa8b",d:"M8 7h2M13 7h1M7 8h4M12 8h3M7 9h4M13 9h1M18 9h1M8 10h2M15 10h1M19 10h1M16 11h1M19 11h1M17 12h1M19 12h1M17 13h1M18 14h1M18 15h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#e5916c",d:"M5 14h1M10 14h2M15 14h1M5 15h1M12 15h1M12 16h2M9 21h1M16 21h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#f4a37a",d:"M14 14h1M6 15h2M19 15h1M21 16h1M5 17h1M20 17h1M6 18h1M12 18h2M19 18h1M6 19h1M12 19h2M19 19h1M7 20h5M14 20h5M10 21h6M6 24h1M19 24h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#bd785a",d:"M20 14h1M20 15h1M6 16h1M19 16h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#dbe2f0",d:"M0 15h2M24 15h2M0 16h3M23 16h3M0 17h3M23 17h3M0 18h4M22 18h4M0 19h4M22 19h4M0 20h5M21 20h5M0 21h5M21 21h5M0 22h5M21 22h5M0 23h5M21 23h5M0 24h5M21 24h5M0 25h6M20 25h6"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#2e2a4b",d:"M11 15h1M14 15h1M7 19h1M11 19h1M14 19h1M18 19h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#fdfeff",d:"M8 16h2M15 16h2M8 17h1M15 17h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#d5e3f7",d:"M10 16h1M17 16h1M9 17h2M16 17h2M8 18h3M15 18h3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#7e0b16",d:"M12 20h2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#847e87",d:"M6 22h1M8 22h1M19 22h1M6 23h1M8 23h3M19 23h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#695d6e",d:"M17 22h1M15 23h3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#746a79",d:"M11 23h4"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#d2dee2",d:"M8 25h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#cee6ef",d:"M9 25h4M14 25h3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#acbac0",d:"M13 25h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#bbcae7",d:"M17 25h1"}));}function unlockSkin2Icon(width){var style=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{style:Object.assign({minWidth:"16px"},style),width:width,height:width,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 -0.5 26 26",shapeRendering:"crispEdges"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#eff0f3",d:"M0 0h26M0 1h26M0 2h26M0 3h26M0 4h26M0 5h26M0 6h9M18 6h8M0 7h7M20 7h6M0 8h6M21 8h5M0 9h6M21 9h5M0 10h5M22 10h4M0 11h5M22 11h4M0 12h4M22 12h4M0 13h4M22 13h4M0 14h4M22 14h4"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#1f0535",d:"M9 6h9M7 7h2M18 7h2M6 8h1M20 8h1M6 9h1M20 9h1M5 10h1M21 10h1M5 11h1M21 11h1M4 12h1M8 12h1M10 12h1M15 12h1M18 12h1M21 12h1M4 13h1M7 13h1M19 13h1M21 13h1M4 14h1M6 14h1M19 14h1M21 14h1M4 15h1M6 15h1M21 15h1M4 16h1M6 16h1M10 16h1M15 16h1M19 16h1M21 16h1M4 17h1M6 17h1M10 17h1M15 17h1M19 17h1M21 17h1M4 18h1M6 18h1M10 18h1M15 18h1M19 18h1M21 18h1M4 19h1M6 19h1M19 19h1M21 19h1M5 20h1M7 20h1M18 20h1M20 20h1M5 21h2M8 21h1M17 21h1M19 21h2M5 22h1M7 22h1M9 22h8M18 22h1M20 22h1M5 23h1M7 23h1M11 23h1M14 23h1M18 23h1M20 23h1M5 24h1M7 24h2M12 24h1M15 24h1M18 24h1M20 24h1M6 25h14"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#adbbea",d:"M9 7h2M7 8h5M7 9h5M8 10h3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#8b9ddd",d:"M11 7h7M12 8h7M12 9h8M6 10h2M11 10h1M13 10h3M17 10h4M6 11h5M14 11h1M19 11h2M5 12h3M20 12h1M6 13h1M13 23h1M15 23h2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#748ad7",d:"M19 8h1M16 10h1M15 11h1M17 11h2M19 12h1M5 13h1M5 14h1M5 15h1M5 16h1M5 17h1M5 18h1M5 19h1M6 22h1M8 22h1M19 22h1M6 23h1M8 23h3M12 23h1M19 23h1M9 24h3M13 24h2M16 24h2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#82571d",d:"M12 10h1M11 11h1M13 11h1M16 11h1M9 12h1M14 12h1M17 12h1M8 13h1M12 13h1M14 13h1M18 13h1M7 14h2M10 14h2M13 14h3M17 14h2M7 15h1M9 15h1M12 15h1M19 15h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#ae6a0f",d:"M12 11h1M11 12h3M16 12h1M9 13h3M13 13h1M15 13h3M9 14h1M12 14h1M16 14h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#7186cd",d:"M20 13h1M20 14h1M20 15h1M20 16h1M20 17h1M20 18h1M20 19h1M6 20h1M19 20h1M18 21h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#dbe2f0",d:"M0 15h4M22 15h4M0 16h4M22 16h4M0 17h4M22 17h4M0 18h4M22 18h4M0 19h4M22 19h4M0 20h5M21 20h5M0 21h5M21 21h5M0 22h5M21 22h5M0 23h5M21 23h5M0 24h5M21 24h5M0 25h6M20 25h6"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#c8896e",d:"M8 15h1M10 15h2M13 15h6"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#d98f6a",d:"M7 16h1M7 17h1M7 18h1M7 19h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#e99976",d:"M8 16h2M11 16h4M17 16h2M8 17h1M8 18h1M8 19h1M17 19h2M8 20h1M17 20h1M9 21h1M16 21h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#f6b594",d:"M16 16h1M16 17h1M16 18h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#fca87e",d:"M9 17h1M11 17h4M18 17h1M9 18h1M11 18h1M18 18h1M9 19h8M9 20h3M14 20h3M10 21h2M14 21h2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#f4a37a",d:"M17 17h1M17 18h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#f5ac87",d:"M12 18h3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#e87171",d:"M12 20h2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#465ba3",d:"M7 21h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#f7b796",d:"M12 21h2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#9dade3",d:"M17 22h1M17 23h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#e19975",d:"M6 24h1M19 24h1"}));}

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNewTurnSeries;
/* harmony export (immutable) */ __webpack_exports__["b"] = getUpdatedBattleState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_order__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cloud_queue_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cloud_queue_encode_decode_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_add_entry_before_entry_js__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__get_dead_teams_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__get_updated_queue_with_deadline__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__is_cloud_action_relevant__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__analysis_track_hp_of_teams_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__get_combatant_id_from_selecting_string_js__ = __webpack_require__(17);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}//Do this at the beginning of every series of turn/
//1 series is over when everybody gets a chance to go.
//Only master does this.
function getNewTurnSeries(){// console.log('masters start turn series');
//-------------------------------------------------------------
//TODO: remove this section. It's just for dev testing
//Let's just stub the cloudQueue here. Need the dynamic ids and stuff
// const playerCasterId = Object.keys( store.getState().battle.combatants ).filter( key => {
//     return key.match(/client_/)
// })[0];
//
// const stubbedCloudQueue = [
//   {
//     turnSpot: true,//
//     actions: []
//   },
//   {
//     turnSpot: true,
//     actions: [
//       {
//         //sortBeforeCombatant: "main",
//         actionId: "natural_recover-deadline",
//         casterId: "main",
//         target: ["main"]
//       }
//       // {
//       //   actionId: "special_promise-resolve",
//       //   casterId: "doug",
//       //   target: ["skeeter"]
//       // }
//     ]
//   },
// ];
// setBattleValue({
//   cloudQueue: stubbedCloudQueue
// });
//-------------------------------------------------------------
//Get the latest cloudQueue
//Get stuff from the cloudQueue for THIS turn!
var currentCloudQueue=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.cloudQueue;var cloudQueueFirstEntry=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cloud_queue_js__["a" /* extractQueuedSubmissions */])(currentCloudQueue);//Separate the cloud actions that need sorting
var automaticCloudQueueActions=(cloudQueueFirstEntry.actions||[]).filter(function(a){return!a.sortBeforeCombatant;})||[];var cloudQueueActionsToSort=(cloudQueueFirstEntry.actions||[]).filter(function(a){return a.sortBeforeCombatant;})||[];//Order the combatants with including automatics up front
var turnOrderedCombatantIds=[].concat(_toConsumableArray(automaticCloudQueueActions.map(function(action){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__cloud_queue_encode_decode_js__["b" /* encodeCloudQueueActionString */])(action);})),_toConsumableArray(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_order__["a" /* getOrderedActionsFromSubmissions */])(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatants)));//Add in the ones that need to be sorted (lag recovery, etc)
cloudQueueActionsToSort.forEach(function(action){var sortBeforeCombatant=action.sortBeforeCombatant;turnOrderedCombatantIds=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_add_entry_before_entry_js__["a" /* addEntryBeforeEntry */])(turnOrderedCombatantIds,sortBeforeCombatant,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__cloud_queue_encode_decode_js__["b" /* encodeCloudQueueActionString */])(action));});//Push cloud queue 1 turn forward
var updatedCloudQueue=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cloud_queue_js__["b" /* removeQueueSlot */])(currentCloudQueue);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["a" /* setBattleValue */])({cloudQueue:updatedCloudQueue});//SORT OF SIDE EFFECT
//Build tracking object:
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__analysis_track_hp_of_teams_js__["a" /* trackHpOfTeams */])();//Only for tracking. Doesn't affect battle
//////////////////////////
//Send this payload as `battleState`
var nextCombatantId=getNextSelectingCombatant(turnOrderedCombatantIds,0);return{combatantSelectingAction:nextCombatantId,//Set the first in the list as first to choose action
arenaSubmissionMenuCombatantIdLock:nextCombatantId.match(/cloudQueueAction::/)?null:nextCombatantId,//Only allow true combatantIds in this value
seriesTurnOrder:turnOrderedCombatantIds,seriesTurnsSubmitters:[],//new empty array
//Supply the latest cloudQueue so a new matster can potentially take over if needbe.
cloudQueue:useCloudQueue(updatedCloudQueue)//get "firebase" safe version
};}/** Firebase safe version of cloud queue / empty array for offline play */function useCloudQueue(candidateCloudQueue){if(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.isMultiplayerMode){return candidateCloudQueue.length?candidateCloudQueue:false;//give Firebase a value that won't be eaten
}return candidateCloudQueue.length?candidateCloudQueue:[];//empty array is fine for offline (no Firebase)
}//Only master does this. Then sends out to everybody
//ONLINE & OFFLINE - get updated values of certain keys in battle state (not everything)
//EX: Next selecting combatant, or a new turn series with updated cloudQueue.
function getUpdatedBattleState(){//TODO: This name is weird. Sometimes it gives the next combatant, but at the end of a turn it gives a whole new `getNewTurnSeries` too.
//Check if battle is over
var deadTeams=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__get_dead_teams_js__["a" /* getDeadTeams */])();if(deadTeams.length){//Need to do rollout of end notification?
return{combatantSelectingAction:"battle-over"};}//Set the next person to the hotseat.
var queue=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.seriesTurnOrder;//Potentially update the queue to include deadline status
//to add an extra -deadline turn for current person.
queue=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__get_updated_queue_with_deadline__["a" /* getUpdatedQueueWithDeadline */])(queue,__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatantSelectingAction,__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatants);//Known deadlines are already set by "start turn series". This add is only for deadlines that are created mid-turn
var indexOfCurrentSelectingCombatant=queue.indexOf(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatantSelectingAction);if(indexOfCurrentSelectingCombatant<queue.length-1){//Find the next valid person in the queue //Therefore, dead person will never get the "SelectionMenu" UI.
var nextCombatantId=getNextSelectingCombatant(queue,indexOfCurrentSelectingCombatant+1);if(!nextCombatantId){//Last person in the queue was invalid, so start a new series
//console.warn('last person was invalid. Start a new series')
return getNewTurnSeries();}return{seriesTurnOrder:queue,//include latest seriesTurnOrder with every update (for Deadline adds)
combatantSelectingAction:nextCombatantId,arenaSubmissionMenuCombatantIdLock:nextCombatantId.match(/cloudQueueAction::/)?null:nextCombatantId//Do not allow cloudQueue IDs to be in this value
};}else{//End of series. //Last person submitted their thing, so start a new series
return getNewTurnSeries();}}function getNextSelectingCombatant(queue,index){//Validate person at this index is ALIVE. If this person is invalid, try again with the next index.
var casterId=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__get_combatant_id_from_selecting_string_js__["a" /* getCombatantIdFromSelectingString */])(queue[index]);//Validate if this person is alive
var combatantModel=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatants[casterId];//Check that a cloudQueue move is actually relevant (Recovering from lag, etc)
var moveIsRelevant=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__is_cloud_action_relevant__["a" /* isCloudActionRelevant */])(queue[index]);//Patch: Make sure Resolving Promises are okay valid, even if caster is dead.
//Do not allow them to be eaten because not Relevant or caster being dead.
var promiseResolveForce=false;if(queue[index].match(/special_promise-resolve/)){promiseResolveForce=true;}//TODO: It bums me out that we can't read an Action property here, but we don't have the model.
//TODO: In the future, if you need more "bypassers", just add their ids to the regex max test
if(combatantModel.isAlive()&&moveIsRelevant||promiseResolveForce){return queue[index];//return the string that is being validated, even if its cloudQueue (for indexOf)
}else{}//console.log('skipping', casterId);
//Try again with recursion
if(queue[index+1]){//if something exists at next point
return getNextSelectingCombatant(queue,index+1);//try to validate the next person
}else{//console.warn('last person was invalid. ruh roh');
return null;//return falsy value as a signal that this queue is over.
}}

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setValue;
/* harmony export (immutable) */ __webpack_exports__["b"] = editNode;
/* unused harmony export removeNode */
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/* Use this when editing a simple value on the top level of the reducer node */function setValue(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var changes=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return Object.assign({},state,changes);}/* Use this when editing one node in a list of nodes */function editNode(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var key=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";var changes=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var updated=Object.assign({},state);//copy state for updates
var node=updated[key];if(node){/* Don't deep compare if target node is undefined */for(var change in changes){/* Merge deep objects together rather than replace. Just replace Arrays */if(_typeof(changes[change])==="object"){if(!Array.isArray(changes[change])){changes[change]=Object.assign({},node[change],changes[change]);}}}}node=Object.assign({},node,changes);updated[key]=node;return updated;}function removeNode(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var key=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";var updated=Object.assign({},state);//copy state for removing
if(updated[key]){delete updated[key];}return updated;}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(482),
    listCacheDelete = __webpack_require__(483),
    listCacheGet = __webpack_require__(484),
    listCacheHas = __webpack_require__(485),
    listCacheSet = __webpack_require__(486);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(19);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(98);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(479);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(75);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(58),
    isObjectLike = __webpack_require__(60);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(9);

var EventPluginRegistry = __webpack_require__(105);
var ReactEventEmitterMixin = __webpack_require__(553);
var ViewportMetrics = __webpack_require__(194);

var getVendorPrefixedEventName = __webpack_require__(586);
var isEventSupported = __webpack_require__(116);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {

  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {

          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {

          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }

});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(64);
var ViewportMetrics = __webpack_require__(194);

var getEventModifierState = __webpack_require__(114);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(4);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html


/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(12);
var DOMNamespaces = __webpack_require__(104);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(112);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xFEFF) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(13);
var normalizeHeaderName = __webpack_require__(242);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(125);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(125);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)))

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FullscreenState=function(_React$Component){_inherits(FullscreenState,_React$Component);function FullscreenState(){_classCallCheck(this,FullscreenState);return _possibleConstructorReturn(this,(FullscreenState.__proto__||Object.getPrototypeOf(FullscreenState)).apply(this,arguments));}_createClass(FullscreenState,[{key:'getDesktopWrap',//Maybe return styles that wrap the desktop layout together
value:function getDesktopWrap(){if(this.props.viewportMode==="portrait"){return{};}return{width:"40em",margin:"0 auto"};}},{key:'render',value:function render(){var style={fontSize:this.props.viewportMode==="portrait"?"0.6em":"0.5em",//mobile, desktop
height:"100%",display:"flex",flexDirection:"column",justifyContent:"space-around"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:style,className:'menu-texture'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:Object.assign({padding:"1em"},this.getDesktopWrap())},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-card'},this.props.children))));}}]);return FullscreenState;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{viewportMode:state.global.viewportMode};})(FullscreenState));

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__b5_home_get_home_menu_options_js__ = __webpack_require__(51);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint jsx-a11y/href-no-hash: "off" */// import MenuHeaderInviteLink from "./MenuHeaderInviteLink";
var MenuHeader=function(_React$Component){_inherits(MenuHeader,_React$Component);function MenuHeader(){_classCallCheck(this,MenuHeader);return _possibleConstructorReturn(this,(MenuHeader.__proto__||Object.getPrototypeOf(MenuHeader)).apply(this,arguments));}_createClass(MenuHeader,[{key:"handleGoToHomeScreen",value:function handleGoToHomeScreen(e){e.preventDefault();__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__b5_home_get_home_menu_options_js__["a" /* goToHomeScreen */])();}},{key:"getContext",value:function getContext(){if(this.props.gameArea==="arena"&&this.props.currentRoomType==="fullteam"){return"fullteam";}if(this.props.gameArea==="arena"&&this.props.currentRoomType==="open"){return"rally";}if(this.props.gameArea==="b5-records-screen"){return"records";}return"home";}},{key:"getTitleText",value:function getTitleText(context){if(context==="fullteam"){return"";//"Versus Battle";
}if(context==="rally"){return"";//"Rally Battle";
}if(context==="records"){return"Battle Record";}return"Assemble Your Crew";}},{key:"renderLeftLink",value:function renderLeftLink(context){if(context==="fullteam"||context==="rally"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"menu-header__link",href:"/"},"Cancel");}if(context==="records"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"menu-header__link",href:"#",onClick:this.handleGoToHomeScreen.bind(this)},"Back");}return null;}},{key:"renderRightLink",value:function renderRightLink(context){// if (context === "fullteam" || context === "rally") {
//   return <MenuHeaderInviteLink />;
// }
return null;}},{key:"render",value:function render(){var context=this.getContext();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"menu-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,this.renderLeftLink(context)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"menu-header--center-section"},this.getTitleText(context)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,this.renderRightLink(context)));}}]);return MenuHeader;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{gameArea:state.global.gameArea,currentRoomType:state.matchmaking.currentRoomType};})(MenuHeader));

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getRecord;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
function getRecord(){var record=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().crew.record;/*
   quickBattleWins: 0,
   quickBattleLosses: 0,

   fullteamBattleWins: 0,
   fullteamBattleLosses: 0,

   openBattleWins: 0,
   openBattleLosses: 0,
   *///Add some computed values from our known Wins/Losses
var totalWins=record.quickBattleWins+record.fullteamBattleWins+record.openBattleWins;var totalLosses=record.quickBattleLosses+record.fullteamBattleLosses+record.openBattleLosses;var totalBattles=totalWins+totalLosses;return Object.assign({},record,{totalWins:totalWins,totalLosses:totalLosses,totalBattles:totalBattles});}

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = encodeCloudQueueActionString;
/* harmony export (immutable) */ __webpack_exports__["a"] = decodeCloudQueueActionString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_make_id_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__battle_data_battle_actions_js__ = __webpack_require__(14);
/** Take in the three inputs and return a formatted string that can be extracted */function encodeCloudQueueActionString(action){//Unite targets into a stringified array
var targetIds=action.target.join(",");//Provide a (hopefully) unique identifier for this string.
//This is only to ensure two duplicates will not be confused in `indexOf` usage when master is determining the next selecting character
var randomCharactersForUniqueness=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_id_js__["a" /* default */])("cqId",10);return"cloudQueueAction::"+action.actionId+"::"+action.casterId+"::["+targetIds+"]::"+randomCharactersForUniqueness;}/** Extract and assemble data from a cloudQueueActionString string. Returning something that can be used to submitAction */function decodeCloudQueueActionString(string){var combatants=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var dataFromString=string.split("::");var actionId=dataFromString[1];var casterId=dataFromString[2];var targetIdsArray=dataFromString[3].replace("[","").replace("]","").split(",");return{actionModel:Object.assign({id:actionId},__WEBPACK_IMPORTED_MODULE_1__battle_data_battle_actions_js__["a" /* default */][actionId]),casterModel:combatants[casterId],//me
targetModels:targetIdsArray.map(function(targetId){return combatants[targetId];})//my targets
};}

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getInitialBattleState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__team_utilities_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addSaltedItemInstanceIdsToCombatants__ = __webpack_require__(352);
function getInitialBattleState(){var combatants=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var teams=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var combatantsWithTeams=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__team_utilities_js__["d" /* addTeamReferencesAndIdsToCombatants */])(combatants,teams);//??? don't seem to need this anymore?
var combatantsWithSaltedItems=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__addSaltedItemInstanceIdsToCombatants__["a" /* addSaltedItemInstanceIdsToCombatants */])(combatantsWithTeams);return{isBattleInit:true,teams:teams,combatants:combatantsWithSaltedItems,//Get all initial values
combatantSelectingAction:"",rolloutId:"initial",cloudQueue:[],hpRatingsOfTeamsPerTurnSeries:[],turnReporting:{},rolloutHistory:[],rolloutData:[]};}

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = submitAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_description_object__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_rollout__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connection_firebase_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__get_replaced_action__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_make_id_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__handle_new_rollout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__analysis_turn_reporting_js__ = __webpack_require__(322);
//targetModels must be an array because of attacking multiple people. always assume its an array
/** Create the result from this submission, then send along the cycle */function submitAction(actionModel,casterModel){var rawTargetModels=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];//Filter for only the targets that can be used (alive vs dead)
var targetModels=rawTargetModels.filter(function(targetModel){if(actionModel.targetMustBeDead){//Only return DEAD
return!targetModel.isAlive();}else{//Only return ALIVE
if(actionModel.targetCanBeDead){return true;}return targetModel.isAlive();}});if(targetModels.length===0){console.warn('something is horribly wrong. targetModels is empty after `targetMustBeDead` check',casterModel.name,actionModel.name);//Action will auto fail
}//Check if action needs replacing (EX: Caster has the 'lag' status)
actionModel=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__get_replaced_action__["a" /* getReplacedAction */])(actionModel,casterModel);//Get latest combatants
var combatants=__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().battle.combatants;//Build a description object
var descriptionObject=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__get_description_object__["a" /* getDescriptionObjectFromSubmission */])(actionModel,casterModel,targetModels,combatants);//Use the description object to get a "Rollout" of human-readable words and state-changing instructions
var rollout=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_rollout__["a" /* getRollout */])(actionModel,casterModel,targetModels,descriptionObject);//SIDE EFFECT: REPORTING! (Does not affect battle) ///////////////////
var turnReport=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__analysis_turn_reporting_js__["a" /* createTurnReport */])(rollout,descriptionObject,actionModel,casterModel,targetModels);if(!turnReport.actionId){console.warn('turnReport created with no actionId',actionModel,casterModel);}__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__analysis_turn_reporting_js__["b" /* addReportToReportingHistory */])(turnReport);////////////////////////////////////////////
//Submitting the action:
//Case 1: Multiplayer!
if(__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().battle.isMultiplayerMode){// console.warn('rolloutSender is', store.getState().battle.combatantSelectingAction);
// console.warn(store.getState().battle.seriesTurnOrder);
// console.warn(store.getState().battle.seriesTurnsSubmitters);
//Send to the server!
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__connection_firebase_js__["a" /* sendRolloutStepsToServer */])(rollout,__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().battle.combatantSelectingAction);}else{//Case 2: Offline Play!
//can go straight to handling this rollout, but need to format this as a model:
var now=Date.now();// console.warn('rolloutSender is', store.getState().battle.combatantSelectingAction);
// console.warn(store.getState().battle.seriesTurnOrder);
// console.warn(store.getState().battle.seriesTurnsSubmitters);
var rolloutUpdateModel={submitterCombatantId:__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().battle.combatantSelectingAction,rolloutId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_make_id_js__["a" /* default */])("rollout",10),timestamp:now,rolloutPayload:rollout};__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__handle_new_rollout__["a" /* handleNewRollout */])(rolloutUpdateModel);}}

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = offlineCheckForAutoSubmission;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lifecycle_master_submits_actions_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lifecycle_submit_battle_over_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__get_combatant_id_from_selecting_string_js__ = __webpack_require__(17);
/** Offline behavior for new battleState coming in and needing to automatically submit for a bot or cloud queue */function offlineCheckForAutoSubmission(){var combatantSelectingAction=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatantSelectingAction;//Check if this is the battle "battle over" submission
if(combatantSelectingAction==="battle-over"){//console.log('submitting again')
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lifecycle_submit_battle_over_js__["a" /* submitBattleOver */])();//TODO: Why was this in here? Might have had to do with auto battles? Some runtime error?
//Might need to do some sort of "okay handle battle over" callback here. To get us out of battle mode
return;}//Check if it's a cloud deal.
if(combatantSelectingAction.match(/^cloudQueueAction/)){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lifecycle_master_submits_actions_js__["b" /* masterSubmitsQueuedAction */])(combatantSelectingAction);return;}//Check if the newSelectingPerson is a bot. (//isBot check handled within that function.)
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lifecycle_master_submits_actions_js__["a" /* masterSelectsActionForBot */])(//Checks for deadline formatting, etc
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__get_combatant_id_from_selecting_string_js__["a" /* getCombatantIdFromSelectingString */])(combatantSelectingAction));//ai handled deeper within this function
}

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getValueCeiling;
/** Take in an input and a max. If input is higher than max, return the max. */function getValueCeiling(){var input=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var max=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;if(input>=max){return max;}return input;}

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MenuOption;
function MenuOption(){var userOptions=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var useOptionId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;// if (!useOptionId) {
//   console.warn('no id specified... ', userOptions)
// }
if(!useOptionId){console.warn("need to provide `id` for this MenuOption",userOptions);}return Object.assign({id:useOptionId||createOptionId(),//Able to supply own ID for internal use
label:"First Option",description:"Some text that can be shown somewhere.. if you want.",optionGroup:null,//"". Can be used to group dynamic options together so client can loop
isVisible:function isVisible(){return true;//true for yes visible, false for non visible. Default: `return true`
},isUnavailable:function isUnavailable(){return false;//CAN be cursored to, but cannot be submitted. Probably would want to gray it out.
},isDisabled:function isDisabled(){//Return either `false` or a String reason for `true`
//EX: return "Not enough PP!" = yes this is disabled, and here is why
//If truthy, arrows will skip over this one. Clicks won't work.
//If this `isVisible` is false, automatically disable this
return false;//A string for disabled (gets `disabledOptionClass` class)
},nextView:null,//"someOtherView", //string name for next view
handleOptionEnter:function handleOptionEnter(){//Execute this function after the user selects this Option.
//Happens BEFORE transferring to the next view.
//
//default: empty. Doesn't do anything.
}},userOptions,{//Now methods that can't be overwritten by the user:
isAbleToBeSubmitted:function isAbleToBeSubmitted(){return this.isVisible()&&!this.isDisabled();}});}/************************//** Generate an ID to be used by each option */function createOptionId(){var prefix="option";var length=15;var text="";var possible="abcdefghijklmnopqrstuvwxyz0123456789";for(var i=0;i<length;i++){text+=possible.charAt(Math.floor(Math.random()*possible.length));}return prefix+"_"+text;}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(487),
    mapCacheDelete = __webpack_require__(488),
    mapCacheGet = __webpack_require__(489),
    mapCacheHas = __webpack_require__(490),
    mapCacheSet = __webpack_require__(491);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 95 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(20),
    isSymbol = __webpack_require__(75);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 97 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 98 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 99 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(432),
    baseKeys = __webpack_require__(447),
    isArrayLike = __webpack_require__(177);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(462);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 102 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(42);
var Danger = __webpack_require__(530);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactInstrumentation = __webpack_require__(15);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(112);
var setInnerHTML = __webpack_require__(80);
var setTextContent = __webpack_require__(201);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {

  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: { toIndex: update.toIndex, content: update.content.toString() }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }

};

module.exports = DOMChildrenOperations;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(4);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {

  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }

};

module.exports = EventPluginRegistry;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactErrorUtils = __webpack_require__(110);

var invariant = __webpack_require__(4);
var warning = __webpack_require__(6);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var React = __webpack_require__(45);
var ReactPropTypesSecret = __webpack_require__(559);

var invariant = __webpack_require__(4);
var warning = __webpack_require__(6);

var hasReadOnlyValue = {
  'button': true,
  'checkbox': true,
  'image': true,
  'hidden': true,
  'radio': true,
  'reset': true,
  'submit': true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: React.PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(4);

var injected = false;

var ReactComponentEnvironment = {

  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }

};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      // $FlowFixMe https://github.com/facebook/flow/issues/2336
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactCurrentOwner = __webpack_require__(23);
var ReactInstanceMap = __webpack_require__(63);
var ReactInstrumentation = __webpack_require__(15);
var ReactUpdates = __webpack_require__(16);

var invariant = __webpack_require__(4);
var warning = __webpack_require__(6);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }

};

module.exports = ReactUpdateQueue;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  'Alt': 'altKey',
  'Control': 'ctrlKey',
  'Meta': 'metaKey',
  'Shift': 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(12);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(9);

var emptyFunction = __webpack_require__(22);
var warning = __webpack_require__(6);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':

      case 'pre':
      case 'listing':

      case 'table':

      case 'hr':

      case 'xmp':

      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(47);

var ReactNoopUpdateQueue = __webpack_require__(122);

var canDefineProperty = __webpack_require__(216);
var emptyObject = __webpack_require__(124);
var invariant = __webpack_require__(48);
var warning = __webpack_require__(29);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

module.exports = ReactComponent;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(29);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);
var settle = __webpack_require__(234);
var buildURL = __webpack_require__(237);
var parseHeaders = __webpack_require__(243);
var isURLSameOrigin = __webpack_require__(241);
var createError = __webpack_require__(128);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(236);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(239);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(233);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAudioPreferenceFromLocalstorage;
/* harmony export (immutable) */ __webpack_exports__["b"] = setAudioPreferenceInLocalstorage;
function getAudioPreferenceFromLocalstorage(){var savedPreference=localStorage.getItem("audioPreference");return savedPreference||"full";//default to full if nothing saved
}function setAudioPreferenceInLocalstorage(setting){localStorage.setItem("audioPreference",setting);}

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditCombatantNameField__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditCombatantAppearance__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditCombatantLoadout__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__edit_combatant_operations__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint jsx-a11y/href-no-hash: "off" */var EditCombatantModal=function(_React$Component){_inherits(EditCombatantModal,_React$Component);function EditCombatantModal(){_classCallCheck(this,EditCombatantModal);return _possibleConstructorReturn(this,(EditCombatantModal.__proto__||Object.getPrototypeOf(EditCombatantModal)).apply(this,arguments));}_createClass(EditCombatantModal,[{key:"handleDoneClick",value:function handleDoneClick(e){e.preventDefault();__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__edit_combatant_operations__["a" /* handleEditingDone */])();}},{key:"handleClose",value:function handleClose(e){e.preventDefault();// console.log("TODO: close without saving");
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__edit_combatant_operations__["a" /* handleEditingDone */])();}},{key:"getDesktopStyle",value:function getDesktopStyle(){var vW=this.props.vW;return{maxWidth:vW*60,fontSize:"0.5em",//padding: "3em",
left:"50%",top:"50%",transform:"translate(-50%,-50%)"};}},{key:"getMobileStyle",value:function getMobileStyle(){return{fontSize:"0.65em",top:"2%",left:"2%",right:"2%"};}},{key:"render",value:function render(){var _props=this.props,viewportMode=_props.viewportMode,editingCombatantProperties=_props.editingCombatantProperties;if(!editingCombatantProperties.isActivated){console.warn("Editing modal should not be mounted (but is). isActivated is not true");return null;}var modalStyle=Object.assign({margin:"0 auto",position:"absolute",left:"5%",right:"5%",borderLeft:"0.4em solid #200535",borderRight:"0.4em solid #200535"},viewportMode==="landscape"?this.getDesktopStyle():this.getMobileStyle());return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ModalOverlay"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Modal",style:modalStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Modal--top-bar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Edit Crew Member"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"Modal--close",href:"#",onClick:this.handleClose.bind(this)},"\xD7"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Modal--content-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__EditCombatantNameField__["a" /* default */],{combatantName:editingCombatantProperties.combatantName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__EditCombatantAppearance__["a" /* default */],{combatantSkin:editingCombatantProperties.combatantSkin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EditCombatantLoadout__["a" /* default */],{combatantLoadoutId:editingCombatantProperties.combatantLoadoutId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button block large",href:"#",onClick:this.handleDoneClick.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"button--text"},"Done Editing"))))));}}]);return EditCombatantModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{editingCombatantProperties:state.matchmaking.editingCombatantProperties,viewportMode:state.global.viewportMode,vW:state.global.vW};})(EditCombatantModal));

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CrewMember__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CrewTitle__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewRecordButton__ = __webpack_require__(259);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CrewLineup=function(_React$Component){_inherits(CrewLineup,_React$Component);function CrewLineup(){_classCallCheck(this,CrewLineup);return _possibleConstructorReturn(this,(CrewLineup.__proto__||Object.getPrototypeOf(CrewLineup)).apply(this,arguments));}_createClass(CrewLineup,[{key:"renderViewRecordButton",value:function renderViewRecordButton(){if(this.props.showViewRecordButton){var containerStyle={textAlign:"center",paddingTop:"1em",paddingBottom:"4em"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:containerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ViewRecordButton__["a" /* default */],null));}return null;}},{key:"render",value:function render(){var _this2=this;var crewTeamArray=Object.keys(this.props.crewTeamModel).map(function(memberId){return Object.assign({},_this2.props.crewTeamModel[memberId]);});var membersContainerStyle={position:"relative",height:"15em",marginTop:"2.3em"//should match offset of the middle combatant
};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CrewTitle__["a" /* default */],{isEditable:this.props.areCombatantsEditable,crewName:this.props.crewName})),this.renderViewRecordButton(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:membersContainerStyle},crewTeamArray.map(function(member,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CrewMember__["a" /* default */],{key:i,showLaptop:_this2.props.showLaptop,position:member.arenaPosition,memberCount:crewTeamArray.length,memberId:member.memberId,name:member.name,rpgClass:member.class,skinId:member.skinId,loadoutTitle:member.loadoutTitle,isEditable:_this2.props.areCombatantsEditable,showClass:_this2.props.areCombatantsEditable});})));}}]);return CrewLineup;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CrewLineup);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_Skins_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__b5_crew_management_edit_combatant_operations_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RemoveBotButton__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_battle_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__get_class_icon__ = __webpack_require__(136);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint jsx-a11y/href-no-hash: "off" */var CrewMember=function(_React$Component){_inherits(CrewMember,_React$Component);function CrewMember(){_classCallCheck(this,CrewMember);return _possibleConstructorReturn(this,(CrewMember.__proto__||Object.getPrototypeOf(CrewMember)).apply(this,arguments));}_createClass(CrewMember,[{key:"handleClick",value:function handleClick(){//Do not allow editing after Ready
if(this.props.isEditable&&!this.props.isReady){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__b5_crew_management_edit_combatant_operations_js__["f" /* launchEditModal */])(this.props.memberId);}}//Only for "Rally Inviter" version of this component
},{key:"handleOpenInviteModal",value:function handleOpenInviteModal(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__redux_actions_battle_actions__["b" /* setMatchmakingValue */])({isLobbyInviteModalOpen:true});}},{key:"handleEditClick",value:function handleEditClick(e){e.preventDefault();//Do not allow editing after Ready
if(this.props.isReady){return false;}__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__b5_crew_management_edit_combatant_operations_js__["f" /* launchEditModal */])(this.props.memberId);}},{key:"getLeftPosition",value:function getLeftPosition(){var position=this.props.position;//TODO: If need later, add support for 2 or 1 person teams.
//TODO: 4,5,6 are only for Rally Lobby positioning. Has nothing to do with actual arenaPosition
if(position===2||position===4){//left
return"20%";}if(position===1||position===5){//main (center)
return"50%";}if(position===3||position===6){//right
return"80%";}}},{key:"getTopPosition",value:function getTopPosition(){var _props=this.props,position=_props.position,isEvenPositionMode=_props.isEvenPositionMode,evenPositionRowNumber=_props.evenPositionRowNumber;//Option to have no bumping
if(isEvenPositionMode){//Top row (first 3 people)
if(evenPositionRowNumber===1){return 0;}//Top row (first 3 people)
if(evenPositionRowNumber===2){return"20em";}}if(position===1){//main (center)
return"-2.3em";}return 0;}},{key:"renderEditLink",value:function renderEditLink(){if(this.props.isEditable&&!this.props.isReady){var containerStyle={textAlign:"center",paddingTop:"0.3em"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:containerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#",className:"button extra-small",onClick:this.handleEditClick.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"button--text"},"...")));}return null;}},{key:"renderReadyBlip",value:function renderReadyBlip(){if(this.props.isReady){var containerStyle={textAlign:"center",paddingTop:"1em"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:containerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{href:"#",className:"button extra-small ready-pressed"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"button--text"},"Ready")));}return null;}},{key:"renderBotRemoveLink",value:function renderBotRemoveLink(){if(this.props.canShowBotRemoveButton&&this.props.isBot){var containerStyle={textAlign:"center",paddingTop:"1em"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:containerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RemoveBotButton__["a" /* default */],{combatantId:this.props.combatantId}));}return null;}},{key:"renderClassName",value:function renderClassName(){if(this.props.showClass){var style={fontSize:"0.8em",color:"#585B72"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style},this.props.isBot?"BOT":this.props.loadoutTitle);}return null;}},{key:"renderClassBadge",value:function renderClassBadge(){if(this.props.showClass){var style={marginTop:"1em"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__get_class_icon__["a" /* getClassIcon */])(this.props.rpgClass,"3em"));}return null;}},{key:"renderRallyInvite",value:function renderRallyInvite(){if(this.props.isRallyInviter){var containerStyle={textAlign:"center",paddingTop:"1em"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:containerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#",className:"button extra-small invite-theme",onClick:this.handleOpenInviteModal.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"button--text"},"INVITE")));}return null;}},{key:"render",value:function render(){var skin=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__data_Skins_js__["a" /* default */])()[this.props.skinId];var containerStyle={position:"absolute",width:"30%",transform:"translateX(-50%)",left:this.getLeftPosition(),top:this.getTopPosition()};var characterContainerStyle={display:"block",width:"11em",height:"11em",position:"relative",margin:"0 auto"};var characterStyle={position:"absolute",left:0,top:0,width:"100%",display:"block",//If Rally inviter, use padding to shrink the skin down
padding:this.props.isRallyInviter?"2em":"0"};var infoStyle={container:{marginBottom:"1em",textAlign:"center"},nameStyle:{color:this.props.isEditable?"#4C86CA":"inherit",textAlign:"center",textTransform:"uppercase",marginBottom:"0.5em"}};var laptopStyle={position:"absolute",left:"2.8em",top:"5.1em",width:"5.3em",display:"block"};var hoverClass=this.props.isEditable?"pointer-on-hover":"";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:containerStyle,className:hoverClass,onClick:this.handleClick.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:infoStyle.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:infoStyle.nameStyle},this.props.name),this.renderClassName(),this.renderClassBadge()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:characterContainerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{style:characterStyle,src:"/images/misc/shadow.svg",alt:"Shadow"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{style:characterStyle,src:skin.frontViewSrc,alt:this.props.name}),this.props.showLaptop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{style:laptopStyle,src:"/images/misc/laptop-back.svg",alt:"Laptop"}):null),this.renderEditLink(),this.renderBotRemoveLink(),this.renderReadyBlip(),this.renderRallyInvite());}}]);return CrewMember;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CrewMember);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LobbyModal__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LobbyCTA__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__b5_crew_management_edit_combatant_operations__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditCrewNameModal=function(_React$Component){_inherits(EditCrewNameModal,_React$Component);function EditCrewNameModal(){_classCallCheck(this,EditCrewNameModal);var _this=_possibleConstructorReturn(this,(EditCrewNameModal.__proto__||Object.getPrototypeOf(EditCrewNameModal)).call(this));_this.state={errors:null};return _this;}_createClass(EditCrewNameModal,[{key:'handleSubmitForm',value:function handleSubmitForm(e){var _this2=this;if(e){e.preventDefault();}var isValid=this.refs.input.value.length>2&&this.refs.input.value.match(/^[a-zA-Z0-9-' ]+$/);if(isValid){this.setState({errors:null},function(){//this.props.submitHandler(this.refs.input.value.trim());
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__b5_crew_management_edit_combatant_operations__["g" /* editCrewName */])(_this2.refs.input.value.trim());//Just close it right away.
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions__["b" /* setMatchmakingValue */])({isCrewNameModalOption:false});});}else{this.setState({errors:"Invalid team name!"});}}},{key:'handleCloseCrewNameModal',value:function handleCloseCrewNameModal(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions__["b" /* setMatchmakingValue */])({isCrewNameModalOption:false});}},{key:'renderErrors',value:function renderErrors(){if(this.state.errors){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:"red",padding:"1.3em",textAlign:"center"}},this.state.errors);}return null;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__LobbyModal__["a" /* default */],{title:'Change Crew Name',handleCloseCallback:this.handleCloseCrewNameModal.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'Modal__paragraph'},'What is your Crew\'s name?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.handleSubmitForm.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'NameTextInput',style:{width:"95%"},defaultValue:this.props.crewName,ref:'input',type:'text',autoFocus:true,autoComplete:'off',autoCorrect:'off',autoCapitalize:'off',spellCheck:'false'}),this.renderErrors()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Modal__btn-container',style:{paddingTop:"3em"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__LobbyCTA__["a" /* default */],{text:'Change Name',handler:this.handleSubmitForm.bind(this),isPrimary:false})))));}}]);return EditCrewNameModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{//someProp: state.something.someProp
crewName:state.crew.name};})(EditCrewNameModal));

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LobbyModal__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__battle_BattleLobbyShareLink_js__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__init_store__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import LobbyCTA from './LobbyCTA'
var FullteamInviteModal=function(_React$Component){_inherits(FullteamInviteModal,_React$Component);function FullteamInviteModal(){_classCallCheck(this,FullteamInviteModal);return _possibleConstructorReturn(this,(FullteamInviteModal.__proto__||Object.getPrototypeOf(FullteamInviteModal)).apply(this,arguments));}_createClass(FullteamInviteModal,[{key:"getText",value:function getText(){if(__WEBPACK_IMPORTED_MODULE_3__init_store__["a" /* default */].getState().matchmaking.currentRoomType==="open"){return"Up to six players can participate in this Rally Battle. Send or Share this Battle invite link to your friends - they will join you in this space.";}return"Send this Battle link to a friend. They will join you in this space. May the best Crew win!";}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__LobbyModal__["a" /* default */],{title:"Get Invite Link",handleCloseCallback:this.props.handleCloseCallback},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"Modal__paragraph"},this.getText()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"Modal__paragraph"},"Your invite link is"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__battle_BattleLobbyShareLink_js__["a" /* default */],null)));}}]);return FullteamInviteModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (FullteamInviteModal);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getClassIcon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__battle_ArenaView_SubmissionMenu_icon_svg_getters_icon_folder__ = __webpack_require__(66);
function getClassIcon(){var rpgClass=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var size=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"1em";var style=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};if(rpgClass==="dps"){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__battle_ArenaView_SubmissionMenu_icon_svg_getters_icon_folder__["a" /* getOffenseIcon */])(size,Object.assign({background:"#81455B",border:"0.2em solid #612F41"},style));}if(rpgClass==="support"){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__battle_ArenaView_SubmissionMenu_icon_svg_getters_icon_folder__["b" /* getSupportIcon */])(size,Object.assign({background:"#E9AA5F",//fill gaps between pixels in Svg
border:"0.2em solid #67632A"},style));}if(rpgClass==="disrupt"){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__battle_ArenaView_SubmissionMenu_icon_svg_getters_icon_folder__["c" /* getDisruptIcon */])(size,Object.assign({background:"#6378FF",border:"0.2em solid #293893"},style));}console.warn('rpgClass not recognized',rpgClass);return"";}

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSeenUnlocksFromLocalstorage;
/* harmony export (immutable) */ __webpack_exports__["b"] = setSeenUnlocksInLocalstorage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__b5_unlocks_getUserUnlocks__ = __webpack_require__(37);
function getSeenUnlocksFromLocalstorage(){var seenUnlocks=window.localStorage.getItem("seenUnlocks");if(seenUnlocks){return seenUnlocks.split(',');//formatted as userUnlocksString below -> turn it back into an array
}return[];}function setSeenUnlocksInLocalstorage(){var userUnlocksString=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__b5_unlocks_getUserUnlocks__["b" /* getUserUnlocksCompletedKeys */])().join(',');window.localStorage.setItem("seenUnlocks",userUnlocksString);}

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getEnvelopeSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function getEnvelopeSvg(style,className){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:className,style:style,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 28 21",shapeRendering:"crispEdges"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M1 0h26M0 1h28M0 2h4M24 2h4M0 3h2M3 3h2M23 3h2M26 3h2M0 4h2M4 4h2M22 4h2M26 4h2M0 5h2M5 5h2M21 5h2M26 5h2M0 6h2M6 6h2M20 6h2M26 6h2M0 7h2M7 7h2M19 7h2M26 7h2M0 8h2M8 8h2M18 8h2M26 8h2M0 9h2M9 9h2M17 9h2M26 9h2M0 10h2M9 10h3M16 10h3M26 10h2M0 11h2M8 11h2M11 11h2M15 11h2M18 11h2M26 11h2M0 12h2M7 12h2M12 12h4M19 12h2M26 12h2M0 13h2M6 13h2M20 13h2M26 13h2M0 14h2M5 14h2M21 14h2M26 14h2M0 15h2M4 15h2M22 15h2M26 15h2M0 16h2M3 16h2M23 16h2M26 16h2M0 17h4M24 17h4M0 18h3M25 18h3M0 19h28M1 20h26"}));}

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getSeenModalFromLocalstorage;
/* harmony export (immutable) */ __webpack_exports__["c"] = setSeenModalInLocalstorage;
/* harmony export (immutable) */ __webpack_exports__["a"] = getHasSignedUpFromLocalstorage;
/* harmony export (immutable) */ __webpack_exports__["d"] = setHasSignedUpInLocalstorage;
//Have I seen the modal?
function getSeenModalFromLocalstorage(){return window.localStorage.getItem("hasSeenEmailModal");}//Set that I've seen the modal
function setSeenModalInLocalstorage(){window.localStorage.setItem("hasSeenEmailModal",true);}//Have I opted in before?
function getHasSignedUpFromLocalstorage(){return window.localStorage.getItem("hasSignedUpFromEmailModal");}//Set that I have opted in
function setHasSignedUpInLocalstorage(){window.localStorage.setItem("hasSignedUpFromEmailModal",true);}

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isNameValid;
/* harmony export (immutable) */ __webpack_exports__["a"] = isEmailValid;
/* harmony export (immutable) */ __webpack_exports__["b"] = submitEmail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
function isNameValid(string){if(string.length<2){return false;}var re=/^[a-zA-Z0-9-' ]+$/;return re.test(string);}function isEmailValid(string){/* eslint-disable */var re=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;/* eslint-enable */return re.test(string);}function submitEmail(emailAddress,callback){var submissionString="https://thedangercrew.us13.list-manage.com/subscribe/post-json?u=467755aba42db48795fa86c95&id=b40db07f16&c=?&EMAIL="+emailAddress;var axiosInstance=__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({withCredentials:true});axiosInstance.get(submissionString).then(function(response){callback();}).catch(function(error){//Mailchimp throws weird cross domain errors, but the submission goes through anyway.
//Just handle the success here...
callback();});}

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ArenaView_RolloutMessageBox__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ArenaView_ArenaSubmissionMenu__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ArenaView_CombatantTeam__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ArenaView_ArenaView_css__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ArenaView_ArenaView_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ArenaView_ArenaView_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ArenaView_SubmissionMenu_ArenaMenuBrain_js__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__get_combatant_id_from_selecting_string__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ArenaView_ArenaTransitionOverlay__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ArenaView_ArenaBackgroundStyle__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__audio_AudioControl_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ArenaView_ArenaEnvironmentBackground__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ArenaView_TauntButton__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ArenaView_TauntTextbox__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ArenaMainLaptopContainer__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DesktopSelectingCombatantTab__ = __webpack_require__(313);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ArenaView=function(_React$Component){_inherits(ArenaView,_React$Component);function ArenaView(){_classCallCheck(this,ArenaView);return _possibleConstructorReturn(this,(ArenaView.__proto__||Object.getPrototypeOf(ArenaView)).apply(this,arguments));}_createClass(ArenaView,[{key:"getTeamOrientation",//Get a map of which row is the Pwlayer's team.
// Enemy team should always be on Top row
// Player team should always be on the Bottom row.
value:function getTeamOrientation(){if(!this.props.battlePlayerIds.length){//Handle the case where no battlePlayerIds are defined. (all bots)
return{//Just roll with something
topTeam:"two",bottomTeam:"one"};}var playerTeam=this.props.combatants[this.props.battlePlayerIds[0]].belongsToTeam;return{topTeam:playerTeam==="one"?"two":"one",bottomTeam:playerTeam==="one"?"one":"two"};}//Return true if the currently selecting string is me (or you know, one of the me's in my battlePlayerIds array)
},{key:"isMenuOpen",value:function isMenuOpen(){var _props=this.props,combatantSelectingAction=_props.combatantSelectingAction,battlePlayerIds=_props.battlePlayerIds;var useCombId=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__get_combatant_id_from_selecting_string__["a" /* getCombatantIdFromSelectingString */])(combatantSelectingAction);if(combatantSelectingAction.match(/^cloudQueueAction::/)){return false;}return battlePlayerIds.includes(useCombId);}},{key:"render",value:function render(){var _props2=this.props,arenaAnimationComponent=_props2.arenaAnimationComponent,viewportHeight=_props2.viewportHeight;var style={position:"relative",height:viewportHeight};//Get the top row vs bottom row combatants
var teamOrientation=this.getTeamOrientation();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ArenaView",style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ArenaView_ArenaEnvironmentBackground__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ArenaView_ArenaBackgroundStyle__["a" /* default */],null),this.isMenuOpen()&&this.props.arenaSubmissionMenuCombatantIdLock&&!this.props.arenaSubmissionIsSubmitted?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ArenaView_SubmissionMenu_ArenaMenuBrain_js__["a" /* default */],null):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ArenaView_CombatantTeam__["a" /* default */],{isEnemyTeam:true,combatantIds:this.props.teams[teamOrientation.topTeam].combatantIds}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ArenaView_CombatantTeam__["a" /* default */],{isEnemyTeam:false,combatantIds:this.props.teams[teamOrientation.bottomTeam].combatantIds}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__DesktopSelectingCombatantTab__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ArenaMainLaptopContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ArenaView_RolloutMessageBox__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ArenaView_ArenaSubmissionMenu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ArenaView_TauntButton__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ArenaView_TauntTextbox__["a" /* default */],null),arenaAnimationComponent||null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ArenaView_ArenaTransitionOverlay__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__audio_AudioControl_js__["a" /* default */],null));}}]);return ArenaView;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{combatants:state.battle.combatants,teams:state.battle.teams,vW:state.global.vW,viewportHeight:state.global.viewportHeight,//someProp: state.something.someProp,
arenaAnimationComponent:state.battle.arenaAnimationComponent,combatantSelectingAction:state.battle.combatantSelectingAction,battlePlayerIds:state.battle.battlePlayerId,//The array of player controlled combatantIds
//Lock the ArenaBrain from mounting again until this flag has a value. It gets nulled out after usage.
arenaSubmissionMenuCombatantIdLock:state.battle.arenaSubmissionMenuCombatantIdLock,arenaSubmissionIsSubmitted:state.battle.arenaSubmissionIsSubmitted//final flag
};})(ArenaView));

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = arenaSubmitFinalAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__get_combatant_id_from_selecting_string_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SubmissionHomeMenu_js__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SubmissionListViewMenu__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__is_submission_menu_open__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ArenaSubmissionMenuBackButton__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SubmissionMenu_SubmissionTargetMenu__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lifecycle_submit_action_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__audio_audio_manager_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ArenaSubmission_css__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ArenaSubmission_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ArenaSubmission_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/** THIS IS JUST FOR DEV TESTING. I ASSUME THIS WILL BE REPLACED WITH A TRUE MENU IMPLEMENTATION */var ArenaSubmissionMenu=function(_React$Component){_inherits(ArenaSubmissionMenu,_React$Component);function ArenaSubmissionMenu(){_classCallCheck(this,ArenaSubmissionMenu);return _possibleConstructorReturn(this,(ArenaSubmissionMenu.__proto__||Object.getPrototypeOf(ArenaSubmissionMenu)).apply(this,arguments));}_createClass(ArenaSubmissionMenu,[{key:'renderRelevantForm',value:function renderRelevantForm(){//Final Step: Action is deployed
if(this.props.arenaSubmissionIsSubmitted){return null;}// //Step 3: might get a TIMING CHALLENGE
//TODO: leaving this here for a bit for reference in case we want to put this back
// if (
//   this.props.arenaSubmissionMenuAction && //have action loaded up
//   this.props.arenaSubmissionMenuAction.hasTimedHitBonusAvailable && //that has a timed opportunity
//   this.props.arenaSubmissionMenuTargets //and target model is loaded up
// ) {
//   return <TimingChallenge />
// }
var viewId=this.props.arenaMenuSnapshot.viewId;//Step 2: pick a target
if(viewId==="targetsView"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SubmissionMenu_SubmissionTargetMenu__["a" /* default */],{vW:this.props.vW,arenaSubmissionMenuAction:this.props.arenaSubmissionMenuAction,arenaMenuSnapshot:this.props.arenaMenuSnapshot});}//If we are in a transition state (rootView), don't render any menu UI
//This is below TimingChallenge because we might have the TimingChallenge up
if(viewId==="rootView"){return null;}if(viewId==="specialsView"||viewId==="itemsView"||viewId==="supersView"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SubmissionListViewMenu__["a" /* default */],null);}//Step 1: pick an action
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SubmissionHomeMenu_js__["a" /* default */],null);}},{key:'renderBackButton',value:function renderBackButton(){var viewId=this.props.arenaMenuSnapshot.viewId;if(viewId==="specialsView"||viewId==="itemsView"||viewId==="supersView"){//Return a back button with the list-view Back option specified. All ListViews share this.
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ArenaSubmissionMenuBackButton__["a" /* default */],{optionId:'listview-back',menuModel:this.props.arenaMenuSnapshot});}if(viewId==="targetsView"){//Return a back button with the targeting step Back option specified
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ArenaSubmissionMenuBackButton__["a" /* default */],{optionId:'target-back',menuModel:this.props.arenaMenuSnapshot});}//Otherwise, no Back button
return null;}},{key:'getStyle',value:function getStyle(){var baseStyle={color:"#eee"};//TODO TODO TODO: This stuff will likely move to the ArenaMainLaptopContainer
//TODO: then this stuff can go away
//Get Desktop Styles
if(this.props.viewportMode==="landscape"){return Object.assign({},baseStyle);}//Otherwise assume Mobile
return Object.assign({},baseStyle);}},{key:'render',value:function render(){if(!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__is_submission_menu_open__["a" /* isSubmissionMenuOpen */])()){//extracted this stuff so other things could use it.
return null;}var combatantSelectingAction=this.props.combatantSelectingAction;var useCombId=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_combatant_id_from_selecting_string_js__["a" /* getCombatantIdFromSelectingString */])(combatantSelectingAction);//Style the top bar
var topBarStyle={// paddingLeft: "4em",
// paddingRight: "4em",
display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"0.5em",fontSize:"0.5em",height:"4em",borderBottom:"0.3em solid rgba(255,255,255,0.1)"};var ppStyle={opacity:"rgba(255,255,255,0.5)"};var mainContentStyle={// paddingLeft: "4em",
// paddingRight: "4em",
};//Get selecting combatant
var selectingCombatantModel=this.props.combatants[useCombId];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:topBarStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.renderBackButton()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:Object.assign({},ppStyle,{marginRight:"2em"})},'HP ',selectingCombatantModel.hp,'/',selectingCombatantModel.maxHp),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:ppStyle},'PP ',selectingCombatantModel.pp,'/',selectingCombatantModel.maxPp))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:mainContentStyle},this.renderRelevantForm()));}}]);return ArenaSubmissionMenu;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{vW:state.global.vW,viewportMode:state.global.viewportMode,combatantSelectingAction:state.battle.combatantSelectingAction,arenaSubmissionMenuCombatantIdLock:state.battle.arenaSubmissionMenuCombatantIdLock,battlePlayerIds:state.battle.battlePlayerId,//The array of player controlled combatantIds
combatants:state.battle.combatants,//Arena Submission progress
arenaSubmissionMenuAction:state.battle.arenaSubmissionMenuAction,//arenaSubmissionMenuCaster: state.battle.arenaSubmissionMenuCaster, //can be computed
arenaSubmissionMenuTargets:state.battle.arenaSubmissionMenuTargets,arenaSubmissionIsSubmitted:state.battle.arenaSubmissionIsSubmitted,//final flag
arenaMenuSnapshot:state.battle.arenaMenuSnapshot};})(ArenaSubmissionMenu));/* Submit all data into the cycle *//* Timing challenge component should do this on completion */function arenaSubmitFinalAction(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions_js__["a" /* setBattleValue */])({arenaSubmissionIsSubmitted:true,arenaSubmissionMenuCombatantIdLock:null//CLEAR THE LOCK OUT
});//Pull data needed for submission
var _store$getState$battl=__WEBPACK_IMPORTED_MODULE_9__init_store_js__["a" /* default */].getState().battle,arenaSubmissionMenuAction=_store$getState$battl.arenaSubmissionMenuAction,combatants=_store$getState$battl.combatants,combatantSelectingAction=_store$getState$battl.combatantSelectingAction,arenaSubmissionMenuTargets=_store$getState$battl.arenaSubmissionMenuTargets;//Play sound effect (if the TimingChallenge did not already do it, like for generic attack)
//TODO: The exact SFX firing might get reworked when implementing the actual design of the Submission Menu
//if (arenaSubmissionMenuAction.actionMeta.actionId !== "attack_generic-attack") {
//Play regular SFX
__WEBPACK_IMPORTED_MODULE_11__audio_audio_manager_js__["a" /* default */].playSfx("sfx_submitAction");//}
//Submit!
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lifecycle_submit_action_js__["a" /* submitAction */])(arenaSubmissionMenuAction,combatants[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_combatant_id_from_selecting_string_js__["a" /* getCombatantIdFromSelectingString */])(combatantSelectingAction)],arenaSubmissionMenuTargets);}

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getIcon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icon_folder__ = __webpack_require__(66);
//Get an icon based on the category
function getIcon(categoryName,width){if(categoryName==="offense"){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__icon_folder__["a" /* getOffenseIcon */])(width);}if(categoryName==="boosting"||categoryName==="healing"){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__icon_folder__["b" /* getSupportIcon */])(width);}if(categoryName==="cursing"||categoryName==="theft"){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__icon_folder__["c" /* getDisruptIcon */])(width);}if(categoryName==="item"){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__icon_folder__["d" /* getItemIcon */])(width);}if(categoryName==="stolen-item"){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__icon_folder__["e" /* getStolenItemIcon */])(width);}if(categoryName==="directory"){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__icon_folder__["f" /* getFolderIcon */])(width);}if(categoryName==="speech"){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__icon_folder__["g" /* getSpeechIcon */])(width);}return null;}

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubmissionMenu_icon_svg_getters_icon_categories_js__ = __webpack_require__(143);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import {getColorIconBase} from './SubmissionMenu/icon-svg-getters/get-color-icon.js'
var SubmissionMenuOption=function(_React$Component){_inherits(SubmissionMenuOption,_React$Component);function SubmissionMenuOption(){_classCallCheck(this,SubmissionMenuOption);return _possibleConstructorReturn(this,(SubmissionMenuOption.__proto__||Object.getPrototypeOf(SubmissionMenuOption)).apply(this,arguments));}_createClass(SubmissionMenuOption,[{key:'handleClick',//TODO: Remove/edit this, but reuse the click handler
value:function handleClick(e){e.preventDefault();this.props.handleClick(this.props.model);}},{key:'handleHover',value:function handleHover(e){this.props.handleHover(this.props.model);}},{key:'getColors',value:function getColors(){var model=this.props.model;if(model.isSelected&&!this.props.isTouchMode){if(model.isUnavailable){//selected but not able to submit
return{background:"linear-gradient( to top, #696969 0%,#696969 90%,#5E5E5E 90.0%,#5E5E5E 100%)",//disabled gray
color:"#C8C8C8"//dark terminal bg color
};}//selected for real!
return{//background: "#69F8BF", //computer hacky green
background:"linear-gradient( to top, #83FFCE 0%,#83FFCE 90%,#66EEB8 90.0%,#66EEB8 100%)",//computery green
color:"#042129"//dark terminal bg color
};}//NOTE: There is a weird problem with `isDisabled` where the cursor is blocked from arrowing through?
//If ITEMS is disabled, you cannot access SUPER. It's super weird. Switching to isUnavailable which allows cursoring
if(model.isDisabled||model.isUnavailable){//disabled: gray and sad (not selected)
return{color:"#666"};}//Default. Available but not selected
return{color:"#FCFCFC"//whiteish
};}// getDangerMeterProgress() {
//   const style = {
//     display: "inline-block",
//     marginLeft: "1em"
//   };
//   return (
//     <span style={style}>[{this.props.model.viewBag.dangerMeter}]</span>
//   )
// }
},{key:'getMetaStyle',value:function getMetaStyle(){var model=this.props.model;if(model.isSelected&&!this.props.isTouchMode&&model.isUnavailable){return{color:"#FB6B6B"//red
};}return{};}// getRevertBadge() {
//   const style = {
//     display: "inline-block",
//     marginLeft: "2em",
//     fontSize: "0.7em"
//   };
//   return (
//     <span style={style}>Commit Available</span>
//   )
// }
//
// renderSuperChargeOption(style, iconStyle) {
//
//   return (
//     <a href="#" className="ArenaSubmissionOption" style={style} onClick={this.handleClick.bind(this)}
//        onMouseEnter={this.handleHover.bind(this)}>
//       <span style={iconStyle}/>
//       <span className="ArenaSubmissionOption-label">
//         {this.props.model.viewBag.superName}
//       </span>
//       <span>{this.getDangerMeterProgress()}</span>
//       <span>{ this.props.model.viewBag.hasRevertAvailable ? this.getRevertBadge() : null}</span>
//     </a>
//   );
// }
},{key:'render',value:function render(){var model=this.props.model;var optionTextContainerStyle=Object.assign({padding:"1em 1em"},this.getColors());var iconContainerStyle={display:"block",marginRight:"0.5em"};var iconCellStyle={boxShadow:"0 0.25em 0 0 rgba(0,0,0,0.3)"};var iconSvg=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__SubmissionMenu_icon_svg_getters_icon_categories_js__["a" /* getIcon */])(model.viewBag.actionCategory,"1.8em");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ArenaSubmissionOption',href:'#',onClick:this.handleClick.bind(this),onMouseOver:this.handleHover.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:iconContainerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:iconCellStyle},iconSvg)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ArenaSubmissionOption-label',style:optionTextContainerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,model.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ArenaSubmissionOption-meta',style:this.getMetaStyle()},model.viewBag.metaData||null)));}}]);return SubmissionMenuOption;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* eslint jsx-a11y/href-no-hash: "off" *//* harmony default export */ __webpack_exports__["a"] = (SubmissionMenuOption);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConsoleView_css__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConsoleView_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ConsoleView_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConsoleView_Combatant__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConsoleViewRollout__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__get_combatant_id_from_selecting_string__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConsoleView=function(_React$Component){_inherits(ConsoleView,_React$Component);function ConsoleView(){_classCallCheck(this,ConsoleView);return _possibleConstructorReturn(this,(ConsoleView.__proto__||Object.getPrototypeOf(ConsoleView)).apply(this,arguments));}_createClass(ConsoleView,[{key:"renderConnectedBotWarning",value:function renderConnectedBotWarning(){//This is an edge case check.. but if you are "in your own browser as a Bot", don't send any ViewConfirmation
if(this.props.isConnectedAsBot){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"THIS IS A BOT. YOU ARE A BOT.");}return null;}},{key:"renderMasterStatus",value:function renderMasterStatus(){if(this.props.isMultiplayerMasterClient){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"MASTER");}return null;}},{key:"render",value:function render(){var _props=this.props,combatants=_props.combatants,combatantSelectingAction=_props.combatantSelectingAction,teams=_props.teams,battlePlayerId=_props.battlePlayerId,serverRoomConnections=_props.serverRoomConnections;if(!serverRoomConnections){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"No `connections` object!");}var useCombId=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__get_combatant_id_from_selecting_string__["a" /* getCombatantIdFromSelectingString */])(combatantSelectingAction);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,combatantSelectingAction,this.renderMasterStatus(),this.renderConnectedBotWarning(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ConsoleView-columns-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ConsoleView-main-area"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,teams["two"].combatantIds.map(function(combId,i){//TODO `isPlayerControlled` should check an array
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ConsoleView_Combatant__["a" /* default */],{key:i,model:combatants[combId],isSelectingAction:useCombId===combId,isPlayerControlled:battlePlayerId.includes(combId),isConnected:Boolean(serverRoomConnections[combId])});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,teams["one"].combatantIds.map(function(combId,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ConsoleView_Combatant__["a" /* default */],{key:i,model:combatants[combId],isSelectingAction:useCombId===combId,isPlayerControlled:battlePlayerId.includes(combId),isConnected:Boolean(serverRoomConnections[combId])});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ConsoleView-rollout-area"},this.props.isConnectedAsBot?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ConsoleViewRollout__["a" /* default */],null))));}}]);return ConsoleView;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){//const myPlayerCombatantModel = state.battle.combatants[ state.battle.battlePlayerId[0] ]; //Assume just one
var playersThatAreNowActuallyBots=state.battle.battlePlayerId.filter(function(id){return state.battle.combatants[id]&&state.battle.combatants[id].isBot;});return{battlePlayerId:state.battle.battlePlayerId,combatantSelectingAction:state.battle.combatantSelectingAction,combatants:state.battle.combatants,teams:state.battle.teams,serverRoomConnections:state.battle.serverRoomConnections,isMultiplayerMasterClient:state.battle.isMultiplayerMasterClient,/*"Browser Bots": I am the browser of a character who is a Bot. This is an edge case, but might become a problem if coming back from leaving*/isConnectedAsBot:playersThatAreNowActuallyBots.length>0};})(ConsoleView));

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return attackList; });
/* harmony export (immutable) */ __webpack_exports__["a"] = getPlayerLoadout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Fixture_combatants_js__ = __webpack_require__(24);
// import makeId from "../helpers/make-id.js";
var attackList=[//Supers
{actionId:"special_wildfire"},{actionId:"special_team-slice"},{actionId:"special_team-foreach"},{actionId:"special_team-revive"},{actionId:"special_team-clean"},{actionId:"special_commit"},{actionId:"special_revert"},{actionId:"special_sql-drop"},//Special
{actionId:"special_thrash"},{actionId:"special_bug"},{actionId:"special_promise"},{actionId:"special_stash"},{actionId:"special_scrum"},{actionId:"special_firewall"},{actionId:"special_foreach"},{actionId:"special_slice"},{actionId:"special_garbage-jammer"},{actionId:"special_ddos"},{actionId:"special_copy-paste"},{actionId:"special_curl"},{actionId:"special_curl-mk2"},{actionId:"special_sql-injection"},{actionId:"special_clean"},{actionId:"special_headphones"},{actionId:"special_deadline"},{actionId:"special_scope-bomb"},{actionId:"special_troll"},{actionId:"special_screen-crack"}];function getPlayerLoadout(){return Object.assign({},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Fixture_combatants_js__["a" /* getRandomLoadout */])());}

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__b5_unlocks_getUserBattleRecord_js__ = __webpack_require__(86);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserCrewRecord=function(_React$Component){_inherits(UserCrewRecord,_React$Component);function UserCrewRecord(){_classCallCheck(this,UserCrewRecord);return _possibleConstructorReturn(this,(UserCrewRecord.__proto__||Object.getPrototypeOf(UserCrewRecord)).apply(this,arguments));}_createClass(UserCrewRecord,[{key:"renderRow",value:function renderRow(statLabel,statNumber){var style={display:"flex",justifyContent:"space-between"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,statLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,statNumber));}},{key:"render",value:function render(){var containerStyle={lineHeight:"2.3em"};var groupStyle={paddingBottom:"1em",borderBottom:"0.2em solid #d1d1d2",marginBottom:"1.7em"};var record=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__b5_unlocks_getUserBattleRecord_js__["a" /* getRecord */])();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:containerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:groupStyle},this.renderRow("TOTAL BATTLES",record.totalBattles),this.renderRow("Wins",record.totalWins),this.renderRow("Losses",record.totalLosses)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,this.renderRow("Quick Battle Wins",record.quickBattleWins),this.renderRow("Versus Battle Wins",record.fullteamBattleWins),this.renderRow("Rally Battle Wins",record.openBattleWins)));}}]);return UserCrewRecord;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{};})(UserCrewRecord));

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trackHpOfTeams;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__analysis_team_analysis_utilities_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__ = __webpack_require__(2);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function trackHpOfTeams(){var teams=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.teams;var combatants=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatants;var teamOneCombatants=teams["one"].combatantIds.map(function(combId){return combatants[combId];});var teamTwoCombatants=teams["two"].combatantIds.map(function(combId){return combatants[combId];});var report=[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__analysis_team_analysis_utilities_js__["c" /* getTeamHpRating */])(teamOneCombatants),__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__analysis_team_analysis_utilities_js__["c" /* getTeamHpRating */])(teamTwoCombatants)];//Add report to list of HP reports (will use at the end of battle for tracking)
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["a" /* setBattleValue */])({hpRatingsOfTeamsPerTurnSeries:[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.hpRatingsOfTeamsPerTurnSeries),[report])});}

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSelfServingTeamOrder;
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/** Take in caster and teamCombatants, return a sorted list with caster first or last depending on selfServing value  */function getSelfServingTeamOrder(casterModel,teamCombatants){var teamWithoutCaster=teamCombatants.filter(function(comb){return comb.id!==casterModel.id;});//Return caster first if isSelfServing
if(casterModel.isSelfServing){return[casterModel].concat(_toConsumableArray(teamWithoutCaster));}//otherwise, return caster last
return[].concat(_toConsumableArray(teamWithoutCaster),[casterModel]);}

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = addQueuedSubmissions;
/* harmony export (immutable) */ __webpack_exports__["a"] = extractQueuedSubmissions;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeQueueSlot;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_range__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function addQueuedSubmissions(){var queue=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var submission=arguments[1];var turnsToWait=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;if(turnsToWait<1){console.warn("turnsToWait must be 1 or more ");return[];}var newLength=queue.length>turnsToWait?queue.length//output is going to have the same length as our current queue
:turnsToWait;//output will be longer than our current queue (this is setting in the last position)
var addToIndex=turnsToWait-1;return __WEBPACK_IMPORTED_MODULE_0_lodash_range___default()(newLength).map(function(index){var turnActions=(queue[index]||{}).actions||[];var addToActions=addToIndex===index?[Object.assign({},submission)]:[];return{turnSpot:true,actions:[].concat(_toConsumableArray(turnActions),addToActions)};});}function extractQueuedSubmissions(){var queue=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];/* Check the first in queue line for submissions. Return empty turnModel if no length */return queue.length?queue[0]:{turnSpot:true,actions:[]};}function removeQueueSlot(){var queue=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];/* Move the queue train forward by removing the first in the queue*/return queue.filter(function(d,i){return i>0;});}

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sendReadyToFirebase;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
function sendReadyToFirebase(callback){var myId=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().crew.logggedInUserId;window.roomRef.child('readyClients').child(myId).set(true).then(callback);}

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBattleType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
function getBattleType(){//Quick utility for providing the right data to update the battle record.
if(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.isMultiplayerMode){return __WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().matchmaking.currentRoomType||"unknownRoomType";}else{return"quick";//Assume offline quick play.
}}

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTargets;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__battle_data_battle_actions_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_models_from_object_js__ = __webpack_require__(18);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function getTargets(){var actionId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var combatantTeamId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";var casterId=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"";var model=__WEBPACK_IMPORTED_MODULE_1__battle_data_battle_actions_js__["a" /* default */][actionId];if(!model){console.warn("no action found",actionId);}if(!casterId){console.warn("no casterId found in getTargets");}var combatants=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatants;/* Get allies and enemies. Allies  */var myTeam=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_models_from_object_js__["a" /* modelsFromObject */])(combatants).filter(function(c){return c.belongsToTeam===combatantTeamId;});var enemyTeam=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_models_from_object_js__["a" /* modelsFromObject */])(combatants).filter(function(c){return c.belongsToTeam!==combatantTeamId;});// const allFriendlyIds = myTeam.map(c => c._id);
// const allEnemyIds = enemyTeam.map(c => c._id);
var aliveFriendlyIds=myTeam.filter(function(c){return c.isAlive();}).map(function(c){return c._id;});var aliveEnemyIds=enemyTeam.filter(function(c){return c.isAlive();}).map(function(c){return c._id;});var deadFriendlyIds=myTeam.filter(function(c){return!c.isAlive();}).map(function(c){return c._id;});var deadEnemyIds=enemyTeam.filter(function(c){return!c.isAlive();}).map(function(c){return c._id;});//Only can target myself
if(model.targetType==="only-me"){return[casterId];//["myId"]
}//Can target ONE opponent
if(model.targetType==="single-opponent"){if(model.targetMustBeDead){return deadEnemyIds;}return aliveEnemyIds;//["myOpponent1","myOpponent1"]
}//Can target ONE ally (includes me as an option)
if(model.targetType==="single-ally"){if(model.targetMustBeDead){return deadFriendlyIds;}return aliveFriendlyIds;//["myId","myFriend1","myFriend2"]
}//Can only target ENTIRE opponent team
if(model.targetType==="opponent-team"){//TODO: Might need "even if they are dead" flag. -> Stealing items, etc. This would not target dead people to steal or bug items. might cause problems?
//Some moves can target both dead and alive (item stuff)
if(model.targetCanBeDead){var conjoinedAllEnemies=[].concat(_toConsumableArray(deadEnemyIds),_toConsumableArray(aliveEnemyIds)).join(",");return[conjoinedAllEnemies];}return[aliveEnemyIds.join(",")];//["myOpponent1,myOpponent2"]... notice the comma delimited string
}//Can only target ENTIRE friendly team
if(model.targetType==="ally-team"){if(model.targetMustBeDead){//Only dead friends...
return[deadFriendlyIds.join(",")];//["myId", "myFriend1,myFriend2"]... notice the comma delimited string
}return[aliveFriendlyIds.join(",")];//["myId", "myFriend1,myFriend2"]... notice the comma delimited string
}//Get ALL (Commit, etc)
if(model.targetType==="all"){return[Object.keys(combatants).join(",")];}console.warn("no return in getTarget",model.targetType,model);}

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildTeamsFromClientBuddies;
/** Return a Teams model that has even teams (doesnt care about wantsToJoinTeam property) */function buildTeamsFromClientBuddies(){var combatants=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var teamOneCombatantIds=[];var teamTwoCombatantIds=[];//Identify the humans
var humanKeys=Object.keys(combatants).filter(function(comb){var model=combatants[comb];return!model.isBot&&!model.isBuddy;});if(humanKeys[0]){teamOneCombatantIds.push(humanKeys[0]);}if(humanKeys[1]){teamTwoCombatantIds.push(humanKeys[1]);}//Sort into two teams
Object.keys(combatants).forEach(function(combId,i){//If it's a Buddy, look at their belongsToClient property.
var model=combatants[combId];if(model&&model.isBuddy){if(model.belongsToClient===humanKeys[0]){teamOneCombatantIds.push(combId);}if(model.belongsToClient===humanKeys[1]){teamTwoCombatantIds.push(combId);}}});return{"one":{combatantIds:teamOneCombatantIds},"two":{combatantIds:teamTwoCombatantIds}};}

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildTeamsFromCombatantData;
/** Take in raw combatant data and provide team infrastructure */function buildTeamsFromCombatantData(){var combatants=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var result={"one":{combatantIds:[]},"two":{combatantIds:[]}};Object.keys(combatants).forEach(function(combId){var model=combatants[combId];//Add my ID to the team's list
result[model.wantsToJoinTeam].combatantIds.push(combId);});return Object.assign({},result);}/* Example output: //Seems funny now, but we used to include more data on here (like items). That's why it's an object.
//Can still include more in the future if needbe!
{
 "one": {
        combatantIds: ["someId_aaa", "someId_bbb"],
    },
 "two": {
        combatantIds: ["someId_ccc"],
    }
 }
 */

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDescriptionObjectFromSubmission;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__description_danger_meter__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__description_pp__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__description_hp__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__description_status__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__description_stats__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__description_items__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__description_stealing__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__description_bugging__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__description_fail__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__description_miss__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__description_followups__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__description_commit_revert_stash__ = __webpack_require__(355);
/** This needs to look at the Action, provide a change object per combatant */function getDescriptionObjectFromSubmission(actionModel,casterModel){var targetModels=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var combatants=arguments[3];//Establish the IDs of caster vs targets
var combatantMap={casterId:casterModel.id,//"c"
targetIds:targetModels.map(function(targetModel){return targetModel.id;})//["a", "b"]
};//Create empty objects for each combatants to track state changes.
//`description` functions will fill in these objects.
var currentCombatantStateChanges={state:{},//the combatants new state that will get merged in
description:{}//extra bit of data we need to capture (item stolen, damage done, was it effective, etc)
};//Add Caster
currentCombatantStateChanges.state[casterModel.id]={};//Add Targets
combatantMap.targetIds.forEach(function(targetId){currentCombatantStateChanges.state[targetId]={};});//Run our stateChanges object through our suite of `description` functions
currentCombatantStateChanges=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__description_danger_meter__["a" /* getDangerMeterChanges */])(actionModel,combatantMap,currentCombatantStateChanges,combatants);currentCombatantStateChanges=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__description_pp__["a" /* getPpChanges */])(actionModel,combatantMap,currentCombatantStateChanges,combatants);currentCombatantStateChanges=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__description_fail__["a" /* getFail */])(actionModel,combatantMap,currentCombatantStateChanges,combatants);//failing
currentCombatantStateChanges=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__description_miss__["a" /* getMiss */])(actionModel,combatantMap,currentCombatantStateChanges,combatants);//missing
currentCombatantStateChanges=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__description_items__["a" /* getItemChanges */])(actionModel,combatantMap,currentCombatantStateChanges,combatants);//remove item from inventory (effects of item are below)
//Stop here if FAIL, MISS, or BUGGED
if(currentCombatantStateChanges.didFail||currentCombatantStateChanges.didMiss||currentCombatantStateChanges.wasBugged){return currentCombatantStateChanges;}currentCombatantStateChanges=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__description_hp__["a" /* getHpChanges */])(actionModel,combatantMap,currentCombatantStateChanges,combatants);currentCombatantStateChanges=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__description_status__["a" /* getStatusChanges */])(actionModel,combatantMap,currentCombatantStateChanges,combatants);currentCombatantStateChanges=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__description_stats__["a" /* getStatChanges */])(actionModel,combatantMap,currentCombatantStateChanges,combatants);currentCombatantStateChanges=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__description_stealing__["a" /* getStealingChanges */])(actionModel,combatantMap,currentCombatantStateChanges,combatants);currentCombatantStateChanges=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__description_bugging__["a" /* getBuggingChanges */])(actionModel,combatantMap,currentCombatantStateChanges,combatants);currentCombatantStateChanges=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__description_followups__["a" /* getFollowupsChanges */])(actionModel,combatantMap,currentCombatantStateChanges,combatants);currentCombatantStateChanges=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__description_commit_revert_stash__["a" /* getCommitRevertStashChanges */])(actionModel,combatantMap,currentCombatantStateChanges,combatants);return currentCombatantStateChanges;}

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = masterSelectsActionForBot;
/* harmony export (immutable) */ __webpack_exports__["b"] = masterSubmitsQueuedAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bot_decisions_get_bot_decision_js__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lifecycle_submit_action_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cloud_queue_encode_decode_js__ = __webpack_require__(87);
//These are used both online and offline
//TODO: This function needs to move out of this file. It is utilized Online and Offline
/* Master submit action form for a bot player (only master does this) */function masterSelectsActionForBot(){var combatantSelectingAction=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var combatants=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatants;var newSelectingCombatantModel=combatants[combatantSelectingAction];//If the next person exists and is a bot, Master needs to submit an aciton for the bot
if(newSelectingCombatantModel&&newSelectingCombatantModel.isBot){//console.log('Master needs to submit an action for the bot');
var decision=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bot_decisions_get_bot_decision_js__["a" /* getBotDecision */])(combatantSelectingAction,combatants,__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.teams);//Submit our new decision. This will create a rollout for bot's action and send up to the server
//and we'll all receive the end result.
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lifecycle_submit_action_js__["a" /* submitAction */])(decision.actionModel,decision.casterModel,decision.targetModels);}}/* Master submits stringified action from the cloudQueue. EX: "cloudQueueAction::actionId::casterId:: etc..." *///TODO: This function needs to move out of this file. It is utilized Online and Offline
function masterSubmitsQueuedAction(){var queuedActionDataString=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var cloudSubmission=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cloud_queue_encode_decode_js__["a" /* decodeCloudQueueActionString */])(queuedActionDataString,__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatants);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lifecycle_submit_action_js__["a" /* submitAction */])(cloudSubmission.actionModel,cloudSubmission.casterModel,cloudSubmission.targetModels);}

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = submitBattleOver;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__handle_new_rollout_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__connection_firebase_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__analysis_track_hp_of_teams_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__get_dead_teams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__analysis_write_tracking_report_to_database_js__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_rollout_message_text_helpers_js__ = __webpack_require__(27);
function submitBattleOver(){//TODO: this block is totally a bandaid. This is getting called when the ID is already "rollout_battle-over"
//TODO: Need to look closer when more focused and less beered
//TODO: UPDATE It might not be that much of a bandaid. It might happen every time? not sure.
if(__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().battle.rolloutId==="rollout_battle-over"){//console.log('stopping battle because rolloutId is `rollout_battle-over`');
return;}//TRACKING ///////////
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__analysis_track_hp_of_teams_js__["a" /* trackHpOfTeams */])();//Include final HP count for tracking (does not affect anything in Battle)
//Future self: this simply records the last HP count in the tracking array. This report may be phased out as we adopt `turnReporting`
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__analysis_write_tracking_report_to_database_js__["a" /* writeTrackingReportToDatabase */])();//side effect
////////////////////
//Figure out if Player team won or lost/////////////
//Get the player model
var playerModel=__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().battle.combatants[__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().battle.battlePlayerId[0]]||{name:"REPORTING-MODE",belongsToTeam:"none"};//provide fallback in case there is no player (Reporting mode, all bots, etc)
//Check dead teams array for the player's team
var didPlayerLose=Boolean(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__get_dead_teams__["a" /* getDeadTeams */])().find(function(teamId){return teamId===playerModel.belongsToTeam;}));//This is the same functionality that submitAction does, but without all the generation of payload
//Create the rollout steps for end of battle
var endingRolloutSteps=[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(playerModel.id),//use colored name
didPlayerLose?'\'s team has been defeated!':'\'s team is victorious!']}];if(__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().battle.isMultiplayerMode){//Note: Only 1 client does this. Whichever client processed the state.
// console.log('submitting ending to the server')
//Online needs to do sendRolloutStepsToServer just like `submitAction`
//sendRolloutStepsToServer(endingRolloutSteps);
//TODO: you should create an alternate server function to replace this guy that does the WHOLE rollout. Just like the client one does.
//Currently, `sendRolloutStepsToServer` does some random ID generation and stuff. You can just provide the whole model
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__connection_firebase_js__["b" /* sendPresetRolloutModelToServer */])({submitterCombatantId:"BATTLE-SYSTEM",rolloutId:"rollout_battle-over",rolloutPayload:endingRolloutSteps});}else{//Offline:
var endingRollout={submitterCombatantId:"BATTLE-SYSTEM",rolloutId:"rollout_battle-over",timestamp:Date.now(),rolloutPayload:endingRolloutSteps};console.warn('battle over');//console.warn('sending of `battle-over` rollout is temporarily disabled. see TODO')
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__handle_new_rollout_js__["a" /* handleNewRollout */])(endingRollout);//TODO: submit battle-over in a way that doesn't cause replay
//It's causing an infinite loop right now because handleRolloutStep doesn't know to stop?
}}

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSiblingInArray;
function getSiblingInArray(array,currentIndex,direction){if(direction==="prev"){//If there is another before this one, return that.
if(currentIndex>0){return array[currentIndex-1];}//Otherwise, return the first one (beginning of list)
return array[array.length-1];}if(direction==="next"){//If there is another skin past this one, return that.
if(array[currentIndex+1]){return array[currentIndex+1];}//Otherwise, return the first one (beginning of list)
return array[0];}console.warn("getSiblingInArray not configured correctly. Direction should be `next` or `prev` ");}

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audio_audio_manager_js__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextLine=function(_React$Component){_inherits(TextLine,_React$Component);function TextLine(){_classCallCheck(this,TextLine);var _this=_possibleConstructorReturn(this,(TextLine.__proto__||Object.getPrototypeOf(TextLine)).call(this));_this.animFrameStep=null;//Keep a reference to the animationFrame step so we can cancel
_this.state={revealedIndex:-1//count upwards
};return _this;}_createClass(TextLine,[{key:"componentDidMount",value:function componentDidMount(){this.revealNext(Date.now()+10);//start X ms after mounting.
}},{key:"componentWillUnmount",value:function componentWillUnmount(){//cancel the frame count on unmount
cancelAnimationFrame(this.animFrameStep);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(newProps){var _this2=this;//We've received instructions to force the text to the end.
if(newProps.isForcedDone){//Cancel anything that has been called.
cancelAnimationFrame(this.animFrameStep);//Warp to the end (assuming 999 is far beyond max)
this.setState({revealedIndex:999},function(){//Then call the final callback
if(typeof _this2.props.onDone==="function"){_this2.props.onDone();}});}}},{key:"revealNext",value:function revealNext(targetTimestamp){var _this3=this;//recursive
var step=function step(){if(Date.now()<targetTimestamp){//Try again next frame and check again
_this3.animFrameStep=requestAnimationFrame(step);}else{//Time to reveal the next character
var nextIndex=_this3.state.revealedIndex+1;_this3.setState({revealedIndex:nextIndex},function(){//There is at least anotehr character in the text line...
if(nextIndex<_this3.props.lineData.length-1){//Play sound!
//TODO: Should this SFX be passed in? So we have options?
if(_this3.props.lineData[nextIndex].char!==" "){//don't play on space characters
//sfxTypeBlip.play();
__WEBPACK_IMPORTED_MODULE_1__audio_audio_manager_js__["a" /* default */].playSfx("sfx_typeBlip");}//Call again with updated time delay
var msToNextChar=_this3.props.lineData[nextIndex].msToNextChar;_this3.revealNext(Date.now()+msToNextChar);}else{//End of the series. Call the passed in callback!
if(typeof _this3.props.onDone==="function"){_this3.props.onDone();}}});}};//Kick off the first step
this.animFrameStep=requestAnimationFrame(step);}},{key:"render",value:function render(){var _this4=this;var string=this.props.lineData.map(function(characterModel,i){var style={opacity:i<=_this4.state.revealedIndex?1:0,color:characterModel.color//will always have a color
};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{key:i,style:style},characterModel.char);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,string);}}]);return TextLine;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (TextLine);/* Expects:
 this.props.lineData = array of ->
  {char: "h", color:"green", msToNextChar: 40}

  and this.props.onDone callback function
 */

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = convertSpeechArrayToTextLineArray;
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function convertSpeechArrayToTextLineArray(array){var userOptions=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};//Defaults
var options=Object.assign({playerTeamId:"unknown",defaultTextColor:"#000"},userOptions);var delivery=[];array.forEach(function(segment,index){if(!segment.match(/@@pause_/)){var speed=50;var color=options.defaultTextColor;//default?
if(segment.match(/^\[LIGHTNING\]/i)){segment=segment.replace("[LIGHTNING]","");speed=10;}if(segment.match(/^\[FAST\]/i)){segment=segment.replace("[FAST]","");speed=35;}if(segment.match(/^\[SLOW\]/i)){segment=segment.replace("[SLOW]","");speed=140;}if(segment.match(/^\[CRAWL\]/i)){segment=segment.replace("[CRAWL]","");speed=360;}//Look for color flag, grab hex and use as the `color` value.
if(segment.match(/^@@color_/)){var extract=segment.match(/@@(.*)@@/).pop();color=extract.replace("color_","");//grab whatever comes after the `color_...` (expecting a hex, or a preset name)
//Feature: variable names for colors! Have presets that decide the color.
//This is important for one piece of text having multiple contexts depending on the reader. (EX: team colors)
//Potentially replace COLOR variable name `COLORVAR` with an actual hex.
//Case 1: team name. Check if the user is on this team (playerTeam provided by options.playerTeamId)
if(color.match(/COLORVAR_NAME_FROM_TEAM::/)){var teamId=color.replace("COLORVAR_NAME_FROM_TEAM::","");color=teamId===options.playerTeamId?"#4A90E2"//Friend Blue
:"#FC304A";//Enemy Red
}//
segment=segment.replace("@@"+extract+"@@","");}var split=segment.split("").map(function(char){return{color:color,char:char,msToNextChar:char!==" "?speed:0};});delivery=[].concat(_toConsumableArray(delivery),_toConsumableArray(split));}else{var parsedDelay=segment.match(/\d+/g)[0];delivery=[].concat(_toConsumableArray(delivery),[{color:options.defaultTextColor,char:" ",msToNextChar:parseInt(parsedDelay,10)}]);}});return delivery;}

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(94),
    setCacheAdd = __webpack_require__(498),
    setCacheHas = __webpack_require__(499);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(69),
    stackClear = __webpack_require__(500),
    stackDelete = __webpack_require__(501),
    stackGet = __webpack_require__(502),
    stackHas = __webpack_require__(503),
    stackSet = __webpack_require__(504);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 165 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(169),
    toKey = __webpack_require__(74);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(441),
    isObjectLike = __webpack_require__(60);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 168 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(20),
    isKey = __webpack_require__(96),
    stringToPath = __webpack_require__(506),
    toString = __webpack_require__(517);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(163),
    arraySome = __webpack_require__(435),
    cacheHas = __webpack_require__(168);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(59);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 173 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var baseRandom = __webpack_require__(452);

/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */
function shuffleSelf(array, size) {
  var index = -1,
      length = array.length,
      lastIndex = length - 1;

  size = size === undefined ? length : size;
  while (++index < size) {
    var rand = baseRandom(index, lastIndex),
        value = array[rand];

    array[rand] = array[index];
    array[index] = value;
  }
  array.length = size;
  return array;
}

module.exports = shuffleSelf;


/***/ }),
/* 175 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(440),
    isObjectLike = __webpack_require__(60);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(179),
    isLength = __webpack_require__(99);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(19),
    stubFalse = __webpack_require__(514);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(82)(module)))

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(58),
    isObject = __webpack_require__(59);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(445),
    baseUnary = __webpack_require__(457),
    nodeUtil = __webpack_require__(495);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var arrayShuffle = __webpack_require__(434),
    baseShuffle = __webpack_require__(454),
    isArray = __webpack_require__(20);

/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */
function shuffle(collection) {
  var func = isArray(collection) ? arrayShuffle : baseShuffle;
  return func(collection);
}

module.exports = shuffle;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(226);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('not a function');
  }
  this._45 = 0;
  this._81 = 0;
  this._65 = null;
  this._54 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._10 = null;
Promise._97 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
};
function handle(self, deferred) {
  while (self._81 === 3) {
    self = self._65;
  }
  if (Promise._10) {
    Promise._10(self);
  }
  if (self._81 === 0) {
    if (self._45 === 0) {
      self._45 = 1;
      self._54 = deferred;
      return;
    }
    if (self._45 === 1) {
      self._45 = 2;
      self._54 = [self._54, deferred];
      return;
    }
    self._54.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._81 === 1) {
        resolve(deferred.promise, self._65);
      } else {
        reject(deferred.promise, self._65);
      }
      return;
    }
    var ret = tryCallOne(cb, self._65);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._81 = 3;
      self._65 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._81 = 1;
  self._65 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._81 = 2;
  self._65 = newValue;
  if (Promise._97) {
    Promise._97(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._45 === 1) {
    handle(self, self._54);
    self._54 = null;
  }
  if (self._45 === 2) {
    for (var i = 0; i < self._54.length; i++) {
      handle(self, self._54[i]);
    }
    self._54 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  })
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(35);

var invariant = __webpack_require__(4);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(43);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactInstrumentation = __webpack_require__(15);

var quoteAttributeValueForBrowser = __webpack_require__(587);
var warning = __webpack_require__(6);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {

  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }

};

module.exports = DOMPropertyOperations;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(9);

var LinkedValueUtils = __webpack_require__(108);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactUpdates = __webpack_require__(16);

var warning = __webpack_require__(6);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(4);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(546);

var containsNode = __webpack_require__(591);
var focusNode = __webpack_require__(205);
var getActiveElement = __webpack_require__(206);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {

  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var DOMLazyTree = __webpack_require__(42);
var DOMProperty = __webpack_require__(43);
var React = __webpack_require__(45);
var ReactBrowserEventEmitter = __webpack_require__(76);
var ReactCurrentOwner = __webpack_require__(23);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactDOMContainerInfo = __webpack_require__(540);
var ReactDOMFeatureFlags = __webpack_require__(542);
var ReactFeatureFlags = __webpack_require__(189);
var ReactInstanceMap = __webpack_require__(63);
var ReactInstrumentation = __webpack_require__(15);
var ReactMarkupChecksum = __webpack_require__(556);
var ReactReconciler = __webpack_require__(44);
var ReactUpdateQueue = __webpack_require__(111);
var ReactUpdates = __webpack_require__(16);

var emptyObject = __webpack_require__(204);
var instantiateReactComponent = __webpack_require__(199);
var invariant = __webpack_require__(4);
var setInnerHTML = __webpack_require__(80);
var shouldUpdateReactComponent = __webpack_require__(117);
var warning = __webpack_require__(6);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {

  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
    // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var React = __webpack_require__(45);

var invariant = __webpack_require__(4);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {

  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }

};

module.exports = ViewportMetrics;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(4);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactNodeTypes = __webpack_require__(193);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(12);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(9);

var ReactCompositeComponent = __webpack_require__(537);
var ReactEmptyComponent = __webpack_require__(188);
var ReactHostComponent = __webpack_require__(190);

var getNextDebugID = __webpack_require__(584);
var invariant = __webpack_require__(4);
var warning = __webpack_require__(6);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};
_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

module.exports = instantiateReactComponent;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  'color': true,
  'date': true,
  'datetime': true,
  'datetime-local': true,
  'email': true,
  'month': true,
  'number': true,
  'password': true,
  'range': true,
  'search': true,
  'tel': true,
  'text': true,
  'time': true,
  'url': true,
  'week': true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(12);
var escapeTextContentForBrowser = __webpack_require__(79);
var setInnerHTML = __webpack_require__(80);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactCurrentOwner = __webpack_require__(23);
var REACT_ELEMENT_TYPE = __webpack_require__(552);

var getIteratorFn = __webpack_require__(583);
var invariant = __webpack_require__(4);
var KeyEscapeUtils = __webpack_require__(107);
var warning = __webpack_require__(6);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(22);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 */
function getActiveElement() /*?DOMElement*/{
  if (typeof document === 'undefined') {
    return null;
  }
  try {
    return document.activeElement || document.body;
  } catch (e) {
    return document.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_storeShape__ = __webpack_require__(210);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_storeShape__["a" /* default */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2_react__["PropTypes"].instanceOf(__WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */]), _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2_react__["PropTypes"].instanceOf(__WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */]), _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + WrappedComponent));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = _this.props[storeKey] || _this.context[storeKey];
        _this.parentSub = props[subscriptionKey] || context[subscriptionKey];

        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or ' + ('props of "' + displayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        // make sure `getState` is properly bound in order to avoid breaking
        // custom store implementations that rely on the store's context
        _this.getState = _this.store.getState.bind(_this.store);

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        return _ref2 = {}, _ref2[subscriptionKey] = this.subscription || this.parentSub, _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        // these are just to guard against extra memory leakage if a parent element doesn't
        // dereference this instance properly, such as an async callback that never finishes
        this.subscription = null;
        this.store = null;
        this.parentSub = null;
        this.selector.run = function () {};
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var dispatch = this.store.dispatch;
        var getState = this.getState;

        var sourceSelector = selectorFactory(dispatch, selectorFactoryOptions);

        // wrap the selector in an object that tracks its results between runs
        var selector = this.selector = {
          shouldComponentUpdate: true,
          props: sourceSelector(getState(), this.props),
          run: function runComponentSelector(props) {
            try {
              var nextProps = sourceSelector(getState(), props);
              if (selector.error || nextProps !== selector.props) {
                selector.shouldComponentUpdate = true;
                selector.props = nextProps;
                selector.error = null;
              }
            } catch (error) {
              selector.shouldComponentUpdate = true;
              selector.error = error;
            }
          }
        };
      };

      Connect.prototype.initSubscription = function initSubscription() {
        var _this2 = this;

        if (shouldHandleStateChanges) {
          (function () {
            var subscription = _this2.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](_this2.store, _this2.parentSub);
            var dummyState = {};

            subscription.onStateChange = function onStateChange() {
              this.selector.run(this.props);

              if (!this.selector.shouldComponentUpdate) {
                subscription.notifyNestedSubs();
              } else {
                this.componentDidUpdate = function componentDidUpdate() {
                  this.componentDidUpdate = undefined;
                  subscription.notifyNestedSubs();
                };

                this.setState(dummyState);
              }
            }.bind(_this2);
          })();
        }
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          if (this.subscription) this.subscription.tryUnsubscribe();
          this.initSubscription();
          if (shouldHandleStateChanges) this.subscription.trySubscribe();
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(211);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      // this.onStateChange is set by connectAdvanced.initSubscription()
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired
}));

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(120);



function verifyPlainObject(value, displayName, methodName) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(617);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(47);

var ReactCurrentOwner = __webpack_require__(23);

var invariant = __webpack_require__(48);
var warning = __webpack_require__(29);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty)
  // Strip regex characters so we can use it for regex
  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  // Remove hasOwnProperty from the template to make it generic
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypeLocationNames = {};

if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
}

module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  var last = funcs[funcs.length - 1];
  var rest = funcs.slice(0, -1);
  return function () {
    return rest.reduceRight(function (composed, f) {
      return f(composed);
    }, last.apply(undefined, arguments));
  };
}

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'
};

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} enhancer The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/zenparsing/es-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(221);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* unused harmony reexport applyMiddleware */
/* unused harmony reexport compose */







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(640);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(641);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__battle_animations_css__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__battle_animations_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__battle_animations_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__init_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__firebase_env_setup__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__init_google_analytics__ = __webpack_require__(394);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* Initialize firebase! */window.firebase.initializeApp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__firebase_env_setup__["a" /* getFirebaseConfig */])());/* Initialize Google Analytics! */__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__init_google_analytics__["a" /* initGoogleAnalytics */])();/* Absolute root of the app */var RootComponent=function(_React$Component){_inherits(RootComponent,_React$Component);function RootComponent(){_classCallCheck(this,RootComponent);return _possibleConstructorReturn(this,(RootComponent.__proto__||Object.getPrototypeOf(RootComponent)).apply(this,arguments));}_createClass(RootComponent,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* Provider */],{store:this.props.store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],null));}}]);return RootComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RootComponent,{store:__WEBPACK_IMPORTED_MODULE_5__init_store__["a" /* default */]}),document.getElementById("root"));

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(523).enable();
  window.Promise = __webpack_require__(522);
}

// fetch() polyfill for making API calls.
__webpack_require__(647);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(521);


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(228);

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);
var bind = __webpack_require__(129);
var Axios = __webpack_require__(230);
var defaults = __webpack_require__(83);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(126);
axios.CancelToken = __webpack_require__(229);
axios.isCancel = __webpack_require__(127);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(244);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(126);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(83);
var utils = __webpack_require__(13);
var InterceptorManager = __webpack_require__(231);
var dispatchRequest = __webpack_require__(232);
var isAbsoluteURL = __webpack_require__(240);
var combineURLs = __webpack_require__(238);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);
var transformData = __webpack_require__(235);
var isCancel = __webpack_require__(127);
var defaults = __webpack_require__(83);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(128);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__battle_BattleLoginWall_js__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__battle_OfflineBattleContainer__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__frame_GameFrame_js__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__battle_BattleOverScreen_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__b5_home_CrewHome__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__battle_b5LoadCrew_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__b5_unlocks_RecordsScreen_js__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__b5_onboarding_OnboardingScreen__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_actions_global_actions__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__getStartingGameArea__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__b5_home_FullscreenState__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__branding_intro_BrandingIntroScreen__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__branding_intro_branding_intro_localstorage_operations__ = __webpack_require__(384);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import HomeScreen from './b5-home/HomeScreen.js'
var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this));_this.state={needsToSeeIntro:!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__branding_intro_branding_intro_localstorage_operations__["a" /* getSeenBrandingIntroFromLocalstorage */])(),isCrewLoaded:false};return _this;}_createClass(App,[{key:"componentWillMount",value:function componentWillMount(){//Check if we've seen the intro
if(!this.state.needsToSeeIntro){//If so, we're ready to launch the game!\
this.launchGame();}//If not.. the screen will fire our `handleIntroSeen` method. No worries.
}},{key:"handleIntroSeen",value:function handleIntroSeen(){var _this2=this;//This will be called by the BrandingIntroScreen after the user has seen it.
//Set that we've seen it:
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__branding_intro_branding_intro_localstorage_operations__["b" /* setSeenBrandingIntroInLocalstorage */])();//Now launch the game
this.setState({needsToSeeIntro:false},function(){_this2.launchGame();});}},{key:"launchGame",value:function launchGame(){var _this3=this;//load the user's crew - then we can get started!
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__battle_b5LoadCrew_js__["a" /* b5LoadCrew */])(function(userStatus/* "newUser" | "returningUser"  */){//Get the starting gameArea for the app, now that b5 is loaded. (for dev, you can force overwrite right here)
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__redux_actions_global_actions__["a" /* setGlobalValue */])({//gameArea: "b5-offline-battle-over" //Dev override
gameArea:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__getStartingGameArea__["a" /* getStartingGameArea */])(userStatus)});_this3.setState({isCrewLoaded:true});});}},{key:"render",value:function render(){if(this.state.needsToSeeIntro){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__frame_GameFrame_js__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__branding_intro_BrandingIntroScreen__["a" /* default */],{onFinish:this.handleIntroSeen.bind(this)}));}if(!this.state.isCrewLoaded){//This could be the "THE DANGER CREW" screen, like MidiPixel
//Do not show anything else until the Crew is loaded
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__frame_GameFrame_js__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__b5_home_FullscreenState__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{textAlign:"center"}},"Loading your crew...")));}//Case: Home screen
if(this.props.gameArea==="b5-onboarding-screen"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__frame_GameFrame_js__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__b5_onboarding_OnboardingScreen__["a" /* default */],null));}//Case: Home screen
if(this.props.gameArea==="b5-home-screen"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__frame_GameFrame_js__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__b5_home_CrewHome__["a" /* default */],null));}//Case: Records screen
if(this.props.gameArea==="b5-records-screen"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__frame_GameFrame_js__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__b5_unlocks_RecordsScreen_js__["a" /* default */],null));}//Case A: Restart screen
if(this.props.gameArea==="b5-offline-battle-over"){//TODO: change gameArea to this string after an offline battle!
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__frame_GameFrame_js__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__battle_BattleOverScreen_js__["a" /* default */],{mode:"offline"}));}if(this.props.gameArea==="b5-online-battle-over"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__frame_GameFrame_js__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__battle_BattleOverScreen_js__["a" /* default */],{mode:"online"}));}//Case B: Multiplayer mode
if(this.props.isMultiplayerMode){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__frame_GameFrame_js__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__battle_BattleLoginWall_js__["a" /* default */],null));}//Case C: Offline mode
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__frame_GameFrame_js__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__battle_OfflineBattleContainer__["a" /* default */],null));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{gameArea:state.global.gameArea,combatants:state.battle.combatants,teams:state.battle.teams,isMultiplayerMode:state.battle.isMultiplayerMode};})(App));

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Howler configs without the Howl instance *//* harmony default export */ __webpack_exports__["a"] = ({music_RegularBattle:{src:["/music/player-vs-computer.mp3"],volume:0.4,loop:true},music_b5Menu:{src:["/music/basement.mp3"],volume:0.4,loop:true}});// import store from '../init/store'
// //SONG
// export const songRegularBattle = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/21542/battle-buns.mp3'],
//     volume: 0.4,
//     loop: true
//     // sprite: {
//     //     trimmed: [0, 60952.381, true]
//     // }
// });

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Howler configs without the Howl instance *//* harmony default export */ __webpack_exports__["a"] = ({sfx_typeBlip:{src:["/sfx/Blip-0.0_bip_3.1.wav"],volume:0.75},sfx_cursorMove:{src:["/sfx/menu-move.mp3"],volume:1},sfx_submitAction:{src:["/sfx/submit.mp3"],volume:1},sfx_submitMegaSuccess:{src:["/sfx/sfx-mega-success.mp3"],volume:1},sfx_loopIterate:{src:["/sfx/iterator.mp3"],volume:1},sfx_Babuhm:{src:["/sfx/baBuhm.mp3"]},sfx_fillHp:{src:["/sfx/increase-xp.mp3"],volume:1},sfx_popup:{src:["/sfx/bell_up.mp3"],volume:0.7},sfx_taunt:{src:["/sfx/taunt.mp3"],volume:1},sfx_jump:{src:["/sfx/sfx-jump.mp3"],volume:0.4},sfx_acceptBattle:{src:["/sfx/shhhink-accepted--bit-crush-more-cresc.mp3"],volume:0.4}});// //SFXs
// export const sfxBabum = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/21542/baBuhm.mp3']
// });
//
// export const sfxTypeBlip = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/21542/Blip-0.0_bip_3.1.wav'],
//     volume: 0.75
// });
//
//
// export const sfxSubmitAction = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/21542/submit.mp3'],
//     volume: 1
// });
//
// export const sfxIterate = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/21542/iterator.mp3'],
//     volume: 1
// });
//
// //Battle REQUESTs
//
// export const sfxBattleRequest = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/163669/exclaim_up.mp3'],
//     volume: 1
// });
// export const sfxBattleRequestDenied = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/163669/exclaim_down.mp3'],
//     volume: 1
// });
// // export const sfxBattleRequestAccepted = new Howl({
// //     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/21542/shhhink-accepted--bit-crush-more-cresc.mp3'],
// //     volume: 1
// // });
//
//
// //Battle Results
// export const sfxBattleResultPopup = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/163669/pod_open.mp3'],
//     volume: 0.4
// });
// export const sfxIncreaseXp = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/21542/increase-xp.mp3'],
//     volume: 1
// });
// export const sfxLevelUp = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/21542/reach-levelup.mp3'],
//     volume: 1
// });
//
//
// //Journal
// export const sfxJournalUpdate = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/163669/bell_down.mp3'],
//     volume: 1
// });
//
// //Popup (onboarding popup)
// export const sfxPopup = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/163669/bell_up.mp3'],
//     volume: 1
// });
//
//
// //Title
// export const sfxTitlePortal = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/163669/speedup6.mp3'],
//     volume: 0.7
// });

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_Skins_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__edit_combatant_operations__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint jsx-a11y/href-no-hash: "off" */var EditCombatantAppearance=function(_React$Component){_inherits(EditCombatantAppearance,_React$Component);function EditCombatantAppearance(){_classCallCheck(this,EditCombatantAppearance);return _possibleConstructorReturn(this,(EditCombatantAppearance.__proto__||Object.getPrototypeOf(EditCombatantAppearance)).apply(this,arguments));}_createClass(EditCombatantAppearance,[{key:"handleNextClick",//These bits of functionality may end up getting converted to MenuOptions if we use a Menu instance here.
//(for keyboarding)
value:function handleNextClick(e){e.preventDefault();__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__edit_combatant_operations__["b" /* changeEditingCombatantValue */])("combatantSkin",__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__edit_combatant_operations__["d" /* getNextSkin */])(this.props.combatantSkin,"next"));}},{key:"handlePrevClick",value:function handlePrevClick(e){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__edit_combatant_operations__["b" /* changeEditingCombatantValue */])("combatantSkin",__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__edit_combatant_operations__["d" /* getNextSkin */])(this.props.combatantSkin,"prev"));}},{key:"render",value:function render(){var groupStyle={marginBottom:"1em"};// const labelStyle = {
//   fontSize: "0.8em",
//   display: "block",
//   textAlign: "center",
//   color: "#9D91A4"
// };
var rowStyle={display:"flex",justifyContent:"space-between",alignItems:"center"};var imageContainerStyle={width:"9em",height:"9em",position:"relative"};var imageStyle={position:"absolute",width:"100%",left:0,top:0};var skinModel=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__data_Skins_js__["a" /* default */])()[this.props.combatantSkin];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:groupStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button small",href:"#",onClick:this.handlePrevClick.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"button--text button--text_left-arrow-nudge"},"<")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:imageContainerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{style:imageStyle,src:"/images/misc/shadow.svg",alt:"Shadow"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{style:imageStyle,src:skinModel.frontViewSrc,alt:"Shadow"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button small",href:"#",onClick:this.handleNextClick.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"button--text button--text_right-arrow-nudge"},">"))));}}]);return EditCombatantAppearance;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (EditCombatantAppearance);

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Fixture_combatants_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__battle_battle_data_battle_actions_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__edit_combatant_operations__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__b5_home_get_class_icon__ = __webpack_require__(136);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint jsx-a11y/href-no-hash: "off" */var EditCombatantLoadout=function(_React$Component){_inherits(EditCombatantLoadout,_React$Component);function EditCombatantLoadout(){_classCallCheck(this,EditCombatantLoadout);return _possibleConstructorReturn(this,(EditCombatantLoadout.__proto__||Object.getPrototypeOf(EditCombatantLoadout)).apply(this,arguments));}_createClass(EditCombatantLoadout,[{key:"handleNextClick",value:function handleNextClick(e){e.preventDefault();__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__edit_combatant_operations__["b" /* changeEditingCombatantValue */])("combatantLoadoutId",__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__edit_combatant_operations__["c" /* getNextLoadout */])(this.props.combatantLoadoutId,"next"));}},{key:"handlePrevClick",value:function handlePrevClick(e){e.preventDefault();__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__edit_combatant_operations__["b" /* changeEditingCombatantValue */])("combatantLoadoutId",__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__edit_combatant_operations__["c" /* getNextLoadout */])(this.props.combatantLoadoutId,"prev"));}},{key:"render",value:function render(){var groupStyle={marginBottom:"1em"};var labelStyle={fontSize:"0.8em",display:"block",textAlign:"center",color:"#9D91A4",marginBottom:"0.5em"};var rowStyle={display:"flex",justifyContent:"space-between",alignItems:"center",height:"6em"//prevent the size of this guy from changing
};var listsContainerStyle={display:"flex",paddingTop:"2em",paddingBottom:"2em",height:"15em"//prevent the size of this guy from changing
};var listStyle={width:"50%"};var listTitleStyle={marginBottom:"1.5em"};var loadoutTitleStyle={textTransform:"uppercase",fontSize:"0.9em",lineHeight:"1.4em",textAlign:"center",display:"flex",alignItems:"center"};//Look up my loadoutModel Model
var loadoutModel=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Fixture_combatants_js__["c" /* getLoadout */])(this.props.combatantLoadoutId);if(!loadoutModel){console.warn("my loadoutModel not found",this.props.combatantLoadoutTitle,this.props.combatantLoadoutId);}var attackNames=loadoutModel.attacks.map(function(atk){var model=__WEBPACK_IMPORTED_MODULE_2__battle_battle_data_battle_actions_js__["a" /* default */][atk.actionId];return{name:model.name,isSuper:model.isSuper};});var itemNames=loadoutModel.items.map(function(atk){var model=__WEBPACK_IMPORTED_MODULE_2__battle_battle_data_battle_actions_js__["a" /* default */][atk.actionId];return{name:model.name};});var blipStyle={marginBottom:"1em",fontSize:"0.85em"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:groupStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button small",href:"#",onClick:this.handlePrevClick.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"button--text button--text_left-arrow-nudge"},"<")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{style:labelStyle},"Class"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:loadoutTitleStyle},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__b5_home_get_class_icon__["a" /* getClassIcon */])(loadoutModel.class,"2.4em",{marginRight:"1em"}),loadoutModel.loadoutTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button small",href:"#",onClick:this.handleNextClick.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"button--text button--text_right-arrow-nudge"},">"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:listsContainerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:listStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:listTitleStyle},"ATTACKS"),attackNames.map(function(model,index){//"isSuper" is available to you here, if you want it.
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:blipStyle,key:index},"* ",model.name);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:listStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:listTitleStyle},"ITEMS"),itemNames.map(function(model,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:blipStyle,key:index},"* ",model.name);}))));}}]);return EditCombatantLoadout;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (EditCombatantLoadout);

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__edit_combatant_operations__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditCombatantNameField=function(_React$Component){_inherits(EditCombatantNameField,_React$Component);function EditCombatantNameField(){_classCallCheck(this,EditCombatantNameField);return _possibleConstructorReturn(this,(EditCombatantNameField.__proto__||Object.getPrototypeOf(EditCombatantNameField)).apply(this,arguments));}_createClass(EditCombatantNameField,[{key:"handleInputChange",value:function handleInputChange(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__edit_combatant_operations__["b" /* changeEditingCombatantValue */])("combatantName",this.refs.input.value);}},{key:"handleInputFocus",value:function handleInputFocus(){//Auto select the whole thing when focusing.
this.refs.input.setSelectionRange(0,this.refs.input.value.length);}},{key:"handleSubmit",value:function handleSubmit(e){e.preventDefault();//Get a clean version of the final name
var safeName=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__edit_combatant_operations__["e" /* getSafeCombatantName */])(this.refs.input.value.trim());__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__edit_combatant_operations__["b" /* changeEditingCombatantValue */])("combatantName",safeName);this.refs.input.blur();}},{key:"render",value:function render(){var groupStyle={marginBottom:"2em"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:groupStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{onSubmit:this.handleSubmit.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{name:"Name",onFocus:this.handleInputFocus.bind(this),className:"NameTextInput",style:{textTransform:"uppercase",fontSize:"1em"},onChange:this.handleInputChange.bind(this),ref:"input",value:this.props.combatantName,autoComplete:"off",autoCorrect:"off",autoCapitalize:"off",spellCheck:"false",maxLength:9})));}}]);return EditCombatantNameField;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (EditCombatantNameField);

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CrewLineup__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LobbyCTA__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__b5_crew_management_EditCombatantModal_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__get_home_menu_options__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__b5_menus_css__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__b5_menus_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__b5_menus_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CrewHomeInviteModal__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EditCrewNameModal__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__audio_AudioControl_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__audio_audio_manager__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MenuBrandingLogo__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__HomeEmailModal__ = __webpack_require__(254);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import GoToMultiplayerLobbyLink from './GoToMultiplayerLobbyLink'
//import MenuHeader from './MenuHeader'
var CrewHome=function(_React$Component){_inherits(CrewHome,_React$Component);function CrewHome(){_classCallCheck(this,CrewHome);var _this=_possibleConstructorReturn(this,(CrewHome.__proto__||Object.getPrototypeOf(CrewHome)).call(this));_this.state={isInviteModalOpen:false,isQuickBattleButtonPressed:false};return _this;}_createClass(CrewHome,[{key:"componentDidMount",value:function componentDidMount(){//Play the music!
__WEBPACK_IMPORTED_MODULE_10__audio_audio_manager__["a" /* default */].playSong("music_b5Menu");}},{key:"handleQuickBattle",value:function handleQuickBattle(){this.setState({isQuickBattleButtonPressed:true},function(){__WEBPACK_IMPORTED_MODULE_10__audio_audio_manager__["a" /* default */].stopSong();__WEBPACK_IMPORTED_MODULE_10__audio_audio_manager__["a" /* default */].playSfx("sfx_acceptBattle");setTimeout(function(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__get_home_menu_options__["c" /* goToQuickBattle */])();},1400);});}},{key:"handleOpenInviteModal",value:function handleOpenInviteModal(){this.setState({isInviteModalOpen:true});}},{key:"handleCloseInviteModal",value:function handleCloseInviteModal(){this.setState({isInviteModalOpen:false});}/* Open the modal if Editing Modal is open */},{key:"renderInviteModal",value:function renderInviteModal(){if(this.state.isInviteModalOpen){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CrewHomeInviteModal__["a" /* default */],{handleCloseCallback:this.handleCloseInviteModal.bind(this)});}return null;}/* Open the modal if Editing Modal is open */},{key:"renderEditCombatantModal",value:function renderEditCombatantModal(){if(this.props.editingCombatantProperties.isActivated){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__b5_crew_management_EditCombatantModal_js__["a" /* default */],null);}return null;}/* Show Crew Name modal if we're editing Crew Name */},{key:"renderEditCrewNameModal",value:function renderEditCrewNameModal(){if(this.props.isCrewNameModalOption){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__EditCrewNameModal__["a" /* default */],null);}return null;}},{key:"renderOptinModal",value:function renderOptinModal(){if(this.props.isHomeEmailModalOpen){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__HomeEmailModal__["a" /* default */],null);}return null;}//Maybe return styles that wrap the desktop layout together
},{key:"getDesktopWrap",value:function getDesktopWrap(){if(this.props.viewportMode==="portrait"){return{};}return{width:"45em",margin:"0 auto"};}},{key:"getCenterSectionPaddingTop",value:function getCenterSectionPaddingTop(){return this.props.viewportMode==="portrait"?this.props.vH*3//mobile
:this.props.vH*5;//desktop
}},{key:"renderQuickBattleButton",value:function renderQuickBattleButton(){if(this.state.isQuickBattleButtonPressed){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__LobbyCTA__["a" /* default */],{text:"Battle Accepted!",handler:this.handleQuickBattle,isReadyPressed:true,isDisabled:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__LobbyCTA__["a" /* default */],{text:"Quick Battle",handler:this.handleQuickBattle.bind(this),isPrimary:true});}},{key:"render",value:function render(){var viewportMode=this.props.viewportMode;var style={fontSize:viewportMode==="portrait"?"0.6em":"0.45em",//mobile, desktop
height:"100%"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style,className:"page-container menu-texture"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__MenuBrandingLogo__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-container--section center-section",style:Object.assign({paddingBottom:"1em",paddingTop:this.getCenterSectionPaddingTop()},this.getDesktopWrap())},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CrewLineup__["a" /* default */],{showLaptop:true,showViewRecordButton:this.props.logggedInUserId,crewTeamModel:this.props.crewMembers,areCombatantsEditable:true,crewName:this.props.crewName})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-container--section",style:Object.assign({padding:"2em 2em 3em"},this.getDesktopWrap())},this.renderQuickBattleButton(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__LobbyCTA__["a" /* default */],{text:"Invite Friends",handler:this.handleOpenInviteModal.bind(this),isPrimary:false}))),this.renderEditCrewNameModal(),this.renderEditCombatantModal(),this.renderInviteModal(),this.renderOptinModal(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__audio_AudioControl_js__["a" /* default */],null));}}]);return CrewHome;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{//someProp: state.something.someProp
vW:state.global.vW,vH:state.global.vH,viewportMode:state.global.viewportMode,logggedInUserId:state.crew.logggedInUserId,crewName:state.crew.name,crewMembers:state.crew.members,editingCombatantProperties:state.matchmaking.editingCombatantProperties,isCrewNameModalOption:state.matchmaking.isCrewNameModalOption,isHomeEmailModalOpen:state.global.isHomeEmailModalOpen};})(CrewHome));

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LobbyModal__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__get_home_menu_options__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LobbyCTA__ = __webpack_require__(50);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CrewHomeInviteModal=function(_React$Component){_inherits(CrewHomeInviteModal,_React$Component);function CrewHomeInviteModal(){_classCallCheck(this,CrewHomeInviteModal);return _possibleConstructorReturn(this,(CrewHomeInviteModal.__proto__||Object.getPrototypeOf(CrewHomeInviteModal)).apply(this,arguments));}_createClass(CrewHomeInviteModal,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__LobbyModal__["a" /* default */],{title:"Choose Battle Type",handleCloseCallback:this.props.handleCloseCallback},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:"Modal__title"},"Versus Battle"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"Modal__paragraph"},"Face off against one friend, each person controlling a Crew of three combatants."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Modal__btn-container--spaced"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__LobbyCTA__["a" /* default */],{text:"Start Versus",handler:__WEBPACK_IMPORTED_MODULE_2__get_home_menu_options__["d" /* goToFullTeamMultiplayerBattle */],isPrimary:false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:"Modal__title"},"Rally Battle"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"Modal__paragraph"},"Control one combatant in a battle of up to six players."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__LobbyCTA__["a" /* default */],{text:"Start Rally",handler:__WEBPACK_IMPORTED_MODULE_2__get_home_menu_options__["e" /* goToOpenBattle */],isPrimary:false})))));}}]);return CrewHomeInviteModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CrewHomeInviteModal);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CrewTitle=function(_React$Component){_inherits(CrewTitle,_React$Component);function CrewTitle(){_classCallCheck(this,CrewTitle);return _possibleConstructorReturn(this,(CrewTitle.__proto__||Object.getPrototypeOf(CrewTitle)).apply(this,arguments));}_createClass(CrewTitle,[{key:"launchEditCrewNameModal",value:function launchEditCrewNameModal(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions__["b" /* setMatchmakingValue */])({isCrewNameModalOption:true});}},{key:"render",value:function render(){var style={display:"inline-block",textAlign:"center",padding:"1em",fontSize:"1.2em",textDecoration:"underline"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"pointer-on-hover",style:style,onClick:this.launchEditCrewNameModal.bind(this)},this.props.crewName);}}]);return CrewTitle;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{};})(CrewTitle));

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LobbyModal__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_global_actions_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__battle_optin_OptinForm__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__battle_optin_get_envelope_svg__ = __webpack_require__(138);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HomeEmailModal=function(_React$Component){_inherits(HomeEmailModal,_React$Component);function HomeEmailModal(){_classCallCheck(this,HomeEmailModal);var _this=_possibleConstructorReturn(this,(HomeEmailModal.__proto__||Object.getPrototypeOf(HomeEmailModal)).call(this));_this.state={hasBeenSubmitted:false};return _this;}_createClass(HomeEmailModal,[{key:"handleModalClose",value:function handleModalClose(){//Close the modal
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_global_actions_js__["a" /* setGlobalValue */])({isHomeEmailModalOpen:false});}},{key:"handleSubmissionSuccess",value:function handleSubmissionSuccess(){//Say THANK YOU! Then close the modal.
this.setState({hasBeenSubmitted:true},function(){setTimeout(function(){//Then close...
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_global_actions_js__["a" /* setGlobalValue */])({isHomeEmailModalOpen:false});},1000);});}},{key:"renderSuccessState",value:function renderSuccessState(){var style={textAlign:"center",fontSize:"2em"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style},"Thank you!");}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__LobbyModal__["a" /* default */],{title:"Email Signup",handleCloseCallback:this.handleModalClose.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__battle_optin_get_envelope_svg__["a" /* getEnvelopeSvg */])({width:"8em",display:"block",margin:"0 auto 1em"},"EmailOptinEnvelope"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"Modal__paragraph",style:{marginBottom:"3em"}},"The full version of The Danger Crew is still in development, but we'll email you when it is ready!"),this.state.hasBeenSubmitted?this.renderSuccessState():__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__battle_optin_OptinForm__["a" /* default */],{successCallback:this.handleSubmissionSuccess.bind(this)})));}}]);return HomeEmailModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (HomeEmailModal);

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_global_actions__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__battle_optin_get_envelope_svg__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__battle_optin_optin_localstorage_operations_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__b5_unlocks_getUserBattleRecord__ = __webpack_require__(86);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HomeOpenOptinModalButton=function(_React$Component){_inherits(HomeOpenOptinModalButton,_React$Component);function HomeOpenOptinModalButton(){_classCallCheck(this,HomeOpenOptinModalButton);//Don't show the button if:
var _this=_possibleConstructorReturn(this,(HomeOpenOptinModalButton.__proto__||Object.getPrototypeOf(HomeOpenOptinModalButton)).call(this));var isHidingButton=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__b5_unlocks_getUserBattleRecord__["a" /* getRecord */])().totalWins<2||//1) Haven't won two battles yet
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__battle_optin_optin_localstorage_operations_js__["a" /* getHasSignedUpFromLocalstorage */])()//2) I've submitted the form before
;//Flash the button if
var isButtonFlashing=!isHidingButton&&//The button is not hiding
!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__battle_optin_optin_localstorage_operations_js__["b" /* getSeenModalFromLocalstorage */])()//We've never seen the form before
;_this.state={isHidingButton:isHidingButton,isButtonFlashing:isButtonFlashing};return _this;}_createClass(HomeOpenOptinModalButton,[{key:'handleOpenClick',value:function handleOpenClick(){//Stop the flashing
this.setState({isButtonFlashing:false});//Open the modal!
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_global_actions__["a" /* setGlobalValue */])({isHomeEmailModalOpen:true});}},{key:'render',value:function render(){if(this.state.isHidingButton){return null;}var style={marginTop:"1em",border:0,outline:0,padding:0,display:"block",background:"rgba(255,255,255,0)"};//class based for weird keyframe on an svg's path
var envelopeClassName=this.state.isButtonFlashing?"EmailOptinEnvelope is-flashing":"EmailOptinEnvelope";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'pointer-on-hover',style:style,onClick:this.handleOpenClick.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__battle_optin_get_envelope_svg__["a" /* getEnvelopeSvg */])({width:"4em"},envelopeClassName)));}}]);return HomeOpenOptinModalButton;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (HomeOpenOptinModalButton);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HomeOpenOptinModalButton__ = __webpack_require__(255);
/* harmony default export */ __webpack_exports__["a"] = (function(props,state){var style={container:{fontSize:"1em",position:"absolute",zIndex:2,top:"1em",left:"1em",opacity:0.7,color:"#B3B8BD"},theSpan:{display:"block",fontSize:"0.6em"},bigSpan:{display:"block"},demoSpan:{display:"block",marginTop:"1em",fontSize:"0.6em"}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:style.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:style.theSpan},'THE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:style.bigSpan},'DANGER'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:style.bigSpan},'CREW'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:style.demoSpan},'BATTLE DEMO')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__HomeOpenOptinModalButton__["a" /* default */],null)));});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint jsx-a11y/href-no-hash: "off" */var MenuHeaderInviteLink=function(_React$Component){_inherits(MenuHeaderInviteLink,_React$Component);function MenuHeaderInviteLink(){_classCallCheck(this,MenuHeaderInviteLink);return _possibleConstructorReturn(this,(MenuHeaderInviteLink.__proto__||Object.getPrototypeOf(MenuHeaderInviteLink)).apply(this,arguments));}_createClass(MenuHeaderInviteLink,[{key:"handleClick",value:function handleClick(e){e.preventDefault();__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["b" /* setMatchmakingValue */])({isLobbyInviteModalOpen:true});}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"menu-header__link",style:this.props.customStyle,href:"#",onClick:this.handleClick.bind(this)},this.props.text);}}]);return MenuHeaderInviteLink;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);MenuHeaderInviteLink.defaultProps={text:"Invite",customStyle:{}};/* harmony default export */ __webpack_exports__["a"] = (MenuHeaderInviteLink);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__battle_connection_firebase_rooms__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveBotButton=function(_React$Component){_inherits(RemoveBotButton,_React$Component);function RemoveBotButton(){_classCallCheck(this,RemoveBotButton);return _possibleConstructorReturn(this,(RemoveBotButton.__proto__||Object.getPrototypeOf(RemoveBotButton)).apply(this,arguments));}_createClass(RemoveBotButton,[{key:"handleClick",value:function handleClick(e){e.preventDefault();__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__battle_connection_firebase_rooms__["f" /* removeBot */])(this.props.combatantId);}},{key:"render",value:function render(){/* eslint jsx-a11y/href-no-hash: "off" */return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#",className:"button extra-small remove-theme",onClick:this.handleClick.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"button--text"},"Remove"));}}]);return RemoveBotButton;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);RemoveBotButton.propTypes={/*someRequiredProp: React.PropTypes.string.isRequired*/};/* harmony default export */ __webpack_exports__["a"] = (RemoveBotButton);

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_home_menu_options__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unlock_localstorage_operations_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__b5_unlocks_getUserUnlocks__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint jsx-a11y/href-no-hash: "off" */var ViewRecordButton=function(_React$Component){_inherits(ViewRecordButton,_React$Component);function ViewRecordButton(){_classCallCheck(this,ViewRecordButton);var _this=_possibleConstructorReturn(this,(ViewRecordButton.__proto__||Object.getPrototypeOf(ViewRecordButton)).call(this));var seenKeys=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__unlock_localstorage_operations_js__["a" /* getSeenUnlocksFromLocalstorage */])();var userUnlockedKeys=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__b5_unlocks_getUserUnlocks__["b" /* getUserUnlocksCompletedKeys */])();_this.state={//Show notification if SEEN is less than total amount of unlocks
isShowingNotification:seenKeys.length<userUnlockedKeys.length};return _this;}_createClass(ViewRecordButton,[{key:"handleGoToRecordScreen",value:function handleGoToRecordScreen(e){e.preventDefault();__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_home_menu_options__["b" /* goToRecordScreen */])();}},{key:"renderNotification",value:function renderNotification(){if(this.state.isShowingNotification){var notificationStyle={position:"absolute",left:"89%",top:"-1.2em",zIndex:2,background:"#EE2828",border:"0.2em solid #FF4646",color:"white",padding:"0.4em",fontSize:"1em"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:notificationStyle},"!");}return null;}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{display:"inline-block",position:"relative"}},this.renderNotification(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#",className:"button small",onClick:this.handleGoToRecordScreen.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"button--text"},"View Record")));}}]);return ViewRecordButton;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ViewRecordButton);

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OnboardingLaptopContainer=function(_React$Component){_inherits(OnboardingLaptopContainer,_React$Component);function OnboardingLaptopContainer(){_classCallCheck(this,OnboardingLaptopContainer);return _possibleConstructorReturn(this,(OnboardingLaptopContainer.__proto__||Object.getPrototypeOf(OnboardingLaptopContainer)).apply(this,arguments));}_createClass(OnboardingLaptopContainer,[{key:"getTranslateValue",value:function getTranslateValue(){if(this.props.isLowered){return"translate3d(0,24em,0)";}// const {vH} = this.props;
return"translate3d(0,0,0)";}},{key:"getMobileStyle",value:function getMobileStyle(){var vH=this.props.vH;return{height:vH*30,padding:"10% 8% 0%",lineHeight:"1.8em"};}},{key:"getDesktopStyle",value:function getDesktopStyle(){var _props=this.props,vH=_props.vH,vW=_props.vW;return{width:"100%",height:vH*37,bottom:0,left:0,paddingTop:vW*3,paddingLeft:vW*3,paddingRight:vW*3,fontSize:"1em",lineHeight:"2.2em"};}},{key:"render",value:function render(){var viewportMode=this.props.viewportMode;var viewportModeStyles=viewportMode==="portrait"?this.getMobileStyle():this.getDesktopStyle();var style=Object.assign({position:"relative",zIndex:3,//Need to control translate with transition
transform:this.getTranslateValue(),transition:"transform 0.5s",backgroundImage:"url(/images/misc/ui-laptop-screen-full.svg)",backgroundRepeat:"no-repeat",backgroundSize:"100%"},viewportModeStyles);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style},this.props.children);}}]);return OnboardingLaptopContainer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{viewportMode:state.global.viewportMode,vH:state.global.vH,vW:state.global.vW//someProp: state.something.someProp
};})(OnboardingLaptopContainer));

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_Skins_js__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OnboardingMember=function(_React$Component){_inherits(OnboardingMember,_React$Component);function OnboardingMember(){_classCallCheck(this,OnboardingMember);return _possibleConstructorReturn(this,(OnboardingMember.__proto__||Object.getPrototypeOf(OnboardingMember)).apply(this,arguments));}_createClass(OnboardingMember,[{key:"render",value:function render(){var skin=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__data_Skins_js__["a" /* default */])()[this.props.skinId];var characterContainerStyle={display:"block",width:"15em",height:"15em",position:"relative",margin:"0 auto"};var characterStyle={position:"absolute",left:0,top:0,width:"100%",display:"block"};var laptopStyle={position:"absolute",left:"3.9em",top:"7em",width:"7em",display:"block"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:characterContainerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{style:characterStyle,src:"/images/misc/shadow.svg",alt:"Shadow"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{style:characterStyle,src:skin.frontViewSrc,alt:"Character"}),this.props.showLaptop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{style:laptopStyle,src:"/images/misc/laptop-back.svg",alt:"Laptop"}):null);}}]);return OnboardingMember;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (OnboardingMember);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OnboardingMember__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_models_from_object_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__audio_audio_manager__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OnboardingMemberRow=function(_React$Component){_inherits(OnboardingMemberRow,_React$Component);function OnboardingMemberRow(){_classCallCheck(this,OnboardingMemberRow);return _possibleConstructorReturn(this,(OnboardingMemberRow.__proto__||Object.getPrototypeOf(OnboardingMemberRow)).apply(this,arguments));}_createClass(OnboardingMemberRow,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(newProps){//Play a sound when laptops pop up
if(newProps.showLaptop&&!this.props.showLaptop){__WEBPACK_IMPORTED_MODULE_4__audio_audio_manager__["a" /* default */].playSfx("sfx_submitAction");}}},{key:"getLeftMemberStyle",value:function getLeftMemberStyle(){return{position:"relative",left:"2em",transform:this.props.buddiesRevealed?"translate3d(0,0,0)":"translate3d(-7em,0,0)",opacity:this.props.buddiesRevealed?"1":"0",transition:"all 0.4s cubic-bezier(.77,0,.94,.81)"};}},{key:"getRightMemberStyle",value:function getRightMemberStyle(){return{position:"relative",left:"-2em",transform:this.props.buddiesRevealed?"translate3d(0,0,0)":"translate3d(7em,0,0)",opacity:this.props.buddiesRevealed?"1":"0",transition:"all 0.4s cubic-bezier(.77,0,.94,.81)"};}},{key:"getMiddleMemberStyle",value:function getMiddleMemberStyle(){return{position:"relative",top:"3em"};}},{key:"render",value:function render(){var crewMembers=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_models_from_object_js__["a" /* modelsFromObject */])(__WEBPACK_IMPORTED_MODULE_2__init_store_js__["a" /* default */].getState().crew.members);var style={display:"flex",justifyContent:"space-around"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:this.getLeftMemberStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__OnboardingMember__["a" /* default */],{skinId:crewMembers[1].skinId,showLaptop:this.props.showLaptop})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:this.getMiddleMemberStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__OnboardingMember__["a" /* default */],{skinId:crewMembers[0].skinId,showLaptop:this.props.showLaptop})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:this.getRightMemberStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__OnboardingMember__["a" /* default */],{skinId:crewMembers[2].skinId,showLaptop:this.props.showLaptop})));}}]);return OnboardingMemberRow;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (OnboardingMemberRow);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__text_convert_speech_array_to_textLine_array_js__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OnboardingScreenIntro__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OnboardingScreenGetName__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loginFromOnboarding__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__b5_home_get_home_menu_options_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_get_query_variable_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OnboardingLaptop__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OnboardingMemberRow__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__audio_AudioControl__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__OnboardingTransitionOverlay__ = __webpack_require__(266);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OnboardingScreen=function(_React$Component){_inherits(OnboardingScreen,_React$Component);function OnboardingScreen(){_classCallCheck(this,OnboardingScreen);var _this=_possibleConstructorReturn(this,(OnboardingScreen.__proto__||Object.getPrototypeOf(OnboardingScreen)).call(this));_this.state={isLoggedIn:Boolean(__WEBPACK_IMPORTED_MODULE_2__init_store_js__["a" /* default */].getState().crew.logggedInUserId),//Use this if you want to add a "Welcome Back" screen.
isOverlayOpaque:true,isLaptopLowered:false,step:"fade-out",//1. intro, intro2 2. getName, 3. outro
nameFromUser:""//"" //not known yet
};return _this;}_createClass(OnboardingScreen,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;//First Step: fade out the overlay
setTimeout(function(){_this2.setState({isOverlayOpaque:false});},200);}//Intro overlay is done fading out, revealing our character and laptop
},{key:"handleOverlayDone",value:function handleOverlayDone(){var _this3=this;setTimeout(function(){//Start the intro text
_this3.setState({step:"intro"});},200);}//Got the name, now move on to the next step in the chain.
},{key:"handleNameReceived",value:function handleNameReceived(nameFromUserInput){this.setState({step:"nice-to-meet-you",nameFromUser:nameFromUserInput});}},{key:"handleTransitionToNextScreen",value:function handleTransitionToNextScreen(){var _this4=this;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__loginFromOnboarding__["a" /* loginFromOnboarding */])(this.state.nameFromUser,function(){//After the login is complete, go to homescreen.
setTimeout(function(){if(_this4.props.isInvitedByFriend){//Invited by friend: go straight to Arena
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__b5_home_get_home_menu_options_js__["f" /* goToArenaFromInvite */])();}else{//Visiting user
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__b5_home_get_home_menu_options_js__["a" /* goToHomeScreen */])();}},600);});}//Callback hell! Wait for a bit, then lower the laptop, then wait some more, and then exit to the Home screen
},{key:"exitLaptopScreen",value:function exitLaptopScreen(){var _this5=this;setTimeout(function(){_this5.setState({isLaptopLowered:true},function(){setTimeout(function(){_this5.handleTransitionToNextScreen();},700);});},600);}},{key:"getIntroText",value:function getIntroText(){if(this.props.isInvitedByFriend){var friendName=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_get_query_variable_js__["a" /* getQueryVariable */])("f")||"A friend";//EX: "Glenn" or "A friend"
return[friendName+" is challenging you to a ","[FAST]Hack Battle!"];}return["Hello!","@@pause_300@@","Welcome to The Danger Crew's ","[FAST]BATTLE DEMO!","@@pause_300@@","I hope you're ready to do some hacking. "];}},{key:"getDesktopWrap",value:function getDesktopWrap(){if(this.props.viewportMode==="portrait"){return{};}return{width:"40em",margin:"0 auto"};}},{key:"setNextStep",value:function setNextStep(nextStep){var _this6=this;var timeout=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1000;setTimeout(function(){_this6.setState({step:nextStep});},timeout);}},{key:"renderContent",value:function renderContent(){//Step one: INTRO
if(this.state.step==="intro"){var introText=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__text_convert_speech_array_to_textLine_array_js__["a" /* convertSpeechArrayToTextLineArray */])(this.getIntroText(),//Returns the proper array of text to use
{defaultTextColor:"#fff"});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__OnboardingScreenIntro__["a" /* default */],{key:"1",text:introText,onTextComplete:this.setNextStep.bind(this,"intro2")});}//Step one: INTRO
if(this.state.step==="intro2"||this.state.step==="getName"){var _introText=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__text_convert_speech_array_to_textLine_array_js__["a" /* convertSpeechArrayToTextLineArray */])(["We just need your name to get started..."],{defaultTextColor:"#fff"});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__OnboardingScreenIntro__["a" /* default */],{key:"2",text:_introText,onTextComplete:this.setNextStep.bind(this,"getName",200)});}if(this.state.step==="nice-to-meet-you"){var _introText2=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__text_convert_speech_array_to_textLine_array_js__["a" /* convertSpeechArrayToTextLineArray */])(["Great! ","@@pause_300@@","Nice to meet you, "+this.state.nameFromUser+"!"],{defaultTextColor:"#fff"});var nextStep=this.props.isInvitedByFriend?"outro"//Skip to end if invite
:"introduce-crew";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__OnboardingScreenIntro__["a" /* default */],{key:"3",text:_introText2,onTextComplete:this.setNextStep.bind(this,nextStep)});}if(this.state.step==="introduce-crew"){var _introText3=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__text_convert_speech_array_to_textLine_array_js__["a" /* convertSpeechArrayToTextLineArray */])(["This is your Crew.","@@pause_300@@","These friendly people will help you defeat rivals in the Hacker Battles to come."],{defaultTextColor:"#fff"});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__OnboardingScreenIntro__["a" /* default */],{key:"4",text:_introText3,onTextComplete:this.setNextStep.bind(this,"outro")});}if(this.state.step==="outro"){var endingLine=this.props.isInvitedByFriend?"It's time to show your friend what you can do!"//Alternate copy for Invite link
:"It's time to show the world what you can do!";var _introText4=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__text_convert_speech_array_to_textLine_array_js__["a" /* convertSpeechArrayToTextLineArray */])(["Grab your laptop and assemble for battle.","@@pause_300",endingLine],{defaultTextColor:"#fff"});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__OnboardingScreenIntro__["a" /* default */],{key:"5",text:_introText4,onTextComplete:this.setNextStep.bind(this,"pre-laptop-delay")});//"Grab your laptops Are you ready to show the world what you can do?"
}if(this.state.step==="pre-laptop-delay"){var _introText5=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__text_convert_speech_array_to_textLine_array_js__["a" /* convertSpeechArrayToTextLineArray */])([""],{defaultTextColor:"#fff"});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__OnboardingScreenIntro__["a" /* default */],{key:"6",text:_introText5,onTextComplete:this.setNextStep.bind(this,"laptops",600)});//"Grab your laptops Are you ready to show the world what you can do?"
}if(this.state.step==="laptops"){var _introText6=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__text_convert_speech_array_to_textLine_array_js__["a" /* convertSpeechArrayToTextLineArray */])([""],{defaultTextColor:"#fff"});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__OnboardingScreenIntro__["a" /* default */],{key:"7",text:_introText6,onTextComplete:this.exitLaptopScreen.bind(this)});//"Grab your laptops Are you ready to show the world what you can do?"
}return null;}},{key:"renderNameModal",value:function renderNameModal(){if(this.state.step==="getName"){// const getNameText = convertSpeechArrayToTextLineArray([
//   "What's your first name?"
// ], {defaultTextColor: "#fff"});
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__OnboardingScreenGetName__["a" /* default */],{onNameReceived:this.handleNameReceived.bind(this),viewportMode:this.props.viewportMode});}}},{key:"render",value:function render(){var style={fontSize:this.props.viewportMode==="portrait"?"0.8em":"0.5em",//mobile, desktop
height:"100%"};var contentStyle=Object.assign({height:"100%",display:"flex",flexDirection:"column",justifyContent:"space-between"},this.getDesktopWrap());var charactersContainerStyle={flex:"1",display:"flex",flexDirection:"column",justifyContent:"space-around"};var isShowingCrew=this.state.step==="introduce-crew"||this.state.step==="outro"||this.state.step==="pre-laptop-delay"||this.state.step==="laptops";var isShowingLaptops=this.state.step==="laptops";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__OnboardingTransitionOverlay__["a" /* default */],{isOpaque:this.state.isOverlayOpaque,onTransitionComplete:this.handleOverlayDone.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style,className:"menu-texture"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__audio_AudioControl__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:contentStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:charactersContainerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__OnboardingMemberRow__["a" /* default */],{buddiesRevealed:isShowingCrew,showLaptop:isShowingLaptops})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__OnboardingLaptop__["a" /* default */],{isLowered:this.state.isLaptopLowered},this.renderContent())),this.renderNameModal()));}}]);return OnboardingScreen;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{viewportMode:state.global.viewportMode,isInvitedByFriend:state.battle.isMultiplayerMode//They mean the same thing here
};})(OnboardingScreen));

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__battle_optin_optin_utilities_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__audio_audio_manager_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__b5_crew_management_edit_combatant_operations_js__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint jsx-a11y/href-no-hash: "off" */var OnboardingScreenGetName=function(_React$Component){_inherits(OnboardingScreenGetName,_React$Component);function OnboardingScreenGetName(){_classCallCheck(this,OnboardingScreenGetName);var _this=_possibleConstructorReturn(this,(OnboardingScreenGetName.__proto__||Object.getPrototypeOf(OnboardingScreenGetName)).call(this));_this.state={isShowingForm:false,isShowingErrors:false,showingCompletedName:null};return _this;}_createClass(OnboardingScreenGetName,[{key:"componentWillMount",value:function componentWillMount(){var _this2=this;setTimeout(function(){_this2.setState({isShowingForm:true});__WEBPACK_IMPORTED_MODULE_2__audio_audio_manager_js__["a" /* default */].playSfx("sfx_popup");},600);}},{key:"handleSubmitButton",value:function handleSubmitButton(e){e.preventDefault();this.handleNameSubmit();}},{key:"capAt10Chars",value:function capAt10Chars(){//If iOS pastes in a name that thrawrts maxLength, just shorten it here.
this.refs.name.value=this.refs.name.value.substr(0,9);}},{key:"handleNameSubmit",value:function handleNameSubmit(e){var _this3=this;if(e){e.preventDefault();}var newValue=this.refs.name.value;//validate it for length
if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__battle_optin_optin_utilities_js__["c" /* isNameValid */])(newValue)){//Run through safe check for weird characters
newValue=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__b5_crew_management_edit_combatant_operations_js__["e" /* getSafeCombatantName */])(newValue);//valid length!
this.setState({showingCompletedName:newValue,isShowingErrors:false});//SFX: "success"
__WEBPACK_IMPORTED_MODULE_2__audio_audio_manager_js__["a" /* default */].playSfx("sfx_submitAction");//Wait a second for effect, then proceed
setTimeout(function(){_this3.props.onNameReceived(newValue);},1000);}else{//Invalid - show errors
this.setState({isShowingErrors:true});}}},{key:"renderSubmitButton",value:function renderSubmitButton(){if(this.state.showingCompletedName){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#",className:"button block large primary",onClick:this.handleSubmitButton.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"button--text"},"Let's Go!"));}},{key:"renderInputArea",value:function renderInputArea(){//If we've submitted, show just the name for a second.
if(this.state.showingCompletedName){var style={fontSize:"1.8em",textAlign:"center"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style},this.state.showingCompletedName,"!");}//Default to the form field
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{onChange:this.capAt10Chars.bind(this),className:"NameTextInput",style:{width:"100%"},id:"onboarding-name-input",ref:"name",type:"text",maxLength:9,autoFocus:true,autoComplete:"off",autoCorrect:"off",autoCapitalize:"off",spellCheck:"false"});}},{key:"renderForm",value:function renderForm(){var overlayStyle={position:"absolute",left:0,right:0,bottom:0,top:0,background:"rgba(255,255,255,0.95)",zIndex:4,display:"flex",flexDirection:"column",justifyContent:"space-around",padding:"2em"};var modalStyle={padding:"3em",background:"#FCFCFC",outline:"0.5em solid #1F0535",margin:"0 auto",width:"100%",zIndex:"1",position:"relative",maxWidth:this.props.viewportMode==="landscape"?"33em":"100%"//desktop, mobile
};var labelStyle={textAlign:"center",display:"block",fontSize:"1em",marginBottom:"3em"};var ctaContainerStyle={marginTop:"3em"};var errorStyle={textAlign:"center",marginTop:"3em",color:"red"};//If we haven't submitted yet, show a form:
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:overlayStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:modalStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{ref:"form",onSubmit:this.handleNameSubmit.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{style:labelStyle,htmlFor:"onboarding-name-input"},"What's your name?"),this.renderInputArea(),this.state.isShowingErrors?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:errorStyle},"Please enter a valid name."):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:ctaContainerStyle},this.renderSubmitButton()))));}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,this.state.isShowingForm?this.renderForm():null);}}]);return OnboardingScreenGetName;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (OnboardingScreenGetName);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__text_SkippableTextLine__ = __webpack_require__(406);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import TextLine from "../text/TextLine.js";
var OnboardingScreenIntro=function(_React$Component){_inherits(OnboardingScreenIntro,_React$Component);function OnboardingScreenIntro(){_classCallCheck(this,OnboardingScreenIntro);return _possibleConstructorReturn(this,(OnboardingScreenIntro.__proto__||Object.getPrototypeOf(OnboardingScreenIntro)).apply(this,arguments));}_createClass(OnboardingScreenIntro,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__text_SkippableTextLine__["a" /* default */],{lineData:this.props.text,onDone:this.props.onTextComplete.bind(this)});}}]);return OnboardingScreenIntro;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (OnboardingScreenIntro);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OnboardingTransitionOverlay=function(_React$Component){_inherits(OnboardingTransitionOverlay,_React$Component);function OnboardingTransitionOverlay(){_classCallCheck(this,OnboardingTransitionOverlay);var _this=_possibleConstructorReturn(this,(OnboardingTransitionOverlay.__proto__||Object.getPrototypeOf(OnboardingTransitionOverlay)).call(this));_this.state={isHidden:false//Is this rendering as 'null' to not block anything
};return _this;}_createClass(OnboardingTransitionOverlay,[{key:"handleTransitionEnd",value:function handleTransitionEnd(){var _this2=this;if(typeof this.props.onTransitionComplete==="function"){this.setState({isHidden:true},function(){_this2.props.onTransitionComplete();});}}},{key:"render",value:function render(){if(this.state.isHidden){return null;}var style={position:"absolute",zIndex:100,left:0,right:0,top:0,bottom:0,background:"#151825 radial-gradient(50% 105%, rgba(40,48,79,0.00) 52%, rgba(11,15,32,0.70) 100%)",opacity:this.props.isOpaque?1:0,transition:"opacity 0.9s"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style,onTransitionEnd:this.handleTransitionEnd.bind(this)});}}]);return OnboardingTransitionOverlay;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (OnboardingTransitionOverlay);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loginFromOnboarding;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__battle_connection_firebase_users_js__ = __webpack_require__(54);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function loginFromOnboarding(userFirstName,callback){//First, update our local crew to include the user's entered firstname.
var localCrew=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().crew.members;var mainKey=Object.keys(localCrew)[0];__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["e" /* setCrewValue */])({name:userFirstName+"'s Crew",record:Object.assign({},__WEBPACK_IMPORTED_MODULE_2__battle_connection_firebase_users_js__["f" /* userRecordsSchema */]),members:Object.assign({},localCrew,_defineProperty({},mainKey,Object.assign({},localCrew[mainKey],{name:userFirstName})))});//Now Log in to firebase, then set our initial crewMembers, Crew name, and record
window.firebase.auth().signInAnonymously().catch(function(error){console.warn("error",error);//
}).then(function(user){// console.log("user", user);
//Set my local user id so we know I'm logged in.
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["e" /* setCrewValue */])({logggedInUserId:user.uid});//Set all of my defaults to Firebase.
var _store$getState$crew=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().crew,name=_store$getState$crew.name,record=_store$getState$crew.record,members=_store$getState$crew.members;window.firebase.database().ref("users/client_"+user.uid).set({battleRecord:record,crewName:name,crewMembers:members}).then(function(){//Ready to proceed
callback();//SIDE PROCESS: Add acquisition type to this user
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__battle_connection_firebase_users_js__["g" /* addAcquisitionTypeToUser */])(user.uid);});});}

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UnlocksList__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__battle_UserCrewRecord_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__b5_home_MenuHeader_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Switcher__ = __webpack_require__(269);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint jsx-a11y/href-no-hash: "off" */var RecordsScreen=function(_React$Component){_inherits(RecordsScreen,_React$Component);function RecordsScreen(){_classCallCheck(this,RecordsScreen);var _this=_possibleConstructorReturn(this,(RecordsScreen.__proto__||Object.getPrototypeOf(RecordsScreen)).call(this));_this.state={viewingScreen:"unlocks"//"unlocks" | "history"
};return _this;}// handleGoBackHomeLink(e) {
//   e.preventDefault();
//   goToHomeScreen();
// }
_createClass(RecordsScreen,[{key:"handleNewSelectionChosen",value:function handleNewSelectionChosen(newSelection){this.setState({viewingScreen:newSelection});}//Maybe return styles that wrap the desktop layout together
},{key:"getDesktopWrap",value:function getDesktopWrap(){if(this.props.viewportMode==="portrait"){return{};}return{width:this.state.viewingScreen==="unlocks"?"90em":"40em",//wider wrap on Desktop/unlocks
margin:"0 auto"};}},{key:"renderRecord",value:function renderRecord(){var crewTitleStyle={container:{textAlign:"center",marginBottom:"4em"},label:{fontSize:"0.7em",marginBottom:"1em",color:"#877F8E"}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:crewTitleStyle.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:crewTitleStyle.label},"Crew History"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,this.props.crewName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__battle_UserCrewRecord_js__["a" /* default */],null));}},{key:"renderUnlocks",value:function renderUnlocks(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UnlocksList__["a" /* default */],{viewportMode:this.props.viewportMode});}},{key:"render",value:function render(){var style={fontSize:this.props.viewportMode==="portrait"?"0.6em":"0.5em",//mobile, desktop
height:"100%",paddingTop:"4em"//Same height as absolute header. Faking a box stacking behavior
};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style,className:"menu-texture"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__b5_home_MenuHeader_js__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:Object.assign({padding:"1em"},this.getDesktopWrap())},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Switcher__["a" /* default */],{options:["history","unlocks"],currentlyActiveKey:this.state.viewingScreen,handleNewSelection:this.handleNewSelectionChosen.bind(this)}),this.state.viewingScreen==="unlocks"?this.renderUnlocks():this.renderRecord())));}}]);return RecordsScreen;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{crewName:state.crew.name,viewportMode:state.global.viewportMode};})(RecordsScreen));

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint jsx-a11y/href-no-hash: "off" */var Switcher=function(_React$Component){_inherits(Switcher,_React$Component);function Switcher(){_classCallCheck(this,Switcher);return _possibleConstructorReturn(this,(Switcher.__proto__||Object.getPrototypeOf(Switcher)).apply(this,arguments));}_createClass(Switcher,[{key:"handleOptionClick",value:function handleOptionClick(option,e){e.preventDefault();//Fire our passed in function with newly selected value
this.props.handleNewSelection(option);}},{key:"renderOptionStyle",value:function renderOptionStyle(option){var isActive=this.props.currentlyActiveKey===option;return{textTransform:"capitalize",textDecoration:"none",padding:"1em 0",width:"50%",textAlign:"center",borderTop:isActive?"0.3em solid #739BFA":"0.3em solid #F0ECEC",background:isActive?"#4A90E2":"#FAFAFA",borderBottom:isActive?"0.3em solid #4A90E2":"0.3em solid #FAFAFA",color:isActive?"#FAFAFA":"#200535"};}},{key:"render",value:function render(){var _this2=this;var containerStyle={display:"flex",width:"28em",margin:"1em auto 3em"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:containerStyle,className:"Switcher"},this.props.options.map(function(option,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{key:i,href:"#",style:_this2.renderOptionStyle(option),onClick:_this2.handleOptionClick.bind(_this2,option)},option);}));}}]);return Switcher;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Switcher);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getUserUnlocks__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__battle_ArenaView_SubmissionMenu_icon_svg_getters_icon_folder_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__b5_home_unlock_localstorage_operations__ = __webpack_require__(137);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UnlocksList=function(_React$Component){_inherits(UnlocksList,_React$Component);function UnlocksList(){_classCallCheck(this,UnlocksList);return _possibleConstructorReturn(this,(UnlocksList.__proto__||Object.getPrototypeOf(UnlocksList)).apply(this,arguments));}_createClass(UnlocksList,[{key:"componentDidMount",value:function componentDidMount(){//Mark these as SEEN!
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__b5_home_unlock_localstorage_operations__["b" /* setSeenUnlocksInLocalstorage */])();}},{key:"renderUnlockAvatar",value:function renderUnlockAvatar(model){var style={marginRight:"1.3em"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style,className:"UnlockIconContainer"},model.isComplete&&typeof model.iconFn==="function"?model.iconFn("3.5em"):__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__battle_ArenaView_SubmissionMenu_icon_svg_getters_icon_folder_js__["j" /* getLockIcon */])("3.5em"));}},{key:"renderUnlock",value:function renderUnlock(model,key){var nameText=model.isComplete?model.name:"?????";var style={container:{marginBottom:"3.2em",padding:this.props.viewportMode==="landscape"?"1em":"0",width:this.props.viewportMode==="landscape"?"50%":"100%"},titleRow:{display:"flex",alignItems:"center",marginBottom:"1.3em"},progressContainerStyle:{height:"0.6em",position:"relative",background:"#485471",// borderTop: "0.3em solid #3E475C",
width:"98%",//quick hack to make the margins feel aligned (bc of outline)
outline:"0.3em solid #200535",margin:"0.3em 1%"},progressFill:{position:"absolute",left:0,top:0,bottom:0,background:model.isComplete?"#50E3C2":"#DBE2F6",borderBottom:model.isComplete?"0.3em solid #43CDAE":"0.3em solid #CAD1E6",width:model.progressPercent},unlockText:{fontSize:"1.1em",textTransform:"uppercase",marginBottom:"0.7em"},requirementText:{color:model.isComplete?"#1E8870":"#585B72"}};var subText=model.isComplete?model.completedText:model.requirementText;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:key,style:style.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style.titleRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,this.renderUnlockAvatar(model)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style.unlockText},nameText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style.requirementText},subText))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style.progressContainerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style.progressFill})));}},{key:"render",value:function render(){var _this2=this;var userUnlocks=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getUserUnlocks__["a" /* getUserUnlocks */])();var containerStyle={padding:"1em",display:this.props.viewportMode==="landscape"?"flex":"block",flexWrap:"wrap"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:containerStyle},__WEBPACK_IMPORTED_MODULE_1__getUserUnlocks__["c" /* unlocks */].map(function(unlock,i){var model=Object.assign({name:unlock.name,requirementText:unlock.requirementText,completedText:unlock.completedText,acquiredNumber:unlock.acquiredNumber,requiredNumber:unlock.requiredNumber,iconFn:unlock.icon},userUnlocks[unlock.id]);return _this2.renderUnlock(model,i);}));}}]);return UnlocksList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (UnlocksList);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compareUnlocksStates;
/* Take in two sets of Unlocks and return the newly added ones */function compareUnlocksStates(oldUnlocks,newUnlocks){var wasCompleted=getCompletedUnlockKeys(oldUnlocks);var nowCompleted=getCompletedUnlockKeys(newUnlocks);//Return an array with only the NEW UNLOCK KEYS included.
return nowCompleted.filter(function(unlockedKey){return!wasCompleted.includes(unlockedKey);//Filter out entries that are seen in wasCompleted
});}function getCompletedUnlockKeys(unlocksObj){return Object.keys(unlocksObj).filter(function(key){var model=unlocksObj[key];return model.isComplete;});}

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__optin_utilities__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__optin_localstorage_operations__ = __webpack_require__(139);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* This file is a bit old now! */var OptinBox=function(_React$Component){_inherits(OptinBox,_React$Component);function OptinBox(){_classCallCheck(this,OptinBox);var _this=_possibleConstructorReturn(this,(OptinBox.__proto__||Object.getPrototypeOf(OptinBox)).call(this));_this.state={currentValidationErrors:[]};return _this;}_createClass(OptinBox,[{key:"componentDidMount",value:function componentDidMount(){//Mark that we've seen this before!
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__optin_localstorage_operations__["c" /* setSeenModalInLocalstorage */])();}},{key:"handleSubmit",value:function handleSubmit(e){var _this2=this;if(e){e.preventDefault();}var inputValue=this.refs.input.value;this.setState({currentValidationErrors:[]//Reset the errors
});if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__optin_utilities__["a" /* isEmailValid */])(inputValue)){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__optin_utilities__["b" /* submitEmail */])(inputValue,function(){///Mark that we've signed up before!
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__optin_localstorage_operations__["d" /* setHasSignedUpInLocalstorage */])();//Call the success callback!
if(_this2.props.successCallback){_this2.props.successCallback();}});return;}//Email was not valid. Add errors
this.setState({currentValidationErrors:["Please enter a valid email address!"]});}},{key:"handleButtonClick",value:function handleButtonClick(e){e.preventDefault();this.handleSubmit();}},{key:"render",value:function render(){var labelStyle={fontSize:"1em",display:"block",marginBottom:"1.5em",color:"#5F506A",marginLeft:"2%"};var inputStyle={// display: "block",
width:"96%",textAlign:"left",paddingLeft:"1em"// fontSize: vW * 5,
// height: vW * 12,
// fontFamily: "Source Code Pro, monospace",
// paddingLeft: vW,
// border: `${vW / 4}px solid #999`,
// borderRadius: 0,
// marginBottom: vW
};var submitStyle={};var errorStyle={color:"red",fontSize:"1em",padding:"3em 0 0"};/* eslint jsx-a11y/href-no-hash: "off" */return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{onSubmit:this.handleSubmit.bind(this),noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{style:labelStyle},"Email Address"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{ref:"input",className:"NameTextInput",style:inputStyle,type:"email"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{marginTop:"2em"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#",onClick:this.handleButtonClick.bind(this),className:"button block primary large",style:submitStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"button--text"},"Submit")))),this.state.currentValidationErrors.map(function(errorString,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i,style:errorStyle},errorString);}));}}]);return OptinBox;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{};})(OptinBox));

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ArenaView_is_submission_menu_open_js__ = __webpack_require__(52);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ArenaMainLaptopContainer=function(_React$Component){_inherits(ArenaMainLaptopContainer,_React$Component);function ArenaMainLaptopContainer(){_classCallCheck(this,ArenaMainLaptopContainer);return _possibleConstructorReturn(this,(ArenaMainLaptopContainer.__proto__||Object.getPrototypeOf(ArenaMainLaptopContainer)).apply(this,arguments));}_createClass(ArenaMainLaptopContainer,[{key:"getTranslateValue",value:function getTranslateValue(){if(this.props.isSubmissionMenuOpen&&this.props.viewportMode==="portrait"){var vH=this.props.vH;return"translate3d(0,"+vH*-21+"px,0)";}return"translate3d(0,0,0)";}},{key:"getMobileStyle",value:function getMobileStyle(){var vH=this.props.vH;return{left:vH,right:vH,bottom:vH*-40,height:vH*65,padding:"5% 8% 0%"};}},{key:"getDesktopStyle",value:function getDesktopStyle(){var _props=this.props,vH=_props.vH,vW=_props.vW;return{width:vW*37,height:vH*47,bottom:0,left:vW*58,paddingTop:vW*2,paddingLeft:vW*3,paddingRight:vW*3,fontSize:"0.7em"};}},{key:"render",value:function render(){var viewportMode=this.props.viewportMode;var viewportModeStyles=viewportMode==="portrait"?this.getMobileStyle():this.getDesktopStyle();var style=Object.assign({position:"absolute",zIndex:3,//Need to control translate with transition
transform:this.getTranslateValue(),transition:"transform 0.2s",backgroundImage:"url(/images/misc/ui-laptop-screen-full.svg)",backgroundRepeat:"no-repeat",backgroundSize:"100%"},viewportModeStyles);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{zIndex:"2",position:"relative"}},this.props.children));}}]);return ArenaMainLaptopContainer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{viewportMode:state.global.viewportMode,vH:state.global.vH,vW:state.global.vW,isSubmissionMenuOpen:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__ArenaView_is_submission_menu_open_js__["a" /* isSubmissionMenuOpen */])()//someProp: state.something.someProp
};})(ArenaMainLaptopContainer));

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ArenaBackgroundStyle=function(_React$Component){_inherits(ArenaBackgroundStyle,_React$Component);function ArenaBackgroundStyle(){_classCallCheck(this,ArenaBackgroundStyle);return _possibleConstructorReturn(this,(ArenaBackgroundStyle.__proto__||Object.getPrototypeOf(ArenaBackgroundStyle)).apply(this,arguments));}_createClass(ArenaBackgroundStyle,[{key:'render',value:function render(){var style={position:"absolute",left:0,top:0,right:0,bottom:0,background:this.props.arenaBackgroundStyle,transition:"background 0.8s"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:style});}}]);return ArenaBackgroundStyle;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{arenaBackgroundStyle:state.battle.arenaBackgroundStyle};})(ArenaBackgroundStyle));

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ArenaCombatantScoreboard__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_models_from_object_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ArenaCombatantWaitingBlip__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_Skins_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__is_submission_menu_open_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ArenaCombatantLaptop__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__audio_audio_manager_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__svg_getters_CombatantWarningIcon__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__svg_getters_CombatantShadow__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__svg_getters_CombatantTargetMarker__ = __webpack_require__(381);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import {getCombatantArenaPosition} from './getCombatantArenaPosition'
var skins=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__data_Skins_js__["a" /* default */])();//cache all skin models right here.
var ArenaCombatant=function(_React$Component){_inherits(ArenaCombatant,_React$Component);function ArenaCombatant(){_classCallCheck(this,ArenaCombatant);return _possibleConstructorReturn(this,(ArenaCombatant.__proto__||Object.getPrototypeOf(ArenaCombatant)).apply(this,arguments));}_createClass(ArenaCombatant,[{key:'componentDidMount',value:function componentDidMount(){this.writeDomPositionToCombatantModel();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newProps){if(newProps.isPlayerControlled){if(!this.props.isCurrentlySelecting&&newProps.isCurrentlySelecting){//hop!
__WEBPACK_IMPORTED_MODULE_9__audio_audio_manager_js__["a" /* default */].playSfx("sfx_jump");__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(this.props.model.id,{animationCssRule:"jump 0.2s"});}}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){//Write X/Y coord data to combatant
if(this.props.vW!==prevProps.vW||this.props.vH!==prevProps.vH){this.writeDomPositionToCombatantModel();}}//This provides our X/Y in state so external components can overlay on our exact position
},{key:'writeDomPositionToCombatantModel',value:function writeDomPositionToCombatantModel(){var bodyRect=document.getElementsByClassName("ArenaView")[0].getBoundingClientRect();var boundingRect=this.refs.combatant.getBoundingClientRect();__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(this.props.model.id,{boundingClientRect:{top:String(boundingRect.top-bodyRect.top)+"px",left:String(boundingRect.left-bodyRect.left)+"px",width:String(boundingRect.width)+"px",height:String(boundingRect.height)+"px"}});}},{key:'handleClick',value:function handleClick(e){//This will either show the info view or target this person as the combatant
if(this.props.isTargetable){//Set this one as the active one
// (Note: this is technically optional, but I like the clean notion that the Submitted one is always selected?)
this.props.arenaMenuSnapshot.setActive(this.props.myMenuNode);//aaaand submit my menu node
this.props.arenaMenuSnapshot.submit(this.props.myMenuNode);}// console.log('combatant clicked! info view!');
}},{key:'handleHover',value:function handleHover(){if(this.props.myMenuNode){this.props.arenaMenuSnapshot.setActive(this.props.myMenuNode);}}/** This combatant is controlled by a different human player Online and we're waiting for them to choose  */},{key:'isWaitingForThisCombatantToSubmit',value:function isWaitingForThisCombatantToSubmit(){return this.props.isCurrentlySelecting&&!this.props.isPlayerControlled;}},{key:'getTurnBubbleArray',value:function getTurnBubbleArray(){/* Look at the seriesTurnOrder to know how many bubbles you should have. *//* Compare that to the turns that have been used. */var _props=this.props,model=_props.model,seriesTurnOrder=_props.seriesTurnOrder,seriesTurnsSubmitters=_props.seriesTurnsSubmitters;//Don't show these if Combatant is dead
if(!model.isAlive()){return[];}return seriesTurnOrder.filter(function(combId){return combId===model.id||combId==='deadline::'+model.id;}).map(function(combId){return!seriesTurnsSubmitters.includes(combId);//True = full bubble.
});//EX: return [true, false] for 1 full bubble, then 1 empty bubble
}},{key:'hasTargetingWarning',value:function hasTargetingWarning(){//Look for validity problems with me
if(this.props.arenaSubmissionMenuAction&&this.props.isTargetable){var validityModel=this.props.arenaSubmissionMenuAction.getValidity(this.props.arenaSubmissionMenuAction,{},//casterModel, not really needed.
[this.props.model]);//Return true if the validityModel is invalid
return!validityModel.isValid;}return false;}/** Show a bot flag if this person is a BOT in multiplayer mode */},{key:'renderBotIcon',value:function renderBotIcon(){if(this.props.isMultiplayerMode&&this.props.model.isBot){var style={position:"absolute",fontSize:"0.5em",color:"#647365",background:"#D9EEDA",padding:"0.25em 0.5em",border:"0.2em solid #EAFFEB",left:"50%",transform:"translateX(-50%)",top:"70%",zIndex:4};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:style},'BOT');}return null;}},{key:'renderTargetingCrosshair',value:function renderTargetingCrosshair(characterSize){if(!this.props.isTargetable){return null;}//Create a crosshair flag for this option attacking multiple opponents at the same time.
var isTargetingMultipleCombatants=this.props.arenaMenuSnapshot.viewId==="targetsView"&&this.props.arenaMenuSnapshot.currentlySelectedOptionData.viewBag.targetIds&&this.props.arenaMenuSnapshot.currentlySelectedOptionData.viewBag.targetIds.length>1;//Decide if we should show this on mobile or not
var shouldShowCrosshairOnMobile=this.props.isTouchMode?isTargetingMultipleCombatants:false;//If I'm targetable and selected, show the crosshair
if(this.props.isSelected&&(shouldShowCrosshairOnMobile||!this.props.isTouchMode)){var imageSrc=this.props.isEnemyTeam?"/images/misc/targeting.svg":"/images/misc/targeting-friendly.svg";var _style={position:"absolute",left:0,right:0,top:0,bottom:0,//background: "red",
background:'url('+imageSrc+') no-repeat no-repeat',backgroundSize:"cover",backgroundPosition:"0% 0%",zIndex:4,animation:"targetCrosshair 0.2s infinite alternate-reverse steps(3)"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:_style});}//Default to static marker (if we're targeted)
var style={position:"absolute",left:0,top:"-6%",zIndex:4};return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__svg_getters_CombatantTargetMarker__["a" /* default */])(characterSize,style,{isFriendly:!this.props.isEnemyTeam});}},{key:'getLeftPosition',value:function getLeftPosition(){var pd=this.props.positionData;var vW=this.props.vW;//Mobile layout!
if(this.props.viewportMode==="portrait"){if(pd.totalPositions===3){//THREE people on the team
if(pd.position===2){return"20%";//return vW * 4
}if(pd.position===1){return"50%";//return vW * 34
}if(pd.position===3){return"80%";//return vW * 62
}}if(pd.totalPositions===2){//TWO people on the team
if(pd.position===1){return 30;}if(pd.position===2){return vW*48;}}//Assume middle
return vW*32;//ONE person on the team
}//Desktop layout!
if(this.props.viewportMode==="landscape"){if(pd.totalPositions===3){//THREE people on the team
if(pd.position===2){return vW*15;}if(pd.position===1){return vW*30;}if(pd.position===3){return vW*45;}}if(pd.totalPositions===2){//TWO people on the team
if(pd.position===1){return vW*20;}if(pd.position===2){return vW*43;}}//Assume middle
return vW*30;//ONE people on the team
}}},{key:'getTopPosition',value:function getTopPosition(){var pd=this.props.positionData;var vW=this.props.vW;var vH=this.props.vH;//Possibly move combatants pretty far up if
//a) Friendly team, b) Submission Menu is open, and c) we're on mobile
if(!this.props.isEnemyTeam&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__is_submission_menu_open_js__["a" /* isSubmissionMenuOpen */])()&&this.props.viewportMode==="portrait"){//The selector is a little bit higher
if(//WARNING! This logic copied from below
this.props.isCurrentlySelecting&&//I'm selecting
this.props.isPlayerControlled&&//I'm controlled by the player
!this.props.arenaSubmissionIsSubmitted//The action has not been submitted yet
){return vH*-11;}//Everybody else
return vH*-8;}if(pd.totalPositions===3&&pd.position===1){//1 is set to be the middle (the main)
//MOBILE vertical offset for middle person
if(this.props.viewportMode==="portrait"){return this.props.isEnemyTeam?vH*-3:vH*3;}//DESKTOP vertical offset for middle person
if(this.props.viewportMode==="landscape"){return this.props.isEnemyTeam?vW*-4:vW*4;}}return 0;}//If this is an enemy combatant who is currently selecting, nudge them forward a little bit.
//This value is animated by transform
},{key:'getSelectingYAxisAdjustment',value:function getSelectingYAxisAdjustment(initialYPosition){var vH=this.props.vH;if(this.props.isEnemyTeam&&this.props.isCurrentlySelecting){return initialYPosition+vH*3;}return initialYPosition;}},{key:'getZIndex',value:function getZIndex(){var pd=this.props.positionData;if(this.props.isEnemyTeam){//Enemy Team: Middle person has lowest Z Index
if(pd.totalPositions===3&&pd.position===2){return 1;}return 2;}else{//Ally Team: Middle person has highest Z Index
if(pd.totalPositions===3&&pd.position===2){return 2;}return 1;}}},{key:'getSkinSrc',value:function getSkinSrc(){var skinModel=skins[this.props.model.skinId];if(this.props.isEnemyTeam){return skinModel.frontViewSrc;}//Turn to face the user if currently selecting
if(this.props.isCurrentlySelecting&&//I'm selecting
this.props.isPlayerControlled&&//I'm controlled by the player
!this.props.arenaSubmissionIsSubmitted//The action has not been submitted yet
){return skinModel.frontViewSrc;}return skinModel.backViewSrc;}},{key:'render',value:function render(){var _props2=this.props,viewportMode=_props2.viewportMode,model=_props2.model,isEnemyTeam=_props2.isEnemyTeam;var vW=viewportMode==="landscape"?this.props.vW/3://Desktop variant of vW
this.props.vW;var topPosition=this.getSelectingYAxisAdjustment(this.getTopPosition());var style={position:"absolute",// border: this.getBorderStyle(),
left:this.getLeftPosition(),//transform: "translateX(-50%)",
transform:'translate3d(-50%, '+topPosition+'px, 0)',// top: this.getTopPosition(),
//transition: "top 0.3s ease-in",
transition:"transform 0.3s ease-in",zIndex:this.getZIndex()// //Note: this will be revisited when doing Desktop and need keyboarding selected states
// background: this.props.isTargetable && this.props.isSelected && !this.props.isTouchMode ? "rgba(255,0,0,0.3)" : "initial",
};var characterStyle={position:"absolute",left:0,top:0,animation:model.animationCssRule,width:"100%"};var shadowColor=this.props.isTargetable?this.props.isEnemyTeam?"#e93434":"#8cb9ef"://red, blue
null;var shadowStyle={position:"absolute",left:0,top:0,width:"100%",transition:"fill 0.2s",fill:shadowColor,//red or nothing
opacity:this.props.isTargetable?"0.8":null//SVG will default if falsy value
};var characterSize="5.5em";//vW * 29; //This number sets the character size
var characterContainerStyle={width:characterSize,height:characterSize,position:"relative",WebkitTapHighlightColor:'rgba(0, 0, 0, 0)'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:characterContainerStyle,onClick:this.handleClick.bind(this),onMouseEnter:this.handleHover.bind(this),ref:'combatant'},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__svg_getters_CombatantShadow__["a" /* default */])(characterSize,shadowStyle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:characterStyle,src:this.getSkinSrc(),alt:model.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ArenaCombatantLaptop__["a" /* default */],{view:isEnemyTeam?"back":"front"}),this.renderBotIcon(characterSize),this.renderTargetingCrosshair(characterSize),this.hasTargetingWarning()?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__svg_getters_CombatantWarningIcon__["a" /* default */])(characterSize,Object.assign({},characterContainerStyle,{zIndex:3})):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ArenaCombatantScoreboard__["a" /* default */],{vW:vW,name:model.name,hp:model.hp,maxHp:model.maxHp,pp:model.pp,maxPp:model.maxPp,status:model.status,isEnemyTeam:isEnemyTeam,turnBubbles:this.getTurnBubbleArray()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ArenaCombatantWaitingBlip__["a" /* default */],{vW:vW,isActive:this.isWaitingForThisCombatantToSubmit()}));}}]);return ArenaCombatant;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);//Look through all targetable Ids and check for mine (indicates that I can be cursored to)
function getIsTargetable(snapshot,combatantId){if(snapshot.viewId==="targetsView"){var optionsMatchingMyId=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_models_from_object_js__["a" /* modelsFromObject */])(snapshot.optionsData).filter(function(option){var targetIds=option.viewBag.targetIds||[];return targetIds.includes(combatantId);});return optionsMatchingMyId.length>0;}return false;}//Check if my combatant ID is listed in the targetIds of the current selection
//(indicates that I am already cursored)
function getIsSelected(snapshot,combatantId){if(!snapshot.currentlySelectedOptionData||!snapshot.currentlySelectedOptionData.viewBag.targetIds){return false;}return snapshot.currentlySelectedOptionData.viewBag.targetIds.includes(combatantId);}//Look up my menu option node from the menu model
function getMyMenuNode(snapshot,combatantId){if(snapshot.viewId==="targetsView"){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_models_from_object_js__["a" /* modelsFromObject */])(snapshot.optionsData).find(function(option){var targetIds=option.viewBag.targetIds||[];return targetIds.includes(combatantId);})||null;}return null;}/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{vW:state.global.vW,vH:state.global.vH,viewportMode:state.global.viewportMode,arenaMenuSnapshot:state.battle.arenaMenuSnapshot,arenaSubmissionMenuAction:state.battle.arenaSubmissionMenuAction,isSelected:getIsSelected(state.battle.arenaMenuSnapshot,props.model.id),isTargetable:getIsTargetable(state.battle.arenaMenuSnapshot,props.model.id),myMenuNode:getMyMenuNode(state.battle.arenaMenuSnapshot,props.model.id),//For keyboard vs touch variations on UI
isTouchMode:state.global.isTouchMode,isMultiplayerMode:state.battle.isMultiplayerMode,//For "waiting" badge
isCurrentlySelecting:state.battle.combatantSelectingAction===props.model.id||state.battle.combatantSelectingAction==='deadline::'+props.model.id,isPlayerControlled:state.battle.battlePlayerId.includes(props.model.id),//Know when I'm done submitting.
arenaSubmissionIsSubmitted:state.battle.arenaSubmissionIsSubmitted,//Know who still has left to go.
seriesTurnOrder:state.battle.seriesTurnOrder,seriesTurnsSubmitters:state.battle.seriesTurnsSubmitters};})(ArenaCombatant));

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ArenaCombatantLaptop=function(_React$Component){_inherits(ArenaCombatantLaptop,_React$Component);function ArenaCombatantLaptop(){_classCallCheck(this,ArenaCombatantLaptop);return _possibleConstructorReturn(this,(ArenaCombatantLaptop.__proto__||Object.getPrototypeOf(ArenaCombatantLaptop)).apply(this,arguments));}_createClass(ArenaCombatantLaptop,[{key:"render",value:function render(){var srcImage=this.props.view==="front"?"/images/misc/laptop-screen.svg":"/images/misc/laptop-back.svg";var style={position:"absolute",left:this.props.view==="front"?"-0.4em":"1.4em",top:this.props.view==="front"?"-0.1em":"2.6em",width:this.props.view==="front"?"4.7em":"2.6em",zIndex:this.props.view==="front"?"-1":"3"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{style:style,src:srcImage,alt:"Laptop"});}}]);return ArenaCombatantLaptop;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ArenaCombatantLaptop);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Lifebar__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ArenaCombatantScoreboard_css__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ArenaCombatantScoreboard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ArenaCombatantScoreboard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getStatusUiModel__ = __webpack_require__(303);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ArenaCombatantScoreboard=function(_React$Component){_inherits(ArenaCombatantScoreboard,_React$Component);function ArenaCombatantScoreboard(){_classCallCheck(this,ArenaCombatantScoreboard);return _possibleConstructorReturn(this,(ArenaCombatantScoreboard.__proto__||Object.getPrototypeOf(ArenaCombatantScoreboard)).apply(this,arguments));}_createClass(ArenaCombatantScoreboard,[{key:'renderTurnBubbles',value:function renderTurnBubbles(isEnemyTeam){var containerStyle={position:"absolute",bottom:"-1.2em",left:0};// const enemyFill = (
// `linear-gradient(
//   -180deg,
//   #E70018 0%,
//   #E70018 50%,
//   #C60A20 50%,
//   #C60A20 100%`
// ); //light on top, dark on bottom
// const friendlyFill = (
//   `linear-gradient(
//   -180deg,
//   #468EE5 0%,
//   #468EE5 50%,
//   #1E69C1 50%,
//   #1E69C1 100%`
// ); //light on top, dark on bottom
// const fillColor = isEnemyTeam
//   ? enemyFill
//   : friendlyFill;
var fillClassName=isEnemyTeam?"is-enemy":"is-friendly";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:containerStyle},this.props.turnBubbles.map(function(value,index){var style={width:"0.8em",height:"0.8em",//background: fillColor,
//border: value ? "0.05em solid rgba(255,255,255,0.4)" : "0.05em solid rgba(0,0,0,0.4)",
border:"0.1em solid #392E4E",display:value?"inline-block":"none",marginRight:"0.3em"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'turn-fill '+fillClassName,key:index,style:style});}));}},{key:'renderStatus',value:function renderStatus(){if(this.props.status==="normal"){return null;}var statusUiModel=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__getStatusUiModel__["a" /* getStatusUiModel */])(this.props.status);var statusStyle={position:"absolute",right:"-0.4em",top:0,transform:"translateY(-70%)",fontSize:"0.5em",color:statusUiModel.textColor,textTransform:"uppercase",background:"#392E4E",padding:"0.5em 0.5em"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:statusStyle},this.props.status);}},{key:'render',value:function render(){var _props=this.props,name=_props.name,hp=_props.hp,maxHp=_props.maxHp,isEnemyTeam=_props.isEnemyTeam;var style={whiteSpace:"nowrap",//Might end up explicitly defining a width. We'll see!
background:"#fff",//TODO
padding:"0.5em"//see class
};var teamColor=isEnemyTeam?"#C41127":"#246BBE";var nameStyle={fontSize:"0.6em",color:hp>0?teamColor:"#AAA1A1",//team color or gray if dead
//color: "#392E4E",
marginBottom:"0.5em",textTransform:"uppercase"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:style,className:'ArenaCombatantScoreboard'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:nameStyle},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Lifebar__["a" /* default */],{hp:hp,maxHp:maxHp,isEnemyTeam:isEnemyTeam})),this.renderStatus(),this.renderTurnBubbles(isEnemyTeam));}}]);return ArenaCombatantScoreboard;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ArenaCombatantScoreboard);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/** This is the little "WAITING" blip for waiting on an Online player to submit something *//* harmony default export */ __webpack_exports__["a"] = (function(props){if(!props.isActive){return null;}var style={position:"absolute",left:"50%",top:"-0.5em",width:"4em",marginLeft:"-2em",textAlign:"center",padding:"0.3em 0",fontSize:"0.4em",background:"#042129",color:"#fff"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style},"...");});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ArenaEnvironmentBackground=function(_React$Component){_inherits(ArenaEnvironmentBackground,_React$Component);function ArenaEnvironmentBackground(){_classCallCheck(this,ArenaEnvironmentBackground);return _possibleConstructorReturn(this,(ArenaEnvironmentBackground.__proto__||Object.getPrototypeOf(ArenaEnvironmentBackground)).apply(this,arguments));}_createClass(ArenaEnvironmentBackground,[{key:'getMobileStyle',value:function getMobileStyle(){return{top:this.props.vH*-4,right:0,bottom:0,backgroundSize:this.props.vW*210};}},{key:'getDesktopStyle',value:function getDesktopStyle(){return{right:0,bottom:0,top:0,backgroundSize:'100%'};}},{key:'render',value:function render(){var viewportModeStyles=this.props.viewportMode==="portrait"?this.getMobileStyle():this.getDesktopStyle();var style=Object.assign({position:'absolute',//NOTE: the gradient overlay is now a psuedo on the class
background:'url(/images/arenas/indoor-map-with-objects.svg) no-repeat, #687991',//hex color at the end should be dynamic to the map that is loaded?
left:0},viewportModeStyles);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ArenaEnvironmentBackground',style:style});}}]);return ArenaEnvironmentBackground;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{vW:state.global.vW,vH:state.global.vH,// vH: state.global.vW,
viewportMode:state.global.viewportMode};})(ArenaEnvironmentBackground));

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint jsx-a11y/href-no-hash: "off" */var ArenaSubmissionMenuBackButton=function(_React$Component){_inherits(ArenaSubmissionMenuBackButton,_React$Component);function ArenaSubmissionMenuBackButton(){_classCallCheck(this,ArenaSubmissionMenuBackButton);return _possibleConstructorReturn(this,(ArenaSubmissionMenuBackButton.__proto__||Object.getPrototypeOf(ArenaSubmissionMenuBackButton)).apply(this,arguments));}_createClass(ArenaSubmissionMenuBackButton,[{key:"handleClick",value:function handleClick(e){e.preventDefault();//Look up my option model
var optionModel=this.props.menuModel.optionsData[this.props.optionId];//Submit my option model through the menu snapshot
this.props.menuModel.submit(optionModel);}},{key:"render",value:function render(){var style={textDecoration:"none",color:"#fff"};var backText="< ESC";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:style,href:"#",onClick:this.handleClick.bind(this)},backText);}}]);return ArenaSubmissionMenuBackButton;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ArenaSubmissionMenuBackButton);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ArenaTransitionOverlay=function(_React$Component){_inherits(ArenaTransitionOverlay,_React$Component);function ArenaTransitionOverlay(){_classCallCheck(this,ArenaTransitionOverlay);var _this=_possibleConstructorReturn(this,(ArenaTransitionOverlay.__proto__||Object.getPrototypeOf(ArenaTransitionOverlay)).call(this));_this.state={overlayOpacity:1};return _this;}//Check if a transition is present on mount
_createClass(ArenaTransitionOverlay,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.arenaTransitionOverlay){this.handleTransitionKickoff(this.props);}}//Listen for transition models to come in
},{key:'componentWillUpdate',value:function componentWillUpdate(newProps){//Check for model to be set in the arenaTransitionOverlay state
//See model description below)
if(newProps.arenaTransitionOverlay&&!this.props.arenaTransitionOverlay){//Incoming change!
this.handleTransitionKickoff(newProps);}}},{key:'handleTransitionKickoff',value:function handleTransitionKickoff(props){var _this2=this;//Case 1: fade OUT (battle starting)
if(props.arenaTransitionOverlay.transition==="fadeOut"){//Set my opacity to 0 to start. Fade in to 1
this.setState({overlayOpacity:1},function(){setTimeout(function(){_this2.setState({overlayOpacity:0});},25);//Delay to make CSS transition fire
});}//Case 2: fade IN (battle ending)
if(props.arenaTransitionOverlay.transition==="fadeIn"){//Set my opacity to 0 to start. Fade in to 1
this.setState({overlayOpacity:0},function(){setTimeout(function(){_this2.setState({overlayOpacity:1});},25);//Delay to make CSS transition fire
});}}},{key:'handleTransitionEnd',value:function handleTransitionEnd(){// console.log('transition over!');
this.props.arenaTransitionOverlay.callback();//Reset state to null
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["a" /* setBattleValue */])({arenaTransitionOverlay:null});}},{key:'render',value:function render(){//Default to nothing
if(!this.props.arenaTransitionOverlay){return null;}var style={position:"absolute",zIndex:100,left:0,right:0,top:0,bottom:0,background:"#fff",opacity:this.state.overlayOpacity,transition:"opacity 0.9s"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:style,onTransitionEnd:this.handleTransitionEnd.bind(this)});}}]);return ArenaTransitionOverlay;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{arenaTransitionOverlay:state.battle.arenaTransitionOverlay};})(ArenaTransitionOverlay));/*
Example model for prop:
 {transition: "fadeIn" | "fadeOut", callback: function }

 FadeIn = start at 0 opacity, transition to 1 then do callback
 */

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ArenaCombatant__ = __webpack_require__(275);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CombatantTeam=function(_React$Component){_inherits(CombatantTeam,_React$Component);function CombatantTeam(){_classCallCheck(this,CombatantTeam);return _possibleConstructorReturn(this,(CombatantTeam.__proto__||Object.getPrototypeOf(CombatantTeam)).apply(this,arguments));}_createClass(CombatantTeam,[{key:'getTopValue',//Nudging the row up or down depending on context
value:function getTopValue(){//Mobile
if(this.props.viewportMode==="portrait"){return this.props.isEnemyTeam?"17%":"50%";//top row, bottom row
}//Desktop
if(this.props.viewportMode==="landscape"){return this.props.isEnemyTeam?"28%":"66%";//top row, bottom row
}}},{key:'render',value:function render(){var _this2=this;var teamRowStyle={position:"absolute",top:this.getTopValue(),left:0,right:0,zIndex:this.props.isEnemyTeam?1:2};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:teamRowStyle},this.props.combatantIds.map(function(combId,index){var combatantModel=_this2.props.combatants[combId];var positionData={position:combatantModel.arenaPosition,//EX: 1
totalPositions:_this2.props.combatantIds.length//of 3
};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ArenaCombatant__["a" /* default */],{key:combId,model:combatantModel,positionData:positionData,isEnemyTeam:_this2.props.isEnemyTeam});}));}}]);return CombatantTeam;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{combatants:state.battle.combatants,viewportMode:state.global.viewportMode//someProp: state.something.someProp
};})(CombatantTeam));

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MockLifebar=function(_React$Component){_inherits(MockLifebar,_React$Component);function MockLifebar(){_classCallCheck(this,MockLifebar);return _possibleConstructorReturn(this,(MockLifebar.__proto__||Object.getPrototypeOf(MockLifebar)).apply(this,arguments));}_createClass(MockLifebar,[{key:"getFillPercent",value:function getFillPercent(){var _props=this.props,hp=_props.hp,maxHp=_props.maxHp;//Floor at 0
if(hp<=0){return"0%";}//Otherwise, figure out the fill percent
return Math.round(hp/maxHp*100)+"%";}},{key:"getBackgroundFillColor",value:function getBackgroundFillColor(){if(this.props.hp<=0){return"#EFECEC";//dead gray
}return this.props.isEnemyTeam?"#F9DBDB":"#DBE9F9";//faded red, faded blue
}},{key:"render",value:function render(){var isEnemyTeam=this.props.isEnemyTeam;var barContainerStyle={width:"100%",height:"0.5em",background:this.getBackgroundFillColor(),position:"relative"};var fillStyle={position:"absolute",left:0,top:0,bottom:0,background:isEnemyTeam?"#E40924":"#4A90E2",//foreground
borderBottom:"0.2em solid "+(isEnemyTeam?"#C41127":"#246BBE"),width:this.getFillPercent()//transition: "width 0.4s" //? keep this? or run with the easing function like in b4?
};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:barContainerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:fillStyle})));}}]);return MockLifebar;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (MockLifebar);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__text_TextLine_js__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lifecycle_handle_new_rollout_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__handleBattleOver_js__ = __webpack_require__(304);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RolloutMessageBox=function(_React$Component){_inherits(RolloutMessageBox,_React$Component);function RolloutMessageBox(){_classCallCheck(this,RolloutMessageBox);return _possibleConstructorReturn(this,(RolloutMessageBox.__proto__||Object.getPrototypeOf(RolloutMessageBox)).apply(this,arguments));}_createClass(RolloutMessageBox,[{key:'handleTextLineDone',value:function handleTextLineDone(){var _this2=this;//TODO: The UX here might change, but for now just auto fire the "I've seen this text line" trigger when text is done revealing
setTimeout(function(){//Delay for effect
//Move to next rollout step if battle is not over
if(_this2.props.rolloutId!=="rollout_battle-over"){//Increment the rolloutIndex and then hit the step
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__redux_actions_battle_actions_js__["a" /* setBattleValue */])({rolloutExecutingIndex:__WEBPACK_IMPORTED_MODULE_5__init_store_js__["a" /* default */].getState().battle.rolloutExecutingIndex+1});//Add a little extra delay if this is the first message
if(_this2.props.rolloutId==="rollout_battle-starting"){setTimeout(__WEBPACK_IMPORTED_MODULE_3__lifecycle_handle_new_rollout_js__["b" /* handleRolloutStep */],700);}else{//FOR ALL OTHER MESSAGES - Tell rollout to move on to next step
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lifecycle_handle_new_rollout_js__["b" /* handleRolloutStep */])();}}else{//The battle is over!
setTimeout(function(){//Activate the transition overlay (ArenaTransitionOverlay) to fade IN to white
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__redux_actions_battle_actions_js__["a" /* setBattleValue */])({arenaTransitionOverlay:{transition:"fadeIn",callback:function callback(){//console.log('complete!')
//Provide the "next steps" screen after a Quick battle (both Online and Offline)
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__handleBattleOver_js__["a" /* handleBattleOver */])();}}});},800);}},600);}},{key:'getStyle',value:function getStyle(){var baseStyle={fontSize:"0.8em",lineHeight:"2.4em"//background: "#052128" //This attempts to help the weird text flashing on the left side,
// position: "absolute",
// bottom: 0,
// zIndex:4, //characters are 1 and 2, submission menu is 3
// background: "#333",
};//Get MOBILE styles
if(this.props.viewportMode==="portrait"){return Object.assign({},baseStyle,{// left:0,
// right: 0,
// height: this.props.vW * 30,
padding:"0.5em"});}//Get DESKTOP styles
if(this.props.viewportMode==="landscape"){return Object.assign({},baseStyle,{height:this.props.vW*15,padding:"1em 0.5em"});}}},{key:'render',value:function render(){if(!this.props.arenaIsRolloutShowing){return null;}if(this.props.rolloutData&&this.props.rolloutData.length>0){var uniqueTextLineKey=this.props.lastSeenTextMessageKey;//Tell React to replace this container with new Mounting for TextLine content changes
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RolloutMessageBox',style:this.getStyle(),key:uniqueTextLineKey},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__text_TextLine_js__["a" /* default */],{lineData:this.props.lastSeenTextMessage,onDone:this.handleTextLineDone.bind(this)}));}//return (<div>no rollout</div>)
return null;}}]);return RolloutMessageBox;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{vW:state.global.vW,viewportMode:state.global.viewportMode,rolloutId:state.battle.rolloutId,rolloutData:state.battle.rolloutData,lastSeenTextMessage:state.battle.lastSeenTextMessage.content,lastSeenTextMessageKey:state.battle.lastSeenTextMessage.key,//Flag for showing the rollout message
arenaIsRolloutShowing:state.battle.arenaIsRolloutShowing};})(RolloutMessageBox));

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_models_from_object_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SubmissionMenuOption__ = __webpack_require__(144);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubmissionHomeMenu=function(_React$Component){_inherits(SubmissionHomeMenu,_React$Component);function SubmissionHomeMenu(){_classCallCheck(this,SubmissionHomeMenu);return _possibleConstructorReturn(this,(SubmissionHomeMenu.__proto__||Object.getPrototypeOf(SubmissionHomeMenu)).apply(this,arguments));}_createClass(SubmissionHomeMenu,[{key:'handleClick',value:function handleClick(model){//This is passed down and back up through MockActionLink
this.props.arenaMenuSnapshot.submit(model);}},{key:'handleHover',value:function handleHover(model){//This is passed down and back up through MockActionLink
this.props.arenaMenuSnapshot.setActive(model);}},{key:'render',value:function render(){var _this2=this;var arenaMenuSnapshot=this.props.arenaMenuSnapshot;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_models_from_object_js__["a" /* modelsFromObject */])(arenaMenuSnapshot.optionsData).map(function(option,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SubmissionMenuOption__["a" /* default */],{key:i,model:option,handleClick:_this2.handleClick.bind(_this2),handleHover:_this2.handleHover.bind(_this2),vW:_this2.props.vW,isTouchMode:_this2.props.isTouchMode});}));}}]);return SubmissionHomeMenu;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{isTouchMode:state.global.isTouchMode,arenaMenuSnapshot:state.battle.arenaMenuSnapshot,vW:state.global.vW};})(SubmissionHomeMenu));

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_models_from_object_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_get_pages_from_array_js__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SubmissionListViewPaginationGroup__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_uniqBy__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubmissionMenuOption__ = __webpack_require__(144);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint jsx-a11y/href-no-hash: "off" */var SubmissionListViewMenu=function(_React$Component){_inherits(SubmissionListViewMenu,_React$Component);function SubmissionListViewMenu(){_classCallCheck(this,SubmissionListViewMenu);return _possibleConstructorReturn(this,(SubmissionListViewMenu.__proto__||Object.getPrototypeOf(SubmissionListViewMenu)).apply(this,arguments));}_createClass(SubmissionListViewMenu,[{key:'handleClick',value:function handleClick(model){//This is passed down and back up through MockActionLink
this.props.arenaMenuSnapshot.submit(model);}},{key:'handleHover',value:function handleHover(model){//This is passed down and back up through MockActionLink
this.props.arenaMenuSnapshot.setActive(model);}//NOTE: These arrow handlers have a lot of duplicate code from `render`, but at the moment, it's simple to leave it like this
//Find the PREVIOUS page
},{key:'handleUpArrowClick',value:function handleUpArrowClick(e){e.preventDefault();//Get the array of options
var optionKeyArray=Object.keys(this.props.arenaMenuSnapshot.optionsData);//Determine which page the current selected option is on.
var pageMapArray=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_get_pages_from_array_js__["a" /* getPagesFromArray */])(optionKeyArray,4);//Identify the selected option and page
var selectedOptionIndex=this.props.arenaMenuSnapshot.currentlySelectedOptionData.viewBag.index;var selectedOptionPage=pageMapArray[selectedOptionIndex]-1;//Take out the paging starting at 1...
//Get a list of options that exist on our desired page index.
var nextPage=[];pageMapArray.forEach(function(optionPage,index){if(optionPage===selectedOptionPage){nextPage.push(index);}});//If we populated anything in nextPage, use the first one. (first option of the 'next' page)
if(nextPage.length){var nextOptionKey=optionKeyArray[nextPage[0]];var nextOptionModel=this.props.arenaMenuSnapshot.optionsData[nextOptionKey];//Finally, set this next one to active
this.props.arenaMenuSnapshot.setActive(nextOptionModel);}}//Fine the "first" option on the NEXT page down.
},{key:'handleDownArrowClick',value:function handleDownArrowClick(e){e.preventDefault();//Get the array of options
var optionKeyArray=Object.keys(this.props.arenaMenuSnapshot.optionsData);//Determine which page the current selected option is on.
var pageMapArray=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_get_pages_from_array_js__["a" /* getPagesFromArray */])(optionKeyArray,4);//Identify the selected option and page
var selectedOptionIndex=this.props.arenaMenuSnapshot.currentlySelectedOptionData.viewBag.index;var selectedOptionPage=pageMapArray[selectedOptionIndex]+1;//Take out the paging starting at 1...
//If we populated anything in nextPage, use the first one. (first option of the 'next' page)
var nextPage=[];pageMapArray.forEach(function(optionPage,index){if(optionPage===selectedOptionPage){nextPage.push(index);}});if(nextPage.length){var nextOptionKey=optionKeyArray[nextPage[0]];var nextOptionModel=this.props.arenaMenuSnapshot.optionsData[nextOptionKey];//Finally, set this next one to active
this.props.arenaMenuSnapshot.setActive(nextOptionModel);}}},{key:'getPaginationPages',value:function getPaginationPages(selectedIndex,array){return array.map(function(option,i){return i===selectedIndex;});//[true, false, false, ...etc]
}},{key:'getPaginationDisplayValue',value:function getPaginationDisplayValue(pageCountArray){if(//Sometimes don't show this column at all.
this.props.isTouchMode||//we are in touch mode
pageCountArray.length===1//only 1 page
){return"none";}return"flex";}},{key:'render',value:function render(){var _this2=this;var containerStyle={//Allow scrolling on touchMode only, not desktop
overflow:this.props.isTouchMode?"scroll":"hidden",WebkitOverflowScrolling:"touch"};var listContainerStyle={//This one is offset up or down based on the selected index
display:"flex"//contains pagination column and content column
// transition: `top 0.3s`
};var optionKeyArray=Object.keys(this.props.arenaMenuSnapshot.optionsData).filter(function(key){//Do not include BACK
return key!=="listview-back";});//Determine which page the selected option is on.
var pageMapArray=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_get_pages_from_array_js__["a" /* getPagesFromArray */])(optionKeyArray,4);//Lodash uniqBy figures out how many pages are in the pageMapArray
//(by eliminating duplicates)
var pageCountArray=__WEBPACK_IMPORTED_MODULE_5_lodash_uniqBy___default()(pageMapArray);//Identify the selected option and page
var selectedOptionIndex=this.props.arenaMenuSnapshot.currentlySelectedOptionData.viewBag.index;var selectedOptionPage=pageMapArray[selectedOptionIndex]-1;//Take out the paging starting at 1...
var paginationColumnStyle={width:"2em",height:"12em",//same as containerStyle
//Do not show this on touchMode
display:this.getPaginationDisplayValue(pageCountArray),flexDirection:"column",justifyContent:"space-between"};var contentColumnStyle={position:"relative",transform:'translateY(calc('+-selectedOptionPage+' * 12em)',transition:'transform 0.3s',flex:"1"};var columnItemsContainerStyle={height:"12em"//TODO: this should be the exact height of the viewable area of items (Should touch the bottom of the screen)
};/* Pagination stuff */var arrowAnchorStyle={paddingTop:"0.5em",paddingBottom:"0.5em"};var arrowStyle={display:"block",width:"1em",margin:"0 auto"};var topArrowAnchorStyle=Object.assign({},arrowAnchorStyle,{opacity:selectedOptionPage===0?0:1//Hide this "up" arrow if first page is active
});var bottomArrowAnchorStyle=Object.assign({},arrowAnchorStyle,{opacity:pageCountArray.length-1===selectedOptionPage?0:1//Hide this "down" arrow if last page is active
});var arenaMenuSnapshot=this.props.arenaMenuSnapshot;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:containerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:listContainerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:contentColumnStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:columnItemsContainerStyle},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_models_from_object_js__["a" /* modelsFromObject */])(arenaMenuSnapshot.optionsData).filter(function(option){//Do not include the BACK option
return option.id!=="listview-back";}).map(function(option,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SubmissionMenuOption__["a" /* default */],{key:i,model:option,handleClick:_this2.handleClick.bind(_this2),handleHover:_this2.handleHover.bind(_this2),vW:_this2.props.vW,isTouchMode:_this2.props.isTouchMode});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:paginationColumnStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',style:topArrowAnchorStyle,onClick:this.handleUpArrowClick.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:arrowStyle,src:'/images/misc/up-arrow.svg',alt:'Prev Page'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SubmissionListViewPaginationGroup__["a" /* default */],{pages:this.getPaginationPages(selectedOptionPage,pageCountArray)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',style:bottomArrowAnchorStyle,onClick:this.handleDownArrowClick.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:arrowStyle,src:'/images/misc/down-arrow.svg',alt:'Next Page'})))));}}]);return SubmissionListViewMenu;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{isTouchMode:state.global.isTouchMode,arenaMenuSnapshot:state.battle.arenaMenuSnapshot,vW:state.global.vW};})(SubmissionListViewMenu));

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(props,state){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,props.pages.map(function(isActive,index){var bubbleStyle={width:"0.25em",height:"0.25em",margin:"1em auto",background:isActive?"#6EFFDF":"#555"};//true or false
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:index,style:bubbleStyle});}));});//props.pages = [true, false, false] for 3 pages, first one being active

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSubmissionMenuData_js__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu_engine__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions_js__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ArenaMenuBrain=function(_React$Component){_inherits(ArenaMenuBrain,_React$Component);function ArenaMenuBrain(){_classCallCheck(this,ArenaMenuBrain);return _possibleConstructorReturn(this,(ArenaMenuBrain.__proto__||Object.getPrototypeOf(ArenaMenuBrain)).apply(this,arguments));}_createClass(ArenaMenuBrain,[{key:'componentWillMount',value:function componentWillMount(){//console.log('>>>>>>>>>>>>>>', 'brain componentWillMount')
//Set up the brain.
this.menuModel=new __WEBPACK_IMPORTED_MODULE_2__menu_engine__["a" /* default */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getSubmissionMenuData_js__["a" /* getBattleArenaMenuData */])(),"homeView");var initialSnapshot=this.menuModel.init();// console.log('client initial snapshot', initialSnapshot);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions_js__["a" /* setBattleValue */])({arenaMenuSnapshot:Object.assign({},initialSnapshot)});//Listen for changes
this.menuModel.listen(function(newSnapshot){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions_js__["a" /* setBattleValue */])({arenaMenuSnapshot:Object.assign({},newSnapshot)});});}// componentWillUpdate(newProps) {
//   if (newProps.rolloutId !== this.props.rolloutId) {
//     console.log('need to reset the brain!')
//     //This happens too early...
//   }
// }
},{key:'componentWillUnmount',value:function componentWillUnmount(){var _this2=this;//Unmount the brain
setTimeout(function(){//For some reason, ENTER key fires before this, but CLICKS do not. Wait a bit before unmounting.
//Rethinking how the brain comes in and out should solve this, I think. Maybe not.
// console.log('unmounting the brain');
_this2.menuModel.destroy();delete _this2.menuModel;},50);}},{key:'render',value:function render(){//I'm the bindings and stuff for the Menu Model
//I don't have any DOM elements
return null;}}]);return ArenaMenuBrain;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ArenaMenuBrain);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init_store_js__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MockTargetPicker=function(_React$Component){_inherits(MockTargetPicker,_React$Component);function MockTargetPicker(){_classCallCheck(this,MockTargetPicker);return _possibleConstructorReturn(this,(MockTargetPicker.__proto__||Object.getPrototypeOf(MockTargetPicker)).apply(this,arguments));}_createClass(MockTargetPicker,[{key:'renderWarning',value:function renderWarning(){//Get our target models
var targetModels=(this.props.arenaMenuSnapshot.currentlySelectedOptionData.viewBag.targetIds||[]).map(function(targetId){return __WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().battle.combatants[targetId];});//If we have valid target models, check the validity of this move on these targets
if(targetModels.length){var validityModel=this.props.arenaSubmissionMenuAction.getValidity(this.props.arenaSubmissionMenuAction,{},//casterModel //(TODO)
targetModels);//If we do have warnings, return warning DOM nodes
if(!validityModel.isValid){var style={color:"#e93434"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,validityModel.invalidReasons.map(function(invalidReasonText,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i,style:style},invalidReasonText);}));}}//Otherwise, assume there are no warnings!
return null;}},{key:'getTargetingText',value:function getTargetingText(action){if(action.targetType==="single-opponent"){return"Select one opponent.";}if(action.targetType==="opponent-team"){return"Affects entire enemy team.";}if(action.targetType==="single-ally"){return"Select one ally.";}if(action.targetType==="ally-team"){return"Affects entire friendly team.";}if(action.targetType==="only-me"){return"Affects only the caster.";}return"Select Target";}},{key:'render',value:function render(){var action=this.props.arenaSubmissionMenuAction;var containerStyle={paddingTop:"1.2em",fontSize:"0.7em"};var nameStyle={color:"#6EFFDF",//cyan ish
marginBottom:"1em"};var descriptionStyle={lineHeight:"1.5em",marginBottom:"3em"};var selectTitleStyle={marginBottom:"1em"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:containerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:nameStyle},action.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:descriptionStyle},action.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:selectTitleStyle},this.getTargetingText(action)),this.renderWarning());}}]);return MockTargetPicker;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (MockTargetPicker);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBattleArenaMenuData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_engine_MenuOption__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__get_combatant_id_from_selecting_string_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getSubmissionMenuDataHome__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getSubmissionMenuDataListView__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__get_targets_js__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ArenaSubmissionMenu_js__ = __webpack_require__(142);
//import DynamicMenuOptionList from '../../../menu-engine/DynamicMenuOptionList'
function getBattleArenaMenuData(){var rootOptions={"firstOption":new __WEBPACK_IMPORTED_MODULE_0__menu_engine_MenuOption__["a" /* MenuOption */]({label:"Ermm"},"firstOption")};//Get the current player
//Assume this person is the player, right?
// NOTE: cloudQueue actions will not make it through to here.
//Only raw combatantIds and ::deadline ids
var _store$getState$battl=__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().battle,combatantSelectingAction=_store$getState$battl.combatantSelectingAction,combatants=_store$getState$battl.combatants;var playerModel=combatants[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__get_combatant_id_from_selecting_string_js__["a" /* getCombatantIdFromSelectingString */])(combatantSelectingAction)];if(!playerModel){console.warn('no playerModel!!',combatantSelectingAction);}//Get home options
var homeOptionModels=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getSubmissionMenuDataHome__["a" /* getSubmissionHomeMenuData */])(playerModel);var specialOptionModels=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getSubmissionMenuDataListView__["a" /* getSubmissionActionOptionsData */])(playerModel,"special");var itemsOptionModels=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getSubmissionMenuDataListView__["a" /* getSubmissionActionOptionsData */])(playerModel,"items");var superOptionModels=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getSubmissionMenuDataListView__["a" /* getSubmissionActionOptionsData */])(playerModel,"supers");return{disabledOptionClass:"is-disabled",//default "is-disabled"
views:{"rootView":{//this is just for waiting. No options or UI
viewBag:{},getMenuOptions:function getMenuOptions(){return rootOptions;},getMenuOptionsLayout:function getMenuOptionsLayout(){return[];},dontRememberOptionIds:[]},"homeView":{viewBag:{title:"Select option"},getMenuOptions:function getMenuOptions(){return homeOptionModels;},getMenuOptionsLayout:function getMenuOptionsLayout(){return Object.keys(homeOptionModels).map(function(key){return[key];});//makes a vertical chain
},dontRememberOptionIds:[]},"specialsView":{viewBag:{title:"Select option"},getMenuOptions:function getMenuOptions(){return specialOptionModels;},getMenuOptionsLayout:function getMenuOptionsLayout(){//Do not include BACK option in Layout (You can press ESC instead)
var nonBackOptions=Object.keys(specialOptionModels).filter(function(key){return key!=="listview-back";});return nonBackOptions.map(function(key){return[key];});//makes a vertical chain
},backOptionId:"listview-back",//ID of the "Back" option
dontRememberOptionIds:["listview-back"]//Don't allow this one to be autoselected if we come back
},"itemsView":{viewBag:{title:"Select option"},getMenuOptions:function getMenuOptions(){return itemsOptionModels;},getMenuOptionsLayout:function getMenuOptionsLayout(){//Do not include BACK option in Layout (You can press ESC instead)
var nonBackOptions=Object.keys(itemsOptionModels).filter(function(key){return key!=="listview-back";});return nonBackOptions.map(function(key){return[key];});//makes a vertical chain
},backOptionId:"listview-back",//ID of the "Back" option
dontRememberOptionIds:["listview-back"]},"supersView":{viewBag:{title:"Select option"},getMenuOptions:function getMenuOptions(){return superOptionModels;},getMenuOptionsLayout:function getMenuOptionsLayout(){return Object.keys(superOptionModels).map(function(key){return[key];});//makes a vertical chain
},backOptionId:"listview-back",dontRememberOptionIds:["listview-back"]},"targetsView":{viewBag:{title:"Select target"},getMenuOptions:function getMenuOptions(){return getTargetOptions();},getMenuOptionsLayout:function getMenuOptionsLayout(){return getTargetOptionsLayout();},shouldRememberOptions:false,//Don't remember targeting
//Which target should be selected first when the view lands?
getFirstSelectedOptionOnActivation:function getFirstSelectedOptionOnActivation(availableOptionModels){var selectedAction=__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().battle.arenaSubmissionMenuAction;// console.log('TARGET OPTIONS', availableOptionModels);
//If we're using an item, default to the caster's targeting option id! (if it exists)
if(selectedAction.isItem){var selectingCombatantId=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__get_combatant_id_from_selecting_string_js__["a" /* getCombatantIdFromSelectingString */])(__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().battle.combatantSelectingAction);//See if caster exists as a target option in availableOptionModels
var casterTargetOption=availableOptionModels.find(function(optionModel){return optionModel.viewBag.targetIds&&//We have targets
optionModel.viewBag.targetIds.length===1&&//Only 1 target (not a multi-person-targeting item)
optionModel.viewBag.targetIds[0]===selectingCombatantId//and its the caster's ID
;});//If so, return that.
if(casterTargetOption){//console.log('casterTargetOption', casterTargetOption)
return casterTargetOption.id;}//If not, just keep going. We'll default to the first option...
}//TODO: If you wanted to add some "obvious targeting auto aim" kind of stuff, you should do it here!
//Like, I select "SCOPE BOMB" so try to find an enemy that has "DEADLINE" first.
//Default to first option
return availableOptionModels[0].id;//Default to just use the first one!
},backOptionId:"target-back",dontRememberOptionIds:["target-back"]}}};}function getTargetOptions(){var _store$getState$battl2=__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().battle,arenaSubmissionMenuAction=_store$getState$battl2.arenaSubmissionMenuAction,combatants=_store$getState$battl2.combatants,combatantSelectingAction=_store$getState$battl2.combatantSelectingAction;//Bail here if we're not selecting a target right now
if(!arenaSubmissionMenuAction){return{};}//Get a Player Model
var playerModel=combatants[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__get_combatant_id_from_selecting_string_js__["a" /* getCombatantIdFromSelectingString */])(combatantSelectingAction)];if(!playerModel){console.warn('no playerModel in getTargetOptions',combatantSelectingAction);}var targetIds=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__get_targets_js__["a" /* getTargets */])(arenaSubmissionMenuAction.id,playerModel.belongsToTeam,playerModel.id);//If we have multiple targets, sort by arenaPosition (left to right)
//This helps the keyboarding know the correct order of the layout.
//Please note: We currently do not ever have cases where there are multiple targets AND single targets.
//If it ever becomes ["one,two,three", "four"], then we'll need to rethink this.
function convertArenaPositionForMain(number,targetsLength){//This is a little silly, but "1" (on a team of 3) is actually in the middle. So we need to turn 1s into 2s and 2s into 1s
if(targetsLength===3||targetsLength===2){//Only do this on 3 person teams. Positioning of 2 and 1 person teams are normal.
if(number===1){return 2;}//1 is actually in the middle position
if(number===2){return 1;}//2 is actually in the left position
}return number;}if(targetIds.length>1){targetIds=targetIds.map(function(id){return combatants[id];}).sort(function(a,b){var aArenaPosition=convertArenaPositionForMain(a.arenaPosition,targetIds.length);var bArenaPosition=convertArenaPositionForMain(b.arenaPosition,targetIds.length);return aArenaPosition>bArenaPosition?1:-1;}).map(function(comb){return comb.id;});}var targetOptions={};//Create Target options
//(These are not actually displayed as a menuOptions loop or anything. ArenaCombatant components change appearance )
targetIds.forEach(function(targetId,index){var key='target-option-'+index;targetOptions[key]=new __WEBPACK_IMPORTED_MODULE_0__menu_engine_MenuOption__["a" /* MenuOption */]({label:"",viewBag:{//Keep a reference to combatant Ids so we can highlight them as target options in the View Layer (ArenaCombatant.js)
targetIds:targetId.split(',')//["a"] for one, or ["a", "b"] for one option for multiple combatants
},nextView:"rootView",//transition to a waiting state
handleOptionEnter:function handleOptionEnter(){handleEnterOnTarget(targetId);}},key);//use key as optionId too
});//Add a back option
//Determine the destination of the Back button
//Assume we're targeting a special attack, so go back to the list view
var backViewId="specialsView";//Go back to Items view if cancelling from an Item
if(arenaSubmissionMenuAction.isItem){backViewId="itemsView";}//Back to Supers if this is a super
if(arenaSubmissionMenuAction.isSuper){//If we have multiple supers showing, then go back to the list view.
//Otherwise, jump back to homeView (because we only have 1 super)
var playerSuperActionId=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getSubmissionMenuDataHome__["b" /* getSuperId */])(playerModel);backViewId=playerSuperActionId==="SHOW-ALL"?"supersView":"homeView";}//Go back to Home if cancelling out of regular Attack target
if(arenaSubmissionMenuAction.id==="attack_generic-attack"){backViewId="homeView";}targetOptions["target-back"]=new __WEBPACK_IMPORTED_MODULE_0__menu_engine_MenuOption__["a" /* MenuOption */]({handleOptionEnter:function handleOptionEnter(){// console.log('HANDLE IT');
},viewBag:{//This sort of ViewBag workaround (both for Targets and Back) is needed because we're not looping through options.
isBackButton:true//Use this so the custom option UI knows to appear selected
},nextView:backViewId},"target-back");return targetOptions;}function handleEnterOnTarget(targetIds){//Take IDs and make a targets array
//const value = this.refs.select.value; //"oneA", or "oneB,oneC,oneD" string with commas
var targetModels=targetIds.split(",").map(function(targetId){return __WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().battle.combatants[targetId];});//From here, either SUBMIT the action for real or wait for the extra timing bonus submission.
//In either case, tell Redux about the targets
// const actionModel = store.getState().battle.arenaSubmissionMenuAction;
// if (false) { //TODO: Trying gameplay without this feature.
//TODO: Leaving this here for a little bit for reference on how to add in that third step if we ever need it
// //if (actionModel.hasTimedHitBonusAvailable) {
//   setBattleValue({
//     arenaSubmissionMenuTargets: targetModels
//   });
//
// } else {
//Submit the targets and completed flag
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["a" /* setBattleValue */])({arenaSubmissionIsSubmitted:true,arenaSubmissionMenuTargets:targetModels});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__ArenaSubmissionMenu_js__["b" /* arenaSubmitFinalAction */])();//submit for real!
//}
}function getTargetOptionsLayout(){//TODO: this will need to be a little more clever in possibly providing a multi-tream layout.
//You might be able to get away with an "enemy row" then "friendly row" and only include the ones that have members.
/*

  like, return [
    enemy list,
    friendly list,
  ]

  or just return [
    one of the lists
  ]

   *///TODO: for now, just provide everything as 1 horizontal row
return[Object.keys(getTargetOptions()).filter(function(key){return key!=="target-back";})//Removing the Back for now for playtesting
];//Returns a horizontal list
}

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSubmissionHomeMenuData;
/* harmony export (immutable) */ __webpack_exports__["b"] = getSuperId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_engine_MenuOption__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__battle_data_battle_actions_js__ = __webpack_require__(14);
function getSubmissionHomeMenuData(playerModel){var attackOption={label:"Attack",viewBag:{actionCategory:"offense"},nextView:"targetsView",handleOptionEnter:function handleOptionEnter(){//Populate the node in state with our selected action!
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["a" /* setBattleValue */])({arenaSubmissionMenuAction:Object.assign({},__WEBPACK_IMPORTED_MODULE_2__battle_data_battle_actions_js__["a" /* default */]["attack_generic-attack"],{id:"attack_generic-attack",actionMeta:{actionId:"attack_generic-attack"//include the actionMeta from our player state (the attacks I know, and Items with instanceIds)
}})});}};var specialsOption={label:"Script...",viewBag:{actionCategory:"directory"},nextView:"specialsView"};var isItemsUnavailable=playerModel.getTeamItems().length===0;var itemsOption={label:"Item...",viewBag:{actionCategory:"directory"},nextView:"itemsView",isUnavailable:function isUnavailable(){return isItemsUnavailable;}};return{"attackOption":new __WEBPACK_IMPORTED_MODULE_0__menu_engine_MenuOption__["a" /* MenuOption */](attackOption,"attackOption"),"specialsOption":new __WEBPACK_IMPORTED_MODULE_0__menu_engine_MenuOption__["a" /* MenuOption */](specialsOption,"specialsOption"),"itemsOption":new __WEBPACK_IMPORTED_MODULE_0__menu_engine_MenuOption__["a" /* MenuOption */](itemsOption,"itemsOption"),"superOption":new __WEBPACK_IMPORTED_MODULE_0__menu_engine_MenuOption__["a" /* MenuOption */](getSuperAction(playerModel),"superOption")};}//Provide the correct action to use.
function getSuperAction(playerModel){var availableSupers=playerModel.getAvailableSupers();//only ones that can be used right now
var isSuperUnavailable=availableSupers.length===0;var superActionId=getSuperId(playerModel);//const isRevertAvailable = Boolean(playerModel.getAvailableSupers().find(a => a.actionId === "special_revert"));
//Case:
//I only have 1 Super, so make this selection go directly to the targeting selection (like regular attack does)
if(superActionId!=="SHOW-ALL"){var actionModel=__WEBPACK_IMPORTED_MODULE_2__battle_data_battle_actions_js__["a" /* default */][superActionId];return{label:actionModel.name,viewBag:{actionCategory:actionModel.category,metaData:String(playerModel.dangerMeter)+"% Charged"},nextView:"targetsView",handleOptionEnter:function handleOptionEnter(){//Populate the node in state with our selected action!
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["a" /* setBattleValue */])({arenaSubmissionMenuAction:Object.assign({},actionModel,{id:superActionId,actionMeta:{actionId:superActionId//include the actionMeta from our player state (the attacks I know, and Items with instanceIds)
}})});},isUnavailable:function isUnavailable(){return isSuperUnavailable;}};}//Default case:
//Return a list view of my supers ("SHOW-ALL")
return{label:"Super Charge...",//playerSuperAction.name,
viewBag:{actionCategory:"directory",//because it goes to a list view //TODO: is this the right call? It feels underwhelming. Not sure, but whatevs.
//Danger Meter in Meta spot:
metaData:String(playerModel.dangerMeter)+"% Charged"//We may want to apply a "COMMIT" badge here, like you have a Commit saved (ready for Revert)
// hasRevertAvailable: isRevertAvailable //TODO: This is not being used at the moment. Do we need it?
},isUnavailable:function isUnavailable(){//Do we have Supers that are available for use?
// (isDangerMeterCheck already done in that method)
return isSuperUnavailable;},nextView:"supersView"};}function getSuperId(playerModel){var allPlayerSupers=playerModel.getAllSupers();//all, regardless of ready or not
var availableSupers=playerModel.getAvailableSupers();//only ones that can be used right now
//None are available
if(availableSupers.length===0&&allPlayerSupers.length>0){return allPlayerSupers[0].actionId;}//I only have 1 available, so show that one.
if(availableSupers.length===1){return availableSupers[0].actionId;}if(availableSupers.length>1){return"SHOW-ALL";//special string flag for using a ListView
}}

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSubmissionActionOptionsData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__battle_data_battle_actions_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__menu_engine_MenuOption__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* Get a dynamic list of MenuOption models for Special or Items (pass in the type) */function getSubmissionActionOptionsData(playerModel){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";var payload={};//Filter (don't filter out PP though)
playerModel.getAvailableActions({filterForPp:false}).filter(function(action){var model=__WEBPACK_IMPORTED_MODULE_0__battle_data_battle_actions_js__["a" /* default */][action.actionId];//First, check for Supers (doesnt use string match)
if(type==="supers"){return model.isSuper;}//Filter by supplied type. Looks at ID of the special. (naming convention prefix)
if(type==="special"&&!model.isSuper&&action.actionId.match(/^special_/)){return true;}if(type==="items"&&action.actionId.match(/^item_/)){return true;}return false;}).forEach(function(action,index){var model=__WEBPACK_IMPORTED_MODULE_0__battle_data_battle_actions_js__["a" /* default */][action.actionId];var optionKey='option-'+type+'-'+index;//console.log(playerModel.name, model.ppCost, playerModel.pp)
var hasEnoughPp=model.ppCost<=playerModel.pp;var metaSpot="";if(model.ppCost>0){metaSpot='PP '+model.ppCost;}// const isStolen = model.isItem &&
payload[optionKey]=new __WEBPACK_IMPORTED_MODULE_1__menu_engine_MenuOption__["a" /* MenuOption */]({label:model.name,description:model.description,isUnavailable:function isUnavailable(){return!hasEnoughPp;},viewBag:{index:index,//For scroll anchoring behavior
//Only things that UI might want to show
metaData:metaSpot,ppCost:model.ppCost,hasEnoughPp:hasEnoughPp,isStolen:action.isStolen||false,//TODO: check for stolen data here before providing the actionCategory.
actionCategory:action.isStolen?"stolen-item":model.category//provides the string to use for getting an icon
},nextView:"targetsView",handleOptionEnter:function handleOptionEnter(){//Populate the node in state with our selected action!
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["a" /* setBattleValue */])({arenaSubmissionMenuAction:Object.assign({},__WEBPACK_IMPORTED_MODULE_0__battle_data_battle_actions_js__["a" /* default */][action.actionId],{id:action.actionId,actionMeta:action//include the actionMeta from our player state (the attacks I know, and Items with instanceIds)
})});}},optionKey);});//Add a back button to the home screen
payload["listview-back"]=new __WEBPACK_IMPORTED_MODULE_1__menu_engine_MenuOption__["a" /* MenuOption */]({label:"Back",description:"Back to previous menu",viewBag:{index:Object.keys(payload).length,//one more than the last option (for scrolly behavior)
isBackButton:true},nextView:"homeView"},"listview-back");return payload;}

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_random_from_array_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__connection_firebase_rooms_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__is_submission_menu_open__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubmissionMenu_icon_svg_getters_icon_categories_js__ = __webpack_require__(143);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var allTaunts=["What are you waiting for?","Hurry up!","Why must you be so slow?","You don't even know what's coming!","Ayyy, batter batter batter!","Is that all you've got?","I thought this was going to be a challenge?","These fingers are going to make you cry!","You got a problem?","Jeez, just pick something.","I'm feeling Dangerous.","Sure you want to do this?"];var TauntButton=function(_React$Component){_inherits(TauntButton,_React$Component);function TauntButton(){_classCallCheck(this,TauntButton);var _this=_possibleConstructorReturn(this,(TauntButton.__proto__||Object.getPrototypeOf(TauntButton)).call(this));_this.state={progress:100};return _this;}_createClass(TauntButton,[{key:'handleSubmit',value:function handleSubmit(e){var _this2=this;e.preventDefault();if(this.state.progress<100){//Button not ready
return;}//Button is ready!
//Set firebase taunt:
var _store$getState$battl=__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().battle,battlePlayerId=_store$getState$battl.battlePlayerId,combatants=_store$getState$battl.combatants;var playerModel=combatants[battlePlayerId[0]];var taunt=playerModel.name+': '+__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_random_from_array_js__["a" /* randomFromArray */])(allTaunts);// Write the taunt!
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__connection_firebase_rooms_js__["b" /* writeTauntToRoom */])(taunt);//Reset the progress bar
this.setState({progress:0},function(){_this2.fillBar();});}},{key:'componentDidMount',value:function componentDidMount(){//this.fillBar();
}},{key:'fillBar',value:function fillBar(){var _this3=this;var step=function step(){if(_this3.state.progress<101){_this3.setState({progress:_this3.state.progress+0.5},function(){requestAnimationFrame(step);});}};requestAnimationFrame(step);}},{key:'getWaitingNameText',value:function getWaitingNameText(){if(this.props.combatantSelectingAction.length){//Create models for both Player and the Person waiting to select
var personModel=__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().battle.combatants[this.props.arenaSubmissionMenuCombatantIdLock];var playerModel=__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().battle.combatants[__WEBPACK_IMPORTED_MODULE_3__init_store_js__["a" /* default */].getState().battle.battlePlayerId[0]];//It's possible that the personModel is undefined (end of rally battle?),
//So just don't show anything here.
if(!personModel){return null;}//Compare teams to get the correct color for the name text.
var nameColor=playerModel.belongsToTeam===personModel.belongsToTeam?"#4A90E2"//Waiting on person from FRIENDLY team (blue)
:"#FC304A";//Waiting on person from ENEMY team (red)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:nameColor}},personModel.name.toUpperCase());}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'somebody');}},{key:'getPositionStyle',value:function getPositionStyle(vW){if(this.props.viewportMode==="landscape"){return{width:vW*30,right:vW*5,bottom:vW*3,fontSize:vW*3};}//mobile
return{right:vW*3,left:vW*3,fontSize:vW*6,bottom:vW*3};}},{key:'render',value:function render(){//Taunting is multiplayer only
if(!this.props.isMultiplayerMode){return null;}if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__is_submission_menu_open__["a" /* isSubmissionMenuOpen */])()){//I'm selecting my option. Focus on that.
return null;}if(!this.props.arenaSubmissionMenuCombatantIdLock){//Do not show if this person's ID has already been nulled out after submitting
return null;}//TODO: for this one, we could maybe check the selectingString instead? but its messy with deadlines and such.
if(this.props.rolloutData.length!==0){//I'm reading the rollout text. Focus on that
return null;}//Get a value for the user to see
var displayValue=Math.round(this.state.progress);displayValue=displayValue>100?100:displayValue;//Floor at 100
var style={color:displayValue<100?"#666":"#FCFCFC"};var iconContainerStyle={display:"block",marginRight:"1em"};var iconCellStyle={boxShadow:"0 0.25em 0 0 rgba(0,0,0,0.3)"};var messageStyle={padding:"1em 0 1em",marginBottom:"1em",fontSize:"0.7em",lineHeight:"1.7em",color:"#FCFCFC",borderBottom:"0.3em solid rgba(255,255,255,0.1)"};//Get the speech bubble icon
var iconSvg=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__SubmissionMenu_icon_svg_getters_icon_categories_js__["a" /* getIcon */])("speech","1.8em");/* eslint jsx-a11y/href-no-hash: "off" */return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:messageStyle},'Waiting for ',this.getWaitingNameText(),' to select an action...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:style,className:'ArenaSubmissionOption',href:'#',onClick:this.handleSubmit.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:iconContainerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:iconCellStyle},iconSvg)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ArenaSubmissionOption-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Taunt!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ArenaSubmissionOption-meta'},displayValue,'%'))));}}]);return TauntButton;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{vW:state.global.vW,viewportMode:state.global.viewportMode,isMultiplayerMode:state.battle.isMultiplayerMode,//So it knows to update...
arenaSubmissionMenuCombatantIdLock:state.battle.arenaSubmissionMenuCombatantIdLock,combatantSelectingAction:state.battle.combatantSelectingAction,rolloutData:state.battle.rolloutData};})(TauntButton));

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TauntTextbox=function(_React$Component){_inherits(TauntTextbox,_React$Component);function TauntTextbox(){_classCallCheck(this,TauntTextbox);return _possibleConstructorReturn(this,(TauntTextbox.__proto__||Object.getPrototypeOf(TauntTextbox)).apply(this,arguments));}_createClass(TauntTextbox,[{key:'render',value:function render(){var _props=this.props,vW=_props.vW,arenaTaunt=_props.arenaTaunt;if(!arenaTaunt){return null;//No arena taunt is set!
}var style={fontSize:this.props.viewportMode==="landscape"?vW:vW*2,//desktop, mobile
position:"absolute",zIndex:10,left:"0",top:"0",padding:"1em",background:"#200535",color:"#fcfcfc"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:style},arenaTaunt);}}]);return TauntTextbox;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{vW:state.global.vW,viewportMode:state.global.viewportMode,arenaTaunt:state.battle.arenaTaunt};})(TauntTextbox));

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AnimationAttack=function(_React$Component){_inherits(AnimationAttack,_React$Component);function AnimationAttack(){_classCallCheck(this,AnimationAttack);return _possibleConstructorReturn(this,(AnimationAttack.__proto__||Object.getPrototypeOf(AnimationAttack)).apply(this,arguments));}_createClass(AnimationAttack,[{key:'runAnimationSeries',value:function(){var _ref=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0://Start shaking
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(this.props.casterId,{animationCssRule:"shake 0.5s infinite"});/* ----------- */_context.next=3;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["b" /* timeout */])(200);case 3://Stop shaking
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(this.props.casterId,{animationCssRule:"none"});//Tell each target to go OUCH
this.props.targetIds.forEach(function(targetId){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(targetId,{animationCssRule:"shake 0.3s infinite"});});/* ----------- */_context.next=7;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["b" /* timeout */])(200);case 7://Stop target shaking
this.props.targetIds.forEach(function(targetId){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(targetId,{animationCssRule:"none"});});//Clear the background stuff
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["c" /* clearArenaAnimations */])();/* ----------- */_context.next=11;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["b" /* timeout */])(50);case 11://Move on to next step
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["a" /* handleAnimationEnd */])();case 12:case'end':return _context.stop();}}},_callee,this);}));function runAnimationSeries(){return _ref.apply(this,arguments);}return runAnimationSeries;}()},{key:'componentDidMount',value:function componentDidMount(){this.runAnimationSeries();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{position:'absolute'}});}}]);return AnimationAttack;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AnimationAttack);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation_lifecycle_utilities__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__audio_audio_manager_js__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AnimationFillHp=function(_React$Component){_inherits(AnimationFillHp,_React$Component);function AnimationFillHp(){_classCallCheck(this,AnimationFillHp);return _possibleConstructorReturn(this,(AnimationFillHp.__proto__||Object.getPrototypeOf(AnimationFillHp)).apply(this,arguments));}_createClass(AnimationFillHp,[{key:'runAnimationSeries',value:function(){var _ref=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0://Play SFX
__WEBPACK_IMPORTED_MODULE_3__audio_audio_manager_js__["a" /* default */].playSfx("sfx_fillHp");//Move on to next step
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__animation_lifecycle_utilities__["a" /* handleAnimationEnd */])();case 2:case'end':return _context.stop();}}},_callee,this);}));function runAnimationSeries(){return _ref.apply(this,arguments);}return runAnimationSeries;}()},{key:'componentDidMount',value:function componentDidMount(){this.runAnimationSeries();}},{key:'render',value:function render(){return null;}}]);return AnimationFillHp;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AnimationFillHp);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__audio_audio_manager_js__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AnimationForEach=function(_React$Component){_inherits(AnimationForEach,_React$Component);function AnimationForEach(){_classCallCheck(this,AnimationForEach);return _possibleConstructorReturn(this,(AnimationForEach.__proto__||Object.getPrototypeOf(AnimationForEach)).apply(this,arguments));}_createClass(AnimationForEach,[{key:'runIterationAnimation',/** Make the caster wiggle (called once per iteration) */value:function(){var _ref=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(subject,callback){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0://Play SFX per iteration!
__WEBPACK_IMPORTED_MODULE_4__audio_audio_manager_js__["a" /* default */].playSfx("sfx_loopIterate");//Shake the caster
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(this.props.casterId,{animationCssRule:"tada 0.4s infinite"});/* ----------- */_context.next=4;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["b" /* timeout */])(400);case 4://Stop shaking caster
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(this.props.casterId,{animationCssRule:"none"});/* ----------- */_context.next=7;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["b" /* timeout */])(90);case 7:callback();case 8:case'end':return _context.stop();}}},_callee,this);}));function runIterationAnimation(_x,_x2){return _ref.apply(this,arguments);}return runIterationAnimation;}()//recursive! Run this step, then call self again with the next step
},{key:'runStep',value:function runStep(index,series){var _this2=this;if(series[index]){return this.runIterationAnimation(series[index],function(){_this2.runStep(index+1,series);});}else{//We've gotten through all of the steps of `series` array. Now fire the "final done" call!
//console.log("we're done! yaaaaay");
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["a" /* handleAnimationEnd */])();}}},{key:'componentDidMount',value:function componentDidMount(){//This animation has 1 single target. Find him in the damageTracks (even though this is the only person in the object for this particular Attack)
var forEachSteps=this.props.targetsDamageTracker[this.props.targetIds[0]//Use the first target
];this.runStep(0,forEachSteps);}},{key:'render',value:function render(){return null;}}]);return AnimationForEach;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AnimationForEach);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AnimationHeadphones=function(_React$Component){_inherits(AnimationHeadphones,_React$Component);function AnimationHeadphones(){_classCallCheck(this,AnimationHeadphones);return _possibleConstructorReturn(this,(AnimationHeadphones.__proto__||Object.getPrototypeOf(AnimationHeadphones)).apply(this,arguments));}_createClass(AnimationHeadphones,[{key:'runAnimationSeries',value:function(){var _ref=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0://Change to Blue
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["a" /* setBattleValue */])({arenaBackgroundStyle:"rgba(69,201,239,0.5)"});/* ----------- */_context.next=3;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["b" /* timeout */])(100);case 3://Start shaking
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(this.props.casterId,{animationCssRule:"shake 2s infinite"});/* ----------- */_context.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["b" /* timeout */])(900);case 6://Stop shaking
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(this.props.casterId,{animationCssRule:"none"});//Tell each target to also shake
this.props.targetIds.forEach(function(targetId){if(targetId!==_this2.props.casterId){//Only do this for targets that are not the caster (who is already shaking)
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(targetId,{animationCssRule:"shake 1.5s infinite"});}});/* ----------- */_context.next=10;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["b" /* timeout */])(400);case 10://Stop target shaking
this.props.targetIds.forEach(function(targetId){if(targetId!==_this2.props.casterId){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(targetId,{animationCssRule:"none"});}});//Clear the background stuff
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["c" /* clearArenaAnimations */])();/* ----------- */_context.next=14;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["b" /* timeout */])(50);case 14://Move on to next step
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["a" /* handleAnimationEnd */])();case 15:case'end':return _context.stop();}}},_callee,this);}));function runAnimationSeries(){return _ref.apply(this,arguments);}return runAnimationSeries;}()},{key:'componentDidMount',value:function componentDidMount(){this.runAnimationSeries();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{position:'absolute'}});}}]);return AnimationHeadphones;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AnimationHeadphones);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__init_store__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AnimationSlice=function(_React$Component){_inherits(AnimationSlice,_React$Component);function AnimationSlice(){_classCallCheck(this,AnimationSlice);var _this=_possibleConstructorReturn(this,(AnimationSlice.__proto__||Object.getPrototypeOf(AnimationSlice)).call(this));_this.state={hasTriggeredAnimation:false};return _this;}_createClass(AnimationSlice,[{key:'runAnimationSeries',value:function(){var _ref=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["b" /* timeout */])(200);case 2://Fire the blade animation
this.setState({hasTriggeredAnimation:true});/* ----------- */_context.next=5;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["b" /* timeout */])(100);case 5://Tell each target to go OUCH
this.props.targetIds.forEach(function(targetId){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(targetId,{animationCssRule:"shake 0.3s infinite"});});/* ----------- */_context.next=8;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["b" /* timeout */])(300);case 8://Stop target shaking
this.props.targetIds.forEach(function(targetId){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(targetId,{animationCssRule:"none"});});//Clear the background stuff
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["c" /* clearArenaAnimations */])();/* ----------- */_context.next=12;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["b" /* timeout */])(200);case 12://Move on to next step
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["a" /* handleAnimationEnd */])();case 13:case'end':return _context.stop();}}},_callee,this);}));function runAnimationSeries(){return _ref.apply(this,arguments);}return runAnimationSeries;}()},{key:'componentDidMount',value:function componentDidMount(){this.runAnimationSeries();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.props.targetIds.map(function(targetId,i){var targetModel=__WEBPACK_IMPORTED_MODULE_4__init_store__["a" /* default */].getState().battle.combatants[targetId];//Get the Left, Top, W, H of the target person.
var _targetModel$bounding=targetModel.boundingClientRect,left=_targetModel$bounding.left,top=_targetModel$bounding.top,width=_targetModel$bounding.width,height=_targetModel$bounding.height;//Create a style block out of that
var style={position:"absolute",background:"url(/images/animations/battle/slice-animation.svg) no-repeat no-repeat",backgroundSize:"cover",zIndex:3,backgroundPosition:_this2.state.hasTriggeredAnimation?parseInt(width,10)*-4+'px 0%':"0% 0%",left:left,top:top,width:width,height:height,transition:"background-position 0.3s steps(4)"};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:i,style:style});}));}}]);return AnimationSlice;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AnimationSlice);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__audio_audio_manager_js__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AnimationTeamForEach=function(_React$Component){_inherits(AnimationTeamForEach,_React$Component);function AnimationTeamForEach(){_classCallCheck(this,AnimationTeamForEach);return _possibleConstructorReturn(this,(AnimationTeamForEach.__proto__||Object.getPrototypeOf(AnimationTeamForEach)).apply(this,arguments));}_createClass(AnimationTeamForEach,[{key:'runIterationAnimation',/** Make the target wiggle (called once per iteration) */value:function(){var _ref=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(subject,callback){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0://Play SFX per iteration!
__WEBPACK_IMPORTED_MODULE_4__audio_audio_manager_js__["a" /* default */].playSfx("sfx_loopIterate");//Shake the caster
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(subject.combatantId,{animationCssRule:"shake 0.4s infinite"});/* ----------- */_context.next=4;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["b" /* timeout */])(300);case 4://Stop shaking caster
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(subject.combatantId,{animationCssRule:"none"});/* ----------- */_context.next=7;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["b" /* timeout */])(150);case 7:callback();case 8:case'end':return _context.stop();}}},_callee,this);}));function runIterationAnimation(_x,_x2){return _ref.apply(this,arguments);}return runIterationAnimation;}()//recursive! Run this step, then call self again with the next step
},{key:'runStep',value:function runStep(index,series){var _this2=this;if(series[index]){return this.runIterationAnimation(series[index],function(){_this2.runStep(index+1,series);});}else{//Series is complete!
//Stop shaking caster
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(this.props.casterId,{animationCssRule:"none"});//We've gotten through all of the steps of `series` array. Now fire the "final done" call!
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["a" /* handleAnimationEnd */])();}}},{key:'componentDidMount',value:function componentDidMount(){var _this3=this;//targetsDamageTracker provides us the data of who got hit, and in what order
//Sort the damage tracker's steps by order.
var tracker=this.props.targetsDamageTracker;var allSteps=Object.keys(tracker).map(function(key){return tracker[key];}).reduce(function(a,b){return[].concat(_toConsumableArray(a),_toConsumableArray(b));}).sort(function(a,b){return a.order>b.order?1:-1;});//Start shaking the Caster. Will stop when we're done
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(this.props.casterId,{animationCssRule:"tada 0.5s infinite"});//Kick off our first step!
setTimeout(function(){_this3.runStep(0,allSteps);},200);//pause for effect. This is a big move!
}},{key:'render',value:function render(){return null;}}]);return AnimationTeamForEach;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AnimationTeamForEach);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AnimationTroll=function(_React$Component){_inherits(AnimationTroll,_React$Component);function AnimationTroll(){_classCallCheck(this,AnimationTroll);return _possibleConstructorReturn(this,(AnimationTroll.__proto__||Object.getPrototypeOf(AnimationTroll)).apply(this,arguments));}_createClass(AnimationTroll,[{key:'runAnimationSeries',value:function(){var _ref=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0://Change to Red
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["a" /* setBattleValue */])({arenaBackgroundStyle:"rgba(255,19,19,0.46)"});/* ----------- */_context.next=3;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["b" /* timeout */])(100);case 3://Start shaking
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(this.props.casterId,{animationCssRule:"shake 0.3s infinite"});/* ----------- */_context.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["b" /* timeout */])(900);case 6://Stop shaking
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(this.props.casterId,{animationCssRule:"none"});//Tell each target to go OUCH
this.props.targetIds.forEach(function(targetId){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(targetId,{animationCssRule:"shake 0.3s infinite"});});/* ----------- */_context.next=10;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["b" /* timeout */])(400);case 10://Stop target shaking
this.props.targetIds.forEach(function(targetId){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(targetId,{animationCssRule:"none"});});//Clear the background stuff
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["c" /* clearArenaAnimations */])();/* ----------- */_context.next=14;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["b" /* timeout */])(50);case 14://Move on to next step
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_lifecycle_utilities__["a" /* handleAnimationEnd */])();case 15:case'end':return _context.stop();}}},_callee,this);}));function runAnimationSeries(){return _ref.apply(this,arguments);}return runAnimationSeries;}()},{key:'componentDidMount',value:function componentDidMount(){this.runAnimationSeries();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{position:'absolute'}});}}]);return AnimationTroll;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AnimationTroll);

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAnimation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnimationSlice__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnimationAttack__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnimationForEach__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AnimationTeamForEach__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AnimationHeadphones__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AnimationTroll__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AnimationFillHp__ = __webpack_require__(296);
function getAnimation(key,properties){//Ensure properties is defined
properties=properties||{};//Firebase will eat this object if it's empty.
// Some animations don't need to pass properties data (because they are just a sound, like AnimationFillHp)
// This line ensures we have an empty object and not `undefined`
var animations={AnimationAttack:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AnimationAttack__["a" /* default */],{casterId:properties.casterId,targetIds:properties.targetIds}),AnimationSlice:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__AnimationSlice__["a" /* default */],{casterId:properties.casterId,targetIds:properties.targetIds}),AnimationForEach:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AnimationForEach__["a" /* default */],{casterId:properties.casterId,targetIds:properties.targetIds,targetsDamageTracker:properties.targetsDamageTracker}),AnimationTeamForEach:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AnimationTeamForEach__["a" /* default */],{casterId:properties.casterId,targetIds:properties.targetIds,targetsDamageTracker:properties.targetsDamageTracker}),AnimationHeadphones:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AnimationHeadphones__["a" /* default */],{casterId:properties.casterId,targetIds:properties.targetIds}),AnimationTroll:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AnimationTroll__["a" /* default */],{casterId:properties.casterId,targetIds:properties.targetIds}),AnimationFillHp:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__AnimationFillHp__["a" /* default */],null)};if(!animations[key]){console.warn('no Animation Key found!',key);}return animations[key];}

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStatusUiModel;
function getStatusUiModel(){var statusString=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";if(statusString==="focus"){return{label:statusString,textColor:"#92C4FF"};}if(statusString==="fury"){return{label:statusString,textColor:"#FF4F4F"};}if(statusString==="deadline"){return{label:statusString,textColor:"#54FFD9"};}if(statusString==="memory-leak"){return{label:"Memory Leak",textColor:"#F798A4"};}if(statusString==="lag"){return{label:statusString,textColor:"#FFF9A9"};}if(statusString==="fire"){return{label:statusString,textColor:"#FF7384"};}//default
return{label:statusString,textColor:"#92C4FF"};}

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleBattleOver;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_actions_global_actions_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lifecycle_get_dead_teams_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions_js__ = __webpack_require__(2);
function handleBattleOver(){//Did I win or lose?
var myTeamId=__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().battle.combatants[__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().battle.battlePlayerId[0]].belongsToTeam;var didILose=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lifecycle_get_dead_teams_js__["a" /* getDeadTeams */])().includes(myTeamId);//Mark this result in state. The BattleOverScreen / BattleResults will use this to interact with Firebase
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions_js__["b" /* setMatchmakingValue */])({matchResult:didILose?"lose":"win"});//Transition to the Battle Over screen for either Multiplayer or Offline Quick battle mode
var nextGameArea=__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().battle.isMultiplayerMode?"b5-online-battle-over":"b5-offline-battle-over";__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_global_actions_js__["a" /* setGlobalValue */])({gameArea:nextGameArea});}

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BattleLobbyShareLink=function(_React$Component){_inherits(BattleLobbyShareLink,_React$Component);function BattleLobbyShareLink(){_classCallCheck(this,BattleLobbyShareLink);var _this=_possibleConstructorReturn(this,(BattleLobbyShareLink.__proto__||Object.getPrototypeOf(BattleLobbyShareLink)).call(this));_this.state={isButtonLit:false};return _this;}_createClass(BattleLobbyShareLink,[{key:"autoClose",value:function autoClose(){//We've hit the COPY button, so fire this to close the modal.
//Saves the user a click or tap.
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions__["b" /* setMatchmakingValue */])({isLobbyInviteModalOpen:false});}},{key:"getShareLink",value:function getShareLink(){var currentRoomId=__WEBPACK_IMPORTED_MODULE_2__init_store_js__["a" /* default */].getState().matchmaking.currentRoomId;//Append a FROM name
// const mainPlayerName = this.props.crewMembers[ Object.keys(this.props.crewMembers)[0] ].name;
// const fromText = mainPlayerName ? `&f=${mainPlayerName}` : "";
var fromText="";//TODO
return window.location.origin+"?online=y&p="+currentRoomId+fromText;}},{key:"handleCopyClick",value:function handleCopyClick(){//Just needs a handler here for iOS. Otherwise button click doesnt submit
}},{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.clipboard=new __WEBPACK_IMPORTED_MODULE_1_clipboard___default.a(".js-copy-share-link-button");var self=this;//Copy Success
this.clipboard.on("success",function(e){// console.info('Action:', e.action);
// console.info('Text:', e.text);
// console.info('Trigger:', e.trigger);
//alert('copied!')
self.setState({isButtonLit:true});setTimeout(function(){self.setState({isButtonLit:false});_this2.autoClose();},600);e.clearSelection();});//Copy Fail
this.clipboard.on("error",function(e){console.error("Action:",e.action);console.error("Trigger:",e.trigger);});}},{key:"componentWillUnmount",value:function componentWillUnmount(){//Destroy this instance of Clipboard
this.clipboard.destroy();}},{key:"getButtonStyle",value:function getButtonStyle(){if(this.state.isButtonLit){return{background:"#46C7AA",borderBottom:"0.3em solid #389C85"};}return{background:"#4990E2",//blue
borderBottom:"0.3em solid #3F7FC9"};}},{key:"render",value:function render(){var buttonText=this.state.isButtonLit?"Copied!":"Copy Link";var style={position:"relative"//overflow: "hidden"
};var inputStyle={display:"block",width:"100%",fontSize:"0.6em",height:"8em",textAlign:"center",marginBottom:"4em",border:"0.5em solid #B2AAB9",boxShadow:"0 0.3em 0 0 rgba(0,0,0,0.1)",color:"#200535"// position: "absolute",
// left: "-999px"
};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{style:inputStyle,id:"js-share-button-input",readOnly:true,value:this.getShareLink()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"js-copy-share-link-button button block large","data-clipboard-target":"#js-share-button-input",onClick:this.handleCopyClick.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"button--text"},buttonText)));}}]);return BattleLobbyShareLink;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BattleLobbyShareLink);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connection_firebase_auth__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_get_query_variable_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RallyBattleLobby__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FullteamBattleLobby__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OnlineBattleContainer__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__b5_crew_management_EditCombatantModal_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__b5_home_FullscreenState__ = __webpack_require__(84);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import ConsoleView from './ConsoleView'
// import SetNameScreen from "./SetNameScreen.js";
//TODO: This name needs to change, but I'm not sure what to call it yet
var BattleLoginWall=function(_React$Component){_inherits(BattleLoginWall,_React$Component);function BattleLoginWall(){_classCallCheck(this,BattleLoginWall);return _possibleConstructorReturn(this,(BattleLoginWall.__proto__||Object.getPrototypeOf(BattleLoginWall)).apply(this,arguments));}_createClass(BattleLoginWall,[{key:"componentWillMount",value:function componentWillMount(){//Look at the URL to see if we have a specific room to join.
var partyIdFromUrl=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_get_query_variable_js__["a" /* getQueryVariable */])("p");if(partyIdFromUrl){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__redux_actions_battle_actions_js__["b" /* setMatchmakingValue */])({redirectToRoom:partyIdFromUrl});}//Find a room, put us in it
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__connection_firebase_auth__["a" /* loginToBattleNetwork */])();}},{key:"renderNotificationMessage",value:function renderNotificationMessage(){//This is a MatchkingErrorMessage flow type:
var model=this.props.matchmakingErrorMsg;//will always be the Flow type^^
if(model.status==="None"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"model status is NONE");}if(model.status==="Error"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"error-text"},model.message);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,model.message);}},{key:"renderBattle",value:function renderBattle(){//rename this?
//Show a Lobby screen if battle has not started
if(!this.props.hasBattleStarted){if(this.props.currentRoomType==="fullteam"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FullteamBattleLobby__["a" /* default */],null);}if(this.props.currentRoomType==="open"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__RallyBattleLobby__["a" /* default */],null);}return null;}var _props=this.props,combatants=_props.combatants,teams=_props.teams;//First render will may not have combatants or teams set. (need to initBattle earlier)
if(!teams||Object.keys(combatants).length===0||Object.keys(teams).length===0){//console.warn('Warning! Tried to render but Combatants and Teams are not set');
// console.log("teams and combatants not yet set for Online battle");
return null;}//Online Arena in game frame
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__OnlineBattleContainer__["a" /* default */],null);}},{key:"renderInnerContent",value:function renderInnerContent(){//Case 1: We successfully joined the room and know the room Type
if(this.props.userDataState==="Success"&&(this.props.currentRoomType==="fullteam"||this.props.currentRoomType==="open")){//TODO: This probably needs to be like, "Check if we're in a battle"
return this.renderBattle();}//Case 2: There is an error.
var errorModel=this.props.matchmakingErrorMsg;if(this.props.matchmakingErrorMsg.status==="Error"){//Room is full
if(errorModel.code==="error/full"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__b5_home_FullscreenState__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"ErrorStateText__text"},"This room is full!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"ErrorStateText__text"},"Start another room, or configure your crew to be ready for the next battle."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button large primary",href:"/?online=y"},"New Versus Battle"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button large",href:"/"},"Go to Your Crew"))));}//Battle has already started!
if(errorModel.code==="error/started"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__b5_home_FullscreenState__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"ErrorStateText__text"},"Uh oh - This battle has already started!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"ErrorStateText__text"},"Start another room, or configure your crew to be ready for the next battle."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button large primary",href:"/?online=y"},"New Versus Battle"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button large",href:"/"},"Go to Your Crew"))));}}// console.log("render - >", this.props.userDataState, this.props.currentRoomType)
//
// console.log('err', this.props.matchmakingErrorMsg)
// console.warn('unknown case in renderInnerContent')
console.log('errorModel',errorModel);return null;}// renderDebugInfo() {
//   const { battlePlayerId, currentRoomId } = this.props;
//   const tempDebugStyle = {
//     fontSize: "11px",
//     position: "absolute",
//     left: 0,
//     top: 0,
//     background: "#333",
//     color: "#fff"
//   };
//
//   const masterBadge = this.props.isMultiplayerMasterClient
//     ? <span> | MASTER</span>
//     : <span />;
//   //const errorMsg = this.props.matchmakingErrorMsg ? <div className="error-text">{this.props.matchmakingErrorMsg}</div> : null
//
//   return (
//     <div style={tempDebugStyle}>
//       <div>
//         You are: {battlePlayerId[0]}
//       </div>
//       <div>
//         Room: {currentRoomId} {masterBadge}
//       </div>
//       {this.renderNotificationMessage()}
//     </div>
//   );
// }
/* Open the modal if we're open */},{key:"renderEditCombatantModal",value:function renderEditCombatantModal(){if(this.props.editingCombatantProperties.isActivated){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__b5_crew_management_EditCombatantModal_js__["a" /* default */],null);}return null;}},{key:"render",value:function render(){//Loading and SetName screen
if(this.props.userDataState==="Loading"){//Figuring out who you are...
return null;}if(this.props.isDuplicateEntryScreen){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__b5_home_FullscreenState__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"ErrorStateText__text"},"Warning! You are already connected to the battle system in another browser window! Please return to your other tab!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button large",href:"/"},"Home Screen"))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"100%"}},this.renderInnerContent(),this.renderEditCombatantModal());}}]);return BattleLoginWall;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{vW:state.global.vW,isMultiplayerMasterClient:state.battle.isMultiplayerMasterClient,hasBattleStarted:state.battle.hasBattleStarted,battlePlayerId:state.battle.battlePlayerId,combatants:state.battle.combatants,teams:state.battle.teams,isDuplicateEntryScreen:state.matchmaking.isDuplicateEntryScreen,matchmakingErrorMsg:state.matchmaking.errorMessage,userDataState:state.matchmaking.userDataState,currentRoomId:state.matchmaking.currentRoomId,currentRoomType:state.matchmaking.currentRoomType,editingCombatantProperties:state.matchmaking.editingCombatantProperties};})(BattleLoginWall));

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_global_actions__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BattleResultProcessingLoader__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserCrewRecord__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NewlyUnlockedList__ = __webpack_require__(315);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint jsx-a11y/href-no-hash: "off" */var BattleOverScreen=function(_React$Component){_inherits(BattleOverScreen,_React$Component);function BattleOverScreen(){_classCallCheck(this,BattleOverScreen);var _this=_possibleConstructorReturn(this,(BattleOverScreen.__proto__||Object.getPrototypeOf(BattleOverScreen)).call(this));_this.state={newUnlockIds:[],isResultsProcessingDone:false//This process needs to complete before we show anything. If not done, show a loader
};return _this;}_createClass(BattleOverScreen,[{key:"handleDoneProcessingResults",value:function handleDoneProcessingResults(){this.setState({isResultsProcessingDone:true});//Now you're safe to pull needed values from redux state.
}//The Processing component has sent up our new unlocks
},{key:"handleReceiveNewUnlocks",value:function handleReceiveNewUnlocks(newUnlocks){this.setState({newUnlockIds:newUnlocks});}},{key:"handleNewOfflineBattle",value:function handleNewOfflineBattle(e){e.preventDefault();//Simply reseting the gameArea to "battle" will remount the battle components and everything will be cool
//If you need to do any "make the next battle state different" kind of stuff, do that before setting gameArea!
//Reset the winner
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions__["b" /* setMatchmakingValue */])({matchResult:"unknown"});//Transition back to battle
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_global_actions__["a" /* setGlobalValue */])({gameArea:"battle"});}/* Generate the href for the next battle link */},{key:"getNextBattleLink",value:function getNextBattleLink(){//NOTE: Make sure "&open" is in the URL here. This way, our Next Battle will also be Open
if(this.props.currentRoomType==="open"){return"/?online=y&open=y&p="+(this.props.currentRoomId||"unknown")+"+1";}//NOTE: This might need to change if URLs get prettier
return"/?online=y&p="+(this.props.currentRoomId||"unknown")+"+1";}//Maybe return styles that wrap the desktop layout together
},{key:"getDesktopWrap",value:function getDesktopWrap(){if(this.props.viewportMode==="portrait"){return{};}return{width:"40em",margin:"0 auto"};}},{key:"renderHeadlineResult",value:function renderHeadlineResult(){var text="unknown";if(this.props.matchResult==="win"){text="Victory!";}if(this.props.matchResult==="lose"){text="Defeat!";}var style={fontSize:"2.3em",marginBottom:"1em",textAlign:"center"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style},text);}},{key:"renderMainContent",value:function renderMainContent(){var mode=this.props.mode;var crewRecordContainerStyle={marginBottom:"3em"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,this.renderHeadlineResult(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__NewlyUnlockedList__["a" /* default */],{newlyUnlockedIds:this.state.newUnlockIds}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:crewRecordContainerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__UserCrewRecord__["a" /* default */],null)),mode==="online"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button block large primary",href:this.getNextBattleLink()},"Join Next Battle!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button block large",href:"/"},"Back to Home Screen")):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button block large primary",href:"#",onClick:this.handleNewOfflineBattle.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"button--text"},"Battle Again!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button block large",href:"/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"button--text"},"Back to Home Screen"))));}},{key:"renderLoadingSequence",value:function renderLoadingSequence(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BattleResultProcessingLoader__["a" /* default */],{onDone:this.handleDoneProcessingResults.bind(this),provideNewUnlocks:this.handleReceiveNewUnlocks.bind(this)}));}},{key:"render",value:function render(){var style={fontSize:this.props.viewportMode==="portrait"?"0.6em":"0.5em",//mobile, desktop
height:"100%",display:"flex",flexDirection:"column",justifyContent:"space-around"};//Uses `mode` prop for online button options vs offline button options
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style,className:"menu-texture"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:Object.assign({padding:"1em"},this.getDesktopWrap())},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"menu-card"},this.state.isResultsProcessingDone?this.renderMainContent():this.renderLoadingSequence()))));}}]);return BattleOverScreen;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{vW:state.global.vW,viewportMode:state.global.viewportMode,currentRoomId:state.matchmaking.currentRoomId,currentRoomType:state.matchmaking.currentRoomType,matchResult:state.matchmaking.matchResult};})(BattleOverScreen));

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__connection_firebase_users_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__b5_unlocks_getUserUnlocks_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__b5_unlocks_compareUnlocksStates_js__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__get_battle_type__ = __webpack_require__(152);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BattleResultProcessingLoader=function(_React$Component){_inherits(BattleResultProcessingLoader,_React$Component);function BattleResultProcessingLoader(){_classCallCheck(this,BattleResultProcessingLoader);var _this=_possibleConstructorReturn(this,(BattleResultProcessingLoader.__proto__||Object.getPrototypeOf(BattleResultProcessingLoader)).call(this));_this.state={isDoneProcessing:false,//This is the flag for knowing the Firebase work is done.
isDoneAnimating:false,//This is the flag for knowing the little animation sequence is complete.
animationBarProgress:0//Flips to 100 after a moment. CSS will bring us there.
//Both of these must get set to TRUE before we fire the callback.
};return _this;}//Watch for both processes to complete
_createClass(BattleResultProcessingLoader,[{key:"componentWillUpdate",value:function componentWillUpdate(newProps,newState){if(newState.isDoneAnimating&&newState.isDoneProcessing){this.props.onDone();}}//After a moment, trigger the bar to start filling.
},{key:"componentDidMount",value:function componentDidMount(){var _this2=this;setTimeout(function(){_this2.setState({animationBarProgress:100});},200);}},{key:"componentWillMount",value:function componentWillMount(){var _this3=this;//Get info for updating our user record.
var winOrLose=__WEBPACK_IMPORTED_MODULE_2__init_store_js__["a" /* default */].getState().matchmaking.matchResult;var battleType=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__get_battle_type__["a" /* getBattleType */])();//Get the current user data
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__connection_firebase_users_js__["d" /* getUserRecord */])(function(data){// console.log('user data', data);
//Save a copy of our previous unlocks
var unlocksBeforeUpdate=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__b5_unlocks_getUserUnlocks_js__["a" /* getUserUnlocks */])();//update the user record with this result
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__connection_firebase_users_js__["e" /* updateUserRecord */])(data,winOrLose,battleType,function(result){//Do something with the result;
//Save it to local state
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions_js__["e" /* setCrewValue */])({record:Object.assign({},result.payload)});//Get a new version of our unlocks so we can compare to our old
//This will allow us to show what has been achieved after this battle.
var unlocksAfterUpdate=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__b5_unlocks_getUserUnlocks_js__["a" /* getUserUnlocks */])();var newUnlocks=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__b5_unlocks_compareUnlocksStates_js__["a" /* compareUnlocksStates */])(unlocksBeforeUpdate,unlocksAfterUpdate);//Pass our ne unlocks up the the parent component
_this3.props.provideNewUnlocks(newUnlocks);//Tell our loader bar that we're actually ready to fire be done
_this3.setState({isDoneProcessing:true});});});}},{key:"handleTransitionEnd",value:function handleTransitionEnd(){this.setState({isDoneAnimating:true});}},{key:"render",value:function render(){var titleStyle={textAlign:"center",marginBottom:"3em"};var containerBarStyle={position:"relative",width:"100%",height:"1.8em",background:"#485471",outline:"0.5em solid #200535"};var fillProgressStyle={position:"absolute",background:"#DBE2F6",borderBottom:"0.4em solid #CAD1E6",left:0,bottom:0,top:0,width:this.state.animationBarProgress+"%",transition:"width 1.1s ease-in"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:titleStyle},"Processing"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:containerBarStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:fillProgressStyle,onTransitionEnd:this.handleTransitionEnd.bind(this)})));}}]);return BattleResultProcessingLoader;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BattleResultProcessingLoader);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubmissionMenu__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__get_online_status_svg__ = __webpack_require__(311);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Combatant=function(_React$Component){_inherits(Combatant,_React$Component);function Combatant(){_classCallCheck(this,Combatant);return _possibleConstructorReturn(this,(Combatant.__proto__||Object.getPrototypeOf(Combatant)).apply(this,arguments));}_createClass(Combatant,[{key:'renderSelectionArea',value:function renderSelectionArea(){if(this.props.isSelectingAction&&this.props.isPlayerControlled){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__SubmissionMenu__["a" /* default */],{model:this.props.model});}if(this.props.isSelectingAction&&!this.props.isPlayerControlled){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SubmissionMenu'},'Waiting for player input...');}return null;}},{key:'renderConnectionStatus',value:function renderConnectionStatus(){if(this.props.isConnected){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_online_status_svg__["a" /* getOnlineStatusCircle */])(true);}return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_online_status_svg__["a" /* getOnlineStatusCircle */])(false);}},{key:'renderBotStatus',value:function renderBotStatus(){return this.props.model.isBot?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'[BOT]'):null;}},{key:'renderBuggedItemStatus',value:function renderBuggedItemStatus(){var buggedItemCount=this.props.model.getTeamItems().filter(function(item){return item.isBugged;}).length;if(buggedItemCount>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,buggedItemCount,' bugged item(s)!');}return null;}},{key:'renderDangerMeter',value:function renderDangerMeter(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Danger Meter: ',this.props.model.dangerMeter,'%');}},{key:'render',value:function render(){var model=this.props.model;var isPlayerClass=this.props.isPlayerControlled?"is-player-controlled":"";var avatarStyle={backgroundImage:'url('+model.skin+')',backgroundSize:"100%",backgroundRepeat:"no-repeat"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Combatant '+isPlayerClass},this.props.isPlayerControlled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:"green"}},'This is you'):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Combatant-avatar',style:avatarStyle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:"inline-block"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Combatant-name'},model.name,' ',this.renderBotStatus(),' ',this.renderConnectionStatus()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Combatant-level'},'LVL ',model.level,' ',model.class)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'HP: ',model.hp,' / ',model.maxHp),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'PP: ',model.pp,' / ',model.maxPp),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.renderDangerMeter()),model.status!=="normal"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,model.status):null,Boolean(model.committedTurnData)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'COMMIT!'):null,this.renderBuggedItemStatus(),this.renderSelectionArea()));}}]);return Combatant;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);// Combatant.propTypes = {
//   /*someRequiredProp: React.PropTypes.string.isRequired*/
//   model: React.PropTypes.object.isRequired,
//   isSelectingAction: React.PropTypes.bool.isRequired,
//   isPlayerControlled: React.PropTypes.bool.isRequired,
//   isConnected: React.PropTypes.bool.isRequired,
// };
/* harmony default export */ __webpack_exports__["a"] = (Combatant);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__battle_data_battle_actions_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__get_targets__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lifecycle_submit_action_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__get_target_ids_from_conjoined_string_js__ = __webpack_require__(349);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubmissionMenu=function(_React$Component){_inherits(SubmissionMenu,_React$Component);function SubmissionMenu(props){_classCallCheck(this,SubmissionMenu);//This stuff is just for Console View. The menu-engine project will handle the Arena View optionIds and stuff.
var _this=_possibleConstructorReturn(this,(SubmissionMenu.__proto__||Object.getPrototypeOf(SubmissionMenu)).call(this));var model=props.model;//Determine if we are able to select ALL TEAM ITEMS or just my own. (Feature Flag)
//const availableItems = props.ff_IsTeamItemsOn ? model.getTeamItems() : model.items;
var actionOptions=model.getAvailableActions();var initialActionKey=actionOptions[0].actionId;var initialTargets=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__get_targets__["a" /* getTargets */])(initialActionKey,model.belongsToTeam,model.id);_this.state={hasBeenSubmitted:false,actionOptions:actionOptions,selectedActionIndex:0,selectedActionId:initialActionKey,actionTargets:initialTargets,//selectedTargetId: this.getFirstAliveCombatant(initialTargets, props.combatants)
selectedTargetId:initialTargets[0]};return _this;}_createClass(SubmissionMenu,[{key:'getFirstAliveCombatant',value:function getFirstAliveCombatant(targetIds,combatants){var isMultipleTargets=targetIds.length&&targetIds[0].match(",");if(isMultipleTargets){return targetIds[0];//return multiple targets if this is a combo
}return targetIds.find(function(id){var combModel=combatants[id];return combModel.isAlive();});}},{key:'componentWillUpdate',value:function componentWillUpdate(newProps){//If this person gets to go twice in a row,
//Make sure button state is updated if we switch from "me" to "deadline:me"
//Because this component does not actually unmount in that case. (Console only)
if(this.props.combatantSelectingAction!==newProps.combatantSelectingAction){this.setState({hasBeenSubmitted:false//reset
});}}},{key:'handleActionChange',value:function handleActionChange(changeEvent){var newActionIndex=changeEvent.target.value;//set active value to new actionId
var newActionId=this.state.actionOptions[newActionIndex].actionId;var newTargetOptions=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__get_targets__["a" /* getTargets */])(newActionId,this.props.model.belongsToTeam,this.props.model.id);this.setState({selectedActionIndex:newActionIndex,actionTargets:newTargetOptions,selectedTargetId:newTargetOptions[0]});}},{key:'handleTargetChange',value:function handleTargetChange(changeEvent){var newTargetId=changeEvent.target.value;this.setState({selectedTargetId:newTargetId});}/** Submit the console UI */},{key:'handleSubmit',value:function handleSubmit(){this.setState({hasBeenSubmitted:true});//Turn comma list into a group of an array of Target Combatant models.
var selectedTargetCombatants=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__get_target_ids_from_conjoined_string_js__["a" /* getTargetIdsFromConjoinedString */])(this.state.selectedTargetId,this.props.combatants);//Use the active index of the list to determine which model to use.
//(We need the whole object, like what is in combatant `attacks` or `items` array.. need libraryId and stolenData, hasTimedHitBonus, etc)
var hasTimedHitBonus=this.refs.timedHitCheckbox&&this.refs.timedHitCheckbox.checked;var selectedActionData=Object.assign({},this.state.actionOptions[this.state.selectedActionIndex],{hasTimedHitBonus:hasTimedHitBonus});var selectedActionId=selectedActionData.actionId;//TODO: Need to refactor this file to select the whole action object rather than just the ID. So we can merge the selected Object in.
//TODO: Submission needs to include this data.
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lifecycle_submit_action_js__["a" /* submitAction */])(Object.assign({id:selectedActionId},__WEBPACK_IMPORTED_MODULE_2__battle_data_battle_actions_js__["a" /* default */][selectedActionId],{actionMeta:selectedActionData}),this.props.model,selectedTargetCombatants);}},{key:'isButtonDisabled',value:function isButtonDisabled(){if(!this.state.selectedTargetId){return true;}return false;}},{key:'renderWarning',value:function renderWarning(actionModel,casterModel,targetModels){if(targetModels.length>1){return null;}var validityModel=actionModel.getValidity(actionModel,casterModel,targetModels);if(!validityModel.isValid){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'WARNING! ',validityModel.invalidReasons[0]);}return null;}},{key:'renderTimedHitCheckbox',value:function renderTimedHitCheckbox(actionModel){// if (actionModel.hasTimedHitBonusAvailable) {
//   return (
//     <div>
//       Timed Hit Bonus?
//       <input type="checkbox" ref="timedHitCheckbox" />
//     </div>
//   )
// }
return null;}},{key:'render',value:function render(){var _this2=this;//Don't render UI if we've already submitted (after button click.. prevents duplicates)
if(this.state.hasBeenSubmitted){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'SUBMITTED!');}//Render ConsoleView form
var selectedActionId=this.state.actionOptions[this.state.selectedActionIndex].actionId;var selectedActionModel=__WEBPACK_IMPORTED_MODULE_2__battle_data_battle_actions_js__["a" /* default */][selectedActionId];var selectedTargetCombatant=this.props.combatants[this.state.selectedTargetId];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SubmissionMenu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'SUBMIT ACTION:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Action'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.selectedActionIndex,onChange:this.handleActionChange.bind(this)},this.state.actionOptions.map(function(action,i){var model=__WEBPACK_IMPORTED_MODULE_2__battle_data_battle_actions_js__["a" /* default */][action.actionId];if(!model){console.warn('no action found',action.actionId);}var stolenText=action.isStolen?" - STOLEN!":null;var displayName=model.name;if(model.isItem){displayName='[ITEM] '+displayName;}if(model.isSuper){displayName='[SUPER] '+displayName;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:i,key:i},displayName,stolenText);}))),this.renderTimedHitCheckbox(selectedActionModel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SubmissionMenu-description'},selectedActionModel.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Target'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.selectedTargetId,onChange:this.handleTargetChange.bind(this)},this.state.actionTargets.map(function(targetId,i){var isMultipleTargets=targetId.match(",");if(isMultipleTargets){//<option value={targetId} key={i}>[Multiple Targets]</option>
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:targetId,key:i},targetId);}//TODO: This kind of "valid target" logic will need to be used in the Menu library
var targetModel=_this2.props.combatants[targetId]||{};var isDisabled=false;if(selectedActionModel.targetMustBeDead&&targetModel.isAlive()){isDisabled=true;}if(!selectedActionModel.targetMustBeDead&&!targetModel.isAlive()){isDisabled=true;}//<option value={targetId} key={i}>{targetId}</option>
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:targetId,key:i,disabled:isDisabled},targetModel.name);}))),this.renderWarning(selectedActionModel,this.props.model,[selectedTargetCombatant]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:this.isButtonDisabled(),onClick:this.handleSubmit.bind(this)},'Submit'));}}]);return SubmissionMenu;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{combatants:state.battle.combatants,combatantSelectingAction:state.battle.combatantSelectingAction,//Feature Flag:
ff_IsTeamItemsOn:state.battle.ff_IsTeamItemsOn};})(SubmissionMenu));

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOnlineStatusCircle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function getOnlineStatusCircle(){var isOnline=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var fillColor=isOnline?"#50E3C2":"#F18E9A";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{width:"12",viewBox:"0 0 31 31",version:"1.1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Page-1",stroke:"none",strokeWidth:"1",fill:"none",fillRule:"evenodd"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{id:"Oval-2",fill:fillColor,cx:"15.5",cy:"15.5",r:"15.5"})));}

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import ConsoleSeenRolloutButton from "./ConsoleSeenRolloutButton";
var ConsoleViewRollout=function(_React$Component){_inherits(ConsoleViewRollout,_React$Component);function ConsoleViewRollout(){_classCallCheck(this,ConsoleViewRollout);return _possibleConstructorReturn(this,(ConsoleViewRollout.__proto__||Object.getPrototypeOf(ConsoleViewRollout)).apply(this,arguments));}_createClass(ConsoleViewRollout,[{key:"renderBlip",value:function renderBlip(blip,index){if(blip.type==="message"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:index},blip.content.map(function(line,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},line);}));}return null;}},{key:"renderCurrentRolloutBlip",value:function renderCurrentRolloutBlip(){var _this2=this;//Only show this if we have rolloutData
if(this.props.rolloutData&&this.props.rolloutData.length>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ConsoleViewRollout-current"},this.props.rolloutData.map(function(blip,i){return _this2.renderBlip(blip,i);}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ConsoleViewRollout-current"},"Waiting for Rollout...");}},{key:"renderHistoryEntry",value:function renderHistoryEntry(entry,i){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i,className:"ConsoleViewRollout-history-entry"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ConsoleViewRollout-history-entry-id"},__WEBPACK_IMPORTED_MODULE_2_moment___default()(entry.timestamp).format("h:mm:ss a")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,entry.rolloutPayload.map(function(blip,i){return _this3.renderBlip(blip,i);})));}},{key:"render",value:function render(){var _this4=this;var isShowingCurrentRollout=this.props.rolloutData&&this.props.rolloutData.length>0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ConsoleViewRollout"},this.renderCurrentRolloutBlip(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ConsoleViewRollout-history"},this.props.rolloutHistory.filter(function(entry,i){if(isShowingCurrentRollout&&i===0){return false;}return true;}).map(function(entry,i){return _this4.renderHistoryEntry(entry,i);})));}}]);return ConsoleViewRollout;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);ConsoleViewRollout.propTypes={//someRequiredProp: React.PropTypes.string.isRequired
};ConsoleViewRollout.defaultProps={};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{rolloutId:state.battle.rolloutId,rolloutData:state.battle.rolloutData,rolloutHistory:state.battle.rolloutHistory};})(ConsoleViewRollout));

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_Skins__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ArenaView_is_submission_menu_open__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__get_combatant_id_from_selecting_string__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__init_store__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DesktopSelectingCombatantTab=function(_React$Component){_inherits(DesktopSelectingCombatantTab,_React$Component);function DesktopSelectingCombatantTab(){_classCallCheck(this,DesktopSelectingCombatantTab);return _possibleConstructorReturn(this,(DesktopSelectingCombatantTab.__proto__||Object.getPrototypeOf(DesktopSelectingCombatantTab)).apply(this,arguments));}_createClass(DesktopSelectingCombatantTab,[{key:'render',value:function render(){var _props=this.props,vW=_props.vW,vH=_props.vH,viewportMode=_props.viewportMode;if(viewportMode==="portrait"){return null;//This is for Desktop only!
}var style={position:"absolute",// width: vW * 37,
left:vW*58,bottom:vH*47,transform:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__ArenaView_is_submission_menu_open__["a" /* isSubmissionMenuOpen */])()?"translate3d(0,0,0)":"translate3d(0,150%,0)",transition:"transform 0.3s"};var textContainerStyle={width:"100%",textAlign:"center",paddingLeft:vW*3};var nameStyle={fontSize:"0.5em",color:"#FCFCFC",textTransform:"uppercase"};var containerStyle={position:"absolute",top:0,bottom:0,left:0,right:0,display:"flex",alignItems:"center",justifyContent:"space-around"};var avatarContainerStyle={position:"absolute",right:vW*4,bottom:0,width:vW*8,height:vW*8,overflow:"hidden"};var selectingPersonModel=__WEBPACK_IMPORTED_MODULE_5__init_store__["a" /* default */].getState().battle.combatants[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__get_combatant_id_from_selecting_string__["a" /* getCombatantIdFromSelectingString */])(this.props.arenaSubmissionMenuCombatantIdLock||"")];var displayName=selectingPersonModel?selectingPersonModel.name:"";//default to empty string if nobody is active
var skinSrc=selectingPersonModel?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_Skins__["a" /* default */])()[selectingPersonModel.skinId].frontViewSrc:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_Skins__["a" /* default */])()["skin_mystery"].frontViewSrc;//default to mystery person if nobody is active
var avatarPersonStyle={position:"absolute",top:vH*4,width:vW*8,height:vW*8,background:'url('+skinSrc+') no-repeat no-repeat',backgroundSize:"cover"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'Tab',src:'/images/misc/selecting-tab-background.svg',style:{width:vW*37}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:containerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:textContainerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:nameStyle},displayName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:avatarContainerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:avatarPersonStyle}))));}}]);return DesktopSelectingCombatantTab;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{viewportMode:state.global.viewportMode,vW:state.global.vW,vH:state.global.vH,arenaSubmissionMenuCombatantIdLock:state.battle.arenaSubmissionMenuCombatantIdLock};})(DesktopSelectingCombatantTab));

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connection_firebase_send_ready_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lifecycle_build_teams_from_client_buddies_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__b5_home_CrewLineup_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__b5_home_LobbyCTA_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__b5_home_MenuHeader_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__b5_home_FullteamInviteModal_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__b5_home_EditCrewNameModal__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__b5_home_MenuHeaderInviteLink__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__audio_AudioControl__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__audio_audio_manager__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import {modelsFromObject} from '../helpers/models-from-object.js'
var FullteamBattleLobby=function(_React$Component){_inherits(FullteamBattleLobby,_React$Component);function FullteamBattleLobby(){_classCallCheck(this,FullteamBattleLobby);return _possibleConstructorReturn(this,(FullteamBattleLobby.__proto__||Object.getPrototypeOf(FullteamBattleLobby)).apply(this,arguments));}_createClass(FullteamBattleLobby,[{key:"componentDidMount",value:function componentDidMount(){//Play the music!
__WEBPACK_IMPORTED_MODULE_12__audio_audio_manager__["a" /* default */].playSong("music_b5Menu");}},{key:"handleStartButtonClick",value:function handleStartButtonClick(){//masterStartBattle();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__connection_firebase_send_ready_js__["a" /* sendReadyToFirebase */])(function(){//console.log('ready!')
//TODO: if you want to fancy up the interaction, you have this callback.
});}},{key:"handleCloseInviteLinkModal",value:function handleCloseInviteLinkModal(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions_js__["b" /* setMatchmakingValue */])({isLobbyInviteModalOpen:false});}//Maybe return styles that wrap the desktop layout together
},{key:"getDesktopWrap",value:function getDesktopWrap(){if(this.props.viewportMode==="portrait"){return{};}return{width:"45em",margin:"0 auto"};}/** Cross reference roomCrewNames with our enemyTeamObject to get a Crew Name */},{key:"getEnemyCrewName",value:function getEnemyCrewName(enemyTeamObject){var _this2=this;//Filter for keys that are in both
var enemyKeysWithCrewNames=Object.keys(enemyTeamObject).filter(function(key){return Boolean(_this2.props.roomCrewNames[key]);});//Return the first match
if(enemyKeysWithCrewNames.length>0){return this.props.roomCrewNames[enemyKeysWithCrewNames[0]];}return"";//Known crew name
}},{key:"renderInviteLinkModal",value:function renderInviteLinkModal(){if(this.props.isLobbyInviteModalOpen){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__b5_home_FullteamInviteModal_js__["a" /* default */],{handleCloseCallback:this.handleCloseInviteLinkModal.bind(this)});}return null;}/* Show Crew Name modal if we're editing Crew Name */},{key:"renderEditCrewNameModal",value:function renderEditCrewNameModal(){if(this.props.isCrewNameModalOption){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__b5_home_EditCrewNameModal__["a" /* default */],null);}return null;}},{key:"renderMasterUi",value:function renderMasterUi(){var isReady=this.props.roomReadyClients[this.props.logggedInUserId];if(isReady){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__b5_home_LobbyCTA_js__["a" /* default */],{text:"Ready!",isDisabled:true,isReadyPressed:true,handler:function handler(){}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__b5_home_LobbyCTA_js__["a" /* default */],{text:"Ready to Battle",isDisabled:false,handler:this.handleStartButtonClick.bind(this)});//return <div>Waiting for Master to start match</div>
}},{key:"renderOpponentTeam",value:function renderOpponentTeam(enemyTeamObject){//If we have a populated object, return the opponent Lineup as usual
if(Object.keys(enemyTeamObject).length>0){var enemyClientId=Object.keys(enemyTeamObject).find(function(key){return key.match(/^client_/);}).replace("client_","");var isEnemyTeamReady=this.props.roomReadyClients[enemyClientId];var readyIndicatorStyle={position:"absolute",left:"50%",top:"8em",transform:"translateX(-50%)",background:"#46D47E",border:"0.2em solid #fff",color:"#fff",width:"13em",padding:"0.7em",textAlign:"center",display:isEnemyTeamReady?"block":"none"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__b5_home_CrewLineup_js__["a" /* default */],{showLaptop:true,crewTeamModel:enemyTeamObject,areCombatantsEditable:false,crewName:this.getEnemyCrewName(enemyTeamObject)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:readyIndicatorStyle},"Ready!"));}//Otherwise, return a mystery man team!
var mysteryManShadowTeam={shadowPersonOne:{skinId:"skin_mystery",arenaPosition:1},shadowPersonTwo:{skinId:"skin_mystery",arenaPosition:2},shadowPersonThree:{skinId:"skin_mystery",arenaPosition:3}};var containerStyle={position:"relative"};var messageStyle={position:"absolute",left:"50%",top:"8em",transform:"translateX(-50%)",background:"#170226",border:"0.2em solid #fff",color:"#fff",// width: "17em",
lineHeight:"1.7em",padding:"1.4em 2em",textAlign:"center",fontSize:"0.8em"};var inviteLinkStyle={display:"block",paddingTop:"1em",color:"#6cb0ff"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:containerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__b5_home_CrewLineup_js__["a" /* default */],{showLaptop:false,crewTeamModel:mysteryManShadowTeam,areCombatantsEditable:false,crewName:""}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:messageStyle},"Waiting for Opponent",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__b5_home_MenuHeaderInviteLink__["a" /* default */],{text:"Invite somebody",customStyle:inviteLinkStyle}))));}},{key:"renderCombatantGroups",value:function renderCombatantGroups(){var _this3=this;//Only for UI layout. Does not affect actual teams
var teams=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lifecycle_build_teams_from_client_buddies_js__["a" /* buildTeamsFromClientBuddies */])(this.props.initialCombatantData);var teamOneCombatantsObject={};teams.one.combatantIds.forEach(function(id){teamOneCombatantsObject[id]=Object.assign({},_this3.props.initialCombatantData[id]);});var teamTwoCombatantsObject={};teams.two.combatantIds.forEach(function(id){teamTwoCombatantsObject[id]=Object.assign({},_this3.props.initialCombatantData[id]);});var playerMainId=this.props.battlePlayerId[0];var playerTeamId=null;if(teams.one.combatantIds.includes(playerMainId)){playerTeamId="one";}if(teams.two.combatantIds.includes(playerMainId)){playerTeamId="two";}if(!playerTeamId){return null;}var playerTeamObject=playerTeamId==="one"?teamOneCombatantsObject:teamTwoCombatantsObject;var enemyTeamObject=playerTeamId==="one"?teamTwoCombatantsObject:teamOneCombatantsObject;//Need to show Player's team from crew state. Use the PlayerTeamObject to create a version that looks up members
//from crew state. This allows them to instantly update on edits and not wait for Firebase response.
//In other words: Enemy team is data from Firebase's initialCombatantData. Friendly team is from local state.
var playerTeamObjectFromCrewState={};Object.keys(playerTeamObject).forEach(function(key){var modelFromPlayerTeamObject=playerTeamObject[key];playerTeamObjectFromCrewState[modelFromPlayerTeamObject.memberId]=Object.assign({},_this3.props.crewMembers[modelFromPlayerTeamObject.memberId]);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,this.renderOpponentTeam(enemyTeamObject),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__b5_home_CrewLineup_js__["a" /* default */],{showLaptop:true,crewTeamModel:playerTeamObjectFromCrewState,areCombatantsEditable:true,crewName:this.props.crewName}));}},{key:"render",value:function render(){if(!this.props.initialCombatantData){console.warn("this.props.initialCombatantData is undefined in FullteamBattleLobby. Shouldnt be mounted");}var _props=this.props,vW=_props.vW,viewportMode=_props.viewportMode;var style={fontSize:viewportMode==="portrait"?"0.6em":"0.45em",//mobile, desktop
height:"100%"};var contentContainerStyle={width:viewportMode==="portrait"?"100%":vW*40,position:"relative",height:"100%",margin:"0 auto"};//TODO: Can this cancel link be js-only? It would be cool to avoid another page load, but would need to clear out of a bunch of stuff
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style,className:"page-container menu-texture"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__b5_home_MenuHeader_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__audio_AudioControl__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-container--section",style:this.getDesktopWrap()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:contentContainerStyle},this.renderCombatantGroups())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-container--section",style:Object.assign({padding:"2em 2em 3em"},this.getDesktopWrap())},this.renderMasterUi())),this.renderEditCrewNameModal(),this.renderInviteLinkModal());}}]);return FullteamBattleLobby;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{vW:state.global.vW,viewportMode:state.global.viewportMode,currentRoomId:state.matchmaking.currentRoomId,initialCombatantData:state.matchmaking.initialCombatantData,roomCrewNames:state.matchmaking.crewNames,//known crewNames in the room
roomReadyClients:state.matchmaking.readyClients,//know who's ready in the room
isLobbyInviteModalOpen:state.matchmaking.isLobbyInviteModalOpen,isCrewNameModalOption:state.matchmaking.isCrewNameModalOption,isMultiplayerMasterClient:state.battle.isMultiplayerMasterClient,battlePlayerId:state.battle.battlePlayerId,crewName:state.crew.name,crewMembers:state.crew.members,logggedInUserId:state.crew.logggedInUserId};})(FullteamBattleLobby));

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__b5_unlocks_getUserUnlocks_js__ = __webpack_require__(37);
/* harmony default export */ __webpack_exports__["a"] = (function(props,state){//Don't show if no new unlocks
if(props.newlyUnlockedIds.length===0){return null;}var containerStyle={textAlign:"center"};var headingStyle={color:"#A897B5",fontSize:"0.8em"};var unlockStyle={unlock:{marginBottom:"1em"},icon:{display:"inline-block",verticalAlign:"middle",marginRight:"2em"},unlockName:{display:"inline-block",verticalAlign:"middle",fontSize:"1.1em",textTransform:"uppercase"}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:containerStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:headingStyle},"You've earned:"),props.newlyUnlockedIds.map(function(id,index){var unlockModel=__WEBPACK_IMPORTED_MODULE_1__b5_unlocks_getUserUnlocks_js__["c" /* unlocks */].find(function(unlock){return unlock.id===id;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:unlockStyle.unlock,key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:unlockStyle.icon,className:"UnlockIconContainer"},unlockModel.icon("3.5em")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:unlockStyle.unlockName},unlockModel.name,"!"));}));});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConsoleView_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ArenaView_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lifecycle_build_teams_from_combatant_data_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lifecycle_init_battle_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lifecycle_start_turn_series_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lifecycle_handle_new_rollout_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__offline_offline_check_for_auto_submissions_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__audio_audio_manager_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_get_query_variable_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__getDevScenario__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reporting_mode_ReportingRunner__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__getQuickBattleScenario__ = __webpack_require__(351);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import {getRandomBattleScenario} from './getRandomBattleScenario'
/** Sets any data before mounting the battle arena */var OfflineBattleContainer=function(_React$Component){_inherits(OfflineBattleContainer,_React$Component);function OfflineBattleContainer(){_classCallCheck(this,OfflineBattleContainer);return _possibleConstructorReturn(this,(OfflineBattleContainer.__proto__||Object.getPrototypeOf(OfflineBattleContainer)).apply(this,arguments));}_createClass(OfflineBattleContainer,[{key:"componentWillMount",/** Load the data for the battle */value:function componentWillMount(){var _crewNames;//Check if we should be in full party control mode or not.
var controlledCombatantIds=["main","oneB","oneC"];//TODO: Hardcoding may become an issue? Not sure.
//UPDATE: Hardcoding in B5 is going to be a thing, but only for initing battles. No need to hardcode in the future
//We could arguable get rid of the hardcoding now, but it's not a deep issue.
//Track the starting time!
//NOTE: this piece happens separately in Online mode via OnlineBattleContainer
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__redux_actions_battle_actions_js__["a" /* setBattleValue */])({battleStartTimestamp:Date.now()//Start time!
});this.initialCombatantData=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helpers_get_query_variable_js__["a" /* getQueryVariable */])("dev")?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__getDevScenario__["a" /* getDevScenario */])(controlledCombatantIds):__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__getQuickBattleScenario__["a" /* getQuickBattleScenario */])(controlledCombatantIds);//Build teams and set initial state for offline battle
var teams=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lifecycle_build_teams_from_combatant_data_js__["a" /* buildTeamsFromCombatantData */])(this.initialCombatantData);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__redux_actions_battle_actions_js__["a" /* setBattleValue */])(Object.assign({},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lifecycle_init_battle_js__["a" /* getInitialBattleState */])(this.initialCombatantData,teams),{battlePlayerId:controlledCombatantIds}));//Get the "lead" of the enemy team
var enemyLeadId=teams["two"].combatantIds[0];var leadEnemyModel=this.initialCombatantData[enemyLeadId];//Just for kicks, set the matchmaking crewNames. This is really only used for Tracking, but maybe we'll want to show the crew names?
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__redux_actions_battle_actions_js__["b" /* setMatchmakingValue */])({crewNames:(_crewNames={},_defineProperty(_crewNames,controlledCombatantIds[0],__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().crew.name),_defineProperty(_crewNames,enemyLeadId,leadEnemyModel.name+"'s Crew"),_crewNames)});// Set the initial turn order and cloudQueue values
var initialSeries=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lifecycle_start_turn_series_js__["a" /* getNewTurnSeries */])();__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__redux_actions_battle_actions_js__["a" /* setBattleValue */])({seriesTurnOrder:initialSeries.seriesTurnOrder,seriesTurnsSubmitters:initialSeries.seriesTurnsSubmitters,//[]
cloudQueue:initialSeries.cloudQueue,arenaTransitionOverlay:{transition:"fadeOut",callback:function callback(){//Kick off intro message after fade
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lifecycle_handle_new_rollout_js__["a" /* handleNewRollout */])({submitterCombatantId:"BATTLE-SYSTEM",rolloutId:"rollout_battle-starting",timestamp:Date.now(),rolloutPayload:[{type:"message",content:[leadEnemyModel.getIntroMessage()]}]});}}});}},{key:"componentDidMount",value:function componentDidMount(){//TODO: Maybe move me?
//Play the battle tune!
// songRegularBattle.play()
__WEBPACK_IMPORTED_MODULE_11__audio_audio_manager_js__["a" /* default */].playSong("music_RegularBattle");if(this.props.battleViewMode==="reporting"){//handled in ReportingRunner
return;}//Regular offline console mode...
//Everything is loaded!
//Check if we need to auto submit the first action
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__offline_offline_check_for_auto_submissions_js__["a" /* offlineCheckForAutoSubmission */])();//TODO: I think this will move to after some sort of Intro
//Otherwise the human player will have a submission menu
}},{key:"render",value:function render(){if(this.props.battleViewMode==="reporting"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__reporting_mode_ReportingRunner__["a" /* default */],null);}if(this.props.battleViewMode==="arena"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ArenaView_js__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ConsoleView_js__["a" /* default */],null);}}]);return OfflineBattleContainer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state,props){return{battleViewMode:state.battle.battleViewMode};})(OfflineBattleContainer));

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConsoleView_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ArenaView_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__audio_audio_manager_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_battle_actions__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__b5_home_FullscreenState__ = __webpack_require__(84);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/** Sets any data before mounting the battle arena */var OnlineBattleContainer=function(_React$Component){_inherits(OnlineBattleContainer,_React$Component);function OnlineBattleContainer(){_classCallCheck(this,OnlineBattleContainer);return _possibleConstructorReturn(this,(OnlineBattleContainer.__proto__||Object.getPrototypeOf(OnlineBattleContainer)).apply(this,arguments));}_createClass(OnlineBattleContainer,[{key:"componentDidMount",value:function componentDidMount(){//NOTE: this happens separately in Offline play via OfflineBattleContainer
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__redux_actions_battle_actions__["a" /* setBattleValue */])({battleStartTimestamp:Date.now()//Start time!
});//Play the music! TODO: maybe move me
__WEBPACK_IMPORTED_MODULE_4__audio_audio_manager_js__["a" /* default */].playSong("music_RegularBattle");}},{key:"render",value:function render(){if(this.props.isBrowserBot){//I do not believe this state will ever occur.
//Now with rejoining, the player should be able to resume control of his or her character.
//Leaving this here just in case.
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__b5_home_FullscreenState__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"ErrorStateText__text"},"Oh no! Your combatant is now a Bot in the match."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button large",href:"/"},"Go to Your Crew"))));}if(this.props.battleViewMode==="arena"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ArenaView_js__["a" /* default */],null);}//Leaving this here in the event you want ConsoleView for online play
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ConsoleView_js__["a" /* default */],null);}}]);return OnlineBattleContainer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){var playerCombThatIsNowABot=state.battle.battlePlayerId.find(function(id){return state.battle.combatants[id]&&state.battle.combatants[id].isBot;});return{battleViewMode:state.battle.battleViewMode,isBrowserBot:Boolean(playerCombThatIsNowABot)};})(OnlineBattleContainer));

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_models_from_object_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__connection_firebase_rooms_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__b5_home_MenuHeader_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__b5_home_FullteamInviteModal_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RallyCombatantsList__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__b5_home_LobbyCTA_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__connection_firebase_send_ready_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__audio_AudioControl__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__audio_audio_manager__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//TODO: rename this file?
var RallyBattleLobby=function(_React$Component){_inherits(RallyBattleLobby,_React$Component);function RallyBattleLobby(){_classCallCheck(this,RallyBattleLobby);return _possibleConstructorReturn(this,(RallyBattleLobby.__proto__||Object.getPrototypeOf(RallyBattleLobby)).apply(this,arguments));}_createClass(RallyBattleLobby,[{key:"componentDidMount",value:function componentDidMount(){//Play the music!
__WEBPACK_IMPORTED_MODULE_11__audio_audio_manager__["a" /* default */].playSong("music_b5Menu");}},{key:"handleCloseInviteLinkModal",value:function handleCloseInviteLinkModal(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__redux_actions_battle_actions_js__["b" /* setMatchmakingValue */])({isLobbyInviteModalOpen:false});}/* Disable the button if there are too many combatants */},{key:"isBotButtonDisabled",value:function isBotButtonDisabled(){return this.props.initialCombatantData&&Object.keys(this.props.initialCombatantData).length>=6;}},{key:"handleAddBotButtonClick",value:function handleAddBotButtonClick(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__connection_firebase_rooms_js__["e" /* addBot */])();}},{key:"handleStartButtonClick",value:function handleStartButtonClick(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__connection_firebase_send_ready_js__["a" /* sendReadyToFirebase */])(function(){//console.log('ready!')
//TODO: if you want to fancy up the interaction, you have this callback.
});}//Maybe return styles that wrap the desktop layout together
},{key:"getDesktopWrap",value:function getDesktopWrap(){if(this.props.viewportMode==="portrait"){return{};}return{width:"45em",margin:"0 auto"};}},{key:"renderInviteLinkModal",value:function renderInviteLinkModal(){if(this.props.isLobbyInviteModalOpen){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__b5_home_FullteamInviteModal_js__["a" /* default */],{handleCloseCallback:this.handleCloseInviteLinkModal.bind(this)});}return null;}},{key:"renderReadyButton",value:function renderReadyButton(){var isReady=this.props.roomReadyClients[this.props.logggedInUserId];var isStartDisabled=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_models_from_object_js__["a" /* modelsFromObject */])(this.props.initialCombatantData).length<2;if(isStartDisabled){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__b5_home_LobbyCTA_js__["a" /* default */],{text:"Need an opponent",isPrimary:false,isDisabled:true,isDisabledAppearance:true});}if(isReady){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__b5_home_LobbyCTA_js__["a" /* default */],{text:"Ready!",isDisabled:true,isReadyPressed:true,handler:function handler(){}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__b5_home_LobbyCTA_js__["a" /* default */],{text:"Ready to Battle",isPrimary:true,isDisabled:false,handler:this.handleStartButtonClick.bind(this)});}},{key:"renderBotButton",value:function renderBotButton(){if(this.props.isMultiplayerMasterClient){var isDisabled=this.isBotButtonDisabled();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__b5_home_LobbyCTA_js__["a" /* default */],{text:!isDisabled?"Add Bot":"Battle is full!",isDisabled:isDisabled,isDisabledAppearance:isDisabled,handler:this.handleAddBotButtonClick.bind(this)});}return null;}},{key:"renderBottomUi",value:function renderBottomUi(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,this.renderReadyButton(),this.renderBotButton());}},{key:"render",value:function render(){if(!this.props.initialCombatantData){console.warn("this.props.initialCombatantData is undefined in RallyBattleLobby. Shouldnt be mounted");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"No Combatant Data");//TODO: ERROR STATE?
}var combatantsList=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_models_from_object_js__["a" /* modelsFromObject */])(this.props.initialCombatantData||{});var viewportMode=this.props.viewportMode;var style={fontSize:viewportMode==="portrait"?"0.6em":"0.45em",//mobile, desktop
height:"100%",paddingTop:"4em"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style,className:"page-container menu-texture"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__b5_home_MenuHeader_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__audio_AudioControl__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-container--section",style:this.getDesktopWrap()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RallyCombatantsList__["a" /* default */],{combatantsList:combatantsList,isMaster:this.props.isMultiplayerMasterClient})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-container--section",style:Object.assign({padding:"2em 2em 3em"},this.getDesktopWrap())},this.renderBottomUi())),this.renderInviteLinkModal());}}]);return RallyBattleLobby;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{vW:state.global.vW,viewportMode:state.global.viewportMode,currentRoomId:state.matchmaking.currentRoomId,initialCombatantData:state.matchmaking.initialCombatantData,//serverRoomConnections: state.battle.serverRoomConnections,
isMultiplayerMasterClient:state.battle.isMultiplayerMasterClient,//invite modal
isLobbyInviteModalOpen:state.matchmaking.isLobbyInviteModalOpen,//readyness
roomReadyClients:state.matchmaking.readyClients,//know who's ready in the room
logggedInUserId:state.crew.logggedInUserId};})(RallyBattleLobby));

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__b5_home_CrewMember_js__ = __webpack_require__(133);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RallyCombatantsList=function(_React$Component){_inherits(RallyCombatantsList,_React$Component);function RallyCombatantsList(){_classCallCheck(this,RallyCombatantsList);return _possibleConstructorReturn(this,(RallyCombatantsList.__proto__||Object.getPrototypeOf(RallyCombatantsList)).apply(this,arguments));}_createClass(RallyCombatantsList,[{key:"renderInvitePlaceholderCombatant",//Provide a Mystery Man as the "INVITE" spot
value:function renderInvitePlaceholderCombatant(){if(this.props.combatantsList.length>=6){return null;}var displayPosition=this.props.combatantsList.length+1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__b5_home_CrewMember_js__["a" /* default */],{isRallyInviter:true,isReady:false,combatantId:"none",showLaptop:false,position:displayPosition,isEvenPositionMode:true,evenPositionRowNumber:displayPosition>3?2:1//Row 2 or Row 1
,memberId:"none",name:"",skinId:"skin_mystery",isBot:false,canShowBotRemoveButton:false,loadoutTitle:"Position",isEditable:false});}//Provide a List of combatants displayed in Rally formation
},{key:"render",value:function render(){var _this2=this;var style={position:"relative",height:"40em"//Tall enough for two rows of combatants
};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style},this.props.combatantsList.map(function(combatant,i){var rawId=combatant._id.replace("client_","");var displayPosition=i+1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__b5_home_CrewMember_js__["a" /* default */],{key:i,isReady:Boolean(_this2.props.roomReadyClients[rawId]),combatantId:combatant._id,showLaptop:true,position:displayPosition,isEvenPositionMode:true,evenPositionRowNumber:displayPosition>3?2:1//Row 2 or Row 1
,memberId:combatant.memberId,name:combatant.name,skinId:combatant.skinId,isBot:combatant.isBot,canShowBotRemoveButton:_this2.props.isMaster/*Only allowed to show this if you're admin*/,loadoutTitle:combatant.loadoutTitle,isEditable:_this2.props.playerRallyCombatantId===combatant._id});}),this.renderInvitePlaceholderCombatant());}}]);return RallyCombatantsList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{//someProp: state.something.someProp
roomReadyClients:state.matchmaking.readyClients,playerRallyCombatantId:state.battle.battlePlayerId[0]};})(RallyCombatantsList));

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMostDamagingAttack;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_numbers_helper_js__ = __webpack_require__(26);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/** Take in a list of attacks and return the one that would [probably] do the most damage */function getMostDamagingAttack(){var actionModels=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];//Filter for only offensive actions that are not
var onlyAttacks=actionModels.filter(function(actionModel){//First remove all items and supers (though, a Super would already have been chosen by now)
return!actionModel.isItem&&!actionModel.isSuper;});var sortedByAttack=onlyAttacks.map(function(actionModel){var repModel=actionModel.affectTargetHpPointsInRepetitions;if(repModel!==null&&(typeof repModel==="undefined"?"undefined":_typeof(repModel))==="object"){var useValue=repModel.affectTargetHpPoints*repModel.min;//Base off the lowest possibility
return{id:actionModel.id,dmg:useValue};}//Special Case! Promise should be boosted, because it does not actually provide a bunch of damage up front
if(actionModel.id==="special_promise"&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_numbers_helper_js__["a" /* coinToss */])()){//MAYBE boost Promise based on Coin Toss (we don't want to always encourage Promise, it would be too often)
return{id:actionModel.id,dmg:-12//initial hit + big blast put together
};}//Create sortable models with a damage value
return{id:actionModel.id,dmg:actionModel.affectTargetHpPoints||0};}).sort(function(a,b){//Sort the damage value: lower number = beginning of the list (because damage dealing values are negative)
return a.dmg>b.dmg?1:-1;}).map(function(sortedModel){return actionModels.find(function(m){return m.id===sortedModel.id;});});return sortedByAttack[0];}

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBattleEndReport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lifecycle_get_dead_teams_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lifecycle_team_utilities_js__ = __webpack_require__(40);
function getBattleEndReport(){var hpReport=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.hpRatingsOfTeamsPerTurnSeries;var turnReporting=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.turnReporting;var allCombatants=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatants;var teamOne=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lifecycle_team_utilities_js__["c" /* getAllCombatantsOfTeam */])("one",allCombatants);var teamTwo=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lifecycle_team_utilities_js__["c" /* getAllCombatantsOfTeam */])("two",allCombatants);var deadTeamId=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lifecycle_get_dead_teams_js__["a" /* getDeadTeams */])()[0]==="one"?"two":"one";//winning team is opposite of dead team
return{turnSeriesCount:hpReport.length-1,//last one is added at the end
winningTeamId:deadTeamId,hpReport:hpReport,turnReporting:turnReporting,teamOneReport:Object.assign({},getTeamReport(teamOne)),teamTwoReport:Object.assign({},getTeamReport(teamTwo))};}function getTeamReport(teamCombatants){return{classes:teamCombatants.map(function(comb){return'LVL '+comb.level+' '+comb.class;}),humanCount:teamCombatants.filter(function(comb){return!comb.isBot;}).length,botCount:teamCombatants.filter(function(comb){return comb.isBot;}).length};}

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTurnReport;
/* harmony export (immutable) */ __webpack_exports__["b"] = addReportToReportingHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connection_firebase_rooms_js__ = __webpack_require__(38);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function getCombatantReportDataPerTurn(combatantModel,descriptionObject){var updatedStatePerCombatant=descriptionObject.state[combatantModel.id]||{};return Object.assign({id:combatantModel.id,hp:combatantModel.hp,maxHp:combatantModel.hp,pp:combatantModel.pp,maxPp:combatantModel.pp,status:combatantModel.pp,control:combatantModel.isBot?"bot":"player",class:combatantModel.class,level:combatantModel.level,teamId:combatantModel.belongsToTeam},updatedStatePerCombatant);}function createTurnReport(rollout,descriptionObject,actionModel,casterModel,targetModels){//console.log(casterModel, targetModels)
var casterData=getCombatantReportDataPerTurn(casterModel,descriptionObject);var targetsData={};targetModels.forEach(function(targetModel){targetsData[targetModel.id]=getCombatantReportDataPerTurn(targetModel,descriptionObject);});if(!actionModel.id){console.warn('no action id found when creating Turn Report',actionModel);}return{actionId:actionModel.id,actionName:actionModel.name,casterData:casterData,targetsData:targetsData,descriptionData:descriptionObject.description};}function addReportToReportingHistory(turnReport){var turnKey="t"+__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.rolloutHistory.length;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["a" /* setBattleValue */])({turnReporting:Object.assign({},__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.turnReporting,_defineProperty({},turnKey,turnReport))});/* IF ONLINE PLAY, Write this turnKey to firebase state */if(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.isMultiplayerMode){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__connection_firebase_rooms_js__["a" /* recordTurnActivityInRoom */])(turnKey,turnReport);}////////////////////////////////////////////////////////////////
}// window.getTurnReports = function() {
//   console.log(
//     JSON.stringify(store.getState().battle.turnReporting)
//   );
//   return store.getState().battle.turnReporting;
// };

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = writeTrackingReportToDatabase;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_get_query_variable_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lifecycle_get_dead_teams_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__get_battle_type_js__ = __webpack_require__(152);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function writeTrackingReportToDatabase(){var user=window.firebase.auth().currentUser;if(user){getFinalReport(function(turnReports){var reportsRef=window.firebase.database().ref('reports');var reportPayload={crewNames:__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().matchmaking.crewNames,clientIds:getClients(),battleType:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__get_battle_type_js__["a" /* getBattleType */])(),isDevScenarioMode:Boolean(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_get_query_variable_js__["a" /* getQueryVariable */])("dev")),winningTeamId:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lifecycle_get_dead_teams_js__["b" /* getWinningTeam */])(),duration:getDurationModel(),turns:Object.assign({},turnReports)};reportsRef.push(reportPayload);});}else{console.warn('not reporting data because this user is not logged in');}}//Return description of starting and ending timestamps of this battle
function getDurationModel(){var battleStartTimestamp=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.battleStartTimestamp;//If we have a starting value (we should, but who knows?)
if(battleStartTimestamp){return{wasDurationTracked:true,battleStartTimestamp:battleStartTimestamp,battleEndTimestamp:Date.now()};}//Otherwise, save an error state
return{wasDurationTracked:false};}//Return an object of all client Ids in this battle
function getClients(){var isMultiplayerMode=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.isMultiplayerMode;//If single player, simply return the user's logged in ID
//Otherwise, everybody will be "main"
if(!isMultiplayerMode){return _defineProperty({},'client_'+__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().crew.logggedInUserId,true);}//If multiplayer, get only the `client_` ids. (Not bots or buddies)
var initialCombatantData=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().matchmaking.initialCombatantData;var payload={};Object.keys(initialCombatantData).forEach(function(key){if(key.match(/^client_/)){payload[key]=true;}});return payload;}function getFinalReport(callback){//For multiplayer, we need to retrieve the true result data from Firebase.
//Because each client captures their own processed piece.
if(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.isMultiplayerMode){//Only one client will submit this!
//Whichever client processed the state.
window.roomRef.child("turnReporting").once("value",function(snap){//Call the callback with our retrieved data
callback(snap.val());});}//Return Synchronous result. No need to wait
callback(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.turnReporting);}

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = b5LoadCrew;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__connection_firebase_users_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_make_id_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Fixture_combatants_js__ = __webpack_require__(24);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function getDefaultCrewData(){var _ref;/* Create dynamic memberIds */var ids=[1,2,3].map(function(num){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_make_id_js__["a" /* default */])("member-"+num,15);});return _ref={},_defineProperty(_ref,ids[0],Object.assign({},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__Fixture_combatants_js__["c" /* getLoadout */])("dpsA"),{name:"Harold",//Default name. You should never actually see this though, as the onboarding overwrites it
arenaPosition:1,//main
skinId:"skin_m3",memberId:ids[0]})),_defineProperty(_ref,ids[1],Object.assign({},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__Fixture_combatants_js__["c" /* getLoadout */])("dpsB"),{name:"Jessie",arenaPosition:2,skinId:"skin_f2",memberId:ids[1]})),_defineProperty(_ref,ids[2],Object.assign({},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__Fixture_combatants_js__["c" /* getLoadout */])("supportA"),{name:"Sako",arenaPosition:3,skinId:"skin_m2",memberId:ids[2]})),_ref;}/* App is starting! Load the user's crew to redux state (or pull from Firebase if they've been here before) */function b5LoadCrew(callback){var _this=this;//Check to see if we're logged in:
var unsubscribe=window.firebase.auth().onAuthStateChanged(function(){var _ref2=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(user){var myData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!user){_context.next=8;break;}_context.next=3;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__connection_firebase_users_js__["c" /* getUserDataFromFirebase */])("client_"+user.uid);case 3:myData=_context.sent;if(!myData){console.warn("this client_ does not exist in Firebase");}if(myData&&myData["crewMembers"]){//Look for crewMembers node in Firebase
//crew exists. Use that one
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["e" /* setCrewValue */])({logggedInUserId:user.uid,name:myData["crewName"]||"Crew",//This should never happen, but somehow this account's Crew Name was deleted from Firebase
record:myData["battleRecord"]||Object.assign({},__WEBPACK_IMPORTED_MODULE_1__connection_firebase_users_js__["f" /* userRecordsSchema */]),//defaults to empty record
members:myData["crewMembers"]//Load my saved crew
});unsubscribe();//Remove this firebase listener (Don't let it fire twice)
callback("returningUser");//Let ths caller know that loaded data has been applied to state.
}else{//User Data in Firebase has been deleted or missing valuable crewMembers
//Not sure how this would ever happen, but who knows?
//If this user data is no longer here - LOG OUT and act like it's our first time here
//TODO: NOTE this block is a little redudant with "not logged in" state below, but meh.
//I'm logged in, but somehow didn't have a crew saved. Give me all defaults.
//Need to just use a default crew
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["e" /* setCrewValue */])({logggedInUserId:null,name:myData?myData["crewName"]||"Crew":"Crew",//Try to use my crew name if I have one saved
members:getDefaultCrewData(),record:Object.assign({},__WEBPACK_IMPORTED_MODULE_1__connection_firebase_users_js__["f" /* userRecordsSchema */])});unsubscribe();//Remove this firebase listener (Don't let it fire twice)
//Sign out of stale account for a fresh start
window.firebase.auth().signOut().then(function(){callback("newUser");//Let ths caller know that loaded data has been applied to state.
});}_context.next=11;break;case 8://Not logged in
//Need to just use a default crew.
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["e" /* setCrewValue */])({logggedInUserId:null,name:"Crew",//This gets replaced in the onboarding process
members:getDefaultCrewData(),record:Object.assign({},__WEBPACK_IMPORTED_MODULE_1__connection_firebase_users_js__["f" /* userRecordsSchema */])});// console.log("removing firebase auth listener [user not logged in]");
unsubscribe();//Remove this firebase listener
//Let ths caller know that data has been applied to state. (all defaults, really)
callback("newUser");//Will be ported to the Onboarding flow
case 11:case"end":return _context.stop();}}},_callee,_this);}));return function(_x){return _ref2.apply(this,arguments);};}());}

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_ActionModel_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_articles_helper_js__ = __webpack_require__(389);
var ItemActionModel=Object.assign({},__WEBPACK_IMPORTED_MODULE_0__models_ActionModel_js__["a" /* default */],{category:"item",isItem:true,increaseDangerMeterOnUse:0,//don't allow items to affect Danger Meter
// (unless it is an actual Danger Meter boosting item (affectTargetDangerMeter)
canMiss:false,canBeReplaced:false,//this is an assumption for all Items,
// but you could toggle some to `true` in the future if needbe
//Set up a buggedStep for items
getBuggedStep:function getBuggedStep(actionModel,casterModel,targetModels,descriptionObject){return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_articles_helper_js__["a" /* default */])(actionModel.name)),{type:"message",content:['but it was BUGGED!']}];}});//Items
/* harmony default export */ __webpack_exports__["a"] = ({//Mini Battery Pack
"item_mini-battery-pack":Object.assign({},ItemActionModel,{name:"Mini Battery Pack",description:"Recovers 20 HP.",targetType:"single-ally",affectTargetHpPoints:20,getValidity:function getValidity(actionModel,casterModel,targetModels){var targetModel=targetModels[0];if(targetModel.hp===targetModel.maxHp){return{isValid:false,invalidReasons:[targetModel.name+'\'s HP is full!']};}return{isValid:true,invalidReasons:[]};},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];var firstMessage=casterModel.id===targetModel.id?' uses a '+actionModel.name+'!':' hands out a '+actionModel.name+'!';var recoverAmount=descriptionObject.description.hpDamage[targetModel.id];return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),firstMessage]},{//Play the sound (animation)
type:"animation",animationKey:"AnimationFillHp",animationData:{}},{//Play the state change!
type:"stateChange",newCombatantState:descriptionObject.state,description:descriptionObject.description||{}},{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),' recovered '+recoverAmount+' HP!']}];}}),//Mini PP Pack
"item_mini-pp-pack":Object.assign({},ItemActionModel,{name:"Mini PP Pack",description:"Recovers 20 PP.",targetType:"single-ally",affectTargetPpPoints:20,getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,"a",false)];},getValidity:function getValidity(actionModel,casterModel,targetModels){var targetModel=targetModels[0];if(targetModel.pp===targetModel.maxPp){return{isValid:false,invalidReasons:['PP is full!']};}return{isValid:true,invalidReasons:[]};}}),//Network Reset Code
"item_network-reset-code":Object.assign({},ItemActionModel,{name:"Network Reset Code",description:"Cures lagging.",targetType:"single-ally",affectTargetStatus:["lag","normal"],shouldFail:function shouldFail(actionModel,casterModel,targetModels){return targetModels[0].status!=="lag";},getValidity:function getValidity(actionModel,casterModel,targetModels){var targetModel=targetModels[0];if(targetModel.status!=="lag"){return{isValid:false,invalidReasons:[targetModel.name+' is not lagging!']};}return{isValid:true,invalidReasons:[]};},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,"a",false),{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),'\'s lagging has ended!']}];},getFailStep:function getFailStep(actionModel,casterModel,targetModels,descriptionObject){return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,"a",false),{type:"message",content:['but it didn\'t do anything!']}];}}),//Breakpoint
"item_breakpoint":Object.assign({},ItemActionModel,{name:"Breakpoint",description:"Patches a memory leak.",targetType:"single-ally",affectTargetStatus:["memory-leak","normal"],shouldFail:function shouldFail(actionModel,casterModel,targetModels){return targetModels[0].status!=="memory-leak";},getValidity:function getValidity(actionModel,casterModel,targetModels){var targetModel=targetModels[0];if(targetModel.status==="fire"){return{isValid:false,invalidReasons:['Need something stronger to stop a fire!']};}if(targetModel.status!=="memory-leak"){return{isValid:false,invalidReasons:[targetModel.name+' does not have a memory leak!']};}return{isValid:true,invalidReasons:[]};},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,"a",false),{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),'\'s memory leak is patched!']}];},getFailStep:function getFailStep(actionModel,casterModel,targetModels,descriptionObject){return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,"a",false),{type:"message",content:['but it didn\'t do anything!']}];}}),//STICKERS
"item_attack-sticker-i":Object.assign({},ItemActionModel,{name:"Attack Sticker I",description:"Increases attack stat for the rest of the battle.",targetType:"single-ally",affectTargetAttackModifier:3,getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];var firstMessage=casterModel.id===targetModel.id?' slaps on an '+actionModel.name+'!':' hands out an '+actionModel.name+'!';return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),firstMessage]},{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),'\'s attack increased!']}];}}),"item_defense-sticker-i":Object.assign({},ItemActionModel,{name:"Defense Sticker I",description:"Increases defense stat for the rest of the battle.",targetType:"single-ally",affectTargetDefenseModifier:3,getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];var firstMessage=casterModel.id===targetModel.id?' slaps on a '+actionModel.name+'!':' hands out a '+actionModel.name+'!';return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),firstMessage]},{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),'\'s defense increased!']}];}}),"item_speed-sticker-i":Object.assign({},ItemActionModel,{name:"Speed Sticker I",description:"Increases speed stat for the rest of the battle.",targetType:"single-ally",affectTargetSpeedModifier:3,getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];var firstMessage=casterModel.id===targetModel.id?' slaps on a '+actionModel.name+'!':' hands out a '+actionModel.name+'!';return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),firstMessage]},{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),'\'s speed increased!']}];}}),//REVIVE
"item_revive":Object.assign({},ItemActionModel,{name:"Revive Pack",description:"Bring a dead ally back to life!",targetType:"single-ally",targetMustBeDead:true,affectTargetHpPointsByPercent:0.45,//% //Should this be POINTS based instead?
shouldFail:function shouldFail(actionModel,casterModel,targetModels){return targetModels[0].isAlive();//fail is combatant isAlive
},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,"a"),{//Play the sound (animation)
type:"animation",animationKey:"AnimationFillHp",animationData:{}},{//Play the state change!
type:"stateChange",newCombatantState:descriptionObject.state,description:descriptionObject.description||{}},{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),' is revived!']}];}}),//FULL REVIVE
"item_full-revive":Object.assign({},ItemActionModel,{name:"Full Revive Pack",description:"Bring a dead ally back to life with 100% HP!",targetType:"single-ally",targetMustBeDead:true,affectTargetHpPointsByPercent:1,//100%
shouldFail:function shouldFail(actionModel,casterModel,targetModels){return targetModels[0].isAlive();//fail is combatant isAlive
},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,"a"),{//Play the sound (animation)
type:"animation",animationKey:"AnimationFillHp",animationData:{}},{//Play the state change!
type:"stateChange",newCombatantState:descriptionObject.state,description:descriptionObject.description||{}},{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),' is revived!']}];}}),//HONEYPOT TRAP
"item_honeypot-trap":Object.assign({},ItemActionModel,{name:"Honeypot Trap",description:"WARNING: explodes in your face! Use it to fool a Copy/Paster.",targetType:"only-me",affectTargetHpPoints:-7,getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),' opens a Honeypot Trap!']},{type:"message",content:['The Honeypot Trap blew up in ',__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),'\'s face!!!']}];}}),//Danger Boost
"item_danger-boost":Object.assign({},ItemActionModel,{name:"Avg Danger Boost",description:"Boost a friendly Danger Meter by 60 percent!",targetType:"single-ally",affectTargetDangerMeter:60,getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];var firstMessage=casterModel.id===targetModel.id?' uses an '+actionModel.name+'!':' hands out an '+actionModel.name+'!';return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),firstMessage]},{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),'\'s Danger Meter is boosted!']}];}}),//Max Danger Boost
"item_max-danger-boost":Object.assign({},ItemActionModel,{name:"Max Danger Boost",description:"Fills a friendly Danger Meter to 100%!",targetType:"single-ally",affectTargetDangerMeter:100,getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];var firstMessage=casterModel.id===targetModel.id?' uses a '+actionModel.name+'!':' hands out a '+actionModel.name+'!';return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),firstMessage]},{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),'\'s Danger Meter is now full!']}];}}),//Team Danger Boost
"item_team-danger-boost":Object.assign({},ItemActionModel,{name:"Team Danger Boost",description:"Boost all friendly Danger Meters by 30 percent!",targetType:"ally-team",affectTargetDangerMeter:30,getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,"a",false),{type:"message",content:['Friendly Danger Meters are boosted!']}];}})});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_ActionModel_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__ = __webpack_require__(27);
var NaturalActionModel=Object.assign({},__WEBPACK_IMPORTED_MODULE_0__models_ActionModel_js__["a" /* default */],{isNatural:true,canMiss:false,increaseDangerMeterOnUse:0//Don't charge DM for naturals
});/* harmony default export */ __webpack_exports__["a"] = ({//Naturals //Caster and Target are the same. For consistency in Naturals, let's always do property changing stuff to the TARGET (affectTargetStatus, affectTargetHpPointsByPercent)
//-----------------------------------------------------
"natural_hurt-by-memory-leak":Object.assign({},NaturalActionModel,{//Target must be ME. Not using `targetType` here because that implies that the user can "choose" through UI.
//This one just happens after your action if you have a mem leak.
affectTargetHpPointsByPercent:-0.11,//11%
getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),' is hurt by the memory leak!']}];}}),"natural_hurt-by-fire":Object.assign({},NaturalActionModel,{affectTargetHpPointsByPercent:-0.25,//25
getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),'\'s laptop is burning in fire!']}];}}),//Lagging
"natural_lag":Object.assign({},NaturalActionModel,{ignoreTargetDieResult:true,//If this move happens while somebody DEAD is targeted (like Revive or Team Revive)
//we'll get the "Person has run out of battery life text...".
//We should never need to see it on a lag out move.
isNaturalLag:true,//one-off flag needed by `get-rollout`
getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),'\'s connection is laggy...']},//animation? like a fadey thing
{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),'\'s move is lost in the lag!']}];}}),"natural_recover-lag":Object.assign({},NaturalActionModel,{canBeReplaced:false,//Can't be replaced by `submit-action`
affectTargetStatus:["lag","normal"],getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),'\'s lagging has ended!']}];}}),"natural_recover-focus":Object.assign({},NaturalActionModel,{canBeReplaced:false,//Can't be replaced by `submit-action`
affectTargetStatus:["focus","normal"],getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),'\'s Focus has faded!']}];}}),"natural_recover-fury":Object.assign({},NaturalActionModel,{canBeReplaced:false,//Can't be replaced by `submit-action`
affectTargetStatus:["fury","normal"],getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),' has calmed down from Fury.']}];}}),"natural_recover-deadline":Object.assign({},NaturalActionModel,{canBeReplaced:false,//Can't be replaced by `submit-action`
affectTargetStatus:["deadline","normal"],getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),'\'s deadline has ended!']}];}}),//Escalate a memory-leak to fire
"natural_memory-leak-to-fire":Object.assign({},NaturalActionModel,{canBeReplaced:false,//Can't be replaced by `submit-action`
affectTargetStatus:["memory-leak","fire"],//We don't want it to "FAIL" if we don't have a memory leak. We just want it to dissolve.
//Maybe the same thing is getting an empty array?
shouldFail:function shouldFail(actionModel,casterModel,targetModels){if(!targetModels.length){// console.warn('bandaid')
return true;}return targetModels[0].status!=="memory-leak";},getFailStep:function getFailStep(actionModel,casterModel,targetModels,descriptionObject){return[// {
//   type: "message",
//   content: [
//     `[${casterModel.name}'s naturally escalated from memory-leak to fire but didnt have a memory-leak ]`,
//   ]
// }
];},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),'\'s laptop CAUGHT ON FIRE!']}];}}),//Running out of HP
"natural_die":Object.assign({},NaturalActionModel,{getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),' has run out of battery life!']}];}})});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_ActionModel_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__ = __webpack_require__(27);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var SpecialActionModel=Object.assign({},__WEBPACK_IMPORTED_MODULE_0__models_ActionModel_js__["a" /* default */],{ppCost:5//TODO: actual economy
});//Special
/* harmony default export */ __webpack_exports__["a"] = ({//ForEach
"special_foreach":Object.assign({},SpecialActionModel,{name:"ForEach",category:"offense",ppCost:4,affectTargetHpPointsInRepetitions:{min:2,max:4,affectTargetHpPoints:-5},//doesn't include attack stat
description:"Delivers pain in 2 to 4 iterations.",getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];var count=descriptionObject.description.targetsDamageTracker[targetModel.id].length;return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),{type:"animation",animationKey:"AnimationForEach",animationData:{casterId:casterModel.id,targetIds:targetModels.map(function(t){return t.id;}),targetsDamageTracker:descriptionObject.description.targetsDamageTracker}},{//Play the state change!
type:"stateChange",newCombatantState:descriptionObject.state,description:descriptionObject.description||{}},{type:"message",content:['It hit '+count+' times!']}];}}),//Slice
"special_slice":Object.assign({},SpecialActionModel,{name:"Slice",category:"offense",description:"Offensive attack which might decrease opponent defense.",affectTargetHpPoints:-5,ppCost:4,affectTargetDefenseModifier:{percentChance:40,value:-3},//X% Chance that this will happen
getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];//Add possible "target's defense was lowered" line.
var wasDefenseChanged=descriptionObject.description.defenseChange&&descriptionObject.description.defenseChange[targetModel.id].defenseChange!==0;var defenseSteps=wasDefenseChanged?[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),'\'s defense is lowered!']}]:[];return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),{type:"animation",animationKey:"AnimationSlice",animationData:{casterId:casterModel.id,targetIds:targetModels.map(function(t){return t.id;})}},{//Play the state change!
type:"stateChange",newCombatantState:descriptionObject.state,description:descriptionObject.description||{}}].concat(defenseSteps);}}),//Clean (Single Ally)
"special_clean":Object.assign({},SpecialActionModel,{name:"Clean",category:"healing",description:"Clear your own status back to normal.",ppCost:5,targetType:"only-me",affectTargetStatus:["*","normal"],canBeReplaced:false,shouldFail:function shouldFail(actionModel,casterModel,targetModels){if(!targetModels.length){return true;//should fail if no targets (see "no targets" note in submit-action.js)
}return targetModels[0].status==="normal";},getValidity:function getValidity(actionModel,casterModel,targetModels){var targetModel=targetModels[0];if(targetModel.status==="normal"){return{isValid:false,invalidReasons:[targetModel.name+' has no status conditions!']};}return{isValid:true,invalidReasons:[]};},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModels[0].id),'\'s status is cleared!']}];}}),//DDoS
"special_ddos":Object.assign({},SpecialActionModel,{name:"DDoS",category:"cursing",description:"Causes an opponent to lag for 2 to 4 turns.",targetType:"single-opponent",affectTargetStatus:["normal","lag"],ppCost:6,shouldFail:function shouldFail(actionModel,casterModel,targetModels){return targetModels[0].status!=="normal";},getValidity:function getValidity(actionModel,casterModel,targetModels){var targetModel=targetModels[0];if(targetModel.status!=="normal"){return{isValid:false,invalidReasons:[targetModel.name+' already has a status!']};}return{isValid:true,invalidReasons:[]};},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];//Only 1 target
return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),' is lagging out!']}];},getFollowupActions:function getFollowupActions(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];//Only 1 affects single-opponent
return[{//Target recovers lagging in 2 to 5 turns
action:{id:"natural_recover-lag",casterId:targetModel.id,targetIds:[targetModel.id]},turnRange:[2,4]}];}}),//Headphones
"special_headphones":Object.assign({},SpecialActionModel,{name:"Headphones",category:"boosting",description:"Chill back to maxed accuracy and increased defense.",targetType:"single-ally",affectTargetStatus:["normal","focus"],ppCost:3,canMiss:false,shouldFail:function shouldFail(actionModel,casterModel,targetModels){return targetModels[0].status!=="normal";},getValidity:function getValidity(actionModel,casterModel,targetModels){var targetModel=targetModels[0];if(targetModel.status!=="normal"){return{isValid:false,invalidReasons:[targetModel.name+' already has a status!']};}return{isValid:true,invalidReasons:[]};},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];//Only 1 target
//Change text based on giving out or using for myself. (Caster targets him/herself)
var actionLine=targetModel.id===casterModel.id?" puts on Headphones!":' hands Headphones to '+targetModel.name+'!';return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),actionLine]},{type:"animation",animationKey:"AnimationHeadphones",animationData:{casterId:casterModel.id,targetIds:targetModels.map(function(t){return t.id;})}},{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),' enters a state of Focus!']}];},getFollowupActions:function getFollowupActions(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];//Only 1 affects single-opponent
return[{//Target recovers focus in 2 to 5 turns
action:{id:"natural_recover-focus",casterId:targetModel.id,targetIds:[targetModel.id]},turnRange:[2,5]//turnRange: [1,1]
}];}}),//Troll
"special_troll":Object.assign({},SpecialActionModel,{name:"Troll",category:"boosting",description:"Become furious. Increases attack but reduces accuracy.",targetType:"single-ally",affectTargetStatus:["normal","fury"],ppCost:3,canMiss:false,shouldFail:function shouldFail(actionModel,casterModel,targetModels){return targetModels[0].status!=="normal";},getValidity:function getValidity(actionModel,casterModel,targetModels){var targetModel=targetModels[0];if(targetModel.status!=="normal"){return{isValid:false,invalidReasons:[targetModel.name+' already has a status!']};}return{isValid:true,invalidReasons:[]};},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];//Only 1 target
return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),' is trolling up a storm!']},{type:"animation",animationKey:"AnimationTroll",animationData:{casterId:casterModel.id,targetIds:targetModels.map(function(t){return t.id;})}},{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),' is enraged in Fury!']}];},getFollowupActions:function getFollowupActions(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];//Only 1 affects single-opponent
return[{//Target recovers focus in 2 to 5 turns
action:{id:"natural_recover-fury",casterId:targetModel.id,targetIds:[targetModel.id]},turnRange:[2,5]}];}}),//Deadline
"special_deadline":Object.assign({},SpecialActionModel,{name:"Deadline",category:"boosting",description:"Gain an extra action submission for 2 to 3 turns.",targetType:"single-ally",affectTargetStatus:["normal","deadline"],ppCost:6,canMiss:false,//It feels weird when a deadline misses. How on earth do you "miss" that?
shouldFail:function shouldFail(actionModel,casterModel,targetModels){return targetModels[0].status!=="normal";},getValidity:function getValidity(actionModel,casterModel,targetModels){var targetModel=targetModels[0];if(targetModel.status!=="normal"){return{isValid:false,invalidReasons:[targetModel.name+' already has a status!']};}return{isValid:true,invalidReasons:[]};},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];//Only 1 target
return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),' establishes a Deadline!']},{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),' is extra productive!']}];},getFollowupActions:function getFollowupActions(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];//Only 1 affects single-opponent
return[{//Target recovers deadline in 2 to 3 turns
action:{id:"natural_recover-deadline",casterId:targetModel.id,targetIds:[targetModel.id]},turnRange:[2,3]// 2,3
}];}}),//Garbage Jammer
"special_garbage-jammer":Object.assign({},SpecialActionModel,{name:"Garbage Jammer",category:"cursing",description:"Causes an opponent to leak HP after each turn.",targetType:"single-opponent",affectTargetStatus:["normal","memory-leak"],ppCost:6,shouldFail:function shouldFail(actionModel,casterModel,targetModels){return targetModels[0].status!=="normal";},getValidity:function getValidity(actionModel,casterModel,targetModels){var targetModel=targetModels[0];if(targetModel.status!=="normal"){return{isValid:false,invalidReasons:[targetModel.name+' already has a status!']};}return{isValid:true,invalidReasons:[]};},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];//Only 1 target
return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),' has a memory leak!']}];}}),//Thrash
"special_thrash":Object.assign({},SpecialActionModel,{name:"Thrash",category:"cursing",description:"Overheat an opponent's laptop to a flaming good-bye.",targetType:"single-opponent",affectTargetStatus:["normal","memory-leak"],ppCost:8,shouldFail:function shouldFail(actionModel,casterModel,targetModels){return targetModels[0].status!=="normal";},getValidity:function getValidity(actionModel,casterModel,targetModels){var targetModel=targetModels[0];if(targetModel.status!=="normal"){return{isValid:false,invalidReasons:[targetModel.name+' already has a status!']};}return{isValid:true,invalidReasons:[]};},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];//Only 1 target
return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),' has a memory leak!']},{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),'\'s laptop is getting uncomfortably warm...']}];},getFollowupActions:function getFollowupActions(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];//Only 1 affects single-opponent
return[{action:{id:"natural_memory-leak-to-fire",casterId:targetModel.id,targetIds:[targetModel.id]},turnRange:[2,2]//escalate this memory-leak to a fire status
}];}}),//Curl
"special_curl":Object.assign({},SpecialActionModel,{name:"Curl",category:"theft",description:"Steal 1 random item from the enemy team.",targetType:"opponent-team",theftQuantity:1,ppCost:8,shouldFail:function shouldFail(actionModel,casterModel,targetModels,descriptionObject){var targetTeamItems=targetModels.map(function(targetModel){return targetModel.items;}).reduce(function(a,b){return[].concat(_toConsumableArray(a),_toConsumableArray(b));});return targetTeamItems.length===0;//Return TRUE if this team has zero items.
},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name),//animation
{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),' stole '+descriptionObject.description.stolenItemsFriendlyText+'!']}];}}),//Curl Mk II -- copied from Curl. Can we clean that up? Might not matter
"special_curl-mk2":Object.assign({},SpecialActionModel,{name:"Curl Mk II",category:"theft",description:"Steal 2 items from the enemy team.",targetType:"opponent-team",theftQuantity:2,ppCost:10,shouldFail:function shouldFail(actionModel,casterModel,targetModels,descriptionObject){var targetTeamItems=targetModels.map(function(targetModel){return targetModel.items;}).reduce(function(a,b){return[].concat(_toConsumableArray(a),_toConsumableArray(b));});return targetTeamItems.length===0;//Return TRUE if this team has zero items.
},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name),//animation
{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),' stole '+descriptionObject.description.stolenItemsFriendlyText+'!']}];}}),"special_copy-paste":Object.assign({},SpecialActionModel,{name:"Copy/Paste",category:"theft",description:"Steal an enemy item and immediately use it.",targetType:"opponent-team",theftQuantity:1,stealAndUseItem:true,ppCost:10,shouldFail:function shouldFail(actionModel,casterModel,targetModels){var targetTeamItems=targetModels.map(function(targetModel){return targetModel.items;}).reduce(function(a,b){return[].concat(_toConsumableArray(a),_toConsumableArray(b));});return targetTeamItems.length===0;//Return TRUE if this team has zero items.
},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name),//animation
{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),' stole '+descriptionObject.description.stolenItemsFriendlyText+'!']}];}}),//SQL Injection
"special_sql-injection":Object.assign({},SpecialActionModel,{name:"SQL Injection",category:"theft",description:"Delete one random enemy item.",targetType:"opponent-team",targetCanBeDead:true,ignoreTargetDieResult:true,//Don't show any "he died" messaging. He might already be dead, and this can't hurt ya.
deleteItemQuantity:1,ppCost:6,shouldFail:function shouldFail(actionModel,casterModel,targetModels,descriptionObject){var targetTeamItems=targetModels.map(function(targetModel){return targetModel.items;}).reduce(function(a,b){return[].concat(_toConsumableArray(a),_toConsumableArray(b));});return targetTeamItems.length===0;//Return TRUE if this team has zero items.
},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),//animation
{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),' deleted '+descriptionObject.description.deletedItemsFriendlyText+' from the enemy team!']}];}}),//Firewall
"special_firewall":Object.assign({},SpecialActionModel,{name:"Firewall",category:"boosting",description:"Increases team defense for the rest of the battle.",targetType:"ally-team",canMiss:false,affectTargetDefenseModifier:3,ppCost:7,getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){// console.log(descriptionObject);
return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),//animation
{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),'\'s team defense increases!']}];}}),//Firewall
"special_scrum":Object.assign({},SpecialActionModel,{name:"Scrum",category:"boosting",description:"Increases team attack for the rest of the battle.",targetType:"ally-team",canMiss:false,affectTargetAttackModifier:3,ppCost:7,getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){// console.log(descriptionObject)
return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),//animation
{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),'\'s team attack increases!']}];}}),//Stash //TODO: UNSURE IF THIS WILL BE AVAILABLE (Why not? It's not an ult.)
"special_stash":Object.assign({},SpecialActionModel,{name:"Stash",category:"cursing",description:"Destroy an opponent's Commit.",canMiss:false,clearTargetCommittedData:true,ppCost:5,getValidity:function getValidity(actionModel,casterModel,targetModels){var targetModel=targetModels[0];if(!targetModel.committedTurnData){return{isValid:false,invalidReasons:[targetModel.name+' doesn\'t have a Commit!']};}return{isValid:true,invalidReasons:[]};},shouldFail:function shouldFail(actionModel,casterModel,targetModels){var targetModel=targetModels[0];return!targetModel.committedTurnData;},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),//animation
{type:"message",content:[casterModel.name+' destroyed '+targetModel.name+'\'s Commit!']}];}}),//Promise
"special_promise":Object.assign({},SpecialActionModel,{name:"Promise",category:"offense",description:"Send a powerful blast in the air to return later.",targetType:"opponent-team",ppCost:8,canMiss:false,//affectTargetHpPoints: -1, //Playing with not having Promise do any damage up front //UPDATE: this made AI never consider Promise. Might want to do a backdoor solution if you want 0 dmg upfront
//Going back to 0 damage
affectTargetHpPoints:0,getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),' sends a Promise into the air!']}];},getFollowupActions:function getFollowupActions(actionModel,casterModel,targetModels,descriptionObject){return[{//Create the followup blow
action:{id:"special_promise-resolve",casterId:casterModel.id,targetIds:targetModels.map(function(targetModel){return targetModel.id;})},turnRange:[2,3]}];}}),"special_promise-resolve":Object.assign({},SpecialActionModel,{ignoreCasterDieResult:true,//Do not say the "Caster is out of hp" message for the caster of this msg
name:"(Resolving Promise)",description:"",//This description is not user facing.
//targetType: "opponent-team", //This isn't really needed because targets are provided only by the FOLLOWUP action
selectRandomTargetForSingleHit:true,//This flag is intended to take an array of targets and only hit 1.
canMiss:false,//seems unfair that this could miss
isImmuneFromLag:true,//do not allow this move to get lost in lag
affectTargetHpPoints:-9,ppCost:0,getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[//animation
{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),'\'s Promise resolves!']}];}}),//Bug
"special_bug":Object.assign({},SpecialActionModel,{name:"Bug",category:"theft",description:"Sabotages 1 random item on the enemy team.",targetType:"opponent-team",sabotageItemQuantity:1,ppCost:6,//Check that Target Team actually has some items to bug
shouldFail:function shouldFail(actionModel,casterModel,targetModels){var targetTeamNonBuggedItems=targetModels.map(function(targetModel){return targetModel.items;}).reduce(function(a,b){return[].concat(_toConsumableArray(a),_toConsumableArray(b));}).filter(function(item){return!item.isBugged;});return targetTeamNonBuggedItems.length===0;//Action fails if target team has no non-bugged items
},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var firstTarget=targetModels[0];return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),//animation
{type:"message",content:['An item on ',__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(firstTarget.id),'\'s team was bugged!']}];}}),//Scope Bomb
"special_scope-bomb":Object.assign({},SpecialActionModel,{name:"Scope Bomb",category:"offense",description:"Strike the opponent with a burndown surprise. Extra painful against a Deadline.",affectTargetHpPoints:-3,ppCost:5,statusMultiplier:["deadline",1.5],//1.5x the damage
getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];//Only 1 target
//Potentially include this line
var extraEffectiveLine=targetModel.status==="deadline"?{type:"message",content:['It is extra painful!']}:null;return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),extraEffectiveLine].filter(function(line){return Boolean(line);});}}),//Screen Crack
"special_screen-crack":Object.assign({},SpecialActionModel,{name:"Screen Crack",category:"cursing",description:"Lowers target accuracy by 5%.",affectTargetAccuracyModifier:-5,ppCost:5,getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){var targetModel=targetModels[0];//Only 1 target
return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(targetModel.id),'\'s accuracy was lowered!']}];}})});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_ActionModel_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__ = __webpack_require__(27);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var SuperActionModel=Object.assign({},__WEBPACK_IMPORTED_MODULE_0__models_ActionModel_js__["a" /* default */],{isSuper:true,canMiss:false,//It's a little unfair that these could miss
increaseDangerMeterOnUse:0,category:"offense"//TODO!!!
});/* harmony default export */ __webpack_exports__["a"] = ({//Team Mega ForEach
"special_team-foreach":Object.assign({},SuperActionModel,{name:"Team ForEach",targetType:"opponent-team",description:"Delivers many iterations of pain to the opponent team.",affectTargetHpPointsInRepetitions:{min:5,max:7,affectTargetHpPoints:-5},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){//const targetModel = targetModels[0];
//const count = descriptionObject.description.targetsDamageTracker[targetModel.id].length;
//console.log(descriptionObject)
return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),{type:"animation",animationKey:"AnimationTeamForEach",animationData:{casterId:casterModel.id,targetIds:targetModels.map(function(t){return t.id;}),targetsDamageTracker:descriptionObject.description.targetsDamageTracker}}];}}),//Team Slice (super)
"special_team-slice":Object.assign({},SuperActionModel,{name:"Team Slice",targetType:"opponent-team",description:"Strikes and lowers defense of entire opponent team.",affectTargetHpPoints:-11,affectTargetDefenseModifier:{percentChance:100,value:-3},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),{type:"animation",animationKey:"AnimationSlice",animationData:{casterId:casterModel.id,targetIds:targetModels.map(function(t){return t.id;})}},{//Play the state change!
type:"stateChange",newCombatantState:descriptionObject.state,description:descriptionObject.description||{}},{type:"message",content:['Enemy team defense lowered!']}];}}),//Team Clean
"special_team-clean":Object.assign({},SuperActionModel,{name:"Team Clean",category:"healing",description:"Return all ally statuses back to normal.",targetType:"ally-team",affectTargetStatus:["*","normal"],canBeReplaced:false,getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),{type:"message",content:['All ally statuses are cleared!']}];}}),//Wildfire
"special_wildfire":Object.assign({},SuperActionModel,{name:"Wildfire",description:"Scorch the enemy team with a wall of flames.",targetType:"opponent-team",affectTargetStatus:["*","fire"],getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),{type:"message",content:['The whole team caught fire!']}];}}),//Team Revive
"special_team-revive":Object.assign({},SuperActionModel,{name:"Team Revive",category:"healing",description:"Raise all dead allies from the dead!",targetType:"ally-team",targetMustBeDead:true,affectTargetHpPointsByPercent:0.45,//%
getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),{type:"message",content:['Allies revived!']}];}}),//Commit
"special_commit":Object.assign({},SuperActionModel,{name:"Commit",description:"Save HP and PP of all combatants to Revert later.",targetType:"all",canMiss:false,changeCasterCommittedData:true,getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),//animation
{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),' committed the situation!']}];}}),//Revert (available after COMMIT)
"special_revert":Object.assign({},SuperActionModel,{name:"Revert",description:"Reset all combatants to saved Commit.",targetType:"all",canMiss:false,useCasterCommittedData:true,canBeReplaced:false,//Can't be replaced when lagging, or whatever. The point of this is to bail you out from bad situations
shouldFail:function shouldFail(actionModel,casterModel,targetModels){return!casterModel.committedTurnData;},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),//animation
{type:"message",content:['The battle is reverted to ',__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),'\'s Commit!']}];}}),//SQL Drop
"special_sql-drop":Object.assign({},SuperActionModel,{name:"SQL Drop",description:"Delete all enemy items.",targetType:"opponent-team",targetCanBeDead:true,ignoreTargetDieResult:true,//Don't show any "he died" messaging. He might already be dead, and this can't hurt ya.
deleteItemQuantity:50,//Banking that this is high enough to get all possible items. Don't want to bloat the loop too much
shouldFail:function shouldFail(actionModel,casterModel,targetModels,descriptionObject){var targetTeamItems=targetModels.map(function(targetModel){return targetModel.items;}).reduce(function(a,b){return[].concat(_toConsumableArray(a),_toConsumableArray(b));});return targetTeamItems.length===0;//Return TRUE if this team has zero items.
},getSuccessStep:function getSuccessStep(actionModel,casterModel,targetModels,descriptionObject){return[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["b" /* getColoredUseLine */])(casterModel.id,actionModel.name,""),//animation
{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),' deleted all enemy items!']}];}})});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBotDecision;
/* unused harmony export getDecisionFromSmartAttempt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_smart_decision__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lifecycle_team_utilities_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__get_bot_personality_for_situation_js__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__get_personality_options_array__ = __webpack_require__(333);
/** Bot making a decision. This function must provide: actionModel, casterModel, targetModels=[] (the three requirements for `submitAction`) */function getBotDecision(botId){var combatants=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var teams=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var casterModel=combatants[botId];//Identify personality variation (default vs goodTimes vs badTimes)
var teamCombatants=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lifecycle_team_utilities_js__["a" /* getAllTeammateModels */])(casterModel,combatants);var enemyCombatants=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lifecycle_team_utilities_js__["b" /* getAllEnemyModels */])(casterModel,combatants);var personalityOptions=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__get_personality_options_array__["a" /* getPersonalityOptionsArray */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_bot_personality_for_situation_js__["a" /* getBotPersonalityForSituation */])(casterModel,teamCombatants));//Create initial attempt model
var attemptModel={smartAttempts:casterModel.personalitySmartAttempts,personalityOptions:personalityOptions,casterModel:casterModel,teamCombatants:teamCombatants,enemyCombatants:enemyCombatants};//Recurrively find a smart move (according to # of smartAttempts)
var decision=getDecisionFromSmartAttempt(attemptModel);//console.log('decision', decision)
return{actionModel:decision.actionModel,casterModel:decision.casterModel,targetModels:decision.targetModels};}/* Take in an attempt model, recursively provide a decision */function getDecisionFromSmartAttempt(attemptModel){if(attemptModel.smartAttempts>0){//Attempt to get a decision
var smartDecision=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__get_smart_decision__["a" /* getSmartDecision */])(attemptModel.casterModel,attemptModel.teamCombatants,attemptModel.enemyCombatants,attemptModel.personalityOptions);//If we found one, return it!
if(smartDecision.wasSuccessful){return smartDecision;}else{//console.log('attempting again')
//We did not find one, so try again (with one less attempt, and without the path we just tried)
return getDecisionFromSmartAttempt({smartAttempts:attemptModel.smartAttempts-1,//reduce count by 1
personalityOptions:attemptModel.personalityOptions.filter(function(p){return p!==smartDecision.personalityUsed;}),//Do not retry with personality previously used
casterModel:attemptModel.casterModel,teamCombatants:attemptModel.teamCombatants,enemyCombatants:attemptModel.enemyCombatants});}}else{//Couldn't find anything at all, so just do a generic attack!
return getDecisionFromSmartAttempt({smartAttempts:1,//reduce count by 1
personalityOptions:["regular"],//Just get the regular one
casterModel:attemptModel.casterModel,teamCombatants:attemptModel.teamCombatants,enemyCombatants:attemptModel.enemyCombatants});}}/*
 This is an attemptModel:
 {
 smartAttempts: 3 //how many times we will try to do smart attempts before just giving up to a fallback
 personalityOptions: ["vicious", "vicious", "protective"]
 casterModel: {},
 teamCombatants:[ {}, {}, {} ],
 enemyCombatants: [ {}, {} ]
 }
 */

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBotObviousOpportunityDecision;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_numbers_helper_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_random_from_array_js__ = __webpack_require__(10);
function getBotObviousOpportunityDecision(casterModel){var teamCombatants=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var enemyCombatants=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var casterActions=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];//% chance that we'll look for an obvious oppportunity
if(!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_numbers_helper_js__["b" /* percentChance */])(casterModel.personalityObviousOpportunityRating)){//If roll fails, stop here
return null;}//-----------------------------------------------------------------------------------------
//Case 1: Look my moves that have positive damage multipliers for status TODO: because someday might have negative multipliers
var decisionMatchesWithPositiveMultipliers=casterActions.filter(function(action){//Find actions that have `statusMultiplayer` as the formatted array
return Array.isArray(action.statusMultiplier)&&action.statusMultiplier[1]>0;}).filter(function(action){//TODO: This bit assumes a) it's an offensive attack and b) we are only accepting one target. This is enough for now
//Now filter for only my actions that have a valid target
return enemyCombatants.find(function(enemyModel){return enemyModel.status===action.statusMultiplier[0];});}).map(function(action){//Create a formatted decision model for returning (will choose one of the results randomly)
return{actionModel:action,casterModel:casterModel,targetModels:[//Same operation as above. Need a copy of the target Model
enemyCombatants.find(function(enemyModel){return enemyModel.status===action.statusMultiplier[0];})]};});//Return one of our status weakness matches randomly
if(decisionMatchesWithPositiveMultipliers.length){return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_random_from_array_js__["a" /* randomFromArray */])(decisionMatchesWithPositiveMultipliers);}//-----------------------------------------------------------------------------------------
//default to no decision
return null;}/*
Should return:
 return {
  actionModel: {},
  casterModel,
  targetModels: [{}, {}]
 }
*/

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBotPersonalityForSituation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__analysis_team_analysis_utilities__ = __webpack_require__(53);
/** Look at current situation and figure out if Bot should use goodTimes,
 badTimes, or default personality */function getBotPersonalityForSituation(casterModel){var teamCombatants=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var teamHpRating=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__analysis_team_analysis_utilities__["c" /* getTeamHpRating */])(teamCombatants);//const teamStatusRating = getTeamStatusRating(teamCombatants);
//TODO: Currently not using `teamStatusRating` because I'm not sure how it would be balanced
var defaultPersonality=casterModel.computerAiPersonality.default;//Default the goodTimes and badTimes to the same as `defaultPersonality` if they are not explicitly defined
var goodTimesPersonality=getValidPersonalityObject(casterModel.computerAiPersonality.goodTimes,defaultPersonality);var badTimesPersonality=getValidPersonalityObject(casterModel.computerAiPersonality.badTimes,defaultPersonality);var value=teamHpRating;if(value>=casterModel.goodTimes[0]&&value<=casterModel.goodTimes[1]){//times are good!
return goodTimesPersonality;}if(value>=casterModel.badTimes[0]&&value<=casterModel.badTimes[1]){//times are bad!
return badTimesPersonality;}//Fall back to default personality
return defaultPersonality;}//Check if the input exists AND has keys. Otherwise, fallback to the default
function getValidPersonalityObject(){var input=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var fallback=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return input&&Object.keys(input).length?input:fallback;}

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBotSuperDecision;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_shuffle__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_shuffle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_shuffle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__super_paths_validate_supers_js__ = __webpack_require__(343);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function getBotSuperDecision(casterModel){var teamCombatants=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var enemyCombatants=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var supers=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];//randomize them.
var shuffledSupers=__WEBPACK_IMPORTED_MODULE_0_lodash_shuffle___default()([].concat(_toConsumableArray(supers)));//Find a valid one (all will be tried until valid one is found)
var validSuper=getValidSuperFromSeries(shuffledSupers,teamCombatants,enemyCombatants,casterModel);if(validSuper){//This one is valid! Get targets and return the info
return{actionModel:validSuper,casterModel:casterModel,targetModels:getTargetsFromSuper(validSuper.targetType,teamCombatants,enemyCombatants)};}//if no solution (no valid supers), keep going on to the usual paths (doesn't take up any `personalitySmartAttempts`)
return null;}function getValidSuperFromSeries(){var chain=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var teamCombatants=arguments[1];var enemyCombatants=arguments[2];var casterModel=arguments[3];//recursive
if(!chain.length){//No options in the chain are valid.
return null;}if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__super_paths_validate_supers_js__["a" /* isSuperValid */])(chain[0].id,teamCombatants,enemyCombatants,casterModel)){// console.log('chosen Super', chain[0]);
//Return the actionModel
return chain[0];}//if not successful.. recursively try again
return getValidSuperFromSeries(chain.filter(function(d,i){return i!==0;}),//remove the first item that was tried
teamCombatants,//pass in the same other properties
enemyCombatants,casterModel);}function getTargetsFromSuper(){var targetType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var teamCombatants=arguments[1];var enemyCombatants=arguments[2];if(targetType==="all"){return[].concat(_toConsumableArray(teamCombatants),_toConsumableArray(enemyCombatants));}if(targetType==="ally-team"){return[].concat(_toConsumableArray(teamCombatants));}if(targetType==="opponent-team"){return[].concat(_toConsumableArray(enemyCombatants));}//TODO: no supers target individuals yet
console.warn('no target found in `getTargetsFromSuper`',targetType);return[];}

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPersonalityOptionsArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_range__);
/** Take in personalityObject and return [] of each number value */function getPersonalityOptionsArray(){var personalityObj=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{regular:1};var payload=[];//For each value in the object, put that many copies of the key into the payload array
Object.keys(personalityObj).forEach(function(key){__WEBPACK_IMPORTED_MODULE_0_lodash_range___default()(personalityObj[key]).forEach(function(point){payload.push(key);});});return payload;}

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSmartDecision;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__battle_data_battle_actions_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_random_from_array_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__get_bot_super_decision__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__get_bot_obvious_opportunity_decision__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__personality_paths_get_regular_path_js__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__personality_paths_get_vicious_path_js__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__personality_paths_get_recover_path_js__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__personality_paths_get_cursing_path_js__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__personality_paths_get_cleaning_path_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__personality_paths_get_boosting_path_js__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__personality_paths_get_thief_path_js__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__personality_paths_get_slowing_path_js__ = __webpack_require__(340);
//Super
//Obvious Opportunities
//Paths
function getSmartDecision(casterModel){var teamCombatants=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var enemyCombatants=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var personalityOptions=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];//Create array of all caster's actions in model form
var casterActions=casterModel.getAvailableActions()//Note: contains PP check, and only Supers if DM is available
.map(function(action){return Object.assign({id:action.actionId},__WEBPACK_IMPORTED_MODULE_0__battle_data_battle_actions_js__["a" /* default */][action.actionId],{actionMeta:action//includes actionId and instanceId, isStolen, etc
});});//First, Figure out if we're going to use a Super move here.. (that will bypass the personality stuff)
var superAttacks=casterActions.filter(function(a){return a.isSuper;});//These will only show up if danger meter is ready
if(superAttacks.length){//Pick a random one to use.
var validSuperAttack=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_bot_super_decision__["a" /* getBotSuperDecision */])(casterModel,teamCombatants,enemyCombatants,superAttacks);if(validSuperAttack){return{wasSuccessful:true,personalityUsed:"super",//TODO: Not really used for successes, but might be useful to know?
actionModel:validSuperAttack.actionModel,casterModel:validSuperAttack.casterModel,targetModels:validSuperAttack.targetModels};}}//Next, Now check for the "obvious" opportunities
// -> These are things like "do I have a move that will do extra damage against person X?" Like, Scope Bomb on a Deadline
var obviousOpportunityDecision=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__get_bot_obvious_opportunity_decision__["a" /* getBotObviousOpportunityDecision */])(casterModel,teamCombatants,enemyCombatants,casterActions);if(obviousOpportunityDecision){return{wasSuccessful:true,personalityUsed:"obvious-decision",//TODO: Again, not really used for successes, but might be useful to know
actionModel:obviousOpportunityDecision.actionModel,casterModel:obviousOpportunityDecision.casterModel,targetModels:obviousOpportunityDecision.targetModels};}//If no decision so far, figure out which personality path we will attempt
var chosenPersonality=personalityOptions.length?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_random_from_array_js__["a" /* randomFromArray */])(personalityOptions):"regular";//default if out of options
var personalityMap={"regular":__WEBPACK_IMPORTED_MODULE_4__personality_paths_get_regular_path_js__["a" /* getRegularPath */],"vicious":__WEBPACK_IMPORTED_MODULE_5__personality_paths_get_vicious_path_js__["a" /* getViciousPath */],"recovering":__WEBPACK_IMPORTED_MODULE_6__personality_paths_get_recover_path_js__["a" /* getRecoverPath */],"cursing":__WEBPACK_IMPORTED_MODULE_7__personality_paths_get_cursing_path_js__["a" /* getCursingPath */],"cleaning":__WEBPACK_IMPORTED_MODULE_8__personality_paths_get_cleaning_path_js__["a" /* getCleaningPath */],"boosting":__WEBPACK_IMPORTED_MODULE_9__personality_paths_get_boosting_path_js__["a" /* getBoostingPath */],"thief":__WEBPACK_IMPORTED_MODULE_10__personality_paths_get_thief_path_js__["a" /* getThiefPath */],"slowing":__WEBPACK_IMPORTED_MODULE_11__personality_paths_get_slowing_path_js__["a" /* getSlowingPath */]};if(!personalityMap[chosenPersonality]){console.warn('personality path not found in personalityMap',chosenPersonality);}var decision=personalityMap[chosenPersonality](casterModel,teamCombatants,enemyCombatants,casterActions);//null or { actionModel:{} casterModel:casterModel, targetModels: [{}, {}] }
return decision?{wasSuccessful:true,personalityUsed:chosenPersonality,actionModel:decision.actionModel,casterModel:decision.casterModel,targetModels:decision.targetModels}:{wasSuccessful:false,personalityUsed:chosenPersonality};}/* Output -> one of two types
Case 1: Success Model
  {
     wasSuccessful: true,
     personalityUsed: "string",
     actionModel: {},
     casterModel: {},
     targetModels: [{}]
  }

Case 2: Fail Model
 {
   wasSuccessful: false,
   personalityUsed: "string",
 }
*/

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBoostingPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_sorted_by_self_serving__ = __webpack_require__(149);
function getBoostingPath(casterModel){var teamCombatants=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var enemyCombatants=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var casterActions=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];//See if we have valid recovery moves
var validMoves=getValidBoostingMoves(casterActions);if(!validMoves.length){return null;}//Pick the action
var actionModel=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__["a" /* randomFromArray */])(validMoves);//If this affects all teammates, just do it.
if(actionModel.targetType==="ally-team"){return{actionModel:actionModel,casterModel:casterModel,targetModels:teamCombatants};}//If this is a SINGLE TARGET stat booster (not a status changer), pick a friendly target by selfServingOrder
if(isStatBoostingAction(actionModel)){return{actionModel:actionModel,casterModel:casterModel,targetModels:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_sorted_by_self_serving__["a" /* getSelfServingTeamOrder */])(casterModel,teamCombatants)[0]]};}//Status changer that requires single target identification...
//Choose a valid person to recover (uses selfServing)
var targetModel=confirmBoostingTarget(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_sorted_by_self_serving__["a" /* getSelfServingTeamOrder */])(casterModel,teamCombatants));//Return a random one of our valid moves
if(targetModel){return{actionModel:actionModel,casterModel:casterModel,targetModels:[targetModel]};}return null;}function confirmBoostingTarget(remainingTargets){//check the first in the list
var candidate=remainingTargets[0];if(candidate.status==="normal"&&candidate.isAlive()){return candidate;}if(remainingTargets.length>1){return confirmBoostingTarget(remainingTargets.filter(function(d,i){return i>0;}));//run again without the 0th entry
}//nobody is valid
return null;}function isStatBoostingAction(actionModel){if(actionModel.affectTargetStatus){return false;}return actionModel.affectTargetDangerMeter>0||//Danger Meter is considered a "stat" for boosting
actionModel.affectTargetAttackModifier>0||actionModel.affectTargetDefenseModifier>0||actionModel.affectTargetSpeedModifier>0;}function getValidBoostingMoves(casterActions){return casterActions.filter(function(action){//Check for moves that boost stats
if(isStatBoostingAction(action)){return true;}//Now rule out anything that isn't a status changer
if(!action.affectTargetStatus){return false;}var resultingStatus=action.affectTargetStatus[1];//Add these as needed
return["fury","focus","deadline"//insert more positive statuses here
].indexOf(resultingStatus)>-1;});}

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCleaningPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__analysis_team_analysis_utilities_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_shuffle__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_shuffle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_shuffle__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function getCleaningPath(casterModel){var teamCombatants=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var enemyCombatants=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var casterActions=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];//See if we have any valid friends to clean
var validFriendlyTargets=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__analysis_team_analysis_utilities_js__["a" /* getCombatantsWithStatus */])(teamCombatants,["lag","memory-leak","fire"]);if(!validFriendlyTargets.length){//console.log('no friendly targets')
return null;}//Look for solutions for suffering friends
var targetActionCombo=getCleaningTargetAndAction(validFriendlyTargets,casterModel,casterActions);//We don't have anything that can help our suffering friends
if(!targetActionCombo){return null;}//Either be single target or whole team target depending on the action's targetType
var isWholeTeamTarget=targetActionCombo.actionModel.targetType==="ally-team";return{actionModel:targetActionCombo.actionModel,casterModel:casterModel,targetModels:isWholeTeamTarget?teamCombatants:[targetActionCombo.targetModel]};}/** Search targets for statuses that we can fix. Return a Target paired with an Action that will fix the status */function getCleaningTargetAndAction(validTargets,casterModel,casterActions){var isCasterInList=validTargets.find(function(comb){return comb.id===casterModel.id;});var useTargets=void 0;if(isCasterInList){var teamWithoutCaster=__WEBPACK_IMPORTED_MODULE_2_lodash_shuffle___default()([].concat(_toConsumableArray(validTargets))).filter(function(comb){return comb.id!==casterModel.id;});if(casterModel.isSelfServing){useTargets=[casterModel].concat(_toConsumableArray(teamWithoutCaster));}else{useTargets=[].concat(_toConsumableArray(teamWithoutCaster),[casterModel]);}}else{useTargets=__WEBPACK_IMPORTED_MODULE_2_lodash_shuffle___default()(validTargets);}//Loop through each target and check if we have a solution
var _loop=function _loop(index){var targetModel=useTargets[index];//Do we have something that can fix this status?
var validActions=casterActions.filter(function(action){if(!action.affectTargetStatus){return false;}var fromStatus=action.affectTargetStatus[0];return(fromStatus===targetModel.status||fromStatus==="*")&&action.affectTargetStatus[1]==="normal";});//TODO: warning: Team Clean comes back with this. Might need to bump that to an "isSuper" flag or something
if(validActions.length){//End the loop
return{v:{actionModel:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__["a" /* randomFromArray */])(validActions),targetModel:targetModel}};}};for(var index=0;index<=useTargets.length-1;index++){var _ret=_loop(index);if((typeof _ret==='undefined'?'undefined':_typeof(_ret))==="object")return _ret.v;}return null;}

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCursingPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__analysis_team_analysis_utilities_js__ = __webpack_require__(53);
function getCursingPath(casterModel){var teamCombatants=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var enemyCombatants=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var casterActions=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];//See if we have valid cursing moves
var validMoves=getValidCursingMoves(casterActions);if(!validMoves.length){return null;}//See if we have any valid enemies to curse
var validEnemyTargets=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__analysis_team_analysis_utilities_js__["a" /* getCombatantsWithStatus */])(enemyCombatants,["normal"]);if(!validEnemyTargets.length){return null;}//Return a random one of our valid moves
var action=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__["a" /* randomFromArray */])(validMoves);var target=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__["a" /* randomFromArray */])(validEnemyTargets);return{actionModel:action,casterModel:casterModel,targetModels:[target]};}/** Search array of actions for moves that cause negative statuses */function getValidCursingMoves(casterActions){return casterActions.filter(function(action){if(!action.affectTargetStatus){return false;}var resultingStatus=action.affectTargetStatus[1];//Add these as needed
return["memory-leak","lag","fire"].indexOf(resultingStatus)>-1;});}

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getRecoverPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_sorted_by_self_serving__ = __webpack_require__(149);
function getRecoverPath(casterModel){var teamCombatants=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var enemyCombatants=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var casterActions=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];//First check for revival moves
var deadTeammateWithRevivalMoveMatch=getValidRevivalMovesAndTarget(casterActions,teamCombatants);if(deadTeammateWithRevivalMoveMatch){//We can revive somebody, so stop here with that:
return{actionModel:deadTeammateWithRevivalMoveMatch.actionModel,casterModel:casterModel,targetModels:[deadTeammateWithRevivalMoveMatch.targetModel]};}//Now see if we have valid recovery moves
var validMoves=getValidRecoverMoves(casterActions);if(!validMoves.length){// console.log('no length')
return null;}//Choose a valid ALIVE person to recover (uses selfServing)
var targetModel=confirmRecoveryTarget(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_sorted_by_self_serving__["a" /* getSelfServingTeamOrder */])(casterModel,teamCombatants.filter(function(model){return model.isAlive();})));//Return a random one of our valid moves
if(targetModel){var actionModel=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__["a" /* randomFromArray */])(validMoves);return{actionModel:actionModel,casterModel:casterModel,targetModels:[targetModel]};}return null;}function confirmRecoveryTarget(remainingTargets){//check the first in the list
var candidate=remainingTargets[0];var candidateHpPercent=candidate.hp/candidate.maxHp*100;if(candidateHpPercent<=75){return candidate;}if(remainingTargets.length>1){return confirmRecoveryTarget(remainingTargets.filter(function(d,i){return i>0;}));//run again without the 0th entry
}//nobody is valid
return null;}function getValidRecoverMoves(casterActions){//TODO: No recovery special attacks exist yet. Only items.
//TODO: make sure PP is validating before returning a recovery attack as an option.
var validMoves=casterActions.filter(function(action){return action.affectTargetHpPoints>0&&!action.targetMustBeDead;//Moves that affect hp to greater values. No revival items! Only ones for alive people
});//TODO: sort isItem actions to be last in the array (so we don't hog the items when we could just use an attack)
//TODO 2: are we sure about that?
return validMoves;}/** Get back a valid pair of Revival move / dead combatant */function getValidRevivalMovesAndTarget(casterActions,combatantsList){//TODO: No recovery revival special attacks exist yet.
//First check that any combatants are dead
var deadCombatants=combatantsList.filter(function(comb){return!comb.isAlive();});//Nobody is dead, so bail here
if(!deadCombatants.length){return null;}//Do we have any revival moves?
var revivalActions=casterActions.filter(function(action){return action.targetMustBeDead&&action.affectTargetHpPointsByPercent>0;});//No revival moves, so bail here
if(!revivalActions.length){return null;}//At this point, we have at least 1 dead Combatant and at least 1 revival move!
return{actionModel:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__["a" /* randomFromArray */])(revivalActions),targetModel:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__["a" /* randomFromArray */])(deadCombatants)};}/*
 RECOVER
 -> Do I have an HP move? //preserves the items for people who don't have these abilities
 -> Do I have an HP item?
 -> Am I SELF serving or TEAM serving (personality setting)
 */

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getRegularPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__ = __webpack_require__(10);
function getRegularPath(casterModel){var teamCombatants=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var enemyCombatants=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var casterActions=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];//strike random enemy opponent
var aliveTargets=enemyCombatants.filter(function(combModel){return combModel.isAlive();});if(!aliveTargets.length){console.warn('!!!!!!!!!!!! no alive targets to target..');console.warn(enemyCombatants);// return null;
}return{actionModel:casterActions.find(function(actionModel){return actionModel.id==="attack_generic-attack";}),casterModel:casterModel,targetModels:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__["a" /* randomFromArray */])(aliveTargets)]};}

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSlowingPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__ = __webpack_require__(10);
//SLOWING is offensively using attacks that lower enemy stats. EX: Lowering an enemy's accuracyModifier
function getSlowingPath(casterModel){var teamCombatants=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var enemyCombatants=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var casterActions=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];//See if we have valid Slowing attacks
var validMoves=casterActions.filter(function(action){//Accuracy lowering
if(action.affectTargetAccuracyModifier<0){return true;}//TODO: Attack/Defense/Speed lowering [offensive] attacks
//At this time, those do not exist. Only in the "boosting" realm, which is a defensive/positive thing
return false;});if(!validMoves.length){return null;}//Return a random one of our valid moves
var action=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__["a" /* randomFromArray */])(validMoves);//Choose one random ALIVE enemy (because the list includes all dead or alive enemies)
var target=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__["a" /* randomFromArray */])(enemyCombatants.filter(function(model){return model.isAlive();}));return{actionModel:action,casterModel:casterModel,targetModels:[target]};}

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getThiefPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__ = __webpack_require__(10);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}//TODO: This file should be re-thought out if team items feature is ever disabled.
function getThiefPath(casterModel){var teamCombatants=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var enemyCombatants=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var casterActions=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];//NOTE: this path also includes BUGGING. Bugging seems like it could be cursing, but that path is for Statuses.
//The Thief-ing path involves Items.
//See if we have valid thief-ing moves
var validMoves=getValidStealingMoves(casterActions);if(!validMoves.length){return null;}//Look at first enemy to get team items
var sampleTarget=enemyCombatants[0];var teamItems=sampleTarget.getTeamItems();//If other team has no items, this path is invalid
if(!teamItems.length){return null;}//Return a random one of our valid moves
var action=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__["a" /* randomFromArray */])(validMoves);//TODO: this block involves the reality of using a feature flag instead of always assuming team items
// const targets = action.targetType === "opponent-team" //Use full team for targets (based on targetType)
//   ? enemyCombatants
//   : [randomFromArray(validEnemyTargets)];
return{actionModel:action,casterModel:casterModel,targetModels:[].concat(_toConsumableArray(enemyCombatants))//For now, always target all enemies for Stealing moves (TODO: should use feature flag, though)
};}/** Search array of actions for moves that steal items or BUG items or DELETE items */function getValidStealingMoves(casterActions){return casterActions.filter(function(action){return action.theftQuantity>0||action.sabotageItemQuantity>0||action.deleteItemQuantity>0;});}

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getViciousPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__analysis_action_analysis_utilities_js__ = __webpack_require__(320);
function getViciousPath(casterModel){var teamCombatants=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var enemyCombatants=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var casterActions=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];var aliveTargets=enemyCombatants.filter(function(combModel){return combModel.hp>0;});var lowestHpEnemy=aliveTargets.sort(function(a,b){return a.hp>b.hp?1:-1;})[0];var action=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__analysis_action_analysis_utilities_js__["a" /* getMostDamagingAttack */])(casterActions);//console.log('vicious path', action.name)
return{actionModel:action,casterModel:casterModel,//Honor the targetType of the selected action (Honeypot Trap)
//targetModels: action.targetType === "only-me" ? [casterModel] : [lowestHpEnemy]
targetModels:getViciousPathTarget(action,casterModel,aliveTargets,lowestHpEnemy)};}//There are a few odd cases for the targeting, so extracting the target picking this to a cleaner function:
function getViciousPathTarget(action,casterModel,aliveTargets,lowestHpEnemy){//If this affects only me (wouldn't expect this to happen in Vicious, but who knows?)
if(action.targetType==="only-me"){return[casterModel];}//We target the whole team, so return all alive targets
if(action.targetType==="opponent-team"){return aliveTargets;}//Default to picking the lowest enemy
return[lowestHpEnemy];}// VICIOUS
// - Identify the lowest HP enemy
// - Strike with attack (should this be the highest damaging attack?)

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSuperValid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__analysis_team_analysis_utilities_js__ = __webpack_require__(53);
//Look at the ID of the super and evaluate if it should be used
function isSuperValid(superId,teamCombatants,enemyCombatants,casterModel){//Case 1: return TRUE if there are 2 or more alive enemies.
if(superId==="special_team-foreach"||superId==="special_team-slice"||superId==="special_wildfire"){var aliveEnemyCombatantCount=enemyCombatants.filter(function(combModel){return combModel.isAlive();}).length;return aliveEnemyCombatantCount>=2;}//Case 2: TEAM CLEAN: return TRUE if friendlies have bad statuses
if(superId==="special_team-clean"){var teamStatusRating=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__analysis_team_analysis_utilities_js__["b" /* getTeamStatusRating */])(teamCombatants);return teamStatusRating<50;//less than normal avg
}//Case 3: TEAM REVIVE: return TRUE if 1 or more friendlies are dead
if(superId==="special_team-revive"){var deadFriendlyCombatantCount=teamCombatants.filter(function(combModel){return!combModel.isAlive();}).length;return deadFriendlyCombatantCount>=1;}//Case 4: COMMIT: return true if the friendly team HP and statuses look good.
if(superId==="special_commit"){if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__analysis_team_analysis_utilities_js__["b" /* getTeamStatusRating */])(teamCombatants)>=50&&__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__analysis_team_analysis_utilities_js__["c" /* getTeamHpRating */])(teamCombatants)>=75){if(!casterModel.committedTurnData){//Don't use this if Bot already has a Commit. Trust that the old one is good.
return true;}}}//Case 4b: REVERT: return true if friendly HP and statuses don't look good
if(superId==="special_revert"){if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__analysis_team_analysis_utilities_js__["b" /* getTeamStatusRating */])(teamCombatants)===0||__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__analysis_team_analysis_utilities_js__["c" /* getTeamHpRating */])(teamCombatants)<50){return true;}}//Case 5: SQL DROP! Delete all enemy items
if(superId==="special_sql-drop"){var sampleEnemy=enemyCombatants[0];if(sampleEnemy.getTeamItems().length>0){return true;}}return false;}

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyArenaPositionsForOpenBattle;
/* Open battles don't have preset teams, or loadouts, so we need to merge in arena positions. */function applyArenaPositionsForOpenBattle(combatants,teams){var nextTeamOnePosition=1;var nextTeamTwoPosition=1;var payload={};Object.keys(combatants).forEach(function(key){var model=combatants[key];if(teams.one.combatantIds.includes(key)){payload[key]=Object.assign({},model,{arenaPosition:nextTeamOnePosition});nextTeamOnePosition++;}if(teams.two.combatantIds.includes(key)){payload[key]=Object.assign({},model,{arenaPosition:nextTeamTwoPosition});nextTeamTwoPosition++;}});return Object.assign({},payload);}

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loginToBattleNetwork;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handle_user_data_received__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase_users__ = __webpack_require__(54);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/** Log in to Firebase (or already logged in) and get the user's data */function loginToBattleNetwork(){var _this=this;//Listen for the login change.
window.firebase.auth().onAuthStateChanged(function(){var _ref=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(user){var formattedUserId,userData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!user){_context.next=10;break;}// User is signed in.
// var isAnonymous = user.isAnonymous;
// var uid = user.uid;
//use this userId to get my user info
formattedUserId='client_'+user.uid;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["a" /* setBattleValue */])({battlePlayerId:[formattedUserId]//save userID in state
});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__redux_actions_battle_actions_js__["e" /* setCrewValue */])({logggedInUserId:user.uid//Tell state that we are logged in.
});//Go check if I have saved data
_context.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__firebase_users__["c" /* getUserDataFromFirebase */])(formattedUserId);case 6:userData=_context.sent;if(userData){//Handler will do something with this data and move us to next step
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__handle_user_data_received__["a" /* handleUserDataReceived */])(userData);}_context.next=11;break;case 10:// User is not logged in.
// ...
//Now login annonymously
window.firebase.auth().signInAnonymously().catch(function(error){// Handle Errors here.
// var errorCode = error.code;
// var errorMessage = error.message;
console.warn("error",error);//
});case 11:case'end':return _context.stop();}}},_callee,_this);}));return function(_x){return _ref.apply(this,arguments);};}());}

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = decodeSafeFirebaseRolloutStateChange;
/** Take in an incoming StateChange from firebase and make it safe. *///EX: converting `false` back to an empty array.
function decodeSafeFirebaseRolloutStateChange(stateChangeInput){var safeStateChange=Object.assign({},stateChangeInput);//Convert back to empty array from false. Firebase won't save empty arrays, so we must save a `false` Boolean instead
if(safeStateChange.items===false){safeStateChange.items=[];}return safeStateChange;}

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = masterChecksForAllClientsReady;
/* unused harmony export masterStartBattle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lifecycle_init_battle_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lifecycle_build_teams_evenly__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lifecycle_build_teams_from_client_buddies__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__applyArenaPositionsForOpenBattle__ = __webpack_require__(344);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//import {buildTeamsFromCombatantData} from '../lifecycle/build-teams-from-combatant-data.js'
function masterChecksForAllClientsReady(){if(__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().battle.isMultiplayerMasterClient){//Get connected keys that are clients.
var clientKeys=Object.keys(__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().matchmaking.initialCombatantData).filter(function(key){return key.match(/^client_/);}).map(function(key){return key.replace("client_","");});//Check that we have readies for each of the clients.
var readyClients=__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().matchmaking.readyClients;var allClientsReady=clientKeys.every(function(key){return readyClients[key];});//If all clients are contained in the ready object, and we're not the only client.
var roomType=__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().matchmaking.currentRoomType;if(allClientsReady&&roomType==="fullteam"&&clientKeys.length>1){masterStartBattle();}if(allClientsReady&&roomType==="open"){masterStartBattle();}}//Make sure that the combatant's were checking are the actual connections. Stale "readys" may be here
//from people leaving.
}/** ONLINE ONLY - Master sends out notification of battle starting */var masterStartBattle=function(){var _ref=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var snapshot,initialCombatantDataFromServer,roomType,teams,initialCombatantData,initialBots;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().battle.isMultiplayerMasterClient&&!__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().battle.hasBattleStarted)){_context.next=12;break;}_context.next=3;return window.roomRef.child("initialCombatantData").once("value");case 3:snapshot=_context.sent;initialCombatantDataFromServer=Object.assign({},snapshot.val());//Use combatant data to build teams (sides and items)
//const teams = buildTeamsFromCombatantData(initialCombatantDataFromServer);
//TODO: ^^ This func will for sure be needed for single player game experience.. uses `wantsToJoinTeam`.
roomType=__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().matchmaking.currentRoomType;teams=roomType==="fullteam"?__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lifecycle_build_teams_from_client_buddies__["a" /* buildTeamsFromClientBuddies */])(initialCombatantDataFromServer):__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lifecycle_build_teams_evenly__["a" /* buildTeamsEvenly */])(initialCombatantDataFromServer);//OPEN BATTLES: Auto apply arenaPositions
if(roomType==="open"){//Replace combatant structure with newly baked arenaPositions.
initialCombatantDataFromServer=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__applyArenaPositionsForOpenBattle__["a" /* applyArenaPositionsForOpenBattle */])(initialCombatantDataFromServer,teams);}//Seed the bots
//Lets set the bots here!
initialCombatantData=__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().matchmaking.initialCombatantData;initialBots={};Object.keys(initialCombatantData).forEach(function(id){var model=initialCombatantData[id];if(model.isBot){initialBots[id]={combatantName:model.name//TODO: This value isn't used or do anything. It just holds space
};}});window.roomRef.child('bots').set(initialBots).then(function(){//console.log('+++++++', initialBots, "set")
//Start the battle
window.roomRef.child('hasBattleStarted').set(true);//Set up the very first pass for rejoiners
//Note: the only people who "request" this property are people who are rejoining
// -> Master resets this property on every "seen" he sends, but that doesnt happen til after the first turn. So set the initial value here.
window.roomRef.child('rejoinCombatantState').set(initialCombatantData);window.roomRef.child('rejoinTeams').set(teams);//Send out the first state
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__firebase__["c" /* sendBattleStateToServer */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lifecycle_init_battle_js__["a" /* getInitialBattleState */])(initialCombatantDataFromServer,teams));});case 12:case'end':return _context.stop();}}},_callee,this);}));return function masterStartBattle(){return _ref.apply(this,arguments);};}();

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleUserDataReceived; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_rooms_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__ = __webpack_require__(2);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/** What we do with player's userData when we set it or receive it from the server. */var handleUserDataReceived=function(){var _ref=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0://Do something with it
//console.log('user data received!', userData);
//Save our user data locally
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_battle_actions_js__["b" /* setMatchmakingValue */])({userDataState:"Success"});//We're ready to
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__firebase_rooms_js__["g" /* pairPlayerWithRoom */])();case 2:case'end':return _context.stop();}}},_callee,this);}));return function handleUserDataReceived(){return _ref.apply(this,arguments);};}();

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTargetIdsFromConjoinedString;
/** Consume a string of target Ids like "id1,id2" and return an array of TargetModels */function getTargetIdsFromConjoinedString(){var stringOfTargets=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var combatantsDataset=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return stringOfTargets.split(",").map(function(id){if(!Boolean(combatantsDataset[id])){console.warn("id not found in combatantsDataset",id,combatantsDataset);}return combatantsDataset[id];});}

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDevScenario;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_CombatantModel_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PlayerFixture_combatant__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Fixture_combatants_js__ = __webpack_require__(24);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function getDevScenario(controlledCombatantIds){return{main:new __WEBPACK_IMPORTED_MODULE_0__models_CombatantModel_js__["a" /* default */](Object.assign({},__WEBPACK_IMPORTED_MODULE_2__Fixture_combatants_js__["b" /* sampleLoadouts */][4],{name:"PLAYER",skinId:"skin_m1",wantsToJoinTeam:"one",//isBot: true,
hp:20,// pp: 2,
// attackModifier: 99,
// defenseModifier: 999,
speedModifier:10,// accuracyModifier: -100,
dangerMeter:100,// status: "lag",
arenaPosition:1,attacks:[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1__PlayerFixture_combatant__["b" /* attackList */])),items:[{actionId:"item_revive",instanceId:"instance_asdasdas"},{actionId:"item_full-revive",instanceId:"instance_asdasdas2"},{actionId:"item_team-danger-boost",instanceId:"instance_asdasdas2b",isBugged:false},{actionId:"item_danger-boost",instanceId:"instance_asdasdas3",isBugged:false},{actionId:"item_max-danger-boost",instanceId:"instance_asdasdas4",isStolen:true},{actionId:"item_mini-battery-pack",instanceId:"instance_asdasdas5",isBugged:false}]})),oneB:new __WEBPACK_IMPORTED_MODULE_0__models_CombatantModel_js__["a" /* default */](Object.assign({},__WEBPACK_IMPORTED_MODULE_2__Fixture_combatants_js__["b" /* sampleLoadouts */][1],{name:"Andre",skinId:"skin_f1",//hp: -4,
// status: "lag",
//Only be a bot if ID does not show up in controlledCombatantIds
isBot:!controlledCombatantIds.includes("oneB"),//true,
wantsToJoinTeam:"one",arenaPosition:2,items:[]})),oneC:new __WEBPACK_IMPORTED_MODULE_0__models_CombatantModel_js__["a" /* default */](Object.assign({},__WEBPACK_IMPORTED_MODULE_2__Fixture_combatants_js__["b" /* sampleLoadouts */][4],{name:"Biff",skinId:"skin_m2",//Only be a bot if ID does not show up in controlledCombatantIds
isBot:!controlledCombatantIds.includes("oneC"),//true,
wantsToJoinTeam:"one",hp:-1,arenaPosition:3,items:[]})),/* ENEMY **************************************************************************************************************************** */twoA:new __WEBPACK_IMPORTED_MODULE_0__models_CombatantModel_js__["a" /* default */](Object.assign({},__WEBPACK_IMPORTED_MODULE_2__Fixture_combatants_js__["b" /* sampleLoadouts */][3],{name:"Cassandra",skinId:"skin_f3",isBot:true,// speedModifier: 999,
// defenseModifier: 999,
// hp: -1,
// pp: 0,
arenaPosition:1,// attacks: [
//   { actionId: "special_slice" },
//   // { actionId: "special_ddos" },
//   // { actionId: "special_copy-paste" },
//   // { actionId: "special_scope-bomb" },
//   // { actionId: "special_firewall" }
//   // {actionId: "special_sql-drop"},
// ],
//status: "memory-leak",
// speedModifier: 9999,
//defenseModifier: 3,
// isSelfServing: false,
//speedModifier: 100,
wantsToJoinTeam:"two",//dangerMeter: 100,
//personalityObviousOpportunityRating: 100,
// speedModifier: 100,
// computerAiPersonality: {
//   default: {
//     vicious: 10
//   }
// },
//   // goodTimes: {
//   //   "thief": 1,
//   // },
//   // badTimes: {
//   //   "recovering": 10,
//   // },
// },
items:[{actionId:"item_revive",instanceId:"instance_asdasdas-a"},{actionId:"item_revive",instanceId:"instance_asdasdas-b"},{actionId:"item_revive",instanceId:"instance_asdasdas-c"},{actionId:"item_revive",instanceId:"instance_asdasdas-d"},{actionId:"item_revive",instanceId:"instance_asdasdas-e"}]// hp: 10,
// speedModifier: 99,
// computerAiPersonality: {
//   default: {
//     "recovering": 10
//   }
// },
})),twoB:new __WEBPACK_IMPORTED_MODULE_0__models_CombatantModel_js__["a" /* default */](Object.assign({},__WEBPACK_IMPORTED_MODULE_2__Fixture_combatants_js__["b" /* sampleLoadouts */][3],{name:"Brooklyn",skinId:"skin_m1",isBot:true,wantsToJoinTeam:"two",arenaPosition:2,status:"focus"// hp: -2,
// items: [
//   { actionId: "item_honeypot-trap", instanceId: makeId("itemInstance", 10), isStolen: false},
// ]
})),twoC:new __WEBPACK_IMPORTED_MODULE_0__models_CombatantModel_js__["a" /* default */](Object.assign({},__WEBPACK_IMPORTED_MODULE_2__Fixture_combatants_js__["b" /* sampleLoadouts */][3],{name:"Betsy",skinId:"skin_f2",// hp: 0,
isBot:true,wantsToJoinTeam:"two",arenaPosition:3//status: "deadline"
// items: [
//   { actionId: "item_honeypot-trap", instanceId: makeId("itemInstance", 10), isStolen: false},
// ]
}))};}

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getQuickBattleScenario;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Fixture_combatants_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_CombatantModel_js__ = __webpack_require__(57);
function getQuickBattleScenario(controlledCombatantIds){//Get a copy of my crew from state
var crewMembers=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().crew.members;//NOTE: These should have attacks and items included (loadouts merged in).
//Set up the delivery object
var payload={};//Fill in each of our known controlled ids with a model from the crew.
controlledCombatantIds.forEach(function(id,index){payload[id]=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__models_CombatantModel_js__["a" /* default */])(Object.assign({},crewMembers[Object.keys(crewMembers)[index]],{wantsToJoinTeam:"one"}));//Boost the human player's main character in speed. (Note: Quick Battle only!)
if(index===0){payload[id].speedModifier=13;}});//Get three random enemy loadouts.
["enemyA","enemyB","enemyC"].forEach(function(id,index){payload[id]=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__models_CombatantModel_js__["a" /* default */])(Object.assign({},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Fixture_combatants_js__["a" /* getRandomLoadout */])(),{wantsToJoinTeam:"two",isBot:true,arenaPosition:index+1}));});return payload;}

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addSaltedItemInstanceIdsToCombatants;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_make_id_js__ = __webpack_require__(34);
/*
  NOTE: You may be able to get rid of this with 1.0. This is required by poor planning of creating the instanceId when defining a loadout.
   InstanceIds are needed for giving uniqueness to possible repeatable inventory items. Right now, we have a problem that all Class X's have the same instanceIds on their items.
   Thus the need to salt them. If you created the randomId when gathering a lineup, it would be fine. But baking the instanceId into the preset is not fine. and here we are...
*/function addSaltedItemInstanceIdsToCombatants(combatants){//Add a little salt at the end of an item's instanceID. If the item does not have an instanceId, provide one.
var payload={};Object.keys(combatants).forEach(function(key){var model=combatants[key];var updatedItems=model.items.map(function(item){var randomSalt=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_id_js__["a" /* default */])("s",10);return Object.assign({},item,{instanceId:item.instanceId?item.instanceId+"+"+randomSalt:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_id_js__["a" /* default */])("instance",12)+"+"+randomSalt});});payload[key]=Object.assign({},model,{items:updatedItems});});return payload;}

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildTeamsEvenly;
/** Return a Teams model that has even teams (doesnt care about wantsToJoinTeam property) */function buildTeamsEvenly(){var combatants=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var result={"one":{combatantIds:[]},"two":{combatantIds:[]}};Object.keys(combatants).forEach(function(combId,i){var teamId=i%2===0?"one":"two";result[teamId].combatantIds.push(combId);});return Object.assign({},result);}

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBuggingChanges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_numbers_helper_js__ = __webpack_require__(26);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function getBuggingChanges(action,combatantMap,currentCombatantStateChanges,combatantModels){//Set up for modification
var changes=Object.assign({},currentCombatantStateChanges);if(action.sabotageItemQuantity===1){//Find the targets that have non-bugged items
var targetModelsWithItems=combatantMap.targetIds.map(function(combId){return combatantModels[combId];//get model
}).filter(function(combModel){//Only include targets that have Buggable items that have not been Bugged yet
var nonBuggedItems=(combModel.items||[]).filter(function(item){return!item.isBugged;});return nonBuggedItems.length;});var singleTarget=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__["a" /* randomFromArray */])(targetModelsWithItems);//Take one enemy that has items
var indexToBug=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_numbers_helper_js__["c" /* getRandomInRange */])(0,singleTarget.items.length-1);//Create a new version of items for this singleCombatant that includes the isBugged flag on chosen index
var updatedSingleTargetItems=singleTarget.items.map(function(item,index){if(index===indexToBug){return Object.assign({},item,{isBugged:true});}return item;});changes.state[singleTarget.id].items=[].concat(_toConsumableArray(updatedSingleTargetItems));//For Reporting:
changes.description["buggedItems"]=[Object.assign({},updatedSingleTargetItems[indexToBug])//Can only bug one item right now. In the future, include any of them that may have been bugged!
];}return changes;}

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCommitRevertStashChanges;
function getCommitRevertStashChanges(action,combatantMap,currentCombatantStateChanges,combatantModels){//Copy the changes.
var changes=Object.assign({},currentCombatantStateChanges);var casterModel=combatantModels[combatantMap.casterId];//const targetModels = combatantMap.targetIds.map(targetId => { return combatantModels[targetId] });
//Commit
if(action.changeCasterCommittedData){//Get all combatant hp and pp.
var committedData={};Object.keys(combatantModels).forEach(function(combatantId){var model=combatantModels[combatantId];committedData[combatantId]={hp:model.hp,//pp: model.pp, //TODO: Not sure about PP yet. Should that be part of a commit?
status:model.status};});//Set the committed data on this combatant model:
changes.state[combatantMap.casterId].committedTurnData=committedData;}//Revert
if(action.useCasterCommittedData){var _committedData=Object.assign({},casterModel.committedTurnData);//Load combatants
Object.keys(_committedData).forEach(function(combatantKey){if(changes.state[combatantKey]&&_committedData[combatantKey]){//This person may be dead, so check that they are sill valid
changes.state[combatantKey].hp=_committedData[combatantKey].hp;//changes.state[combatantKey].pp = committedData[combatantKey].pp;
changes.state[combatantKey].status=_committedData[combatantKey].status;}});//Then clear out caster's commit
changes.state[combatantMap.casterId].committedTurnData=false;//because Firebase will eat it
}//Stash
if(action.clearTargetCommittedData){//Turn the target's `committedTurnData` to false
combatantMap.targetIds.forEach(function(targetId){changes.state[targetId].committedTurnData=false;//because Firebase will eat it
});}return changes;}

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDangerMeterChanges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_get_value_ceiling_js__ = __webpack_require__(91);
//Danger Meter
function getDangerMeterChanges(action,combatantMap,currentCombatantStateChanges,combatantModels){//Copy the changes.
var changes=Object.assign({},currentCombatantStateChanges);//Use up the Danger Meter if this is a SUPER attack!
if(action.isSuper){changes.state[combatantMap.casterId].dangerMeter=0;return changes;//stop here!
}if(action.actionMeta.isBugged){//Stop here. Danger Item is bugged (this one is BEFORE the true Bugging check, so it's weird.)
return changes;//stop here!
}//Boost Danger Meter for USING a move (not an explicit Danger Meter boosting action)
if(action.increaseDangerMeterOnUse>0){var casterModel=combatantModels[combatantMap.casterId];//Apply the new value to state
changes.state[combatantMap.casterId].dangerMeter=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_get_value_ceiling_js__["a" /* getValueCeiling */])(casterModel.dangerMeter+action.increaseDangerMeterOnUse,100);//max Danger Meter at 100;
}//Explicit Danger Meter boosting action (EX: danger boost item)
if(action.affectTargetDangerMeter>0){combatantMap.targetIds.forEach(function(targetId){var targetModel=combatantModels[targetId];//Apply the new value to target
changes.state[targetId].dangerMeter=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_get_value_ceiling_js__["a" /* getValueCeiling */])(targetModel.dangerMeter+action.affectTargetDangerMeter,100);//max Danger Meter at 100;
});}return changes;}

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFail;
function getFail(action,combatantMap,currentCombatantStateChanges,combatantModels){//Copy the changes.
var changes=Object.assign({},currentCombatantStateChanges);var casterModel=combatantModels[combatantMap.casterId];var targetModels=combatantMap.targetIds.map(function(combId){return combatantModels[combId];});//Add stuff to the changes
if(action.shouldFail(action,casterModel,targetModels)){changes["didFail"]=true;}//Auto fail if empty targetModels array
if(targetModels.length===0){//Targets are filtered for only alive, only dead etc. Sometimes an empty targets array can end up slip through the cracks.
//If that happens, this move should auto fail.
//console.log('auto failing because of empty targetModels array', action.name)
changes["didFail"]=true;}return changes;}

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFollowupsChanges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_numbers_helper_js__ = __webpack_require__(26);
function getFollowupsChanges(action,combatantMap,currentCombatantStateChanges,combatantModels){//Copy the changes.
var changes=Object.assign({},currentCombatantStateChanges);var casterModel=combatantModels[combatantMap.casterId];var targetModels=combatantMap.targetIds.map(function(targetId){return combatantModels[targetId];});//Convert followup actions into Followup Models
// { actionId, casterId, [targetIds, turnCount }
var followupActions=action.getFollowupActions(action,casterModel,targetModels).map(function(followupModel){var turnsToWait=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_numbers_helper_js__["c" /* getRandomInRange */])(followupModel.turnRange[0],followupModel.turnRange[1]);return Object.assign({},followupModel.action,{turnsToWait:turnsToWait});});//Include followup actions (or empty array if we don't have any followups to add)
changes.description["followupActions"]=followupActions||[];return changes;}

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getHpChanges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_get_value_ceiling_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_numbers_helper_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_random_from_array_js__ = __webpack_require__(10);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function getHpChanges(action,combatantMap,currentCombatantStateChanges,combatantModels){//Copy the changes.
var changes=Object.assign({},currentCombatantStateChanges);var casterModel=combatantModels[combatantMap.casterId];//Remember, recover items have Caster as the Target too, and the Target is what we're looking at.
//Haven't needed to truly affect Caster HP yet (would be for a blowback kind of move)
//Static 1 hit
if(action.affectTargetHpPoints!==0){//Possibly narrow an array of targets down to 1 random one (EX: Promise)
var targetIds=[].concat(_toConsumableArray(combatantMap.targetIds));if(action.selectRandomTargetForSingleHit){targetIds=[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_random_from_array_js__["a" /* randomFromArray */])(targetIds)];//Turn array of many into array of 1.
}targetIds.forEach(function(targetId){var targetModel=combatantModels[targetId];var isHealing=action.affectTargetHpPoints>0;var damageAdjustment=isHealing?//Provide the healing value, but no more than the target's max recovery amount
// EX: maxHp - current hp. EX: max 50 - now 48, can only recover 2 hp.
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_get_value_ceiling_js__["a" /* getValueCeiling */])(action.affectTargetHpPoints,targetModel.maxHp-targetModel.hp)://If this is an attack, use the attack calc
casterModel.getAttackCalc(action.affectTargetHpPoints,targetModel,action.statusMultiplier,action.actionMeta.hasTimedHitBonus,action.bypassCasterAttackStats);changes.state[targetId].hp=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_get_value_ceiling_js__["a" /* getValueCeiling */])(targetModel.hp+damageAdjustment,targetModel.maxHp);//New damage value. damageAdjustment is NEGATIVE for losing HP
//Document the diff
changes.description.hpDamage=changes.description.hpDamage||{};changes.description.hpDamage[targetId]=damageAdjustment;//Note, this doesn't account for ceiling value.
// EX: 45 hp recover +20, max at 50 HP. This will report 20, not 5.
});}//Repetitions
if(action.affectTargetHpPointsInRepetitions){//Model looks like this: {min:1, max: 4, affectTargetHpPoints: -4}
var repetitionModel=action.affectTargetHpPointsInRepetitions;var iterationCount=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_numbers_helper_js__["c" /* getRandomInRange */])(repetitionModel.min,repetitionModel.max);//Build up an object that contains each Hit on individual targets
var targetsDamageTracker={};for(var i=1;i<=iterationCount;i++){var targetModel=combatantModels[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_random_from_array_js__["a" /* randomFromArray */])(combatantMap.targetIds)];//For each iteration, get a random target
//Single-opponents will always be the same, but at least this opens the door to multi target iterations
targetsDamageTracker[targetModel.id]=targetsDamageTracker[targetModel.id]||[];targetsDamageTracker[targetModel.id].push({hpAdjustment:casterModel.getRepetitionHitCalc(repetitionModel.affectTargetHpPoints),//TODO: use a calculation function here
order:i,combatantId:targetModel.id//This will help give an interface for ordering the animation
});}//Save the hit tracking object to the description object
changes.description.targetsDamageTracker=targetsDamageTracker;//Deliver the final values of new HP
Object.keys(targetsDamageTracker).forEach(function(targetId){var targetModel=combatantModels[targetId];var totalDamage=targetsDamageTracker[targetId].map(function(iteration){return iteration.hpAdjustment;}).reduce(function(a,b){return a+b;});//Note that we're assuming this is the only type of HP damage this action will do. It's wiping out whatever this target's new HP was. (if it existed)
//No Actions use both yet (if ever), so we're cool for now. In the future, may need to check what `changes.state[targetId].hp` is first before setting
changes.state[targetId].hp=targetModel.hp+totalDamage;//Track the hpDamage changes for description object
changes.description.hpDamage=changes.description.hpDamage||{};changes.description.hpDamage[targetId]=totalDamage;});}//Percentages
if(action.affectTargetHpPointsByPercent!==0){combatantMap.targetIds.forEach(function(targetId){var targetModel=combatantModels[targetId];var damageAdjustment=Math.round(action.affectTargetHpPointsByPercent*targetModel.maxHp);//Percent is 0.15, 0.5, -0.75 etc
var targetHp=targetModel.hp>0?targetModel.hp:0;//Don't start with a negative number if recovering
changes.state[targetId].hp=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_get_value_ceiling_js__["a" /* getValueCeiling */])(targetHp+damageAdjustment,targetModel.maxHp);//Document the diff
changes.description.hpDamage=changes.description.hpDamage||{};changes.description.hpDamage[targetId]=damageAdjustment;//Same deal.. this will report the wanted change, ignores ceiling values
});}return changes;}

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getItemChanges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__team_utilities_js__ = __webpack_require__(40);
function getItemChanges(action,combatantMap,currentCombatantStateChanges,combatantModels){//Set up for modification
var changes=Object.assign({},currentCombatantStateChanges);var casterModel=combatantModels[combatantMap.casterId];if(action.isItem){//Find the person who owned this item and remove it from his/her inventory
//If "use teammate items" is active (which is always, at the moment) you can use a teammate's item
//That's why we don't assume it's the caster.
if(action.actionMeta.instanceId){var teamModels=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__team_utilities_js__["a" /* getAllTeammateModels */])(casterModel,combatantModels);var itemOwnerModel=teamModels.filter(function(combModel){return combModel.items.find(function(item){return item.instanceId===action.actionMeta.instanceId;});})[0];var updatedItemOwnerItems=itemOwnerModel.items.filter(function(item){return item.instanceId!==action.actionMeta.instanceId;});var existingOwnerChanges=changes.state[itemOwnerModel.id]||{};changes.state[itemOwnerModel.id]=Object.assign({},existingOwnerChanges,{items:updatedItemOwnerItems.length?updatedItemOwnerItems:false//use Boolean to protect from Firebase eating
});//Check if this ITEM was bugged. If so, set a flag (similar to Fail) that will bypass state operations.
if(action.actionMeta.isBugged){changes["wasBugged"]=true;}}else{console.warn('no instanceId found in item submission',action);}}return changes;}

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMiss;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_numbers_helper_js__ = __webpack_require__(26);
function getMiss(action,combatantMap,currentCombatantStateChanges,combatantModels){//Copy the changes.
var changes=Object.assign({},currentCombatantStateChanges);//Bail out of accuracy roll if this action can't miss
if(!action.canMiss){return changes;}var casterModel=combatantModels[combatantMap.casterId];var accuracyChance=casterModel.getTotalAccuracy(action);//number
var didSucceed=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_numbers_helper_js__["b" /* percentChance */])(accuracyChance);//Add stuff to the changes
if(!didSucceed){//console.log(`missed with ${accuracyChance}% chance`)
changes["didMiss"]=true;}return changes;}

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPpChanges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_get_value_ceiling_js__ = __webpack_require__(91);
function getPpChanges(action,combatantMap,currentCombatantStateChanges,combatantModels){//Copy the changes.
var changes=Object.assign({},currentCombatantStateChanges);//Add stuff to the changes
if(action.ppCost>0){var casterModel=combatantModels[combatantMap.casterId];//Apply the new value to state
changes.state[combatantMap.casterId].pp=casterModel.pp-action.ppCost;}//PP Increase (Ex: Mini PP Pack. Note: This would wipe out any changes from ppCost^^)
if(action.affectTargetPpPoints!==0){combatantMap.targetIds.forEach(function(targetId){var targetModel=combatantModels[targetId];var initialPpValue=targetModel.pp;var newPpValue=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_get_value_ceiling_js__["a" /* getValueCeiling */])(initialPpValue+action.affectTargetPpPoints,targetModel.maxPp);//Set the new PP value
changes.state[combatantMap.casterId].pp=newPpValue;//Track the change from Old to New
changes.description.ppDiff=changes.description.ppDiff||{};changes.description.ppDiff[targetId]=newPpValue-initialPpValue;});}return changes;}

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStatChanges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_numbers_helper_js__ = __webpack_require__(26);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function getStatChanges(action,combatantMap,currentCombatantStateChanges,combatantModels){//Copy the changes.
var changes=Object.assign({},currentCombatantStateChanges);//Attack modifier up or down
//TODO: no support for percentChance yet for attackModifier... but see Defense for reference.
//It should work the exact same way.
if(action.affectTargetAttackModifier!==0){combatantMap.targetIds.forEach(function(targetId){var targetModel=combatantModels[targetId];changes.state[targetId].attackModifier=targetModel.attackModifier+action.affectTargetAttackModifier;//TODO: Perhaps might need valueCeiling to prevent player from boosting too high?
//Alternatively, the action could fail if stat is already higher than a certain %.
//For now, let's just let it fly...
});}//Defense modifier up or down
var affectTargetDefenseModifier=action.affectTargetDefenseModifier;affectTargetDefenseModifier=(typeof affectTargetDefenseModifier==="undefined"?"undefined":_typeof(affectTargetDefenseModifier))==="object"?//percentChance object support
extractValueFromChanceObject(affectTargetDefenseModifier):affectTargetDefenseModifier;if(affectTargetDefenseModifier!==0){combatantMap.targetIds.forEach(function(targetId){var targetModel=combatantModels[targetId];changes.state[targetId].defenseModifier=targetModel.defenseModifier+affectTargetDefenseModifier;//Document the diff
changes.description.defenseChange=changes.description.defenseChange||{};changes.description.defenseChange[targetId]=affectTargetDefenseModifier;//Document this so we can message it to players
});}//Speed modifier up or down
if(action.affectTargetSpeedModifier!==0){combatantMap.targetIds.forEach(function(targetId){var targetModel=combatantModels[targetId];changes.state[targetId].speedModifier=targetModel.speedModifier+action.affectTargetSpeedModifier;});}//Accuracy Modifier up or down
if(action.affectTargetAccuracyModifier!==0){combatantMap.targetIds.forEach(function(targetId){var targetModel=combatantModels[targetId];changes.state[targetId].accuracyModifier=targetModel.accuracyModifier+action.affectTargetAccuracyModifier;});}//Not capturing delta diffs at the moment for stats.. only the new values
return changes;}/** Specific type of object that provides a value and a percentChance. Roll if the output should be the value or 0 */function extractValueFromChanceObject(chanceObj){var defaultValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_numbers_helper_js__["b" /* percentChance */])(chanceObj.percentChance)){return chanceObj.value;}return defaultValue;}

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStatusChanges;
function getStatusChanges(action,combatantMap,currentCombatantStateChanges,combatantModels){//Copy the changes.
var changes=Object.assign({},currentCombatantStateChanges);if(action.affectCasterStatus&&Array.isArray(action.affectCasterStatus)){//There is only one casterId in combatantMap, so no need for a loop
var casterModel=combatantModels[combatantMap.casterId];if(casterModel.status===action.affectCasterStatus[0]||action.affectCasterStatus[0]==="*"){var existingChanges=changes.state[combatantMap.casterId]||{};changes.state[combatantMap.casterId]=Object.assign({},existingChanges,{status:action.affectCasterStatus[1]//set status to "to" value in array
});}}if(action.affectTargetStatus&&Array.isArray(action.affectTargetStatus)){combatantMap.targetIds.forEach(function(targetId){//Get a model of this target. (within the loop of all selected targets)
var targetModel=combatantModels[targetId];//Validate that targetModel's status is specified as the "from" in the Action... or that the action accepts any status ("*")
if(targetModel.status===action.affectTargetStatus[0]||action.affectTargetStatus[0]==="*"){var _existingChanges=changes.state[targetId]||{};changes.state[targetId]=Object.assign({},_existingChanges,{status:action.affectTargetStatus[1]//set status to "to" value in array
});}});}//Reset status to NORMAL when dead
//Loop through changes and Set status to NORMAL if HP is <= 0
Object.keys(changes.state).forEach(function(combKey){var model=changes.state[combKey];if(model.hp<=0){changes.state[combKey].status="normal";}});return changes;}

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStealingChanges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__battle_data_battle_actions_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_listing_text_helper_js__ = __webpack_require__(393);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function getStealingChanges(action,combatantMap,currentCombatantStateChanges,combatantModels){//Set up for modification
var changes=Object.assign({},currentCombatantStateChanges);//Remember, at this point in the DescriptionCycle, we know the attack has not failed.
//Therefore, we can assume that the enemy has items.
if(action.theftQuantity>0||action.deleteItemQuantity>0){var casterModel=combatantModels[combatantMap.casterId];var targetModels=combatantMap.targetIds.map(function(combId){return combatantModels[combId];});//Construct a list of Target Team models with references back to the individual owner
var targetItemModels=[];targetModels.forEach(function(targetModel){targetModel.items.forEach(function(itemModel){targetItemModels.push({model:itemModel,belongsToCombatantId:targetModel.id});});});//Decide which quantity to use (will only be one or the other.)
//Both would be a config error.
var quantity=action.theftQuantity>0?action.theftQuantity:action.deleteItemQuantity;//Note^^ This is pretty coupled to TWO possible options. If a third option is ever present here, may need to rework this.
//Gather up the item(s) that we're stealing (or deleting)
var stolenItems=[];__WEBPACK_IMPORTED_MODULE_1_lodash_range___default()(quantity).forEach(function(){var stolenItem=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_random_from_array_js__["a" /* randomFromArray */])(targetItemModels);if(stolenItem){targetItemModels=targetItemModels.filter(function(itemModel){return itemModel.model.instanceId!==stolenItem.model.instanceId;});stolenItems.push(stolenItem);}});//If we're in "stealing" mode (not deleting), add these stolen items to our Caster
if(action.theftQuantity>0){//Apply these items to the caster.
var existingCasterStateChanges=changes.state[combatantMap.casterId]||{};changes.state[combatantMap.casterId]=Object.assign({},existingCasterStateChanges,{items:[].concat(_toConsumableArray(casterModel.items),_toConsumableArray(stolenItems.map(function(itemModelWithRef){return Object.assign({},itemModelWithRef.model,{//Shave off the `belongsToCombatantId part`
isStolen:true,//Note that this item is now stolen
isBugged:false//Clear any bug status that this item has
});})))});}//Remove each stolenItem from original owner.
stolenItems.forEach(function(stolenItemModel){var ownerCombModel=combatantModels[stolenItemModel.belongsToCombatantId];//Filter out stolen item from owner's list of items.
var items=changes.state[stolenItemModel.belongsToCombatantId].items||ownerCombModel.items;//check for existing items in changes first
var updatedOwnerItems=items.filter(function(inventoryItemModel){return stolenItemModel.model.instanceId!==inventoryItemModel.instanceId;});//Apply reduced items list to owner
var existingOwnerChanges=changes.state[stolenItemModel.belongsToCombatantId];changes.state[stolenItemModel.belongsToCombatantId]=Object.assign({},existingOwnerChanges,{items:updatedOwnerItems.length?updatedOwnerItems:false//stub `false` for empty array because of silly Firebase.
});});//Create the keys for our description object. Note that we're still pretty married to only two cases here: theftQuantity or deleting
var affectedItemIdsKeyName=action.theftQuantity>0?"stolenItemIds":"deletedItemIds";var affectedItemFriendlyTextKeyName=action.theftQuantity>0?"stolenItemsFriendlyText":"deletedItemsFriendlyText";//Mark the stolenIds. These are used for Reporting!
changes.description[affectedItemIdsKeyName]=stolenItems.map(function(item){return item.model.actionId;});//Create the human readable item text for the Rollout.
changes.description[affectedItemFriendlyTextKeyName]=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_listing_text_helper_js__["a" /* default */])(stolenItems.map(function(item){return item.model.actionId;}).map(function(actionId){return __WEBPACK_IMPORTED_MODULE_2__battle_data_battle_actions_js__["a" /* default */][actionId].name;}));//Add itemModel data if this was a stealAndUse kind of action
if(action.stealAndUseItem){changes.description["stealAndUseItems"]=[].concat(_toConsumableArray(stolenItems.map(function(itemModelWithRef){return Object.assign({},itemModelWithRef.model);}//Shave off the `belongsToCombatantId part`
)));}}return changes;}

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUpdatedCombatantStateFromDescriptionMerge;
/** Take in current combatant state and changes from  */function getUpdatedCombatantStateFromDescriptionMerge(){var currentCombatants=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var descriptionCombatants=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var payload=Object.assign({},currentCombatants);Object.keys(descriptionCombatants).forEach(function(combId){payload[combId]=Object.assign({},payload[combId],descriptionCombatants[combId]);});return payload;}

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOrderedActionsFromSubmissions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_models_from_object_js__ = __webpack_require__(18);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}//Take in combatants and get back the order for this series.
function getOrderedActionsFromSubmissions(){var combatantModels=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var sortedIds=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_models_from_object_js__["a" /* modelsFromObject */])(combatantModels).map(function(combatantModel){//Get speed rating + little random decimal for ordering ties.
//const speedRating = combatantModel.getTotalSpeed() + parseFloat(Math.random().toFixed(1));
var speedRating=combatantModel.getTotalSpeed();//No tie breaker
return{_id:combatantModel._id,speedRating:speedRating};}).sort(function(a,b){//Sort the array by calculated speedRating
return a.speedRating<b.speedRating?1:-1;}).map(function(sorted){return sorted._id;});//Return the sorted IDs in order.
//Add in initial deadlines
return sortedIds.map(function(id){var combatantModel=combatantModels[id];if(combatantModel.status==="deadline"){return[id,"deadline::"+id];}return[id];}).reduce(function(a,b){return[].concat(_toConsumableArray(a),_toConsumableArray(b));});}

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getReplacedAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__battle_data_battle_actions_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_numbers_helper_js__ = __webpack_require__(26);
/** Potentially replace inputted action with other action based on casterModel state */function getReplacedAction(actionModel,casterModel){//Check that this action is safe from being replaced
if(!actionModel.canBeReplaced){/*
         Examples:
         - recovering from lag: "natural_recover-lag"
         //Item
         //death
         //"clean" status clearing type of moves
         //recovering-from-lag
         */return actionModel;}//Replacement possibilities
if(casterModel.status==="lag"&&!actionModel.isImmuneFromLag){//Roll the dice using the caster's probability rating (higher number = more likely to lag out)
if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_numbers_helper_js__["b" /* percentChance */])(casterModel.getLaggingProbability())){return Object.assign({id:"natural_lag"},__WEBPACK_IMPORTED_MODULE_0__battle_data_battle_actions_js__["a" /* default */]["natural_lag"]);}//If we survived the probability, return the initial action as intended
//Note: `get-rollout` will prepend a "Caster is lagging..." message to the rollout.
return actionModel;}//Default to the original actionModel
return actionModel;}//From b4:
/*
 if ([
 "natural-death-a",
 "attack-008-a-resolve", //promise resolve
 "attack-special-006-a", //"clean" status back to normal
 "natural-recover-lag",
 ].indexOf(originalActionId) > -1) {
 return originalActionId;
 }

 ...

 if (casterModel.status == "lag" && actionModel.type != "Item") {
 return "natural-lag-a";
 }

 */

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getRollout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_combatants_state_change__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloud_queue_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_rollout_message_text_helpers_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__get_dead_teams__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__get_description_object__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__battle_data_battle_actions_js__ = __webpack_require__(14);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/** Return array of step models */function getRollout(actionModel,casterModel,targetModels,descriptionObject){//I want to reword this to `submittedActionModel`, because the output may have more than 1 action depending on PRE/POST/NATURAL adds.
//Get Submission result messages
var messageSteps=[];if(descriptionObject.didFail){messageSteps=actionModel.getFailStep(actionModel,casterModel,targetModels,descriptionObject);}if(descriptionObject.didMiss){messageSteps=actionModel.getMissStep(actionModel,casterModel,targetModels,descriptionObject);}if(descriptionObject.wasBugged){messageSteps=actionModel.getBuggedStep(actionModel,casterModel,targetModels,descriptionObject);}if(!descriptionObject.didFail&&!descriptionObject.didMiss&&!descriptionObject.wasBugged){messageSteps=actionModel.getSuccessStep(actionModel,casterModel,targetModels,descriptionObject);}//Prepend the lagging message. (NOTE: at this point, the attack is already successful. We just want to add the messaging)
//TODO: this particular part could be extracted to it's own function, but I think it's okay right here
if(casterModel.status==="lag"&&!actionModel.isItem&&!actionModel.isNatural){// console.log(actionModel)
messageSteps=[{type:"message",content:[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_rollout_message_text_helpers_js__["a" /* getColoredNameById */])(casterModel.id),'\'s connection is laggy...']}].concat(_toConsumableArray(messageSteps));}///
//Steps from main action.
var stepsFromSubmittedAction=[].concat(_toConsumableArray(messageSteps),[{type:"stateChange",newCombatantState:descriptionObject.state,description:descriptionObject.description||{}}]);//Now lets get the "post" steps.....
//Figure out what the state is after the main attack's description object
var combatants=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_combatants_state_change__["a" /* getUpdatedCombatantStateFromDescriptionMerge */])(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.combatants,descriptionObject.state);var casterModelId=casterModel.id;var targetIds=targetModels.map(function(targetModel){return targetModel.id;});//Get next possible Post steps by using newCombatantState from previous possible post thing (TODO: can we make this code prettier?)
//We have to do this: `combatants[casterModelId]` to make sure we're passing the most up to date casterModel.
//Check if target(s) died from my Submitted Action
var targetDieResultModel=getDieResultModel(targetIds.map(function(targetId){return combatants[targetId];}),combatants,actionModel);//Get results from Steal-And-Use if relevant
var stealAndUseResultModel=getStealAndUseResultModel(combatants[casterModelId],combatants,descriptionObject);//Update combatants with output of getStealAndUseResultModel
combatants=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_combatants_state_change__["a" /* getUpdatedCombatantStateFromDescriptionMerge */])(combatants,stealAndUseResultModel.newCombatantState);//Get memory leak steps by using the simulated version of `combatants` after the first action has been applied.
var memLeakResultModel=getMemoryLeakSteps(combatants[casterModelId],combatants);//Update combatants with output of memLeakSteps
combatants=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_combatants_state_change__["a" /* getUpdatedCombatantStateFromDescriptionMerge */])(combatants,memLeakResultModel.newCombatantState);//Check if the caster died from post things
var casterDieResultModel=actionModel.ignoreCasterDieResult?//Actions (like promise_resolve) may choose to ignore announcing the caster is dead
{steps:[],newCombatantState:Object.assign({},combatants)//If we're opting out of this message, just supply a vanilla step in the chain with no modifications
}:getDieResultModel([combatants[casterModelId]],combatants,actionModel);//Otherwise, pipe through the death catcher
/** Provide updated cloudQueue at the end of the rollout with future queued actions */var cloudQueuePayload=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.cloudQueue));//Start with initial cloudQueueue
//For each followup, generate the new queue
(descriptionObject.description.followupActions||[]).forEach(function(followupAction){var action={sortBeforeCombatant:followupAction.casterId,actionId:followupAction.id,casterId:followupAction.casterId,target:followupAction.targetIds};cloudQueuePayload=[].concat(_toConsumableArray(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cloud_queue_js__["c" /* addQueuedSubmissions */])(cloudQueuePayload,action,followupAction.turnsToWait)));});var cloudQueueStep={type:"cloudQueue",payload:[].concat(_toConsumableArray(cloudQueuePayload))};return[].concat(_toConsumableArray(stepsFromSubmittedAction),_toConsumableArray(stealAndUseResultModel.steps),_toConsumableArray(targetDieResultModel.steps),_toConsumableArray(memLeakResultModel.steps),_toConsumableArray(casterDieResultModel.steps),[//only checks if the caster was defeated
//Include latest cloudQueue, because I may have added future actions.
cloudQueueStep]);}/* If this steal-and-use key exists, get result model */function getStealAndUseResultModel(casterModel,combatants){var currentDescObj=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};if(currentDescObj&&currentDescObj.description.stealAndUseItems){var itemAction=currentDescObj.description.stealAndUseItems[0];//Limiting this to 1 steal and use.
//If stealing/using more than 1 item is a thing in the future, feel free to revisit this :) Just need to return more steps
//Copied from Natural helper below. Didn't think it was safe to couple them yet in case something has to change
var actionModel=Object.assign({id:itemAction.actionId},__WEBPACK_IMPORTED_MODULE_6__battle_data_battle_actions_js__["a" /* default */][itemAction.actionId],{actionMeta:Object.assign({},itemAction)//need instanceId to use an item
});//Get a description object for this guy
var descriptionObject=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__get_description_object__["a" /* getDescriptionObjectFromSubmission */])(actionModel,casterModel,[casterModel],combatants);//Create success step
var successStep=actionModel.getSuccessStep(actionModel,casterModel,[casterModel],descriptionObject);//Create fail step
var failStep=actionModel.getFailStep(actionModel,casterModel,[casterModel],descriptionObject);//Determine which steps to use
var useSteps=descriptionObject.didFail?failStep:successStep;return{steps:[].concat(_toConsumableArray(useSteps),[//animation step?
{type:"stateChange",newCombatantState:descriptionObject.state,description:descriptionObject.description||{}}]),newCombatantState:descriptionObject.state};}//If not a steal-and-use thing, just default to this:
return{steps:[],newCombatantState:combatants};}function getMemoryLeakSteps(casterModel,combatants){//Stop here if the battle is over... no extra rollout steps to be added
if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__get_dead_teams__["c" /* isBattleOver */])(combatants)){return{steps:[],newCombatantState:combatants};}//If Caster has memory leak or fire, tack on the extra rollout steps
if(casterModel.status==="memory-leak"){return getNaturalActionResultModel("natural_hurt-by-memory-leak",casterModel,combatants);}if(casterModel.status==="fire"){return getNaturalActionResultModel("natural_hurt-by-fire",casterModel,combatants);}//Caster is not memory-leaking
//Default: return 0 steps and the same state as before
return{steps:[],newCombatantState:combatants};}/**
 "Result Model"
 {
   steps: [], //StepModels
   newCombatantState: [], //new properties in combatants (not always full combatant models)
 }
 */function getDieResultModel(){var combatantModels=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var combatants=arguments[1];var actionModel=arguments[2];var steps=[];var newCombatantState=Object.assign({},combatants);combatantModels.filter(function(model){//If this action ignores death message, just return false.
if(actionModel.ignoreTargetDieResult){return false;}return!model.isAlive();//Only return TRUE for combatants who are dead
}).forEach(function(model){var natural=getNaturalActionResultModel("natural_die",model,combatants);steps=[].concat(_toConsumableArray(steps),_toConsumableArray(natural.steps));newCombatantState=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_combatants_state_change__["a" /* getUpdatedCombatantStateFromDescriptionMerge */])(newCombatantState,natural.newCombatantState);});return{steps:steps,newCombatantState:newCombatantState};}/** Get the RolloutSteps for any natural action. (builds in the actionId/Caster/Target stuff) *///`getNaturalActionResultModel`
function getNaturalActionResultModel(){var actionId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var casterModel=arguments[1];var combatants=arguments[2];var actionModel=__WEBPACK_IMPORTED_MODULE_6__battle_data_battle_actions_js__["a" /* default */][actionId];//Get a description object for this guy
var descriptionObject=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__get_description_object__["a" /* getDescriptionObjectFromSubmission */])(actionModel,casterModel,[casterModel],combatants);//Create success step
var successStep=actionModel.getSuccessStep(actionModel,casterModel,[casterModel],descriptionObject);//Can this pattern be part of the action model? Like a function that gets the arrangement of the array?
//That way some actions could customize it?
return{steps:[].concat(_toConsumableArray(successStep),[//Might need an animation step {} here
{type:"stateChange",newCombatantState:descriptionObject.state,description:descriptionObject.description||{}}]),newCombatantState:descriptionObject.state};}

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUpdatedQueueWithDeadline;
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}//This function is for adding in deadline:: to the queue DURING A TURN that a deadline is set.
//Start Turn Series already provides known deadlines at the beginning of a turn.
function getUpdatedQueueWithDeadline(){var currentQueue=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var combatantSelectingAction=arguments[1];var combatants=arguments[2];if(!currentQueue.length){return[];//Fallback incase our queue is not populated yet
}//Return a copy of the list with deadlines in place (will replace any already known deadline entries)
return currentQueue.map(function(id){var combatantModel=combatants[id];if(id.match(/^deadline::/)){return null;//Take this instance of deadline out. Don't worry! We will replace it.
}if(!combatantModel){//Probably from the cloudQueue. Just return this one.
return[id];}if(combatantModel.status==="deadline"){return[id,//If we have a deadline, provide both my ID and then my deadline turn
"deadline::"+id];}return[id];}).filter(function(d){return Boolean(d);}).reduce(function(a,b){//Remove any null values and return 1 array
return[].concat(_toConsumableArray(a),_toConsumableArray(b));});}

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleSeenRollout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__connection_firebase_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__start_turn_series_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__offline_offline_check_for_auto_submissions_js__ = __webpack_require__(90);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/** Do something once the current rollout has been SEEN and state changes APPLIED */function handleSeenRollout(){//Get the person who submitted this so we can add to our list of 'seriesTurnsSubmitters'
var lastSubmitterId=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.rolloutHistory[0].submitterCombatantId;//Clear the arena view submission menu (for Arena view)
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions_js__["a" /* setBattleValue */])({arenaIsRolloutShowing:false,arenaSubmissionMenuAction:null,arenaSubmissionMenuTargets:null,arenaSubmissionIsSubmitted:false,//Record the person that submitted this (so we can visualize)
seriesTurnsSubmitters:[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.seriesTurnsSubmitters),[lastSubmitterId])});//Case 1: Multiplayer!
if(__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.isMultiplayerMode){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__connection_firebase_js__["e" /* sendViewConfirmationToServer */])();}else{//Case 2: Offline play!
var nextBattleState=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__start_turn_series_js__["b" /* getUpdatedBattleState */])();//Get the next state
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__redux_actions_battle_actions_js__["a" /* setBattleValue */])(Object.assign({},nextBattleState));//Check for offlineBot submission
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__offline_offline_check_for_auto_submissions_js__["a" /* offlineCheckForAutoSubmission */])();//This will select for an offline bot if we're waiting on somebody.
}}

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleStateChange;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__connection_firebase_safe_js__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handle_new_rollout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__run_ease_out__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__audio_audio_manager_js__ = __webpack_require__(8);
function handleStateChange(currentStep){var newCombatantState=currentStep.newCombatantState||{};var description=currentStep.description||{};//Fires when all graduals are completed (or no graduals are required)
function completeStateChange(){//Firebase eats this if it's empty, so provide fallback empty object.
Object.keys(newCombatantState||{}).forEach(function(combatantId){//Convert "firebase safe" values back to actual falsy values that our app needs.
//I know this is Firebase specific, but it's safe for the local-only play to run through also.
var safeFirebaseState=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__connection_firebase_safe_js__["a" /* decodeSafeFirebaseRolloutStateChange */])(newCombatantState[combatantId]);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(combatantId,Object.assign({},safeFirebaseState));});handleStateChangeFinished();}/** Skip the gradual stuff on Console and Reporting views */if(__WEBPACK_IMPORTED_MODULE_2__init_store_js__["a" /* default */].getState().battle.battleViewMode!=="arena"){completeStateChange();return;}//GRADUALS: //The only gradual change at the moment is HP values.
//For each HP change, need to kick off a loop (check for graduals)
if(description.hpDamage){//Create required count and progress count
var gradualHpChangeCountRequired=0;var gradualHpChangeCountCompleted=0;//Create HP Change loops for each affected combatant
Object.keys(description.hpDamage).forEach(function(combatantId){var change=description.hpDamage[combatantId];var wasValue=newCombatantState[combatantId].hp-change;//Supply the original "was" value (new value with offset change);
//Check that this state change has not been executed already
//Some moves run "stateChanges" throughout the rollout. If our state has already been rectified, we don't want to re-run these gradual changes.
//The end result would be the same, but you'd see the blinking and health bars depleting twice. (ending at the same point)
//...
//Verify that state has not changed yet, and we need to see the gradual animation
// TODO I'm having a hard time wrapping my head around these values after coming back from awhile, but the redux value being negative is causing the GradualHpChange to not be created.
//Floor this value at 0. If it's negative, it causes the animation to not fire.
var useHpValueFromReduxState=__WEBPACK_IMPORTED_MODULE_2__init_store_js__["a" /* default */].getState().battle.combatants[combatantId].hp;if(useHpValueFromReduxState<0){useHpValueFromReduxState=0;}//Create an HP Change if the current state value is still the wasValue. This means it hasn't transitioned to the new value.
if(useHpValueFromReduxState===wasValue){gradualHpChangeCountRequired++;//Increment the number of graduals we're waiting for
//Create a gradual HP change and wait for it to finish
new GradualHpChange(combatantId,function(){//Gradual change completed!
//increment number of completed graduals
gradualHpChangeCountCompleted++;//Check if we are through with all graduals
if(gradualHpChangeCountCompleted>=gradualHpChangeCountRequired){completeStateChange();}},wasValue,change);}});//In the case that all state changes have already been displayed, we might be waiting on 0 graduals, so just move on
if(gradualHpChangeCountRequired===0){//console.log('not waiting on any Gradual changes')
completeStateChange();}}else{//Not waiting on any graduals, so just go directly to conclusion
completeStateChange();}}function GradualHpChange(combatantId,callback,oldValue,change){//Start blinking the combatant if HP change is negative
if(change<0){//Play sound!
__WEBPACK_IMPORTED_MODULE_5__audio_audio_manager_js__["a" /* default */].playSfx("sfx_Babuhm");__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(combatantId,{animationCssRule:"blink 0.3s steps(2, start) infinite"});}function handleIteration(newValue){// console.log(newValue, combatantId);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(combatantId,{hp:newValue});}//Run the easing loop, then fire callback and remove blinking animation
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__run_ease_out__["a" /* runEaseOut */])(oldValue,change,100,handleIteration,function(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__["c" /* setCombatantValue */])(combatantId,{animationCssRule:"none"});callback();});}function handleStateChangeFinished(){__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__["a" /* setBattleValue */])({rolloutExecutingIndex:__WEBPACK_IMPORTED_MODULE_2__init_store_js__["a" /* default */].getState().battle.rolloutExecutingIndex+1});__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__handle_new_rollout__["b" /* handleRolloutStep */])();//move on to the next step
}

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasLoggedRolloutById;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
/** Return whether or not this rollout exists in my log */function hasLoggedRolloutById(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var currentRolloutHistory=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.rolloutHistory;return currentRolloutHistory.find(function(rollout){return rollout.rolloutId===id;});}

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isCloudActionRelevant;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloud_queue_encode_decode_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init_store_js__ = __webpack_require__(1);
function isCloudActionRelevant(turnQueueString){if(!turnQueueString.match(/cloudQueueAction/)){//Assume this move is relevant if it's not from the cloudQueue
return true;}//Get actionModel, casterModel, and targetModels
var cloudSubmission=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cloud_queue_encode_decode_js__["a" /* decodeCloudQueueActionString */])(turnQueueString,__WEBPACK_IMPORTED_MODULE_1__init_store_js__["a" /* default */].getState().battle.combatants);//Case 1: Natural status heal:
// Validate that the target is still suffering from the oncoming natural heal
if(cloudSubmission.actionModel.affectTargetStatus){var targetModel=cloudSubmission.targetModels[0];//Assume only 1 target for natural recoveries.
var naturalRecoveringStatus=cloudSubmission.actionModel.affectTargetStatus[0];if(targetModel.status!==naturalRecoveringStatus){// console.log('IRRELEVANT CLOUD RECOVERY');
return false;}}//Case 2: This combatant is dead! Who woulda thunk!
return true;}

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runEaseOut;
function easeOutCubic(currentIteration,startValue,changeInValue,totalIterations){return changeInValue*(Math.pow(currentIteration/totalIterations-1,3)+1)+startValue;}function runEaseOut(){var startValue=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var changeInStartValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var totalIterations=arguments.length>2&&arguments[2]!==undefined?arguments[2]:100;var iterationCallback=arguments[3];var doneCallback=arguments[4];var iteration=0;var value=0;var step=function step(){value=Math.round(easeOutCubic(iteration,startValue,changeInStartValue,totalIterations));iterationCallback(value);iteration+=1;if(iteration<totalIterations){requestAnimationFrame(step);}else{doneCallback();}};requestAnimationFrame(step);}

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getGrowthPatterns;
function grow(initialValue,growthPattern){var steps=[];var value=initialValue;var growthIndex=0;for(var i=1;i<=31;i++){if(i>1){value+=growthPattern[growthIndex];var nextIndex=growthIndex+1;growthIndex=growthPattern[nextIndex]?nextIndex:0;}steps.push(value);}return steps;}var Presets={"fastHp":[9,10,10],"standardHp":[9],"slowHp":[9,8,8],"fastStat":[3,3,3,2],"standardStat":[3,2],"slowStat":[2,2,2,3]};var growthPatterns={"dps":{hpGrowthPattern:grow(20,Presets.standardHp),ppGrowthPattern:grow(10,Presets.standardStat),atkGrowthPattern:grow(1,Presets.fastStat),spdGrowthPattern:grow(1,Presets.slowStat)},"disrupt":{hpGrowthPattern:grow(20,Presets.standardHp),ppGrowthPattern:grow(10,Presets.fastStat),atkGrowthPattern:grow(1,Presets.slowStat),spdGrowthPattern:grow(1,Presets.slowStat)},"support":{hpGrowthPattern:grow(20,Presets.fastHp),ppGrowthPattern:grow(10,Presets.standardStat),atkGrowthPattern:grow(1,Presets.slowStat),spdGrowthPattern:grow(1,Presets.standardStat)}};function getGrowthPatterns(className){if(!growthPatterns[className]){console.warn('className not found in `getGrowthPatterns`',className);}return growthPatterns[className];}

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = openWindowToReportingPage;
function openWindowToReportingPage(){var reports=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];//OLD:
// const CODEPEN_LINK = "http://codepen.io/punkydrewster713/debug/aab0bddb3c51f19dcb94cb6b1c4265be?editors=1010";
// const encodedString = encodeURIComponent( JSON.stringify(reports) );
//
// const url = `${CODEPEN_LINK}#reports=${encodedString}`;
// window.open(url,'_blank');
//NEW: (only 1 turnReporting)
var CODEPEN_LINK="https://codepen.io/punkydrewster713/pen/1ecb65050cb0be81ddfb7249a76a98df";var encodedString=encodeURIComponent(JSON.stringify(reports));var url=CODEPEN_LINK+"#reports="+encodedString;window.open(url,"_blank");}

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Fixture_combatants_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__run_full_battle_js__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_CombatantModel_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__open_window_to_reporting_page_js__ = __webpack_require__(377);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReportingRunner=function(_React$Component){_inherits(ReportingRunner,_React$Component);function ReportingRunner(){_classCallCheck(this,ReportingRunner);var _this=_possibleConstructorReturn(this,(ReportingRunner.__proto__||Object.getPrototypeOf(ReportingRunner)).call(this));_this.state={trialCount:3};_this.charConfigs=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1__Fixture_combatants_js__["b" /* sampleLoadouts */]));return _this;}_createClass(ReportingRunner,[{key:'handleChangeTrial',value:function handleChangeTrial(){this.setState({trialCount:parseInt(this.refs.trialSelectBox.value,10)});}},{key:'getTeamsFromSelectBoxes',value:function getTeamsFromSelectBoxes(){var _this2=this;function getTeamNumber(id){if(id.match(/^one/)){return"one";}if(id.match(/^two/)){return"two";}//leaving the door open for team three in the future
return null;}var combatants={};["oneA","oneB","oneC","twoA","twoB","twoC"].forEach(function(id){var teamId=getTeamNumber(id);var refValue=_this2.refs[id].value;if(refValue!=="none"&&teamId){var loadout=_this2.charConfigs.find(function(char){return char.name===refValue;});combatants[id]=new __WEBPACK_IMPORTED_MODULE_3__models_CombatantModel_js__["a" /* default */](Object.assign({},loadout,{wantsToJoinTeam:teamId}));}});return combatants;}},{key:'handleRunButton',value:function handleRunButton(){var _this3=this;var combatantData=this.getTeamsFromSelectBoxes();//console.log(combatantData);
var battleCount=0;var reports=[];var runOneBattle=function runOneBattle(){//This could be triggered by a button or something instead?
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__run_full_battle_js__["a" /* runFullBattle */])(combatantData,function(report){// console.log(report);
reports.push(report);battleCount++;//Run another battle
if(battleCount<_this3.state.trialCount){setTimeout(function(){runOneBattle();},100);//give browser a tiny bit of space to breathe. We could be doing 99+ battles here.
}else{//OR battles are done!
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__open_window_to_reporting_page_js__["a" /* openWindowToReportingPage */])(reports);console.log('done!!');}});};//Kickoff!
runOneBattle();}},{key:'renderTrialCountSelect',value:function renderTrialCountSelect(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{ref:'trialSelectBox',value:this.state.trialCount,onChange:this.handleChangeTrial.bind(this)},[1,3,9,17,99].map(function(value,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:value},value);}));}},{key:'renderSelectBox',value:function renderSelectBox(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{ref:id},this.charConfigs.map(function(charModel,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:charModel.name,key:i},charModel.name);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'none'},'(none)')));}},{key:'render',value:function render(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Team One:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,["oneA","oneB","oneC"].map(function(id){return _this4.renderSelectBox(id);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Team Two:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,["twoA","twoB","twoC"].map(function(id){return _this4.renderSelectBox(id);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.handleRunButton.bind(this)},'Run Battles'),this.renderTrialCountSelect()));}}]);return ReportingRunner;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ReportingRunner);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runFullBattle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lifecycle_start_turn_series_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__offline_offline_check_for_auto_submissions_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lifecycle_build_teams_from_combatant_data_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lifecycle_init_battle_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__analysis_get_battle_end_report_js__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__init_store_js__ = __webpack_require__(1);
function runFullBattle(battleCombatants,finalCallback){// FIRST, Reset the state so that we're clear for a fresh battle! ------------------------------------------
//Make sure all combatants are bots
Object.keys(battleCombatants).forEach(function(combId){battleCombatants[combId]=Object.assign({},battleCombatants[combId],{isBot:true});});//Build teams and set initial state for offline battle
var teams=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lifecycle_build_teams_from_combatant_data_js__["a" /* buildTeamsFromCombatantData */])(battleCombatants);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__["a" /* setBattleValue */])(Object.assign({},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lifecycle_init_battle_js__["a" /* getInitialBattleState */])(battleCombatants,teams)));//Set up the first turn
var initialSeries=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lifecycle_start_turn_series_js__["a" /* getNewTurnSeries */])();__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__redux_actions_battle_actions_js__["a" /* setBattleValue */])(Object.assign({},initialSeries));// NEXT, Run the battle! We call `finalCallback` with the result when we're finished! ---------------------
//Kicks off the first action. The rest will automatically trigger
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__offline_offline_check_for_auto_submissions_js__["a" /* offlineCheckForAutoSubmission */])();//We don't know when it will end though, (because we don't have clear callbacks on individual turns..
// it just doesn't make as much sense outside of Reporting mode)
//So start a poll sequence to check when this battle is done.
function checkIfBattleIsOver(){//Check for rolloutId: "rollout_battle-over"
var rolloutId=__WEBPACK_IMPORTED_MODULE_6__init_store_js__["a" /* default */].getState().battle.rolloutId;if(rolloutId==="rollout_battle-over"){//Get the battle report and pass into final callback!
finalCallback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__analysis_get_battle_end_report_js__["a" /* getBattleEndReport */])());}else{//This battle is still running Try again in a few ms.
// console.log('will retry')
setTimeout(checkIfBattleIsOver,100);}}setTimeout(checkIfBattleIsOver,100);}

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(){var size=arguments.length>0&&arguments[0]!==undefined?arguments[0]:32;var style=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{width:size,height:size,style:style,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 160 160",shapeRendering:"crispEdges"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:style.fill||"#200535",opacity:style.opacity||".09",d:"M125 130v-5h-5v-5h-5v-5H45v5h-5v5h-5v5h-5v15h5v5h5v5h5v5h70v-5h5v-5h5v-5h5v-15z",fillRule:"evenodd"}));});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(){var size=arguments.length>0&&arguments[0]!==undefined?arguments[0]:32;var style=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var config=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var isFriendly=config.isFriendly||false;var outlineColor=isFriendly?"#4a90e2":"#e93434";var bodyColor=isFriendly?"#99bce4":"#fa9f9f";var lightColor=isFriendly?"#4a90e2":"#fab9b9";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{width:size,height:size,style:style,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 32 32",shapeRendering:"crispEdges"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:outlineColor,d:"M15 0h3M14 1h1M18 1h1M15 2h1M17 2h1M16 3h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:lightColor,d:"M15 1h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:bodyColor,d:"M16 1h2M16 2h1"}));});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(){var size=arguments.length>0&&arguments[0]!==undefined?arguments[0]:32;var style=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{width:size,height:size,style:style,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 32 32",shapeRendering:"crispEdges"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#fab9b9",d:"M13 18h5M12 19h1M18 19h1M11 20h1M19 20h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#e93434",d:"M13 19h5M12 20h3M16 20h3M12 21h3M16 21h3M12 22h3M16 22h3M12 23h7M13 24h2M16 24h2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#f4c6d4",d:"M15 20h1M15 21h1M15 22h1M15 24h1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#fa9f9f",d:"M11 21h1M19 21h1M11 22h1M19 22h1M11 23h1M19 23h1M11 24h1M19 24h1M12 25h1M18 25h1M13 26h5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{stroke:"#d93c3c",d:"M12 24h1M18 24h1M13 25h5"}));});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__battle_ArenaView_animation_components_animation_lifecycle_utilities__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__audio_audio_manager__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BrandingIntroScreen=function(_React$Component){_inherits(BrandingIntroScreen,_React$Component);function BrandingIntroScreen(){_classCallCheck(this,BrandingIntroScreen);var _this=_possibleConstructorReturn(this,(BrandingIntroScreen.__proto__||Object.getPrototypeOf(BrandingIntroScreen)).call(this));_this.state={step:0};return _this;}_createClass(BrandingIntroScreen,[{key:'componentDidMount',value:function componentDidMount(){this.runAnimationSteps();}},{key:'runAnimationSteps',value:function(){var _ref=_asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__battle_ArenaView_animation_components_animation_lifecycle_utilities__["b" /* timeout */])(600);case 2:__WEBPACK_IMPORTED_MODULE_4__audio_audio_manager__["a" /* default */].playSfx("sfx_jump");this.setState({step:1});_context.next=6;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__battle_ArenaView_animation_components_animation_lifecycle_utilities__["b" /* timeout */])(800);case 6:this.setState({step:0});_context.next=9;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__battle_ArenaView_animation_components_animation_lifecycle_utilities__["b" /* timeout */])(200);case 9://Call our finisher function to notify App.js that we're ready to move on
this.props.onFinish();case 10:case'end':return _context.stop();}}},_callee,this);}));function runAnimationSteps(){return _ref.apply(this,arguments);}return runAnimationSteps;}()},{key:'renderContent',value:function renderContent(){var viewportMode=__WEBPACK_IMPORTED_MODULE_2__init_store__["a" /* default */].getState().global.viewportMode;var style={container:{display:"flex",alignItems:"center",position:"absolute",left:"50%",top:"50%",transform:"translate(-50%,-50%)",fontSize:viewportMode==="portrait"?"1.4em":"1em"},character:{width:"2em",height:"2em",marginRight:"0.2em",background:"url(/images/skins/m-3-front.svg) no-repeat no-repeat",backgroundSize:"cover",opacity:this.state.step>=1?"1":"0"},textContainer:{color:"#F0F5F7",fontSize:"0.7em"},theSpan:{display:"block",fontSize:"0.7em",margin:"0.1em 0",opacity:this.state.step>=1?"1":"0"},titleSpan:{display:"block",margin:"0.2em 0",opacity:this.state.step>=1?"1":"0"}};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:style.container},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:style.character}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:style.textContainer},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:style.theSpan},'THE'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:style.titleSpan},'DANGER'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:style.titleSpan},'CREW')));}},{key:'render',value:function render(){var style={background:'#151825 radial-gradient(50% 105%, rgba(40,48,79,0.00) 52%, rgba(11,15,32,0.70) 100%)',height:"100%"};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:style},this.renderContent());}}]);return BrandingIntroScreen;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BrandingIntroScreen);

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSeenBrandingIntroFromLocalstorage;
/* harmony export (immutable) */ __webpack_exports__["b"] = setSeenBrandingIntroInLocalstorage;
function getSeenBrandingIntroFromLocalstorage(){return window.localStorage.getItem("seenBrandingIntro");//true or false
}function setSeenBrandingIntroInLocalstorage(){window.localStorage.setItem("seenBrandingIntro",true);}

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFirebaseConfig;
function getFirebaseConfig(){//For production, return b5-production firebase app config
//This value is passed in via package.json
if(__webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_BUILD_VERSION":"v1.0.000"}).REACT_APP_FIREBASE_CONFIG==="production"){return{apiKey:"AIzaSyBHMr8JwgFYlhp4NIt-A35uxiuVLZuRrtU",authDomain:"b5-production-38c4f.firebaseapp.com",databaseURL:"https://b5-production-38c4f.firebaseio.com",projectId:"b5-production-38c4f",storageBucket:"b5-production-38c4f.appspot.com",messagingSenderId:"732036237587"};}//Default: return the b5-prototype config settings
//This is for local and stage
return{apiKey:"AIzaSyBnQIfb1-JklN-7RyQW1lxImiiojahov-0",authDomain:"b5-prototype.firebaseapp.com",databaseURL:"https://b5-prototype.firebaseio.com",storageBucket:"b5-prototype.appspot.com",messagingSenderId:"683372399292"};}

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_global_actions_js__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GameFrame=function(_React$Component){_inherits(GameFrame,_React$Component);function GameFrame(){_classCallCheck(this,GameFrame);return _possibleConstructorReturn(this,(GameFrame.__proto__||Object.getPrototypeOf(GameFrame)).apply(this,arguments));}_createClass(GameFrame,[{key:"componentWillMount",value:function componentWillMount(){var _this2=this;this.setViewportModel(this.getViewportModel());//Watch for resizing window:
var resizeTimeout=void 0;window.onresize=function(){clearTimeout(resizeTimeout);resizeTimeout=setTimeout(function(){_this2.setViewportModel(_this2.getViewportModel());},50);};}},{key:"getViewportModel",value:function getViewportModel(){var windowWidth=window.innerWidth;var windowHeight=window.innerHeight;if(windowWidth<=600){//TODO: unsure if this the right call, but basically a media query for <= px
//mobile
return{width:windowWidth,//TODO: Just use full mobile screen for now. Can cross this bridge later if we have issues
height:windowHeight,mode:"portrait"};}//Get the computed value for //16:9 aspect ratio
var windowHeightInRatioFromWidth=Math.round(windowWidth*0.56);//If we can't fit the whole height of the screen, measure using the HEIGHT as the baseline
if(windowHeightInRatioFromWidth>windowHeight){// console.warn('cant fit!');
return{width:Math.round(windowHeight*1.77),//get 16:9 aspect ratio from height
height:windowHeight,mode:"landscape"};}//desktop (with room to fit the computed height):
return{width:windowWidth,height:windowHeightInRatioFromWidth,//16:9 aspect ratio
mode:"landscape"};}},{key:"setViewportModel",value:function setViewportModel(viewportModel){//Apply viewportModel to redux state:
var width=viewportModel.width,height=viewportModel.height,mode=viewportModel.mode;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__redux_actions_global_actions_js__["b" /* setViewportSize */])(width,height,mode);}},{key:"render",value:function render(){//no measurement yet.
if(this.props.viewportWidth<=0||this.props.viewportHeight<=0){return null;}var frameStyle={position:"relative",width:this.props.viewportWidth,height:this.props.viewportHeight,// border: "1px solid red",
margin:"0 auto",//In case we need to center a small'ed landscape view
overflow:"hidden",//?
//THIS IS THE GLOBAL FONT SIZE. EVERYTHING ELSE SHALL USE "em".
fontSize:this.props.viewportMode==="portrait"?this.props.vW*4//Mobile global font size
:this.props.vW*2//Desktop global font size
};var className="GameFrame--"+this.props.viewportMode;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:frameStyle,className:className},this.props.children);}}]);return GameFrame;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){return{vW:state.global.vW,viewportMode:state.global.viewportMode,viewportWidth:state.global.viewportWidth,viewportHeight:state.global.viewportHeight};})(GameFrame));

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStartingGameArea;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__init_store_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_get_query_variable_js__ = __webpack_require__(33);
function getStartingGameArea(userStatus){//TODO: TAKE OUT
//return "b5-records-screen";
//return "b5-offline-battle-over";
//DEV STUFF FIRST:
if(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_get_query_variable_js__["a" /* getQueryVariable */])("dev")){return"arena";}//END DEV STUFF
//New Users MUST go through some form of Onboarding to get signed in.
if(userStatus==="newUser"){return"b5-onboarding-screen";}//If you're already logged in, you can go to either arena (which is a lobby) or b5-home-screen
if(userStatus==="returningUser"){//This flag is set by store.js immediately if we've received an INVITE flag in the URL.
var isInvitedFromLink=__WEBPACK_IMPORTED_MODULE_0__init_store_js__["a" /* default */].getState().battle.isMultiplayerMode;return isInvitedFromLink?"arena":"b5-home-screen";}}

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEntryBeforeEntry;
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/** Take in an array.. target one entry of the array.. insert a payload before this entry */function addEntryBeforeEntry(){var originalArray=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var target=arguments[1];var payload=arguments[2];var index=originalArray.indexOf(target);//If the target is not found, just return the original.
if(index===-1){return originalArray;}//Insert payload item at `index` position.
var newArray=[].concat(_toConsumableArray(originalArray));newArray.splice(index,0,payload);return newArray;}

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * "a"/"an" article helper!
 * Return the correct grammar option based on an input word!
 * @param input
 * @returns {*}
 *//* harmony default export */ __webpack_exports__["a"] = (function(){var input=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";input=input.toLowerCase();// const exceptions = {
//     "example": "an"
// };
//return an exception?
//Otherwise, check for a vowel
var firstLetter=input.split("")[0];if(["a","e","i","o","u"].indexOf(firstLetter)>-1){return"an";}return"a";});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getObjectKeyDiff;
/* harmony export (immutable) */ __webpack_exports__["b"] = getObjectAdditions;
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};//Take in two objects (new and old), return one object that has the LOST stuff from old.
function getObjectKeyDiff(newObj,oldObj){var removedData={};//Loop through each value in oldObj. If the same key does not exist in newObj, add the data to removedData
Object.keys(oldObj).forEach(function(key){var model=oldObj[key];if(!newObj[key]){removedData[key]=model;}});return Object.assign({},removedData);}//EX: {a, b, c}, {a,c}, return {b}
//Take in two objects and return the NEW keys
function getObjectAdditions(newObj,oldObj){var payload={};var oldObjKeys=Object.keys(oldObj);Object.keys(newObj).forEach(function(key){if(!oldObjKeys.includes(key)){var newValue=newObj[key];//NOTE: this will crumble on arrays
payload[key]=(typeof newValue==="undefined"?"undefined":_typeof(newValue))==="object"?Object.assign({},newValue):newValue;}});return payload;}

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPagesFromArray;
/* Returns a page number for each member in the array */function getPagesFromArray(){var input=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var countPerPage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:3;var payload=[];//Set up our array that will be returned. It starts empty.
var page=1;//start at page 1
var countOfCurrentPage=0;//tally 0 entries for first page
//For each member of the array
input.forEach(function(){payload.push(page);//add the current page for this member
countOfCurrentPage++;//uptick how many entries are in this page
//If we've now reached the maximum per page
if(countOfCurrentPage===countPerPage){//Start adding to the next page (in next iteration)
page++;//reset the count back to 0 (fresh for the new page)
countOfCurrentPage=0;}});//return the payload!
return payload;}//Example return: [1,1,1,2,2,2,3,3,3] (9 members, 3 per page)

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//UPDATED: http://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
/* OLD WAY: http://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript*//* harmony default export */ __webpack_exports__["a"] = (function(){/* eslint-disable */if(typeof window==="undefined"){return false;}var check=false;(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check=true;})(navigator.userAgent||navigator.vendor||window.opera);return check;/* eslint-enable */});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(){var items=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var entries=[];items.forEach(function(item,ii){var matches=entries.filter(function(entry){return entry.name===item;});if(matches.length===0){entries.push({name:item,quantity:1});}else{entries.forEach(function(e){if(e.name===item){e.quantity+=1;}});}});var str="";entries.map(function(entry,index){var end=entry.quantity>1?"s":"";return entry.quantity+" "+entry.name+end;}).forEach(function(segment,index){str+=segment;if(index===entries.length-2){if(entries.length>2){str+=",";}str+=" and ";}if(index<entries.length-2){str+=", ";}});return str;});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initGoogleAnalytics;
//Kickoff google analytics if this is a production build (not stage)
function initGoogleAnalytics(){if(__webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_BUILD_VERSION":"v1.0.000"}).REACT_APP_FIREBASE_CONFIG==="production"){/* eslint-disable *///Initialize Google Analytics
(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments);},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m);})(window,document,'script','//www.google-analytics.com/analytics.js','ga');//execute Google Analytics
window.ga('create','UA-75243711-1','auto');/* eslint-enable */}}

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_reducers_global_reducer__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_reducers_battle_reducer__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_reducers_matchmaking_reducer__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_reducers_crew_reducer__ = __webpack_require__(403);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/* harmony default export */ __webpack_exports__["a"] = (function(data){var reducer=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* combineReducers */])(Object.assign({},__WEBPACK_IMPORTED_MODULE_1__redux_reducers_global_reducer__,__WEBPACK_IMPORTED_MODULE_2__redux_reducers_battle_reducer__,__WEBPACK_IMPORTED_MODULE_3__redux_reducers_matchmaking_reducer__,__WEBPACK_IMPORTED_MODULE_4__redux_reducers_crew_reducer__)//...anotherReducer,
);var store;if((typeof window==="undefined"?"undefined":_typeof(window))==="object"){store=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* createStore */])(reducer,data,window.devToolsExtension?window.devToolsExtension():undefined);}else{store=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* createStore */])(reducer,data);}return store;});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(userOptions){return Object.assign({//Defaults
viewBag:{},backOptionId:null,//give id of the "back" menu option for ESC key
shouldRememberOptions:true,//Default to YES - remember things
dontRememberOptionIds:[],//But don't allow remember-setting of these optionIds
getFirstSelectedOptionOnActivation:function getFirstSelectedOptionOnActivation(availableOptionModels){//Default to just use the first one!
return availableOptionModels[0].id;}},userOptions,{//Computed
menuOptions:userOptions.getMenuOptions(),menuOptionsLayout:userOptions.getMenuOptionsLayout()});});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = filterNonSelectableOptions;
/** Take in desired layout and filter out disabled or invisible items */function filterNonSelectableOptions(){var menuOptionsLayout=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var menuOptions=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return menuOptionsLayout.map(function(row){return row.filter(function(optionKey){var optionModel=menuOptions[optionKey];if(typeof optionModel.isDisabled==="function"&&optionModel.isDisabled()){return false;}if(typeof optionModel.isVisible==="function"&&!optionModel.isVisible()){return false;}return true;});});}

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__View__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keyboard_bindKeyboard__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keyboard_handleArrowPress__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__audio_audio_manager__ = __webpack_require__(8);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//returns an instance of a  menuModel.
/* harmony default export */ __webpack_exports__["a"] = (function(){var config=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var initialViewKey=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;//Create view models with defaults
var views={};Object.keys(config.views).forEach(function(userViewModelKey){var userViewModelOptions=config.views[userViewModelKey];views[userViewModelKey]=new __WEBPACK_IMPORTED_MODULE_0__View__["a" /* default */](userViewModelOptions);});//Get the initial snapshot's view to use. User can pass this in.
//(EX: start me on the Journal page)
var firstViewKey=initialViewKey||Object.keys(views)[0];//Default to first in Object keys
var activeViewModel=views[firstViewKey];//Get first option that is not INVISIBLE or DISABLED
var firstOptionKey=Object.keys(activeViewModel.menuOptions).filter(function(optionKey){var model=activeViewModel.menuOptions[optionKey];return model.isVisible()&&!model.isDisabled();})[0];var firstOptionModel=activeViewModel.menuOptions[firstOptionKey];var initialSelectedOptionId=firstOptionModel.id;return{menuState:{isLocked:false,//for disabling movement while modals are up, etc (or multiple instances)
//Locking prevents `setActive` and `submit` from doing anything
viewId:firstViewKey,activeViewModel:activeViewModel,selectedOptionId:initialSelectedOptionId,rememberingOptionIds:{//space to record `viewId: optionId` so we know the right one to select when going
}},//Listening and Handling
listenHandlers:[],listen:function listen(handler){this.listenHandlers.push(handler);},/** Fire each handler with a new copy of our latest state */fireHandlers:function fireHandlers(){var _this=this;this.listenHandlers.forEach(function(handler){if(typeof handler==="function"){handler(Object.assign({},_this.getSnapshot()));}});},/** Sets `selectedOptionId` for visual difference on which is cursored */setActive:function setActive(model){var fromKeyboard=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;//Cancel here if the menu is locked
if(this.menuState.isLocked){// console.log('NOPE. menu is locked')
return;}//Look model up in our under-the-hood system
var selectedOptionModel=this.getOptionModelFromId(model.id);if(!selectedOptionModel){//A wrong thing was trying to be accessed
console.warn("misfire!",model);return;}//Diff the new and old for keyboard sound
if(this.menuState.selectedOptionId!==selectedOptionModel.id){if(fromKeyboard){//TODO This should probably be a setting in the loaded view? Opt in or out of cursor sounds?
playCursorSound();}}//make sure it's valid to be selected: a) not already selected, and b) is not Disabled
if(!selectedOptionModel.isSelected&&!selectedOptionModel.isDisabled()){//Do our change
this.mergeChange({selectedOptionId:selectedOptionModel.id});}},/** Submit the thing that this Option does. EX: ENTER KEY or CLICKING on an option */submit:function submit(model){//Cancel here if the menu is locked
if(this.menuState.isLocked){// console.log('NOPE. menu is locked')
return;}var selectedOptionModel=this.getOptionModelFromId(model.id);//Cancel here if this model is not able to be submitted
if(!selectedOptionModel.isAbleToBeSubmitted()){return;}//Cancel here if this model is "unavailable", which means it can be cursored to but not submitted.
if(selectedOptionModel.isUnavailable()){return;}//Do the Enter handler (EX: data setting before transitioning to next view)
selectedOptionModel.handleOptionEnter(this);//pass in the instance of the menu in case handler needs it
//Check for nextView change. (many options will set data above THEN transition to a new view)
//While some options simply set data without affecting menu state
if(selectedOptionModel.nextView){this.goToNextView(selectedOptionModel);}},/** Go to this option's menu area "view" */goToNextView:function goToNextView(model){var viewKey=model.nextView;var nextArea=new __WEBPACK_IMPORTED_MODULE_0__View__["a" /* default */](config.views[viewKey]);if(nextArea){//Remember our current option in case we come back to this view!
var currentView=new __WEBPACK_IMPORTED_MODULE_0__View__["a" /* default */](config.views[this.menuState.viewId]);//get a ref of the current View model
//Create a flag that notes if an option is okay to be remembered or not.
var shouldRememberOption=currentView.shouldRememberOptions&&//This view is allowing options to be remembered
!currentView.dontRememberOptionIds.includes(//This option ID is not excluded from remembering
this.menuState.selectedOptionId);//Add this optionId to our remembering object (or set it to null because its blacklisted, so the remembering resets)
var updatedRememberingState=Object.assign({},this.menuState.rememberingOptionIds,_defineProperty({},this.menuState.viewId,shouldRememberOption?this.menuState.selectedOptionId:null));this.mergeChange({rememberingOptionIds:updatedRememberingState});//----- Find the next option to select when we get to the next view ------------------
//let nextSelectedOptionKey = null; //We'll get a value as we go through this:
var availableOptionIdsInNextView=Object.keys(nextArea.menuOptions).filter(function(optionKey){var model=nextArea.menuOptions[optionKey];return model.isVisible()&&!model.isDisabled();});//Now, for the NEXT VIEW, see if we have a remembered one.
var rememberedOptionIdForNextView=this.menuState.rememberingOptionIds[viewKey];//Start with the View's wanted default selection.
//Ask for View's preferred first selected (will default to first)
var nextSelectedOptionKey=nextArea.getFirstSelectedOptionOnActivation(availableOptionIdsInNextView.map(function(id){return nextArea.menuOptions[id];}));//But if we have a remembered one, override to that!
if(rememberedOptionIdForNextView&&availableOptionIdsInNextView.includes(rememberedOptionIdForNextView)){nextSelectedOptionKey=rememberedOptionIdForNextView;}var nextSelectedOption=nextArea.menuOptions[nextSelectedOptionKey];var nextSelectedOptionId=nextSelectedOption?nextArea.menuOptions[nextSelectedOptionKey].id:availableOptionIdsInNextView[0];//In the event that `nextSelectedOption` is undefined (some MenuOption needs a manual id), just fall back to the first key.
//Transition to new view with correct option selected --------
this.mergeChange({viewId:viewKey,activeViewModel:nextArea,selectedOptionId:nextSelectedOptionId});}else{console.warn(viewKey,"view not found in `views`: ",views);}},/** Retrieve one option from our internal list of Option Models */getOptionModelFromId:function getOptionModelFromId(){var _this2=this;var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";//Turn each key into a model, and find the one that matches passed in ID
return Object.keys(this.menuState.activeViewModel.menuOptions).map(function(optionKey){return _this2.menuState.activeViewModel.menuOptions[optionKey];}).find(function(optionModel){return id===optionModel.id;});},mergeChange:function mergeChange(){var changes=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.menuState=Object.assign({},this.menuState,changes);this.fireHandlers();},getOptionsList:function getOptionsList(){var _this3=this;return Object.keys(this.menuState.activeViewModel.menuOptions).map(function(optionKey){var model=_this3.menuState.activeViewModel.menuOptions[optionKey];return{id:model.id,viewBag:model.viewBag||{},isVisible:model.isVisible(),isUnavailable:model.isUnavailable(),isDisabled:model.isDisabled(),isSelected:model.id===_this3.menuState.selectedOptionId,label:model.label,description:model.description,belongsToGroup:model.optionGroup};});},getOptionsData:function getOptionsData(){var _this4=this;var data={};Object.keys(this.menuState.activeViewModel.menuOptions).forEach(function(optionKey){var model=_this4.menuState.activeViewModel.menuOptions[optionKey];data[optionKey]={id:model.id,viewBag:model.viewBag||{},isVisible:model.isVisible(),isUnavailable:model.isUnavailable(),isDisabled:model.isDisabled(),isSelected:model.id===_this4.menuState.selectedOptionId,label:model.label,description:model.description};});return data;},getSnapshot:function getSnapshot(){var currentlySelectedOptionData=this.getOptionsList().find(function(o){return o.isSelected;});if(!currentlySelectedOptionData){// console.log(this.getOptionsList());
console.warn("no selection");}//This is the snapshot
return{submit:this.submit.bind(this),//include a reference to the submitting function
setActive:this.setActive.bind(this),//and setting active
viewId:this.menuState.viewId,viewBag:this.menuState.activeViewModel.viewBag,optionsData:this.getOptionsData(),//key:value so the client can reference a specific option by key: EX: optionsData["character"]
//optionsList: optionsList, //If you just want to loop through a list
//TODO: I took out optionsList because it's super redundant of optionsData. Just generate a list from optionsData on the other side
currentlySelectedOptionData:currentlySelectedOptionData};},/** Call this to unmount the bindings for clean exit */destroy:function destroy(){// console.log('destroy');
this.listenHandlers=[];//Remove bindings!
var el=document.getElementsByTagName("body")[0];//New Way: loop through our bindings and remove the keyUp and keyDown handlers
[this.bindings.submitKey,this.bindings.downKey,this.bindings.upKey,this.bindings.leftKey,this.bindings.rightKey,this.bindings.escKey].forEach(function(keyBinding){keyBinding.forEach(function(handlersObject){//for each binding, get rid of the Up and Down handlers
el.removeEventListener("keyup",handlersObject.keyUpHandler);el.removeEventListener("keydown",handlersObject.keyDownHandler);});});//I believe these are unbinding properly? but it's a little hard to test
//OLD WAY: remove the bindings!
// //Enter
// el.removeEventListener("keyup", this.bindings.submitKey.keyUpHandler);
// el.removeEventListener("keydown", this.bindings.submitKey.keyDownHandler);
// //Down
// el.removeEventListener("keyup", this.bindings.downKey.keyUpHandler);
// el.removeEventListener("keydown", this.bindings.downKey.keyDownHandler);
// //Up
// el.removeEventListener("keyup", this.bindings.upKey.keyUpHandler);
// el.removeEventListener("keydown", this.bindings.upKey.keyDownHandler);
// //Left
// el.removeEventListener("keyup", this.bindings.leftKey.keyUpHandler);
// el.removeEventListener("keydown", this.bindings.leftKey.keyDownHandler);
// //Right
// el.removeEventListener("keyup", this.bindings.rightKey.keyUpHandler);
// el.removeEventListener("keydown", this.bindings.rightKey.keyDownHandler);
},lock:function lock(){this.mergeChange({isLocked:true});},unlock:function unlock(){this.mergeChange({isLocked:false});},/** Set up and provide initial snapshot */init:function init(){var _this5=this;// console.log("under the hood state", this.menuState);
//Do any bindings here...
this.bindings={submitKey:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__keyboard_bindKeyboard__["a" /* createSingleKeyPressBinding */])([13,32],function(){//Enter, Space
_this5.submit({id:_this5.menuState.selectedOptionId});}),escKey:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__keyboard_bindKeyboard__["a" /* createSingleKeyPressBinding */])([27],function(){var activeModel=_this5.menuState.activeViewModel;if(activeModel.backOptionId){//Lookup the Back option by config'ed id
var backOption=activeModel.menuOptions[activeModel.backOptionId];//Note, getMenuOptions() returns a different ID than straight up `menuOptions`
//If we found one, set submit it
if(backOption){_this5.submit(backOption);}else{console.warn("back option looked for but not found",activeModel.backOptionId);}}//Find back option and submit it (even if it isn't displayed in the View Layer)
}),downKey:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__keyboard_bindKeyboard__["a" /* createSingleKeyPressBinding */])([40,83],function(){//down arrow, S
//See comment notes on RIGHT handler
var nextSelectedOptionModel=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__keyboard_handleArrowPress__["a" /* getNextSelectedOptionModelFromArrowPress */])("down",_this5.menuState);if(nextSelectedOptionModel){_this5.setActive(nextSelectedOptionModel,true);//true = from keyboard flag
}}),upKey:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__keyboard_bindKeyboard__["a" /* createSingleKeyPressBinding */])([38,87],function(){//up arrow, W
//See comment notes on RIGHT handler
var nextSelectedOptionModel=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__keyboard_handleArrowPress__["a" /* getNextSelectedOptionModelFromArrowPress */])("up",_this5.menuState);if(nextSelectedOptionModel){_this5.setActive(nextSelectedOptionModel,true);}}),leftKey:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__keyboard_bindKeyboard__["a" /* createSingleKeyPressBinding */])([37,65],function(){//left arrow, A
//See comment notes on RIGHT handler
var nextSelectedOptionModel=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__keyboard_handleArrowPress__["a" /* getNextSelectedOptionModelFromArrowPress */])("left",_this5.menuState);if(nextSelectedOptionModel){_this5.setActive(nextSelectedOptionModel,true);}}),rightKey:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__keyboard_bindKeyboard__["a" /* createSingleKeyPressBinding */])([39,68],function(){//right arrow, D
//Might need to refactor a tiny bit in the future if arrowing
//does stuff other than changing the selected value. For now, let's just have this
//return the next model and give it to `setActive`
var nextSelectedOptionModel=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__keyboard_handleArrowPress__["a" /* getNextSelectedOptionModelFromArrowPress */])("right",_this5.menuState);if(nextSelectedOptionModel){_this5.setActive(nextSelectedOptionModel,true);}})};//Return a SNAPSHOT of whatever the menu is right now
return this.getSnapshot();}};});//TODO: this should be configurable, probably. Maybe Not all menus will want to do this, or they might have their own sound?
function playCursorSound(){__WEBPACK_IMPORTED_MODULE_3__audio_audio_manager__["a" /* default */].playSfx("sfx_cursorMove");}

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSingleKeyPressBinding;
function createSingleKeyPressBinding(){var keyCodes=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var handler=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(){};return keyCodes.map(function(keyCode){var el=document.getElementsByTagName("body")[0];var keysafe=true;var keyDownHandler=function keyDownHandler(event){if(event.keyCode===keyCode&&keysafe){keysafe=false;handler();}};var keyUpHandler=function keyUpHandler(event){if(event.keyCode===keyCode){keysafe=true;}};el.addEventListener("keydown",keyDownHandler);el.addEventListener("keyup",keyUpHandler);//Return references so we can UNBIND later
return{keyUpHandler:keyUpHandler,keyDownHandler:keyDownHandler};});//[ {keyUp, keyDown}, {keyUp, keyDown} ]
}

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNextSelectedOptionModelFromArrowPress;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keyboard_navigation__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filterNonSelectableOptionItems__ = __webpack_require__(397);
function getNextSelectedOptionModelFromArrowPress(){var direction=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var menuState=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};//Use a menu layout that does not include DISABLEDS or INVISIBLES
var menuLayout=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__filterNonSelectableOptionItems__["a" /* filterNonSelectableOptions */])(menuState.activeViewModel.menuOptionsLayout,menuState.activeViewModel.menuOptions);//Get the active "key" in menuOptions Object by looking up the selectedOptionId
var activeKey=Object.keys(menuState.activeViewModel.menuOptions).find(function(key){var model=menuState.activeViewModel.menuOptions[key];return model.id===menuState.selectedOptionId;});//Get the next active "key" from our utility
var nextOptionKey=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__keyboard_navigation__["a" /* getNextOptionFromArrowing */])(direction,menuLayout,activeKey);//Look up by Key and return the option model
return menuState.activeViewModel.menuOptions[nextOptionKey];}

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNextOptionFromArrowing;
function getNextOptionFromArrowing(){var direction=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"left";var menuOptionsLayout=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var currentlyActiveKey=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"";/**
     * EXAMPLE
         menuOptionsLayout: [
            ["firstViewKey", "secondViewKey"],
            ["thirdViewKey", "fourthViewKey"],
            ["fifthViewKey", "sixthViewKey"],
        ]
     *///Default return. If it's just an empty array, return whatever is active.
if(menuOptionsLayout.length===0){return currentlyActiveKey;}var selectedRowIndex=void 0;var selectedKeyPosition=void 0;menuOptionsLayout.forEach(function(row,index){var positionInRow=row.indexOf(currentlyActiveKey);if(positionInRow>-1){selectedKeyPosition=positionInRow;selectedRowIndex=index;}});if(typeof selectedRowIndex!=="undefined"&&typeof selectedKeyPosition!=="undefined"){//Left and Right
var selectedRow=menuOptionsLayout[selectedRowIndex];if(direction==="left"){var candidate=selectedRow[selectedKeyPosition-1];return candidate||currentlyActiveKey;//Return the one to the right, or the same one we're on
}if(direction==="right"){var _candidate=selectedRow[selectedKeyPosition+1];return _candidate||currentlyActiveKey;//Return the one to the right, or the same one we're on
}//Up and Down
if(direction==="down"){var nextRowDown=menuOptionsLayout[selectedRowIndex+1];if(nextRowDown){var _candidate2=nextRowDown[selectedKeyPosition];if(_candidate2){return _candidate2;}else{return nextRowDown[nextRowDown.length-1];}}else{return currentlyActiveKey;//No change. return the current one.
}}if(direction==="up"){var nextRowUp=menuOptionsLayout[selectedRowIndex-1];if(nextRowUp){var _candidate3=nextRowUp[selectedKeyPosition];if(_candidate3){return _candidate3;}else{//No matching horizontal member on this new Row, so just use the last one
return nextRowUp[nextRowUp.length-1];}}else{return currentlyActiveKey;//No change. return the current one.
}}}}

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["battle"] = battle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_reducer_utilities__ = __webpack_require__(68);
function battle(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case"SET_BATTLE_VALUE":return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_reducer_utilities__["a" /* setValue */])(state,action.payload.changes);case"SET_BATTLE_COMBATANT_VALUE":return Object.assign({},state,{combatants:__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_reducer_utilities__["b" /* editNode */])(state.combatants,action.payload.key,action.payload.changes)});default:return state;}}

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["crew"] = crew;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_reducer_utilities__ = __webpack_require__(68);
function crew(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case"SET_CREW_VALUE":return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_reducer_utilities__["a" /* setValue */])(state,action.payload.changes);default:return state;}}

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["global"] = global;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_reducer_utilities__ = __webpack_require__(68);
function global(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case"SET_GLOBAL_VALUE":return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_reducer_utilities__["a" /* setValue */])(state,action.payload.changes);default:return state;}}

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["matchmaking"] = matchmaking;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_reducer_utilities__ = __webpack_require__(68);
function matchmaking(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case"SET_MATCHMAKING_VALUE":return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_reducer_utilities__["a" /* setValue */])(state,action.payload.changes);default:return state;}}

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TextLine__ = __webpack_require__(160);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SkippableTextLine=function(_React$Component){_inherits(SkippableTextLine,_React$Component);function SkippableTextLine(){_classCallCheck(this,SkippableTextLine);var _this=_possibleConstructorReturn(this,(SkippableTextLine.__proto__||Object.getPrototypeOf(SkippableTextLine)).call(this));_this.state={isForcedDone:false};return _this;}//TODO: Keyboard binding will go here too!
_createClass(SkippableTextLine,[{key:"handleClick",value:function handleClick(){this.setState({isForcedDone:true});}},{key:"render",value:function render(){//Pass in same props that TextLine needs
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{onClick:this.handleClick.bind(this),style:this.props.style||{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TextLine__["a" /* default */],{isForcedDone:this.state.isForcedDone,lineData:this.props.lineData,onDone:this.props.onDone}));}}]);return SkippableTextLine;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SkippableTextLine);

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(413)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('select'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.select);
        global.clipboardAction = mod.exports;
    }
})(this, function (module, _select) {
    'use strict';

    var _select2 = _interopRequireDefault(_select);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var ClipboardAction = function () {
        /**
         * @param {Object} options
         */
        function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);

            this.resolveOptions(options);
            this.initSelection();
        }

        /**
         * Defines base properties passed from constructor.
         * @param {Object} options
         */


        _createClass(ClipboardAction, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = options.action;
                this.emitter = options.emitter;
                this.target = options.target;
                this.text = options.text;
                this.trigger = options.trigger;

                this.selectedText = '';
            }
        }, {
            key: 'initSelection',
            value: function initSelection() {
                if (this.text) {
                    this.selectFake();
                } else if (this.target) {
                    this.selectTarget();
                }
            }
        }, {
            key: 'selectFake',
            value: function selectFake() {
                var _this = this;

                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

                this.removeFake();

                this.fakeHandlerCallback = function () {
                    return _this.removeFake();
                };
                this.fakeHandler = document.body.addEventListener('click', this.fakeHandlerCallback) || true;

                this.fakeElem = document.createElement('textarea');
                // Prevent zooming on iOS
                this.fakeElem.style.fontSize = '12pt';
                // Reset box model
                this.fakeElem.style.border = '0';
                this.fakeElem.style.padding = '0';
                this.fakeElem.style.margin = '0';
                // Move element out of screen horizontally
                this.fakeElem.style.position = 'absolute';
                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
                // Move element to the same position vertically
                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                this.fakeElem.style.top = yPosition + 'px';

                this.fakeElem.setAttribute('readonly', '');
                this.fakeElem.value = this.text;

                document.body.appendChild(this.fakeElem);

                this.selectedText = (0, _select2.default)(this.fakeElem);
                this.copyText();
            }
        }, {
            key: 'removeFake',
            value: function removeFake() {
                if (this.fakeHandler) {
                    document.body.removeEventListener('click', this.fakeHandlerCallback);
                    this.fakeHandler = null;
                    this.fakeHandlerCallback = null;
                }

                if (this.fakeElem) {
                    document.body.removeChild(this.fakeElem);
                    this.fakeElem = null;
                }
            }
        }, {
            key: 'selectTarget',
            value: function selectTarget() {
                this.selectedText = (0, _select2.default)(this.target);
                this.copyText();
            }
        }, {
            key: 'copyText',
            value: function copyText() {
                var succeeded = void 0;

                try {
                    succeeded = document.execCommand(this.action);
                } catch (err) {
                    succeeded = false;
                }

                this.handleResult(succeeded);
            }
        }, {
            key: 'handleResult',
            value: function handleResult(succeeded) {
                this.emitter.emit(succeeded ? 'success' : 'error', {
                    action: this.action,
                    text: this.selectedText,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            }
        }, {
            key: 'clearSelection',
            value: function clearSelection() {
                if (this.target) {
                    this.target.blur();
                }

                window.getSelection().removeAllRanges();
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.removeFake();
            }
        }, {
            key: 'action',
            set: function set() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

                this._action = action;

                if (this._action !== 'copy' && this._action !== 'cut') {
                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
                }
            },
            get: function get() {
                return this._action;
            }
        }, {
            key: 'target',
            set: function set(target) {
                if (target !== undefined) {
                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                        }

                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        }

                        this._target = target;
                    } else {
                        throw new Error('Invalid "target" value, use a valid Element');
                    }
                }
            },
            get: function get() {
                return this._target;
            }
        }]);

        return ClipboardAction;
    }();

    module.exports = ClipboardAction;
});

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(407), __webpack_require__(414), __webpack_require__(412)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
        global.clipboard = mod.exports;
    }
})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';

    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

    var _goodListener2 = _interopRequireDefault(_goodListener);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Clipboard = function (_Emitter) {
        _inherits(Clipboard, _Emitter);

        /**
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         * @param {Object} options
         */
        function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);

            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

            _this.resolveOptions(options);
            _this.listenClick(trigger);
            return _this;
        }

        /**
         * Defines if attributes would be resolved using internal setter functions
         * or custom functions that were passed in the constructor.
         * @param {Object} options
         */


        _createClass(Clipboard, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
            }
        }, {
            key: 'listenClick',
            value: function listenClick(trigger) {
                var _this2 = this;

                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                    return _this2.onClick(e);
                });
            }
        }, {
            key: 'onClick',
            value: function onClick(e) {
                var trigger = e.delegateTarget || e.currentTarget;

                if (this.clipboardAction) {
                    this.clipboardAction = null;
                }

                this.clipboardAction = new _clipboardAction2.default({
                    action: this.action(trigger),
                    target: this.target(trigger),
                    text: this.text(trigger),
                    trigger: trigger,
                    emitter: this
                });
            }
        }, {
            key: 'defaultAction',
            value: function defaultAction(trigger) {
                return getAttributeValue('action', trigger);
            }
        }, {
            key: 'defaultTarget',
            value: function defaultTarget(trigger) {
                var selector = getAttributeValue('target', trigger);

                if (selector) {
                    return document.querySelector(selector);
                }
            }
        }, {
            key: 'defaultText',
            value: function defaultText(trigger) {
                return getAttributeValue('text', trigger);
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.listener.destroy();

                if (this.clipboardAction) {
                    this.clipboardAction.destroy();
                    this.clipboardAction = null;
                }
            }
        }], [{
            key: 'isSupported',
            value: function isSupported() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

                var actions = typeof action === 'string' ? [action] : action;
                var support = !!document.queryCommandSupported;

                actions.forEach(function (action) {
                    support = support && !!document.queryCommandSupported(action);
                });

                return support;
            }
        }]);

        return Clipboard;
    }(_tinyEmitter2.default);

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */
    function getAttributeValue(suffix, element) {
        var attribute = 'data-clipboard-' + suffix;

        if (!element.hasAttribute(attribute)) {
            return;
        }

        return element.getAttribute(attribute);
    }

    module.exports = Clipboard;
});

/***/ }),
/* 409 */
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (element.matches(selector)) return element;
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__(409);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),
/* 411 */
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__(411);
var delegate = __webpack_require__(410);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),
/* 413 */
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),
/* 414 */
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 *  howler.js v2.0.4
 *  howlerjs.com
 *
 *  (c) 2013-2017, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */

(function() {

  'use strict';

  /** Global Methods **/
  /***************************************************************************/

  /**
   * Create the global controller. All contained methods and properties apply
   * to all sounds that are currently playing or will be in the future.
   */
  var HowlerGlobal = function() {
    this.init();
  };
  HowlerGlobal.prototype = {
    /**
     * Initialize the global Howler object.
     * @return {Howler}
     */
    init: function() {
      var self = this || Howler;

      // Create a global ID counter.
      self._counter = 1000;

      // Internal properties.
      self._codecs = {};
      self._howls = [];
      self._muted = false;
      self._volume = 1;
      self._canPlayEvent = 'canplaythrough';
      self._navigator = (typeof window !== 'undefined' && window.navigator) ? window.navigator : null;

      // Public properties.
      self.masterGain = null;
      self.noAudio = false;
      self.usingWebAudio = true;
      self.autoSuspend = true;
      self.ctx = null;

      // Set to false to disable the auto iOS enabler.
      self.mobileAutoEnable = true;

      // Setup the various state values for global tracking.
      self._setup();

      return self;
    },

    /**
     * Get/set the global volume for all sounds.
     * @param  {Float} vol Volume from 0.0 to 1.0.
     * @return {Howler/Float}     Returns self or current volume.
     */
    volume: function(vol) {
      var self = this || Howler;
      vol = parseFloat(vol);

      // If we don't have an AudioContext created yet, run the setup.
      if (!self.ctx) {
        setupAudioContext();
      }

      if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
        self._volume = vol;

        // Don't update any of the nodes if we are muted.
        if (self._muted) {
          return self;
        }

        // When using Web Audio, we just need to adjust the master gain.
        if (self.usingWebAudio) {
          self.masterGain.gain.value = vol;
        }

        // Loop through and change volume for all HTML5 audio nodes.
        for (var i=0; i<self._howls.length; i++) {
          if (!self._howls[i]._webAudio) {
            // Get all of the sounds in this Howl group.
            var ids = self._howls[i]._getSoundIds();

            // Loop through all sounds and change the volumes.
            for (var j=0; j<ids.length; j++) {
              var sound = self._howls[i]._soundById(ids[j]);

              if (sound && sound._node) {
                sound._node.volume = sound._volume * vol;
              }
            }
          }
        }

        return self;
      }

      return self._volume;
    },

    /**
     * Handle muting and unmuting globally.
     * @param  {Boolean} muted Is muted or not.
     */
    mute: function(muted) {
      var self = this || Howler;

      // If we don't have an AudioContext created yet, run the setup.
      if (!self.ctx) {
        setupAudioContext();
      }

      self._muted = muted;

      // With Web Audio, we just need to mute the master gain.
      if (self.usingWebAudio) {
        self.masterGain.gain.value = muted ? 0 : self._volume;
      }

      // Loop through and mute all HTML5 Audio nodes.
      for (var i=0; i<self._howls.length; i++) {
        if (!self._howls[i]._webAudio) {
          // Get all of the sounds in this Howl group.
          var ids = self._howls[i]._getSoundIds();

          // Loop through all sounds and mark the audio node as muted.
          for (var j=0; j<ids.length; j++) {
            var sound = self._howls[i]._soundById(ids[j]);

            if (sound && sound._node) {
              sound._node.muted = (muted) ? true : sound._muted;
            }
          }
        }
      }

      return self;
    },

    /**
     * Unload and destroy all currently loaded Howl objects.
     * @return {Howler}
     */
    unload: function() {
      var self = this || Howler;

      for (var i=self._howls.length-1; i>=0; i--) {
        self._howls[i].unload();
      }

      // Create a new AudioContext to make sure it is fully reset.
      if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== 'undefined') {
        self.ctx.close();
        self.ctx = null;
        setupAudioContext();
      }

      return self;
    },

    /**
     * Check for codec support of specific extension.
     * @param  {String} ext Audio file extention.
     * @return {Boolean}
     */
    codecs: function(ext) {
      return (this || Howler)._codecs[ext.replace(/^x-/, '')];
    },

    /**
     * Setup various state values for global tracking.
     * @return {Howler}
     */
    _setup: function() {
      var self = this || Howler;

      // Keeps track of the suspend/resume state of the AudioContext.
      self.state = self.ctx ? self.ctx.state || 'running' : 'running';

      // Automatically begin the 30-second suspend process
      self._autoSuspend();

      // Check if audio is available.
      if (!self.usingWebAudio) {
        // No audio is available on this system if noAudio is set to true.
        if (typeof Audio !== 'undefined') {
          try {
            var test = new Audio();

            // Check if the canplaythrough event is available.
            if (typeof test.oncanplaythrough === 'undefined') {
              self._canPlayEvent = 'canplay';
            }
          } catch(e) {
            self.noAudio = true;
          }
        } else {
          self.noAudio = true;
        }
      }

      // Test to make sure audio isn't disabled in Internet Explorer.
      try {
        var test = new Audio();
        if (test.muted) {
          self.noAudio = true;
        }
      } catch (e) {}

      // Check for supported codecs.
      if (!self.noAudio) {
        self._setupCodecs();
      }

      return self;
    },

    /**
     * Check for browser support for various codecs and cache the results.
     * @return {Howler}
     */
    _setupCodecs: function() {
      var self = this || Howler;
      var audioTest = null;

      // Must wrap in a try/catch because IE11 in server mode throws an error.
      try {
        audioTest = (typeof Audio !== 'undefined') ? new Audio() : null;
      } catch (err) {
        return self;
      }

      if (!audioTest || typeof audioTest.canPlayType !== 'function') {
        return self;
      }

      var mpegTest = audioTest.canPlayType('audio/mpeg;').replace(/^no$/, '');

      // Opera version <33 has mixed MP3 support, so we need to check for and block it.
      var checkOpera = self._navigator && self._navigator.userAgent.match(/OPR\/([0-6].)/g);
      var isOldOpera = (checkOpera && parseInt(checkOpera[0].split('/')[1], 10) < 33);

      self._codecs = {
        mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType('audio/mp3;').replace(/^no$/, ''))),
        mpeg: !!mpegTest,
        opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ''),
        ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
        oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
        wav: !!audioTest.canPlayType('audio/wav; codecs="1"').replace(/^no$/, ''),
        aac: !!audioTest.canPlayType('audio/aac;').replace(/^no$/, ''),
        caf: !!audioTest.canPlayType('audio/x-caf;').replace(/^no$/, ''),
        m4a: !!(audioTest.canPlayType('audio/x-m4a;') || audioTest.canPlayType('audio/m4a;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
        mp4: !!(audioTest.canPlayType('audio/x-mp4;') || audioTest.canPlayType('audio/mp4;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
        weba: !!audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, ''),
        webm: !!audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, ''),
        dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ''),
        flac: !!(audioTest.canPlayType('audio/x-flac;') || audioTest.canPlayType('audio/flac;')).replace(/^no$/, '')
      };

      return self;
    },

    /**
     * Mobile browsers will only allow audio to be played after a user interaction.
     * Attempt to automatically unlock audio on the first user interaction.
     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
     * @return {Howler}
     */
    _enableMobileAudio: function() {
      var self = this || Howler;

      // Only run this on mobile devices if audio isn't already eanbled.
      var isMobile = /iPhone|iPad|iPod|Android|BlackBerry|BB10|Silk|Mobi/i.test(self._navigator && self._navigator.userAgent);
      var isTouch = !!(('ontouchend' in window) || (self._navigator && self._navigator.maxTouchPoints > 0) || (self._navigator && self._navigator.msMaxTouchPoints > 0));
      if (self._mobileEnabled || !self.ctx || (!isMobile && !isTouch)) {
        return;
      }

      self._mobileEnabled = false;

      // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
      // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
      // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
      if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
        self._mobileUnloaded = true;
        self.unload();
      }

      // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
      // http://stackoverflow.com/questions/24119684
      self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);

      // Call this method on touch start to create and play a buffer,
      // then check if the audio actually played to determine if
      // audio has now been unlocked on iOS, Android, etc.
      var unlock = function() {
        // Fix Android can not play in suspend state.
        Howler._autoResume();

        // Create an empty buffer.
        var source = self.ctx.createBufferSource();
        source.buffer = self._scratchBuffer;
        source.connect(self.ctx.destination);

        // Play the empty buffer.
        if (typeof source.start === 'undefined') {
          source.noteOn(0);
        } else {
          source.start(0);
        }

        // Calling resume() on a stack initiated by user gesture is what actually unlocks the audio on Android Chrome >= 55.
        if (typeof self.ctx.resume === 'function') {
          self.ctx.resume();
        }

        // Setup a timeout to check that we are unlocked on the next event loop.
        source.onended = function() {
          source.disconnect(0);

          // Update the unlocked state and prevent this check from happening again.
          self._mobileEnabled = true;
          self.mobileAutoEnable = false;

          // Remove the touch start listener.
          document.removeEventListener('touchend', unlock, true);
        };
      };

      // Setup a touch start listener to attempt an unlock in.
      document.addEventListener('touchend', unlock, true);

      return self;
    },

    /**
     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
     * @return {Howler}
     */
    _autoSuspend: function() {
      var self = this;

      if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === 'undefined' || !Howler.usingWebAudio) {
        return;
      }

      // Check if any sounds are playing.
      for (var i=0; i<self._howls.length; i++) {
        if (self._howls[i]._webAudio) {
          for (var j=0; j<self._howls[i]._sounds.length; j++) {
            if (!self._howls[i]._sounds[j]._paused) {
              return self;
            }
          }
        }
      }

      if (self._suspendTimer) {
        clearTimeout(self._suspendTimer);
      }

      // If no sound has played after 30 seconds, suspend the context.
      self._suspendTimer = setTimeout(function() {
        if (!self.autoSuspend) {
          return;
        }

        self._suspendTimer = null;
        self.state = 'suspending';
        self.ctx.suspend().then(function() {
          self.state = 'suspended';

          if (self._resumeAfterSuspend) {
            delete self._resumeAfterSuspend;
            self._autoResume();
          }
        });
      }, 30000);

      return self;
    },

    /**
     * Automatically resume the Web Audio AudioContext when a new sound is played.
     * @return {Howler}
     */
    _autoResume: function() {
      var self = this;

      if (!self.ctx || typeof self.ctx.resume === 'undefined' || !Howler.usingWebAudio) {
        return;
      }

      if (self.state === 'running' && self._suspendTimer) {
        clearTimeout(self._suspendTimer);
        self._suspendTimer = null;
      } else if (self.state === 'suspended') {
        self.ctx.resume().then(function() {
          self.state = 'running';

          // Emit to all Howls that the audio has resumed.
          for (var i=0; i<self._howls.length; i++) {
            self._howls[i]._emit('resume');
          }
        });

        if (self._suspendTimer) {
          clearTimeout(self._suspendTimer);
          self._suspendTimer = null;
        }
      } else if (self.state === 'suspending') {
        self._resumeAfterSuspend = true;
      }

      return self;
    }
  };

  // Setup the global audio controller.
  var Howler = new HowlerGlobal();

  /** Group Methods **/
  /***************************************************************************/

  /**
   * Create an audio group controller.
   * @param {Object} o Passed in properties for this group.
   */
  var Howl = function(o) {
    var self = this;

    // Throw an error if no source is provided.
    if (!o.src || o.src.length === 0) {
      console.error('An array of source files must be passed with any new Howl.');
      return;
    }

    self.init(o);
  };
  Howl.prototype = {
    /**
     * Initialize a new Howl group object.
     * @param  {Object} o Passed in properties for this group.
     * @return {Howl}
     */
    init: function(o) {
      var self = this;

      // If we don't have an AudioContext created yet, run the setup.
      if (!Howler.ctx) {
        setupAudioContext();
      }

      // Setup user-defined default properties.
      self._autoplay = o.autoplay || false;
      self._format = (typeof o.format !== 'string') ? o.format : [o.format];
      self._html5 = o.html5 || false;
      self._muted = o.mute || false;
      self._loop = o.loop || false;
      self._pool = o.pool || 5;
      self._preload = (typeof o.preload === 'boolean') ? o.preload : true;
      self._rate = o.rate || 1;
      self._sprite = o.sprite || {};
      self._src = (typeof o.src !== 'string') ? o.src : [o.src];
      self._volume = o.volume !== undefined ? o.volume : 1;

      // Setup all other default properties.
      self._duration = 0;
      self._state = 'unloaded';
      self._sounds = [];
      self._endTimers = {};
      self._queue = [];

      // Setup event listeners.
      self._onend = o.onend ? [{fn: o.onend}] : [];
      self._onfade = o.onfade ? [{fn: o.onfade}] : [];
      self._onload = o.onload ? [{fn: o.onload}] : [];
      self._onloaderror = o.onloaderror ? [{fn: o.onloaderror}] : [];
      self._onpause = o.onpause ? [{fn: o.onpause}] : [];
      self._onplay = o.onplay ? [{fn: o.onplay}] : [];
      self._onstop = o.onstop ? [{fn: o.onstop}] : [];
      self._onmute = o.onmute ? [{fn: o.onmute}] : [];
      self._onvolume = o.onvolume ? [{fn: o.onvolume}] : [];
      self._onrate = o.onrate ? [{fn: o.onrate}] : [];
      self._onseek = o.onseek ? [{fn: o.onseek}] : [];
      self._onresume = [];

      // Web Audio or HTML5 Audio?
      self._webAudio = Howler.usingWebAudio && !self._html5;

      // Automatically try to enable audio on iOS.
      if (typeof Howler.ctx !== 'undefined' && Howler.ctx && Howler.mobileAutoEnable) {
        Howler._enableMobileAudio();
      }

      // Keep track of this Howl group in the global controller.
      Howler._howls.push(self);

      // If they selected autoplay, add a play event to the load queue.
      if (self._autoplay) {
        self._queue.push({
          event: 'play',
          action: function() {
            self.play();
          }
        });
      }

      // Load the source file unless otherwise specified.
      if (self._preload) {
        self.load();
      }

      return self;
    },

    /**
     * Load the audio file.
     * @return {Howler}
     */
    load: function() {
      var self = this;
      var url = null;

      // If no audio is available, quit immediately.
      if (Howler.noAudio) {
        self._emit('loaderror', null, 'No audio support.');
        return;
      }

      // Make sure our source is in an array.
      if (typeof self._src === 'string') {
        self._src = [self._src];
      }

      // Loop through the sources and pick the first one that is compatible.
      for (var i=0; i<self._src.length; i++) {
        var ext, str;

        if (self._format && self._format[i]) {
          // If an extension was specified, use that instead.
          ext = self._format[i];
        } else {
          // Make sure the source is a string.
          str = self._src[i];
          if (typeof str !== 'string') {
            self._emit('loaderror', null, 'Non-string found in selected audio sources - ignoring.');
            continue;
          }

          // Extract the file extension from the URL or base64 data URI.
          ext = /^data:audio\/([^;,]+);/i.exec(str);
          if (!ext) {
            ext = /\.([^.]+)$/.exec(str.split('?', 1)[0]);
          }

          if (ext) {
            ext = ext[1].toLowerCase();
          }
        }

        // Log a warning if no extension was found.
        if (!ext) {
          console.warn('No file extension was found. Consider using the "format" property or specify an extension.');
        }

        // Check if this extension is available.
        if (ext && Howler.codecs(ext)) {
          url = self._src[i];
          break;
        }
      }

      if (!url) {
        self._emit('loaderror', null, 'No codec support for selected audio sources.');
        return;
      }

      self._src = url;
      self._state = 'loading';

      // If the hosting page is HTTPS and the source isn't,
      // drop down to HTML5 Audio to avoid Mixed Content errors.
      if (window.location.protocol === 'https:' && url.slice(0, 5) === 'http:') {
        self._html5 = true;
        self._webAudio = false;
      }

      // Create a new sound object and add it to the pool.
      new Sound(self);

      // Load and decode the audio data for playback.
      if (self._webAudio) {
        loadBuffer(self);
      }

      return self;
    },

    /**
     * Play a sound or resume previous playback.
     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Number}          Sound ID.
     */
    play: function(sprite, internal) {
      var self = this;
      var id = null;

      // Determine if a sprite, sound id or nothing was passed
      if (typeof sprite === 'number') {
        id = sprite;
        sprite = null;
      } else if (typeof sprite === 'string' && self._state === 'loaded' && !self._sprite[sprite]) {
        // If the passed sprite doesn't exist, do nothing.
        return null;
      } else if (typeof sprite === 'undefined') {
        // Use the default sound sprite (plays the full audio length).
        sprite = '__default';

        // Check if there is a single paused sound that isn't ended.
        // If there is, play that sound. If not, continue as usual.
        var num = 0;
        for (var i=0; i<self._sounds.length; i++) {
          if (self._sounds[i]._paused && !self._sounds[i]._ended) {
            num++;
            id = self._sounds[i]._id;
          }
        }

        if (num === 1) {
          sprite = null;
        } else {
          id = null;
        }
      }

      // Get the selected node, or get one from the pool.
      var sound = id ? self._soundById(id) : self._inactiveSound();

      // If the sound doesn't exist, do nothing.
      if (!sound) {
        return null;
      }

      // Select the sprite definition.
      if (id && !sprite) {
        sprite = sound._sprite || '__default';
      }

      // If the sound hasn't loaded, we must wait to get the audio's duration.
      // We also need to wait to make sure we don't run into race conditions with
      // the order of function calls.
      if (self._state !== 'loaded') {
        // Set the sprite value on this sound.
        sound._sprite = sprite;

        // Makr this sounded as not ended in case another sound is played before this one loads.
        sound._ended = false;

        // Add the sound to the queue to be played on load.
        var soundId = sound._id;
        self._queue.push({
          event: 'play',
          action: function() {
            self.play(soundId);
          }
        });

        return soundId;
      }

      // Don't play the sound if an id was passed and it is already playing.
      if (id && !sound._paused) {
        // Trigger the play event, in order to keep iterating through queue.
        if (!internal) {
          setTimeout(function() {
            self._emit('play', sound._id);
          }, 0);
        }

        return sound._id;
      }

      // Make sure the AudioContext isn't suspended, and resume it if it is.
      if (self._webAudio) {
        Howler._autoResume();
      }

      // Determine how long to play for and where to start playing.
      var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
      var duration = Math.max(0, ((self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000) - seek);
      var timeout = (duration * 1000) / Math.abs(sound._rate);

      // Update the parameters of the sound
      sound._paused = false;
      sound._ended = false;
      sound._sprite = sprite;
      sound._seek = seek;
      sound._start = self._sprite[sprite][0] / 1000;
      sound._stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
      sound._loop = !!(sound._loop || self._sprite[sprite][2]);

      // Begin the actual playback.
      var node = sound._node;
      if (self._webAudio) {
        // Fire this when the sound is ready to play to begin Web Audio playback.
        var playWebAudio = function() {
          self._refreshBuffer(sound);

          // Setup the playback params.
          var vol = (sound._muted || self._muted) ? 0 : sound._volume;
          node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
          sound._playStart = Howler.ctx.currentTime;

          // Play the sound using the supported method.
          if (typeof node.bufferSource.start === 'undefined') {
            sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
          } else {
            sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
          }

          // Start a new timer if none is present.
          if (timeout !== Infinity) {
            self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
          }

          if (!internal) {
            setTimeout(function() {
              self._emit('play', sound._id);
            }, 0);
          }
        };

        var isRunning = (Howler.state === 'running');
        if (self._state === 'loaded' && isRunning) {
          playWebAudio();
        } else {
          // Wait for the audio to load and then begin playback.
          var event = !isRunning && self._state === 'loaded' ? 'resume' : 'load';
          self.once(event, playWebAudio, isRunning ? sound._id : null);

          // Cancel the end timer.
          self._clearTimer(sound._id);
        }
      } else {
        // Fire this when the sound is ready to play to begin HTML5 Audio playback.
        var playHtml5 = function() {
          node.currentTime = seek;
          node.muted = sound._muted || self._muted || Howler._muted || node.muted;
          node.volume = sound._volume * Howler.volume();
          node.playbackRate = sound._rate;
          node.play();

          // Setup the new end timer.
          if (timeout !== Infinity) {
            self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
          }

          if (!internal) {
            self._emit('play', sound._id);
          }
        };

        // Play immediately if ready, or wait for the 'canplaythrough'e vent.
        var loadedNoReadyState = (self._state === 'loaded' && (window && window.ejecta || !node.readyState && Howler._navigator.isCocoonJS));
        if (node.readyState === 4 || loadedNoReadyState) {
          playHtml5();
        } else {
          var listener = function() {
            // Begin playback.
            playHtml5();

            // Clear this listener.
            node.removeEventListener(Howler._canPlayEvent, listener, false);
          };
          node.addEventListener(Howler._canPlayEvent, listener, false);

          // Cancel the end timer.
          self._clearTimer(sound._id);
        }
      }

      return sound._id;
    },

    /**
     * Pause playback and save current position.
     * @param  {Number} id The sound ID (empty to pause all in group).
     * @return {Howl}
     */
    pause: function(id) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to pause when capable.
      if (self._state !== 'loaded') {
        self._queue.push({
          event: 'pause',
          action: function() {
            self.pause(id);
          }
        });

        return self;
      }

      // If no id is passed, get all ID's to be paused.
      var ids = self._getSoundIds(id);

      for (var i=0; i<ids.length; i++) {
        // Clear the end timer.
        self._clearTimer(ids[i]);

        // Get the sound.
        var sound = self._soundById(ids[i]);

        if (sound && !sound._paused) {
          // Reset the seek position.
          sound._seek = self.seek(ids[i]);
          sound._rateSeek = 0;
          sound._paused = true;

          // Stop currently running fades.
          self._stopFade(ids[i]);

          if (sound._node) {
            if (self._webAudio) {
              // Make sure the sound has been created.
              if (!sound._node.bufferSource) {
                continue;
              }

              if (typeof sound._node.bufferSource.stop === 'undefined') {
                sound._node.bufferSource.noteOff(0);
              } else {
                sound._node.bufferSource.stop(0);
              }

              // Clean up the buffer source.
              self._cleanBuffer(sound._node);
            } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
              sound._node.pause();
            }
          }
        }

        // Fire the pause event, unless `true` is passed as the 2nd argument.
        if (!arguments[1]) {
          self._emit('pause', sound ? sound._id : null);
        }
      }

      return self;
    },

    /**
     * Stop playback and reset to start.
     * @param  {Number} id The sound ID (empty to stop all in group).
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Howl}
     */
    stop: function(id, internal) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to stop when capable.
      if (self._state !== 'loaded') {
        self._queue.push({
          event: 'stop',
          action: function() {
            self.stop(id);
          }
        });

        return self;
      }

      // If no id is passed, get all ID's to be stopped.
      var ids = self._getSoundIds(id);

      for (var i=0; i<ids.length; i++) {
        // Clear the end timer.
        self._clearTimer(ids[i]);

        // Get the sound.
        var sound = self._soundById(ids[i]);

        if (sound) {
          // Reset the seek position.
          sound._seek = sound._start || 0;
          sound._rateSeek = 0;
          sound._paused = true;
          sound._ended = true;

          // Stop currently running fades.
          self._stopFade(ids[i]);

          if (sound._node) {
            if (self._webAudio) {
              // Make sure the sound's AudioBufferSourceNode has been created.
              if (sound._node.bufferSource) {
                if (typeof sound._node.bufferSource.stop === 'undefined') {
                  sound._node.bufferSource.noteOff(0);
                } else {
                  sound._node.bufferSource.stop(0);
                }

                // Clean up the buffer source.
                self._cleanBuffer(sound._node);
              }
            } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
              sound._node.currentTime = sound._start || 0;
              sound._node.pause();
            }
          }

          if (!internal) {
            self._emit('stop', sound._id);
          }
        }
      }

      return self;
    },

    /**
     * Mute/unmute a single sound or all sounds in this Howl group.
     * @param  {Boolean} muted Set to true to mute and false to unmute.
     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
     * @return {Howl}
     */
    mute: function(muted, id) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to mute when capable.
      if (self._state !== 'loaded') {
        self._queue.push({
          event: 'mute',
          action: function() {
            self.mute(muted, id);
          }
        });

        return self;
      }

      // If applying mute/unmute to all sounds, update the group's value.
      if (typeof id === 'undefined') {
        if (typeof muted === 'boolean') {
          self._muted = muted;
        } else {
          return self._muted;
        }
      }

      // If no id is passed, get all ID's to be muted.
      var ids = self._getSoundIds(id);

      for (var i=0; i<ids.length; i++) {
        // Get the sound.
        var sound = self._soundById(ids[i]);

        if (sound) {
          sound._muted = muted;

          if (self._webAudio && sound._node) {
            sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler.ctx.currentTime);
          } else if (sound._node) {
            sound._node.muted = Howler._muted ? true : muted;
          }

          self._emit('mute', sound._id);
        }
      }

      return self;
    },

    /**
     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
     *   volume() -> Returns the group's volume value.
     *   volume(id) -> Returns the sound id's current volume.
     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
     *   volume(vol, id) -> Sets the volume of passed sound id.
     * @return {Howl/Number} Returns self or current volume.
     */
    volume: function() {
      var self = this;
      var args = arguments;
      var vol, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // Return the value of the groups' volume.
        return self._volume;
      } else if (args.length === 1 || args.length === 2 && typeof args[1] === 'undefined') {
        // First check if this is an ID, and if not, assume it is a new volume.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else {
          vol = parseFloat(args[0]);
        }
      } else if (args.length >= 2) {
        vol = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // Update the volume or return the current volume.
      var sound;
      if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
        // If the sound hasn't loaded, add it to the load queue to change volume when capable.
        if (self._state !== 'loaded') {
          self._queue.push({
            event: 'volume',
            action: function() {
              self.volume.apply(self, args);
            }
          });

          return self;
        }

        // Set the group volume.
        if (typeof id === 'undefined') {
          self._volume = vol;
        }

        // Update one or all volumes.
        id = self._getSoundIds(id);
        for (var i=0; i<id.length; i++) {
          // Get the sound.
          sound = self._soundById(id[i]);

          if (sound) {
            sound._volume = vol;

            // Stop currently running fades.
            if (!args[2]) {
              self._stopFade(id[i]);
            }

            if (self._webAudio && sound._node && !sound._muted) {
              sound._node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
            } else if (sound._node && !sound._muted) {
              sound._node.volume = vol * Howler.volume();
            }

            self._emit('volume', sound._id);
          }
        }
      } else {
        sound = id ? self._soundById(id) : self._sounds[0];
        return sound ? sound._volume : 0;
      }

      return self;
    },

    /**
     * Fade a currently playing sound between two volumes (if no id is passsed, all sounds will fade).
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id (omit to fade all sounds).
     * @return {Howl}
     */
    fade: function(from, to, len, id) {
      var self = this;
      var diff = Math.abs(from - to);
      var dir = from > to ? 'out' : 'in';
      var steps = diff / 0.01;
      var stepLen = (steps > 0) ? len / steps : len;

      // Since browsers clamp timeouts to 4ms, we need to clamp our steps to that too.
      if (stepLen < 4) {
        steps = Math.ceil(steps / (4 / stepLen));
        stepLen = 4;
      }

      // If the sound hasn't loaded, add it to the load queue to fade when capable.
      if (self._state !== 'loaded') {
        self._queue.push({
          event: 'fade',
          action: function() {
            self.fade(from, to, len, id);
          }
        });

        return self;
      }

      // Set the volume to the start position.
      self.volume(from, id);

      // Fade the volume of one or all sounds.
      var ids = self._getSoundIds(id);
      for (var i=0; i<ids.length; i++) {
        // Get the sound.
        var sound = self._soundById(ids[i]);

        // Create a linear fade or fall back to timeouts with HTML5 Audio.
        if (sound) {
          // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
          if (!id) {
            self._stopFade(ids[i]);
          }

          // If we are using Web Audio, let the native methods do the actual fade.
          if (self._webAudio && !sound._muted) {
            var currentTime = Howler.ctx.currentTime;
            var end = currentTime + (len / 1000);
            sound._volume = from;
            sound._node.gain.setValueAtTime(from, currentTime);
            sound._node.gain.linearRampToValueAtTime(to, end);
          }

          var vol = from;
          sound._interval = setInterval(function(soundId, sound) {
            // Update the volume amount, but only if the volume should change.
            if (steps > 0) {
              vol += (dir === 'in' ? 0.01 : -0.01);
            }

            // Make sure the volume is in the right bounds.
            vol = Math.max(0, vol);
            vol = Math.min(1, vol);

            // Round to within 2 decimal points.
            vol = Math.round(vol * 100) / 100;

            // Change the volume.
            if (self._webAudio) {
              if (typeof id === 'undefined') {
                self._volume = vol;
              }

              sound._volume = vol;
            } else {
              self.volume(vol, soundId, true);
            }

            // When the fade is complete, stop it and fire event.
            if ((to < from && vol <= to) || (to > from && vol >= to)) {
              clearInterval(sound._interval);
              sound._interval = null;
              self.volume(to, soundId);
              self._emit('fade', soundId);
            }
          }.bind(self, ids[i], sound), stepLen);
        }
      }

      return self;
    },

    /**
     * Internal method that stops the currently playing fade when
     * a new fade starts, volume is changed or the sound is stopped.
     * @param  {Number} id The sound id.
     * @return {Howl}
     */
    _stopFade: function(id) {
      var self = this;
      var sound = self._soundById(id);

      if (sound && sound._interval) {
        if (self._webAudio) {
          sound._node.gain.cancelScheduledValues(Howler.ctx.currentTime);
        }

        clearInterval(sound._interval);
        sound._interval = null;
        self._emit('fade', id);
      }

      return self;
    },

    /**
     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
     *   loop() -> Returns the group's loop value.
     *   loop(id) -> Returns the sound id's loop value.
     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
     *   loop(loop, id) -> Sets the loop value of passed sound id.
     * @return {Howl/Boolean} Returns self or current loop value.
     */
    loop: function() {
      var self = this;
      var args = arguments;
      var loop, id, sound;

      // Determine the values for loop and id.
      if (args.length === 0) {
        // Return the grou's loop value.
        return self._loop;
      } else if (args.length === 1) {
        if (typeof args[0] === 'boolean') {
          loop = args[0];
          self._loop = loop;
        } else {
          // Return this sound's loop value.
          sound = self._soundById(parseInt(args[0], 10));
          return sound ? sound._loop : false;
        }
      } else if (args.length === 2) {
        loop = args[0];
        id = parseInt(args[1], 10);
      }

      // If no id is passed, get all ID's to be looped.
      var ids = self._getSoundIds(id);
      for (var i=0; i<ids.length; i++) {
        sound = self._soundById(ids[i]);

        if (sound) {
          sound._loop = loop;
          if (self._webAudio && sound._node && sound._node.bufferSource) {
            sound._node.bufferSource.loop = loop;
            if (loop) {
              sound._node.bufferSource.loopStart = sound._start || 0;
              sound._node.bufferSource.loopEnd = sound._stop;
            }
          }
        }
      }

      return self;
    },

    /**
     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   rate() -> Returns the first sound node's current playback rate.
     *   rate(id) -> Returns the sound id's current playback rate.
     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
     *   rate(rate, id) -> Sets the playback rate of passed sound id.
     * @return {Howl/Number} Returns self or the current playback rate.
     */
    rate: function() {
      var self = this;
      var args = arguments;
      var rate, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // We will simply return the current rate of the first node.
        id = self._sounds[0]._id;
      } else if (args.length === 1) {
        // First check if this is an ID, and if not, assume it is a new rate value.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else {
          rate = parseFloat(args[0]);
        }
      } else if (args.length === 2) {
        rate = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // Update the playback rate or return the current value.
      var sound;
      if (typeof rate === 'number') {
        // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
        if (self._state !== 'loaded') {
          self._queue.push({
            event: 'rate',
            action: function() {
              self.rate.apply(self, args);
            }
          });

          return self;
        }

        // Set the group rate.
        if (typeof id === 'undefined') {
          self._rate = rate;
        }

        // Update one or all volumes.
        id = self._getSoundIds(id);
        for (var i=0; i<id.length; i++) {
          // Get the sound.
          sound = self._soundById(id[i]);

          if (sound) {
            // Keep track of our position when the rate changed and update the playback
            // start position so we can properly adjust the seek position for time elapsed.
            sound._rateSeek = self.seek(id[i]);
            sound._playStart = self._webAudio ? Howler.ctx.currentTime : sound._playStart;
            sound._rate = rate;

            // Change the playback rate.
            if (self._webAudio && sound._node && sound._node.bufferSource) {
              sound._node.bufferSource.playbackRate.value = rate;
            } else if (sound._node) {
              sound._node.playbackRate = rate;
            }

            // Reset the timers.
            var seek = self.seek(id[i]);
            var duration = ((self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000) - seek;
            var timeout = (duration * 1000) / Math.abs(sound._rate);

            // Start a new end timer if sound is already playing.
            if (self._endTimers[id[i]] || !sound._paused) {
              self._clearTimer(id[i]);
              self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
            }

            self._emit('rate', sound._id);
          }
        }
      } else {
        sound = self._soundById(id);
        return sound ? sound._rate : self._rate;
      }

      return self;
    },

    /**
     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   seek() -> Returns the first sound node's current seek position.
     *   seek(id) -> Returns the sound id's current seek position.
     *   seek(seek) -> Sets the seek position of the first sound node.
     *   seek(seek, id) -> Sets the seek position of passed sound id.
     * @return {Howl/Number} Returns self or the current seek position.
     */
    seek: function() {
      var self = this;
      var args = arguments;
      var seek, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // We will simply return the current position of the first node.
        id = self._sounds[0]._id;
      } else if (args.length === 1) {
        // First check if this is an ID, and if not, assume it is a new seek position.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else {
          id = self._sounds[0]._id;
          seek = parseFloat(args[0]);
        }
      } else if (args.length === 2) {
        seek = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // If there is no ID, bail out.
      if (typeof id === 'undefined') {
        return self;
      }

      // If the sound hasn't loaded, add it to the load queue to seek when capable.
      if (self._state !== 'loaded') {
        self._queue.push({
          event: 'seek',
          action: function() {
            self.seek.apply(self, args);
          }
        });

        return self;
      }

      // Get the sound.
      var sound = self._soundById(id);

      if (sound) {
        if (typeof seek === 'number' && seek >= 0) {
          // Pause the sound and update position for restarting playback.
          var playing = self.playing(id);
          if (playing) {
            self.pause(id, true);
          }

          // Move the position of the track and cancel timer.
          sound._seek = seek;
          sound._ended = false;
          self._clearTimer(id);

          // Restart the playback if the sound was playing.
          if (playing) {
            self.play(id, true);
          }

          // Update the seek position for HTML5 Audio.
          if (!self._webAudio && sound._node) {
            sound._node.currentTime = seek;
          }

          self._emit('seek', id);
        } else {
          if (self._webAudio) {
            var realTime = self.playing(id) ? Howler.ctx.currentTime - sound._playStart : 0;
            var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
            return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
          } else {
            return sound._node.currentTime;
          }
        }
      }

      return self;
    },

    /**
     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
     * @return {Boolean} True if playing and false if not.
     */
    playing: function(id) {
      var self = this;

      // Check the passed sound ID (if any).
      if (typeof id === 'number') {
        var sound = self._soundById(id);
        return sound ? !sound._paused : false;
      }

      // Otherwise, loop through all sounds and check if any are playing.
      for (var i=0; i<self._sounds.length; i++) {
        if (!self._sounds[i]._paused) {
          return true;
        }
      }

      return false;
    },

    /**
     * Get the duration of this sound. Passing a sound id will return the sprite duration.
     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
     * @return {Number} Audio duration in seconds.
     */
    duration: function(id) {
      var self = this;
      var duration = self._duration;

      // If we pass an ID, get the sound and return the sprite length.
      var sound = self._soundById(id);
      if (sound) {
        duration = self._sprite[sound._sprite][1] / 1000;
      }

      return duration;
    },

    /**
     * Returns the current loaded state of this Howl.
     * @return {String} 'unloaded', 'loading', 'loaded'
     */
    state: function() {
      return this._state;
    },

    /**
     * Unload and destroy the current Howl object.
     * This will immediately stop all sound instances attached to this group.
     */
    unload: function() {
      var self = this;

      // Stop playing any active sounds.
      var sounds = self._sounds;
      for (var i=0; i<sounds.length; i++) {
        // Stop the sound if it is currently playing.
        if (!sounds[i]._paused) {
          self.stop(sounds[i]._id);
        }

        // Remove the source or disconnect.
        if (!self._webAudio) {
          // Set the source to 0-second silence to stop any downloading (except in IE).
          var checkIE = /MSIE |Trident\//.test(Howler._navigator && Howler._navigator.userAgent);
          if (!checkIE) {
            sounds[i]._node.src = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';
          }

          // Remove any event listeners.
          sounds[i]._node.removeEventListener('error', sounds[i]._errorFn, false);
          sounds[i]._node.removeEventListener(Howler._canPlayEvent, sounds[i]._loadFn, false);
        }

        // Empty out all of the nodes.
        delete sounds[i]._node;

        // Make sure all timers are cleared out.
        self._clearTimer(sounds[i]._id);

        // Remove the references in the global Howler object.
        var index = Howler._howls.indexOf(self);
        if (index >= 0) {
          Howler._howls.splice(index, 1);
        }
      }

      // Delete this sound from the cache (if no other Howl is using it).
      var remCache = true;
      for (i=0; i<Howler._howls.length; i++) {
        if (Howler._howls[i]._src === self._src) {
          remCache = false;
          break;
        }
      }

      if (cache && remCache) {
        delete cache[self._src];
      }

      // Clear global errors.
      Howler.noAudio = false;

      // Clear out `self`.
      self._state = 'unloaded';
      self._sounds = [];
      self = null;

      return null;
    },

    /**
     * Listen to a custom event.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
     * @return {Howl}
     */
    on: function(event, fn, id, once) {
      var self = this;
      var events = self['_on' + event];

      if (typeof fn === 'function') {
        events.push(once ? {id: id, fn: fn, once: once} : {id: id, fn: fn});
      }

      return self;
    },

    /**
     * Remove a custom event. Call without parameters to remove all events.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
     * @param  {Number}   id    (optional) Only remove events for this sound.
     * @return {Howl}
     */
    off: function(event, fn, id) {
      var self = this;
      var events = self['_on' + event];
      var i = 0;

      // Allow passing just an event and ID.
      if (typeof fn === 'number') {
        id = fn;
        fn = null;
      }

      if (fn || id) {
        // Loop through event store and remove the passed function.
        for (i=0; i<events.length; i++) {
          var isId = (id === events[i].id);
          if (fn === events[i].fn && isId || !fn && isId) {
            events.splice(i, 1);
            break;
          }
        }
      } else if (event) {
        // Clear out all events of this type.
        self['_on' + event] = [];
      } else {
        // Clear out all events of every type.
        var keys = Object.keys(self);
        for (i=0; i<keys.length; i++) {
          if ((keys[i].indexOf('_on') === 0) && Array.isArray(self[keys[i]])) {
            self[keys[i]] = [];
          }
        }
      }

      return self;
    },

    /**
     * Listen to a custom event and remove it once fired.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @return {Howl}
     */
    once: function(event, fn, id) {
      var self = this;

      // Setup the event listener.
      self.on(event, fn, id, 1);

      return self;
    },

    /**
     * Emit all events of a specific type and pass the sound id.
     * @param  {String} event Event name.
     * @param  {Number} id    Sound ID.
     * @param  {Number} msg   Message to go with event.
     * @return {Howl}
     */
    _emit: function(event, id, msg) {
      var self = this;
      var events = self['_on' + event];

      // Loop through event store and fire all functions.
      for (var i=events.length-1; i>=0; i--) {
        if (!events[i].id || events[i].id === id || event === 'load') {
          setTimeout(function(fn) {
            fn.call(this, id, msg);
          }.bind(self, events[i].fn), 0);

          // If this event was setup with `once`, remove it.
          if (events[i].once) {
            self.off(event, events[i].fn, events[i].id);
          }
        }
      }

      return self;
    },

    /**
     * Queue of actions initiated before the sound has loaded.
     * These will be called in sequence, with the next only firing
     * after the previous has finished executing (even if async like play).
     * @return {Howl}
     */
    _loadQueue: function() {
      var self = this;

      if (self._queue.length > 0) {
        var task = self._queue[0];

        // don't move onto the next task until this one is done
        self.once(task.event, function() {
          self._queue.shift();
          self._loadQueue();
        });

        task.action();
      }

      return self;
    },

    /**
     * Fired when playback ends at the end of the duration.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */
    _ended: function(sound) {
      var self = this;
      var sprite = sound._sprite;

      // If we are using IE and there was network latency we may be clipping
      // audio before it completes playing. Lets check the node to make sure it
      // believes it has completed, before ending the playback.
      if (!self._webAudio && self._node && !self._node.ended) {
        setTimeout(self._ended.bind(self, sound), 100);
        return self;
      }

      // Should this sound loop?
      var loop = !!(sound._loop || self._sprite[sprite][2]);

      // Fire the ended event.
      self._emit('end', sound._id);

      // Restart the playback for HTML5 Audio loop.
      if (!self._webAudio && loop) {
        self.stop(sound._id, true).play(sound._id);
      }

      // Restart this timer if on a Web Audio loop.
      if (self._webAudio && loop) {
        self._emit('play', sound._id);
        sound._seek = sound._start || 0;
        sound._rateSeek = 0;
        sound._playStart = Howler.ctx.currentTime;

        var timeout = ((sound._stop - sound._start) * 1000) / Math.abs(sound._rate);
        self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
      }

      // Mark the node as paused.
      if (self._webAudio && !loop) {
        sound._paused = true;
        sound._ended = true;
        sound._seek = sound._start || 0;
        sound._rateSeek = 0;
        self._clearTimer(sound._id);

        // Clean up the buffer source.
        self._cleanBuffer(sound._node);

        // Attempt to auto-suspend AudioContext if no sounds are still playing.
        Howler._autoSuspend();
      }

      // When using a sprite, end the track.
      if (!self._webAudio && !loop) {
        self.stop(sound._id);
      }

      return self;
    },

    /**
     * Clear the end timer for a sound playback.
     * @param  {Number} id The sound ID.
     * @return {Howl}
     */
    _clearTimer: function(id) {
      var self = this;

      if (self._endTimers[id]) {
        clearTimeout(self._endTimers[id]);
        delete self._endTimers[id];
      }

      return self;
    },

    /**
     * Return the sound identified by this ID, or return null.
     * @param  {Number} id Sound ID
     * @return {Object}    Sound object or null.
     */
    _soundById: function(id) {
      var self = this;

      // Loop through all sounds and find the one with this ID.
      for (var i=0; i<self._sounds.length; i++) {
        if (id === self._sounds[i]._id) {
          return self._sounds[i];
        }
      }

      return null;
    },

    /**
     * Return an inactive sound from the pool or create a new one.
     * @return {Sound} Sound playback object.
     */
    _inactiveSound: function() {
      var self = this;

      self._drain();

      // Find the first inactive node to recycle.
      for (var i=0; i<self._sounds.length; i++) {
        if (self._sounds[i]._ended) {
          return self._sounds[i].reset();
        }
      }

      // If no inactive node was found, create a new one.
      return new Sound(self);
    },

    /**
     * Drain excess inactive sounds from the pool.
     */
    _drain: function() {
      var self = this;
      var limit = self._pool;
      var cnt = 0;
      var i = 0;

      // If there are less sounds than the max pool size, we are done.
      if (self._sounds.length < limit) {
        return;
      }

      // Count the number of inactive sounds.
      for (i=0; i<self._sounds.length; i++) {
        if (self._sounds[i]._ended) {
          cnt++;
        }
      }

      // Remove excess inactive sounds, going in reverse order.
      for (i=self._sounds.length - 1; i>=0; i--) {
        if (cnt <= limit) {
          return;
        }

        if (self._sounds[i]._ended) {
          // Disconnect the audio source when using Web Audio.
          if (self._webAudio && self._sounds[i]._node) {
            self._sounds[i]._node.disconnect(0);
          }

          // Remove sounds until we have the pool size.
          self._sounds.splice(i, 1);
          cnt--;
        }
      }
    },

    /**
     * Get all ID's from the sounds pool.
     * @param  {Number} id Only return one ID if one is passed.
     * @return {Array}    Array of IDs.
     */
    _getSoundIds: function(id) {
      var self = this;

      if (typeof id === 'undefined') {
        var ids = [];
        for (var i=0; i<self._sounds.length; i++) {
          ids.push(self._sounds[i]._id);
        }

        return ids;
      } else {
        return [id];
      }
    },

    /**
     * Load the sound back into the buffer source.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */
    _refreshBuffer: function(sound) {
      var self = this;

      // Setup the buffer source for playback.
      sound._node.bufferSource = Howler.ctx.createBufferSource();
      sound._node.bufferSource.buffer = cache[self._src];

      // Connect to the correct node.
      if (sound._panner) {
        sound._node.bufferSource.connect(sound._panner);
      } else {
        sound._node.bufferSource.connect(sound._node);
      }

      // Setup looping and playback rate.
      sound._node.bufferSource.loop = sound._loop;
      if (sound._loop) {
        sound._node.bufferSource.loopStart = sound._start || 0;
        sound._node.bufferSource.loopEnd = sound._stop;
      }
      sound._node.bufferSource.playbackRate.value = sound._rate;

      return self;
    },

    /**
     * Prevent memory leaks by cleaning up the buffer source after playback.
     * @param  {Object} node Sound's audio node containing the buffer source.
     * @return {Howl}
     */
    _cleanBuffer: function(node) {
      var self = this;

      if (self._scratchBuffer) {
        node.bufferSource.onended = null;
        node.bufferSource.disconnect(0);
        try { node.bufferSource.buffer = self._scratchBuffer; } catch(e) {}
      }
      node.bufferSource = null;

      return self;
    }
  };

  /** Single Sound Methods **/
  /***************************************************************************/

  /**
   * Setup the sound object, which each node attached to a Howl group is contained in.
   * @param {Object} howl The Howl parent group.
   */
  var Sound = function(howl) {
    this._parent = howl;
    this.init();
  };
  Sound.prototype = {
    /**
     * Initialize a new Sound object.
     * @return {Sound}
     */
    init: function() {
      var self = this;
      var parent = self._parent;

      // Setup the default parameters.
      self._muted = parent._muted;
      self._loop = parent._loop;
      self._volume = parent._volume;
      self._rate = parent._rate;
      self._seek = 0;
      self._paused = true;
      self._ended = true;
      self._sprite = '__default';

      // Generate a unique ID for this sound.
      self._id = ++Howler._counter;

      // Add itself to the parent's pool.
      parent._sounds.push(self);

      // Create the new node.
      self.create();

      return self;
    },

    /**
     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
     * @return {Sound}
     */
    create: function() {
      var self = this;
      var parent = self._parent;
      var volume = (Howler._muted || self._muted || self._parent._muted) ? 0 : self._volume;

      if (parent._webAudio) {
        // Create the gain node for controlling volume (the source will connect to this).
        self._node = (typeof Howler.ctx.createGain === 'undefined') ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
        self._node.gain.setValueAtTime(volume, Howler.ctx.currentTime);
        self._node.paused = true;
        self._node.connect(Howler.masterGain);
      } else {
        self._node = new Audio();

        // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
        self._errorFn = self._errorListener.bind(self);
        self._node.addEventListener('error', self._errorFn, false);

        // Listen for 'canplaythrough' event to let us know the sound is ready.
        self._loadFn = self._loadListener.bind(self);
        self._node.addEventListener(Howler._canPlayEvent, self._loadFn, false);

        // Setup the new audio node.
        self._node.src = parent._src;
        self._node.preload = 'auto';
        self._node.volume = volume * Howler.volume();

        // Begin loading the source.
        self._node.load();
      }

      return self;
    },

    /**
     * Reset the parameters of this sound to the original state (for recycle).
     * @return {Sound}
     */
    reset: function() {
      var self = this;
      var parent = self._parent;

      // Reset all of the parameters of this sound.
      self._muted = parent._muted;
      self._loop = parent._loop;
      self._volume = parent._volume;
      self._rate = parent._rate;
      self._seek = 0;
      self._rateSeek = 0;
      self._paused = true;
      self._ended = true;
      self._sprite = '__default';

      // Generate a new ID so that it isn't confused with the previous sound.
      self._id = ++Howler._counter;

      return self;
    },

    /**
     * HTML5 Audio error listener callback.
     */
    _errorListener: function() {
      var self = this;

      // Fire an error event and pass back the code.
      self._parent._emit('loaderror', self._id, self._node.error ? self._node.error.code : 0);

      // Clear the event listener.
      self._node.removeEventListener('error', self._errorFn, false);
    },

    /**
     * HTML5 Audio canplaythrough listener callback.
     */
    _loadListener: function() {
      var self = this;
      var parent = self._parent;

      // Round up the duration to account for the lower precision in HTML5 Audio.
      parent._duration = Math.ceil(self._node.duration * 10) / 10;

      // Setup a sprite if none is defined.
      if (Object.keys(parent._sprite).length === 0) {
        parent._sprite = {__default: [0, parent._duration * 1000]};
      }

      if (parent._state !== 'loaded') {
        parent._state = 'loaded';
        parent._emit('load');
        parent._loadQueue();
      }

      // Clear the event listener.
      self._node.removeEventListener(Howler._canPlayEvent, self._loadFn, false);
    }
  };

  /** Helper Methods **/
  /***************************************************************************/

  var cache = {};

  /**
   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
   * @param  {Howl} self
   */
  var loadBuffer = function(self) {
    var url = self._src;

    // Check if the buffer has already been cached and use it instead.
    if (cache[url]) {
      // Set the duration from the cache.
      self._duration = cache[url].duration;

      // Load the sound into this Howl.
      loadSound(self);

      return;
    }

    if (/^data:[^;]+;base64,/.test(url)) {
      // Decode the base64 data URI without XHR, since some browsers don't support it.
      var data = atob(url.split(',')[1]);
      var dataView = new Uint8Array(data.length);
      for (var i=0; i<data.length; ++i) {
        dataView[i] = data.charCodeAt(i);
      }

      decodeAudioData(dataView.buffer, self);
    } else {
      // Load the buffer from the URL.
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'arraybuffer';
      xhr.onload = function() {
        // Make sure we get a successful response back.
        var code = (xhr.status + '')[0];
        if (code !== '0' && code !== '2' && code !== '3') {
          self._emit('loaderror', null, 'Failed loading audio file with status: ' + xhr.status + '.');
          return;
        }

        decodeAudioData(xhr.response, self);
      };
      xhr.onerror = function() {
        // If there is an error, switch to HTML5 Audio.
        if (self._webAudio) {
          self._html5 = true;
          self._webAudio = false;
          self._sounds = [];
          delete cache[url];
          self.load();
        }
      };
      safeXhrSend(xhr);
    }
  };

  /**
   * Send the XHR request wrapped in a try/catch.
   * @param  {Object} xhr XHR to send.
   */
  var safeXhrSend = function(xhr) {
    try {
      xhr.send();
    } catch (e) {
      xhr.onerror();
    }
  };

  /**
   * Decode audio data from an array buffer.
   * @param  {ArrayBuffer} arraybuffer The audio data.
   * @param  {Howl}        self
   */
  var decodeAudioData = function(arraybuffer, self) {
    // Decode the buffer into an audio source.
    Howler.ctx.decodeAudioData(arraybuffer, function(buffer) {
      if (buffer && self._sounds.length > 0) {
        cache[self._src] = buffer;
        loadSound(self, buffer);
      }
    }, function() {
      self._emit('loaderror', null, 'Decoding audio data failed.');
    });
  };

  /**
   * Sound is now loaded, so finish setting everything up and fire the loaded event.
   * @param  {Howl} self
   * @param  {Object} buffer The decoded buffer sound source.
   */
  var loadSound = function(self, buffer) {
    // Set the duration.
    if (buffer && !self._duration) {
      self._duration = buffer.duration;
    }

    // Setup a sprite if none is defined.
    if (Object.keys(self._sprite).length === 0) {
      self._sprite = {__default: [0, self._duration * 1000]};
    }

    // Fire the loaded event.
    if (self._state !== 'loaded') {
      self._state = 'loaded';
      self._emit('load');
      self._loadQueue();
    }
  };

  /**
   * Setup the audio context when available, or switch to HTML5 Audio mode.
   */
  var setupAudioContext = function() {
    // Check if we are using Web Audio and setup the AudioContext if we are.
    try {
      if (typeof AudioContext !== 'undefined') {
        Howler.ctx = new AudioContext();
      } else if (typeof webkitAudioContext !== 'undefined') {
        Howler.ctx = new webkitAudioContext();
      } else {
        Howler.usingWebAudio = false;
      }
    } catch(e) {
      Howler.usingWebAudio = false;
    }

    // Check if a webview is being used on iOS8 or earlier (rather than the browser).
    // If it is, disable Web Audio as it causes crashing.
    var iOS = (/iP(hone|od|ad)/.test(Howler._navigator && Howler._navigator.platform));
    var appVersion = Howler._navigator && Howler._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    var version = appVersion ? parseInt(appVersion[1], 10) : null;
    if (iOS && version && version < 9) {
      var safari = /safari/.test(Howler._navigator && Howler._navigator.userAgent.toLowerCase());
      if (Howler._navigator && Howler._navigator.standalone && !safari || Howler._navigator && !Howler._navigator.standalone && !safari) {
        Howler.usingWebAudio = false;
      }
    }

    // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
    if (Howler.usingWebAudio) {
      Howler.masterGain = (typeof Howler.ctx.createGain === 'undefined') ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
      Howler.masterGain.gain.value = Howler._muted ? 0 : 1;
      Howler.masterGain.connect(Howler.ctx.destination);
    }

    // Re-run the setup on Howler.
    Howler._setup();
  };

  // Add support for AMD (Asynchronous Module Definition) libraries such as require.js.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return {
        Howler: Howler,
        Howl: Howl
      };
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }

  // Add support for CommonJS libraries such as browserify.
  if (true) {
    exports.Howler = Howler;
    exports.Howl = Howl;
  }

  // Define globally in case AMD is not available or unused.
  if (typeof window !== 'undefined') {
    window.HowlerGlobal = HowlerGlobal;
    window.Howler = Howler;
    window.Howl = Howl;
    window.Sound = Sound;
  } else if (typeof global !== 'undefined') { // Add to global in Node.js (for testing, etc).
    global.HowlerGlobal = HowlerGlobal;
    global.Howler = Howler;
    global.Howl = Howl;
    global.Sound = Sound;
  }
})();


/*!
 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
 *  
 *  howler.js v2.0.4
 *  howlerjs.com
 *
 *  (c) 2013-2017, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */

(function() {

  'use strict';

  // Setup default properties.
  HowlerGlobal.prototype._pos = [0, 0, 0];
  HowlerGlobal.prototype._orientation = [0, 0, -1, 0, 1, 0];
  
  /** Global Methods **/
  /***************************************************************************/

  /**
   * Helper method to update the stereo panning position of all current Howls.
   * Future Howls will not use this value unless explicitly set.
   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
   * @return {Howler/Number}     Self or current stereo panning value.
   */
  HowlerGlobal.prototype.stereo = function(pan) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Loop through all Howls and update their stereo panning.
    for (var i=self._howls.length-1; i>=0; i--) {
      self._howls[i].stereo(pan);
    }

    return self;
  };

  /**
   * Get/set the position of the listener in 3D cartesian space. Sounds using
   * 3D position will be relative to the listener's position.
   * @param  {Number} x The x-position of the listener.
   * @param  {Number} y The y-position of the listener.
   * @param  {Number} z The z-position of the listener.
   * @return {Howler/Array}   Self or current listener position.
   */
  HowlerGlobal.prototype.pos = function(x, y, z) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = (typeof y !== 'number') ? self._pos[1] : y;
    z = (typeof z !== 'number') ? self._pos[2] : z;

    if (typeof x === 'number') {
      self._pos = [x, y, z];
      self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
    } else {
      return self._pos;
    }

    return self;
  };

  /**
   * Get/set the direction the listener is pointing in the 3D cartesian space.
   * A front and up vector must be provided. The front is the direction the
   * face of the listener is pointing, and up is the direction the top of the
   * listener is pointing. Thus, these values are expected to be at right angles
   * from each other.
   * @param  {Number} x   The x-orientation of the listener.
   * @param  {Number} y   The y-orientation of the listener.
   * @param  {Number} z   The z-orientation of the listener.
   * @param  {Number} xUp The x-orientation of the top of the listener.
   * @param  {Number} yUp The y-orientation of the top of the listener.
   * @param  {Number} zUp The z-orientation of the top of the listener.
   * @return {Howler/Array}     Returns self or the current orientation vectors.
   */
  HowlerGlobal.prototype.orientation = function(x, y, z, xUp, yUp, zUp) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    var or = self._orientation;
    y = (typeof y !== 'number') ? or[1] : y;
    z = (typeof z !== 'number') ? or[2] : z;
    xUp = (typeof xUp !== 'number') ? or[3] : xUp;
    yUp = (typeof yUp !== 'number') ? or[4] : yUp;
    zUp = (typeof zUp !== 'number') ? or[5] : zUp;

    if (typeof x === 'number') {
      self._orientation = [x, y, z, xUp, yUp, zUp];
      self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
    } else {
      return or;
    }

    return self;
  };

  /** Group Methods **/
  /***************************************************************************/

  /**
   * Add new properties to the core init.
   * @param  {Function} _super Core init method.
   * @return {Howl}
   */
  Howl.prototype.init = (function(_super) {
    return function(o) {
      var self = this;

      // Setup user-defined default properties.
      self._orientation = o.orientation || [1, 0, 0];
      self._stereo = o.stereo || null;
      self._pos = o.pos || null;
      self._pannerAttr = {
        coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : 360,
        coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : 360,
        coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : 0,
        distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : 'inverse',
        maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : 10000,
        panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : 'HRTF',
        refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : 1,
        rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : 1
      };

      // Setup event listeners.
      self._onstereo = o.onstereo ? [{fn: o.onstereo}] : [];
      self._onpos = o.onpos ? [{fn: o.onpos}] : [];
      self._onorientation = o.onorientation ? [{fn: o.onorientation}] : [];

      // Complete initilization with howler.js core's init function.
      return _super.call(this, o);
    };
  })(Howl.prototype.init);

  /**
   * Get/set the stereo panning of the audio source for this sound or all in the group.
   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Number}    Returns self or the current stereo panning value.
   */
  Howl.prototype.stereo = function(pan, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'stereo',
        action: function() {
          self.stereo(pan, id);
        }
      });

      return self;
    }

    // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
    var pannerType = (typeof Howler.ctx.createStereoPanner === 'undefined') ? 'spatial' : 'stereo';

    // Setup the group's stereo panning if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's stereo panning if no parameters are passed.
      if (typeof pan === 'number') {
        self._stereo = pan;
        self._pos = [pan, 0, 0];
      } else {
        return self._stereo;
      }
    }

    // Change the streo panning of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);

      if (sound) {
        if (typeof pan === 'number') {
          sound._stereo = pan;
          sound._pos = [pan, 0, 0];

          if (sound._node) {
            // If we are falling back, make sure the panningModel is equalpower.
            sound._pannerAttr.panningModel = 'equalpower';

            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner || !sound._panner.pan) {
              setupPanner(sound, pannerType);
            }

            if (pannerType === 'spatial') {
              sound._panner.setPosition(pan, 0, 0);
            } else {
              sound._panner.pan.value = pan;
            }
          }

          self._emit('stereo', sound._id);
        } else {
          return sound._stereo;
        }
      }
    }

    return self;
  };

  /**
   * Get/set the 3D spatial position of the audio source for this sound or
   * all in the group. The most common usage is to set the 'x' position for
   * left/right panning. Setting any value higher than 1.0 will begin to
   * decrease the volume of the sound as it moves further away.
   * @param  {Number} x  The x-position of the audio from -1000.0 to 1000.0.
   * @param  {Number} y  The y-position of the audio from -1000.0 to 1000.0.
   * @param  {Number} z  The z-position of the audio from -1000.0 to 1000.0.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
   */
  Howl.prototype.pos = function(x, y, z, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change position when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'pos',
        action: function() {
          self.pos(x, y, z, id);
        }
      });

      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = (typeof y !== 'number') ? 0 : y;
    z = (typeof z !== 'number') ? -0.5 : z;

    // Setup the group's spatial position if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's spatial position if no parameters are passed.
      if (typeof x === 'number') {
        self._pos = [x, y, z];
      } else {
        return self._pos;
      }
    }

    // Change the spatial position of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);

      if (sound) {
        if (typeof x === 'number') {
          sound._pos = [x, y, z];

          if (sound._node) {
            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner || sound._panner.pan) {
              setupPanner(sound, 'spatial');
            }

            sound._panner.setPosition(x, y, z);
          }

          self._emit('pos', sound._id);
        } else {
          return sound._pos;
        }
      }
    }

    return self;
  };

  /**
   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
   * space. Depending on how direction the sound is, based on the `cone` attributes,
   * a sound pointing away from the listener can be quiet or silent.
   * @param  {Number} x  The x-orientation of the source.
   * @param  {Number} y  The y-orientation of the source.
   * @param  {Number} z  The z-orientation of the source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
   */
  Howl.prototype.orientation = function(x, y, z, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'orientation',
        action: function() {
          self.orientation(x, y, z, id);
        }
      });

      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = (typeof y !== 'number') ? self._orientation[1] : y;
    z = (typeof z !== 'number') ? self._orientation[2] : z;

    // Setup the group's spatial orientation if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's spatial orientation if no parameters are passed.
      if (typeof x === 'number') {
        self._orientation = [x, y, z];
      } else {
        return self._orientation;
      }
    }

    // Change the spatial orientation of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);

      if (sound) {
        if (typeof x === 'number') {
          sound._orientation = [x, y, z];

          if (sound._node) {
            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner) {
              // Make sure we have a position to setup the node with.
              if (!sound._pos) {
                sound._pos = self._pos || [0, 0, -0.5];
              }

              setupPanner(sound, 'spatial');
            }

            sound._panner.setOrientation(x, y, z);
          }

          self._emit('orientation', sound._id);
        } else {
          return sound._orientation;
        }
      }
    }

    return self;
  };

  /**
   * Get/set the panner node's attributes for a sound or group of sounds.
   * This method can optionall take 0, 1 or 2 arguments.
   *   pannerAttr() -> Returns the group's values.
   *   pannerAttr(id) -> Returns the sound id's values.
   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
   *   pannerAttr(o, id) -> Set's the values of passed sound id.
   *
   *   Attributes:
   *     coneInnerAngle - (360 by default) There will be no volume reduction inside this angle.
   *     coneOuterAngle - (360 by default) The volume will be reduced to a constant value of
   *                      `coneOuterGain` outside this angle.
   *     coneOuterGain - (0 by default) The amount of volume reduction outside of `coneOuterAngle`.
   *     distanceModel - ('inverse' by default) Determines algorithm to use to reduce volume as audio moves
   *                      away from listener. Can be `linear`, `inverse` or `exponential`.
   *     maxDistance - (10000 by default) Volume won't reduce between source/listener beyond this distance.
   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
   *                     Can be `HRTF` or `equalpower`.
   *     refDistance - (1 by default) A reference distance for reducing volume as the source
   *                    moves away from the listener.
   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener.
   * 
   * @return {Howl/Object} Returns self or current panner attributes.
   */
  Howl.prototype.pannerAttr = function() {
    var self = this;
    var args = arguments;
    var o, id, sound;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // Determine the values based on arguments.
    if (args.length === 0) {
      // Return the group's panner attribute values.
      return self._pannerAttr;
    } else if (args.length === 1) {
      if (typeof args[0] === 'object') {
        o = args[0];

        // Set the grou's panner attribute values.
        if (typeof id === 'undefined') {
          self._pannerAttr = {
            coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : self._coneInnerAngle,
            coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : self._coneOuterAngle,
            coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : self._coneOuterGain,
            distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : self._distanceModel,
            maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : self._maxDistance,
            panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : self._panningModel,
            refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : self._refDistance,
            rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : self._rolloffFactor
          };
        }
      } else {
        // Return this sound's panner attribute values.
        sound = self._soundById(parseInt(args[0], 10));
        return sound ? sound._pannerAttr : self._pannerAttr;
      }
    } else if (args.length === 2) {
      o = args[0];
      id = parseInt(args[1], 10);
    }

    // Update the values of the specified sounds.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      sound = self._soundById(ids[i]);

      if (sound) {
        // Merge the new values into the sound.
        var pa = sound._pannerAttr;
        pa = {
          coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : pa.coneInnerAngle,
          coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : pa.coneOuterAngle,
          coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : pa.coneOuterGain,
          distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : pa.distanceModel,
          maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : pa.maxDistance,
          panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : pa.panningModel,
          refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : pa.refDistance,
          rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : pa.rolloffFactor
        };

        // Update the panner values or create a new panner if none exists.
        var panner = sound._panner;
        if (panner) {
          panner.coneInnerAngle = pa.coneInnerAngle;
          panner.coneOuterAngle = pa.coneOuterAngle;
          panner.coneOuterGain = pa.coneOuterGain;
          panner.distanceModel = pa.distanceModel;
          panner.maxDistance = pa.maxDistance;
          panner.panningModel = pa.panningModel;
          panner.refDistance = pa.refDistance;
          panner.rolloffFactor = pa.rolloffFactor;
        } else {
          // Make sure we have a position to setup the node with.
          if (!sound._pos) {
            sound._pos = self._pos || [0, 0, -0.5];
          }

          // Create a new panner node.
          setupPanner(sound, 'spatial');
        }
      }
    }

    return self;
  };

  /** Single Sound Methods **/
  /***************************************************************************/

  /**
   * Add new properties to the core Sound init.
   * @param  {Function} _super Core Sound init method.
   * @return {Sound}
   */
  Sound.prototype.init = (function(_super) {
    return function() {
      var self = this;
      var parent = self._parent;

      // Setup user-defined default properties.
      self._orientation = parent._orientation;
      self._stereo = parent._stereo;
      self._pos = parent._pos;
      self._pannerAttr = parent._pannerAttr;

      // Complete initilization with howler.js core Sound's init function.
      _super.call(this);

      // If a stereo or position was specified, set it up.
      if (self._stereo) {
        parent.stereo(self._stereo);
      } else if (self._pos) {
        parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
      }
    };
  })(Sound.prototype.init);

  /**
   * Override the Sound.reset method to clean up properties from the spatial plugin.
   * @param  {Function} _super Sound reset method.
   * @return {Sound}
   */
  Sound.prototype.reset = (function(_super) {
    return function() {
      var self = this;
      var parent = self._parent;

      // Reset all spatial plugin properties on this sound.
      self._orientation = parent._orientation;
      self._pos = parent._pos;
      self._pannerAttr = parent._pannerAttr;

      // Complete resetting of the sound.
      return _super.call(this);
    };
  })(Sound.prototype.reset);

  /** Helper Methods **/
  /***************************************************************************/

  /**
   * Create a new panner node and save it on the sound.
   * @param  {Sound} sound Specific sound to setup panning on.
   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
   */
  var setupPanner = function(sound, type) {
    type = type || 'spatial';

    // Create the new panner node.
    if (type === 'spatial') {
      sound._panner = Howler.ctx.createPanner();
      sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
      sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
      sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
      sound._panner.distanceModel = sound._pannerAttr.distanceModel;
      sound._panner.maxDistance = sound._pannerAttr.maxDistance;
      sound._panner.panningModel = sound._pannerAttr.panningModel;
      sound._panner.refDistance = sound._pannerAttr.refDistance;
      sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
      sound._panner.setPosition(sound._pos[0], sound._pos[1], sound._pos[2]);
      sound._panner.setOrientation(sound._orientation[0], sound._orientation[1], sound._orientation[2]);
    } else {
      sound._panner = Howler.ctx.createStereoPanner();
      sound._panner.pan.value = sound._stereo;
    }

    sound._panner.connect(sound._node);

    // Update the connections.
    if (!sound._paused) {
      sound._parent.pause(sound._id, true).play(sound._id);
    }
  };
})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 423 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(473),
    hashDelete = __webpack_require__(474),
    hashGet = __webpack_require__(475),
    hashHas = __webpack_require__(476),
    hashSet = __webpack_require__(477);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(19);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 429 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(439);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 431 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(455),
    isArguments = __webpack_require__(176),
    isArray = __webpack_require__(20),
    isBuffer = __webpack_require__(178),
    isIndex = __webpack_require__(95),
    isTypedArray = __webpack_require__(180);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 433 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(460),
    shuffleSelf = __webpack_require__(174);

/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function arrayShuffle(array) {
  return shuffleSelf(copyArray(array));
}

module.exports = arrayShuffle;


/***/ }),
/* 435 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 436 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(433),
    isArray = __webpack_require__(20);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 438 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(436),
    baseIsNaN = __webpack_require__(443),
    strictIndexOf = __webpack_require__(505);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(58),
    isObjectLike = __webpack_require__(60);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(164),
    equalArrays = __webpack_require__(170),
    equalByTag = __webpack_require__(464),
    equalObjects = __webpack_require__(465),
    getTag = __webpack_require__(470),
    isArray = __webpack_require__(20),
    isBuffer = __webpack_require__(178),
    isTypedArray = __webpack_require__(180);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(164),
    baseIsEqual = __webpack_require__(167);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 443 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(179),
    isMasked = __webpack_require__(480),
    isObject = __webpack_require__(59),
    toSource = __webpack_require__(175);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(58),
    isLength = __webpack_require__(99),
    isObjectLike = __webpack_require__(60);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(448),
    baseMatchesProperty = __webpack_require__(449),
    identity = __webpack_require__(509),
    isArray = __webpack_require__(20),
    property = __webpack_require__(512);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(481),
    nativeKeys = __webpack_require__(494);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(442),
    getMatchData = __webpack_require__(467),
    matchesStrictComparable = __webpack_require__(173);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(167),
    get = __webpack_require__(507),
    hasIn = __webpack_require__(508),
    isKey = __webpack_require__(96),
    isStrictComparable = __webpack_require__(172),
    matchesStrictComparable = __webpack_require__(173),
    toKey = __webpack_require__(74);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 450 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(166);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 452 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

module.exports = baseRandom;


/***/ }),
/* 453 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var shuffleSelf = __webpack_require__(174),
    values = __webpack_require__(519);

/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function baseShuffle(collection) {
  return shuffleSelf(values(collection));
}

module.exports = baseShuffle;


/***/ }),
/* 455 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(70),
    arrayMap = __webpack_require__(165),
    isArray = __webpack_require__(20),
    isSymbol = __webpack_require__(75);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 457 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(163),
    arrayIncludes = __webpack_require__(430),
    arrayIncludesWith = __webpack_require__(431),
    cacheHas = __webpack_require__(168),
    createSet = __webpack_require__(463),
    setToArray = __webpack_require__(97);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(165);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 460 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(19);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(453),
    isIterateeCall = __webpack_require__(478),
    toFinite = __webpack_require__(515);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(162),
    noop = __webpack_require__(511),
    setToArray = __webpack_require__(97);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(70),
    Uint8Array = __webpack_require__(427),
    eq = __webpack_require__(98),
    equalArrays = __webpack_require__(170),
    mapToArray = __webpack_require__(492),
    setToArray = __webpack_require__(97);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(466);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(437),
    getSymbols = __webpack_require__(469),
    keys = __webpack_require__(100);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(172),
    keys = __webpack_require__(100);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(70);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(429),
    stubArray = __webpack_require__(513);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(424),
    Map = __webpack_require__(93),
    Promise = __webpack_require__(426),
    Set = __webpack_require__(162),
    WeakMap = __webpack_require__(428),
    baseGetTag = __webpack_require__(58),
    toSource = __webpack_require__(175);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 471 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(169),
    isArguments = __webpack_require__(176),
    isArray = __webpack_require__(20),
    isIndex = __webpack_require__(95),
    isLength = __webpack_require__(99),
    toKey = __webpack_require__(74);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(73);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 474 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(73);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(73);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(73);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(98),
    isArrayLike = __webpack_require__(177),
    isIndex = __webpack_require__(95),
    isObject = __webpack_require__(59);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 479 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(461);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 481 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 482 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(71);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(71);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(71);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(71);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(425),
    ListCache = __webpack_require__(69),
    Map = __webpack_require__(93);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(72);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(72);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(72);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(72);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 492 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(510);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(497);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(171);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(82)(module)))

/***/ }),
/* 496 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 497 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 498 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 499 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(69);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 501 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 502 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 503 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(69),
    Map = __webpack_require__(93),
    MapCache = __webpack_require__(94);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 505 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(493);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(166);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(438),
    hasPath = __webpack_require__(472);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 509 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(94);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 511 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(450),
    basePropertyDeep = __webpack_require__(451),
    isKey = __webpack_require__(96),
    toKey = __webpack_require__(74);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 513 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 514 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(516);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(59),
    isSymbol = __webpack_require__(75);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(456);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(446),
    baseUniq = __webpack_require__(458);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(459),
    keys = __webpack_require__(100);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
//! version : 2.17.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    var k;
    for (k in obj) {
        // even if its not own property I'd still call it non-empty
        return false;
    }
    return true;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

var some$1 = some;

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

function isUndefined(input) {
    return input === void 0;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i in momentProperties) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _ordinalParseLenient.
    this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var keys$1 = keys;

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid()) {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

var indexOf$1 = indexOf;

function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return this._months;
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return this._monthsShort;
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function createDate (y, m, d, h, M, s, ms) {
    //can't just apply() to create a date:
    //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
    var date = new Date(y, m, d, h, M, s, ms);

    //the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    //the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

//http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return this._weekdays;
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    ordinalParse: defaultOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
            // because defineLocale currently also sets the global locale, we
            // want to undo that for lazy loaded locales
            getSetGlobalLocale(oldLocale);
        } catch (e) { }
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys$1(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
        hooks.createFromInputFallback(config);
    }
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse)) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }

    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (input === undefined) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (typeof(input) === 'object') {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    if (units === 'year' || units === 'month' || units === 'quarter') {
        output = monthDiff(this, that);
        if (units === 'quarter') {
            output = output / 3;
        } else if (units === 'year') {
            output = output / 12;
        }
    } else {
        delta = this - that;
        output = units === 'second' ? delta / 1e3 : // 1000
            units === 'minute' ? delta / 6e4 : // 1000 * 60
            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
            delta;
    }
    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString () {
    var m = this.clone().utc();
    if (0 < m.year() && m.year() <= 9999) {
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            return this.toDate().toISOString();
        } else {
            return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        }
    } else {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 < this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$1 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$1;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function get$2 (units) {
    units = normalizeUnits(units);
    return this[units + 's']();
}

function makeGetter(name) {
    return function () {
        return this._data[name];
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    s: 45,  // seconds to minute
    m: 45,  // minutes to hour
    h: 22,  // hours to day
    d: 26,  // days to month
    M: 11   // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds < thresholds.s && ['s', seconds]  ||
            minutes <= 1           && ['m']           ||
            minutes < thresholds.m && ['mm', minutes] ||
            hours   <= 1           && ['h']           ||
            hours   < thresholds.h && ['hh', hours]   ||
            days    <= 1           && ['d']           ||
            days    < thresholds.d && ['dd', days]    ||
            months  <= 1           && ['M']           ||
            months  < thresholds.M && ['MM', months]  ||
            years   <= 1           && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    return true;
}

function humanize (withSuffix) {
    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds;
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    return (total < 0 ? '-' : '') +
        'P' +
        (Y ? Y + 'Y' : '') +
        (M ? M + 'M' : '') +
        (D ? D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? h + 'H' : '') +
        (m ? m + 'M' : '') +
        (s ? s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.17.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(82)(module)))

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(182);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._81 = 1;
  p._65 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._81 === 3) {
            val = val._65;
          }
          if (val._81 === 1) return res(i, val._65);
          if (val._81 === 2) reject(val._65);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(182);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._10 = null;
  Promise._97 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._10 = function (promise) {
    if (
      promise._81 === 2 && // IS REJECTED
      rejections[promise._72]
    ) {
      if (rejections[promise._72].logged) {
        onHandled(promise._72);
      } else {
        clearTimeout(rejections[promise._72].timeout);
      }
      delete rejections[promise._72];
    }
  };
  Promise._97 = function (promise, err) {
    if (promise._45 === 0) { // not yet handled
      promise._72 = id++;
      rejections[promise._72] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._72),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(538);


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(7);

var focusNode = __webpack_require__(205);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(62);
var ExecutionEnvironment = __webpack_require__(12);
var FallbackCompositionState = __webpack_require__(533);
var SyntheticCompositionEvent = __webpack_require__(570);
var SyntheticInputEvent = __webpack_require__(573);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(183);
var ExecutionEnvironment = __webpack_require__(12);
var ReactInstrumentation = __webpack_require__(15);

var camelizeStyleName = __webpack_require__(590);
var dangerousStyleValue = __webpack_require__(579);
var hyphenateStyleName = __webpack_require__(597);
var memoizeStringOnly = __webpack_require__(600);
var warning = __webpack_require__(6);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {

  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var styleValue = styles[styleName];
      if (false) {
        warnValidStyle(styleName, styleValue, component);
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      if (false) {
        warnValidStyle(styleName, styles[styleName], component);
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }

};

module.exports = CSSPropertyOperations;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(61);
var EventPropagators = __webpack_require__(62);
var ExecutionEnvironment = __webpack_require__(12);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactUpdates = __webpack_require__(16);
var SyntheticEvent = __webpack_require__(21);

var getEventTarget = __webpack_require__(115);
var isEventSupported = __webpack_require__(116);
var isTextInputElement = __webpack_require__(200);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;
var activeElementValue = null;
var activeElementValueProp = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
  EventPropagators.accumulateTwoPhaseDispatches(event);

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}
function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.
  // IE10+ fire input events to often, such when a placeholder
  // changes or when an input with a placeholder is focused.
  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
}

/**
 * (For IE <=11) Replacement getter/setter for the `value` property that gets
 * set on the active element.
 */
var newValueProp = {
  get: function () {
    return activeElementValueProp.get.call(this);
  },
  set: function (val) {
    // Cast to a string so we can do equality checks.
    activeElementValue = '' + val;
    activeElementValueProp.set.call(this, val);
  }
};

/**
 * (For IE <=11) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElementValue = target.value;
  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');

  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
  // on DOM elements
  Object.defineProperty(activeElement, 'value', newValueProp);
  if (activeElement.attachEvent) {
    activeElement.attachEvent('onpropertychange', handlePropertyChange);
  } else {
    activeElement.addEventListener('propertychange', handlePropertyChange, false);
  }
}

/**
 * (For IE <=11) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }

  // delete restores the original property definition
  delete activeElement.value;

  if (activeElement.detachEvent) {
    activeElement.detachEvent('onpropertychange', handlePropertyChange);
  } else {
    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
  }

  activeElement = null;
  activeElementInst = null;
  activeElementValue = null;
  activeElementValueProp = null;
}

/**
 * (For IE <=11) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  var value = nativeEvent.srcElement.value;
  if (value === activeElementValue) {
    return;
  }
  activeElementValue = value;

  manualDispatchChangeEvent(nativeEvent);
}

/**
 * If a `change` event should be fired, returns the target's ID.
 */
function getTargetInstForInputEvent(topLevelType, targetInst) {
  if (topLevelType === 'topInput') {
    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
    // what we want so fall through here and trigger an abstract event
    return targetInst;
  }
}

function handleEventsForInputEventIE(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9-11, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventIE(topLevelType, targetInst) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    if (activeElement && activeElement.value !== activeElementValue) {
      activeElementValue = activeElement.value;
      return activeElementInst;
    }
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst) {
  if (topLevelType === 'topClick') {
    return targetInst;
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventIE;
        handleEventFunc = handleEventsForInputEventIE;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst);
      if (inst) {
        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
        event.type = 'change';
        EventPropagators.accumulateTwoPhaseDispatches(event);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }
  }

};

module.exports = ChangeEventPlugin;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var DOMLazyTree = __webpack_require__(42);
var ExecutionEnvironment = __webpack_require__(12);

var createNodesFromMarkup = __webpack_require__(593);
var emptyFunction = __webpack_require__(22);
var invariant = __webpack_require__(4);

var Danger = {

  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }

};

module.exports = Danger;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(62);
var ReactDOMComponentTree = __webpack_require__(7);
var SyntheticMouseEvent = __webpack_require__(77);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {

  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }

};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(9);

var PooledClass = __webpack_require__(35);

var getTextContentAccessor = __webpack_require__(198);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(43);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {}
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(44);

var instantiateReactComponent = __webpack_require__(199);
var KeyEscapeUtils = __webpack_require__(107);
var shouldUpdateReactComponent = __webpack_require__(117);
var traverseAllChildren = __webpack_require__(202);
var warning = __webpack_require__(6);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_BUILD_VERSION":"v1.0.000"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(213);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
  ) {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
  ) {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }

};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)))

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(103);
var ReactDOMIDOperations = __webpack_require__(543);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {

  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup

};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(9);

var React = __webpack_require__(45);
var ReactComponentEnvironment = __webpack_require__(109);
var ReactCurrentOwner = __webpack_require__(23);
var ReactErrorUtils = __webpack_require__(110);
var ReactInstanceMap = __webpack_require__(63);
var ReactInstrumentation = __webpack_require__(15);
var ReactNodeTypes = __webpack_require__(193);
var ReactReconciler = __webpack_require__(44);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(204);
var invariant = __webpack_require__(4);
var shallowEqual = __webpack_require__(119);
var shouldUpdateReactComponent = __webpack_require__(117);
var warning = __webpack_require__(6);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {

  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'childContext');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null

};

module.exports = ReactCompositeComponent;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(7);
var ReactDefaultInjection = __webpack_require__(551);
var ReactMount = __webpack_require__(192);
var ReactReconciler = __webpack_require__(44);
var ReactUpdates = __webpack_require__(16);
var ReactVersion = __webpack_require__(564);

var findDOMNode = __webpack_require__(580);
var getHostComponentFromComposite = __webpack_require__(197);
var renderSubtreeIntoContainer = __webpack_require__(588);
var warning = __webpack_require__(6);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {

    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(9);

var AutoFocusUtils = __webpack_require__(526);
var CSSPropertyOperations = __webpack_require__(528);
var DOMLazyTree = __webpack_require__(42);
var DOMNamespaces = __webpack_require__(104);
var DOMProperty = __webpack_require__(43);
var DOMPropertyOperations = __webpack_require__(185);
var EventPluginHub = __webpack_require__(61);
var EventPluginRegistry = __webpack_require__(105);
var ReactBrowserEventEmitter = __webpack_require__(76);
var ReactDOMComponentFlags = __webpack_require__(186);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactDOMInput = __webpack_require__(544);
var ReactDOMOption = __webpack_require__(545);
var ReactDOMSelect = __webpack_require__(187);
var ReactDOMTextarea = __webpack_require__(548);
var ReactInstrumentation = __webpack_require__(15);
var ReactMultiChild = __webpack_require__(557);
var ReactServerRenderingTransaction = __webpack_require__(562);

var emptyFunction = __webpack_require__(22);
var escapeTextContentForBrowser = __webpack_require__(79);
var invariant = __webpack_require__(4);
var isEventSupported = __webpack_require__(116);
var shallowEqual = __webpack_require__(119);
var validateDOMNesting = __webpack_require__(118);
var warning = __webpack_require__(6);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { 'string': true, 'number': true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':

      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  'area': true,
  'base': true,
  'br': true,
  'col': true,
  'embed': true,
  'hr': true,
  'img': true,
  'input': true,
  'keygen': true,
  'link': true,
  'meta': true,
  'param': true,
  'source': true,
  'track': true,
  'wbr': true
};

var newlineEatingTags = {
  'listing': true,
  'pre': true,
  'textarea': true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  'menuitem': true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {

  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }

};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(118);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(9);

var DOMLazyTree = __webpack_require__(42);
var ReactDOMComponentTree = __webpack_require__(7);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(103);
var ReactDOMComponentTree = __webpack_require__(7);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {

  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(9);

var DOMPropertyOperations = __webpack_require__(185);
var LinkedValueUtils = __webpack_require__(108);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactUpdates = __webpack_require__(16);

var invariant = __webpack_require__(4);
var warning = __webpack_require__(6);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };

    if (false) {
      inst._wrapperState.controlled = isControlled(props);
    }
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {

      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(9);

var React = __webpack_require__(45);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactDOMSelect = __webpack_require__(187);

var warning = __webpack_require__(6);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }

};

module.exports = ReactDOMOption;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(12);

var getNodeForCharacterOffset = __webpack_require__(585);
var getTextContentAccessor = __webpack_require__(198);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(9);

var DOMChildrenOperations = __webpack_require__(103);
var DOMLazyTree = __webpack_require__(42);
var ReactDOMComponentTree = __webpack_require__(7);

var escapeTextContentForBrowser = __webpack_require__(79);
var invariant = __webpack_require__(4);
var validateDOMNesting = __webpack_require__(118);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {

  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }

});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(9);

var LinkedValueUtils = __webpack_require__(108);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactUpdates = __webpack_require__(16);

var invariant = __webpack_require__(4);
var warning = __webpack_require__(6);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(4);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(9);

var ReactUpdates = __webpack_require__(16);
var Transaction = __webpack_require__(78);

var emptyFunction = __webpack_require__(22);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(525);
var BeforeInputEventPlugin = __webpack_require__(527);
var ChangeEventPlugin = __webpack_require__(529);
var DefaultEventPluginOrder = __webpack_require__(531);
var EnterLeaveEventPlugin = __webpack_require__(532);
var HTMLDOMPropertyConfig = __webpack_require__(534);
var ReactComponentBrowserEnvironment = __webpack_require__(536);
var ReactDOMComponent = __webpack_require__(539);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactDOMEmptyComponent = __webpack_require__(541);
var ReactDOMTreeTraversal = __webpack_require__(549);
var ReactDOMTextComponent = __webpack_require__(547);
var ReactDefaultBatchingStrategy = __webpack_require__(550);
var ReactEventListener = __webpack_require__(554);
var ReactInjection = __webpack_require__(555);
var ReactReconcileTransaction = __webpack_require__(560);
var SVGDOMPropertyConfig = __webpack_require__(565);
var SelectEventPlugin = __webpack_require__(566);
var SimpleEventPlugin = __webpack_require__(567);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(61);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {

  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(9);

var EventListener = __webpack_require__(203);
var ExecutionEnvironment = __webpack_require__(12);
var PooledClass = __webpack_require__(35);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactUpdates = __webpack_require__(16);

var getEventTarget = __webpack_require__(115);
var getUnboundedScrollPosition = __webpack_require__(595);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(43);
var EventPluginHub = __webpack_require__(61);
var EventPluginUtils = __webpack_require__(106);
var ReactComponentEnvironment = __webpack_require__(109);
var ReactEmptyComponent = __webpack_require__(188);
var ReactBrowserEventEmitter = __webpack_require__(76);
var ReactHostComponent = __webpack_require__(190);
var ReactUpdates = __webpack_require__(16);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(578);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactComponentEnvironment = __webpack_require__(109);
var ReactInstanceMap = __webpack_require__(63);
var ReactInstrumentation = __webpack_require__(15);

var ReactCurrentOwner = __webpack_require__(23);
var ReactReconciler = __webpack_require__(44);
var ReactChildReconciler = __webpack_require__(535);

var emptyFunction = __webpack_require__(22);
var flattenChildren = __webpack_require__(581);
var invariant = __webpack_require__(4);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {

  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {

    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }

  }

};

module.exports = ReactMultiChild;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(4);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }

};

module.exports = ReactOwner;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(9);

var CallbackQueue = __webpack_require__(184);
var PooledClass = __webpack_require__(35);
var ReactBrowserEventEmitter = __webpack_require__(76);
var ReactInputSelection = __webpack_require__(191);
var ReactInstrumentation = __webpack_require__(15);
var Transaction = __webpack_require__(78);
var ReactUpdateQueue = __webpack_require__(111);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(558);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(9);

var PooledClass = __webpack_require__(35);
var Transaction = __webpack_require__(78);
var ReactInstrumentation = __webpack_require__(15);
var ReactServerUpdateQueue = __webpack_require__(563);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(111);

var warning = __webpack_require__(6);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.4.2';

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(62);
var ExecutionEnvironment = __webpack_require__(12);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactInputSelection = __webpack_require__(191);
var SyntheticEvent = __webpack_require__(21);

var getActiveElement = __webpack_require__(206);
var isTextInputElement = __webpack_require__(200);
var shallowEqual = __webpack_require__(119);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;

      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);

      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var EventListener = __webpack_require__(203);
var EventPropagators = __webpack_require__(62);
var ReactDOMComponentTree = __webpack_require__(7);
var SyntheticAnimationEvent = __webpack_require__(568);
var SyntheticClipboardEvent = __webpack_require__(569);
var SyntheticEvent = __webpack_require__(21);
var SyntheticFocusEvent = __webpack_require__(572);
var SyntheticKeyboardEvent = __webpack_require__(574);
var SyntheticMouseEvent = __webpack_require__(77);
var SyntheticDragEvent = __webpack_require__(571);
var SyntheticTouchEvent = __webpack_require__(575);
var SyntheticTransitionEvent = __webpack_require__(576);
var SyntheticUIEvent = __webpack_require__(64);
var SyntheticWheelEvent = __webpack_require__(577);

var emptyFunction = __webpack_require__(22);
var getEventCharCode = __webpack_require__(113);
var invariant = __webpack_require__(4);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }

};

module.exports = SimpleEventPlugin;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(21);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(21);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(21);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(77);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(64);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(21);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(64);

var getEventCharCode = __webpack_require__(113);
var getEventKey = __webpack_require__(582);
var getEventModifierState = __webpack_require__(114);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(64);

var getEventModifierState = __webpack_require__(114);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(21);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(77);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX :
    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY :
    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY :
    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(183);
var warning = __webpack_require__(6);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactCurrentOwner = __webpack_require__(23);
var ReactDOMComponentTree = __webpack_require__(7);
var ReactInstanceMap = __webpack_require__(63);

var getHostComponentFromComposite = __webpack_require__(197);
var invariant = __webpack_require__(4);
var warning = __webpack_require__(6);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(107);
var traverseAllChildren = __webpack_require__(202);
var warning = __webpack_require__(6);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_BUILD_VERSION":"v1.0.000"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(213);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)))

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(113);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  'Esc': 'Escape',
  'Spacebar': ' ',
  'Left': 'ArrowLeft',
  'Up': 'ArrowUp',
  'Right': 'ArrowRight',
  'Down': 'ArrowDown',
  'Del': 'Delete',
  'Win': 'OS',
  'Menu': 'ContextMenu',
  'Apps': 'ContextMenu',
  'Scroll': 'ScrollLock',
  'MozPrintableKey': 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(12);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(79);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactMount = __webpack_require__(192);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var camelize = __webpack_require__(589);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var isTextNode = __webpack_require__(599);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var invariant = __webpack_require__(4);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(12);

var createArrayFromMixed = __webpack_require__(592);
var getMarkupWrap = __webpack_require__(594);
var invariant = __webpack_require__(4);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(12);

var invariant = __webpack_require__(4);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable === window) {
    return {
      x: window.pageXOffset || document.documentElement.scrollLeft,
      y: window.pageYOffset || document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(596);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var isNode = __webpack_require__(598);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Provider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Subscription__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_storeShape__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(120);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  Provider.prototype.getChildContext = function getChildContext() {
    return { store: this.store, storeSubscription: null };
  };

  function Provider(props, context) {
    _classCallCheck(this, Provider);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.store = props.store;
    return _this;
  }

  Provider.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
  };

  return Provider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);




if (false) {
  Provider.prototype.componentWillReceiveProps = function (nextProps) {
    var store = this.store;
    var nextStore = nextProps.store;


    if (store !== nextStore) {
      warnAboutReceivingStore();
    }
  };
}

Provider.propTypes = {
  store: __WEBPACK_IMPORTED_MODULE_2__utils_storeShape__["a" /* default */].isRequired,
  children: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].element.isRequired
};
Provider.childContextTypes = {
  store: __WEBPACK_IMPORTED_MODULE_2__utils_storeShape__["a" /* default */].isRequired,
  storeSubscription: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].instanceOf(__WEBPACK_IMPORTED_MODULE_1__utils_Subscription__["a" /* default */])
};
Provider.displayName = 'Provider';

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(606);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(208);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(208);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(211);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(607);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(120);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function shallowEqual(a, b) {
  if (a === b) return true;

  var countA = 0;
  var countB = 0;

  for (var key in a) {
    if (hasOwn.call(a, key) && a[key] !== b[key]) return false;
    countA++;
  }

  for (var _key in b) {
    if (hasOwn.call(b, _key)) countB++;
  }

  return countA === countB;
}

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(615);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30)))

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(616);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(212);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(612);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(618);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(47);

var invariant = __webpack_require__(48);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(621);
var ReactElement = __webpack_require__(46);

var emptyFunction = __webpack_require__(123);
var traverseAllChildren = __webpack_require__(630);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(47),
    _assign = __webpack_require__(81);

var ReactComponent = __webpack_require__(121);
var ReactElement = __webpack_require__(46);
var ReactPropTypeLocationNames = __webpack_require__(215);
var ReactNoopUpdateQueue = __webpack_require__(122);

var emptyObject = __webpack_require__(124);
var invariant = __webpack_require__(48);
var warning = __webpack_require__(29);

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

/**
 * Policies that describe methods in `ReactClassInterface`.
 */


var injectedMixins = [];

/**
 * Composite components are higher-level components that compose other composite
 * or host components.
 *
 * To create a new type of `ReactClass`, pass a specification of
 * your new class to `React.createClass`. The only requirement of your class
 * specification is that you implement a `render` method.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return <div>Hello World</div>;
 *     }
 *   });
 *
 * The class specification supports a specific protocol of methods that have
 * special meaning (e.g. `render`). See `ReactClassInterface` for
 * more the comprehensive protocol. Any other properties and methods in the
 * class specification will be available on the prototype.
 *
 * @interface ReactClassInterface
 * @internal
 */
var ReactClassInterface = {

  /**
   * An array of Mixin objects to include when defining your component.
   *
   * @type {array}
   * @optional
   */
  mixins: 'DEFINE_MANY',

  /**
   * An object containing properties and methods that should be defined on
   * the component's constructor instead of its prototype (static methods).
   *
   * @type {object}
   * @optional
   */
  statics: 'DEFINE_MANY',

  /**
   * Definition of prop types for this component.
   *
   * @type {object}
   * @optional
   */
  propTypes: 'DEFINE_MANY',

  /**
   * Definition of context types for this component.
   *
   * @type {object}
   * @optional
   */
  contextTypes: 'DEFINE_MANY',

  /**
   * Definition of context types this component sets for its children.
   *
   * @type {object}
   * @optional
   */
  childContextTypes: 'DEFINE_MANY',

  // ==== Definition methods ====

  /**
   * Invoked when the component is mounted. Values in the mapping will be set on
   * `this.props` if that prop is not specified (i.e. using an `in` check).
   *
   * This method is invoked before `getInitialState` and therefore cannot rely
   * on `this.state` or use `this.setState`.
   *
   * @return {object}
   * @optional
   */
  getDefaultProps: 'DEFINE_MANY_MERGED',

  /**
   * Invoked once before the component is mounted. The return value will be used
   * as the initial value of `this.state`.
   *
   *   getInitialState: function() {
   *     return {
   *       isOn: false,
   *       fooBaz: new BazFoo()
   *     }
   *   }
   *
   * @return {object}
   * @optional
   */
  getInitialState: 'DEFINE_MANY_MERGED',

  /**
   * @return {object}
   * @optional
   */
  getChildContext: 'DEFINE_MANY_MERGED',

  /**
   * Uses props from `this.props` and state from `this.state` to render the
   * structure of the component.
   *
   * No guarantees are made about when or how often this method is invoked, so
   * it must not have side effects.
   *
   *   render: function() {
   *     var name = this.props.name;
   *     return <div>Hello, {name}!</div>;
   *   }
   *
   * @return {ReactComponent}
   * @nosideeffects
   * @required
   */
  render: 'DEFINE_ONCE',

  // ==== Delegate methods ====

  /**
   * Invoked when the component is initially created and about to be mounted.
   * This may have side effects, but any external subscriptions or data created
   * by this method must be cleaned up in `componentWillUnmount`.
   *
   * @optional
   */
  componentWillMount: 'DEFINE_MANY',

  /**
   * Invoked when the component has been mounted and has a DOM representation.
   * However, there is no guarantee that the DOM node is in the document.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been mounted (initialized and rendered) for the first time.
   *
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidMount: 'DEFINE_MANY',

  /**
   * Invoked before the component receives new props.
   *
   * Use this as an opportunity to react to a prop transition by updating the
   * state using `this.setState`. Current props are accessed via `this.props`.
   *
   *   componentWillReceiveProps: function(nextProps, nextContext) {
   *     this.setState({
   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
   *     });
   *   }
   *
   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
   * transition may cause a state change, but the opposite is not true. If you
   * need it, you are probably looking for `componentWillUpdate`.
   *
   * @param {object} nextProps
   * @optional
   */
  componentWillReceiveProps: 'DEFINE_MANY',

  /**
   * Invoked while deciding if the component should be updated as a result of
   * receiving new props, state and/or context.
   *
   * Use this as an opportunity to `return false` when you're certain that the
   * transition to the new props/state/context will not require a component
   * update.
   *
   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
   *     return !equal(nextProps, this.props) ||
   *       !equal(nextState, this.state) ||
   *       !equal(nextContext, this.context);
   *   }
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @return {boolean} True if the component should update.
   * @optional
   */
  shouldComponentUpdate: 'DEFINE_ONCE',

  /**
   * Invoked when the component is about to update due to a transition from
   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
   * and `nextContext`.
   *
   * Use this as an opportunity to perform preparation before an update occurs.
   *
   * NOTE: You **cannot** use `this.setState()` in this method.
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @param {ReactReconcileTransaction} transaction
   * @optional
   */
  componentWillUpdate: 'DEFINE_MANY',

  /**
   * Invoked when the component's DOM representation has been updated.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been updated.
   *
   * @param {object} prevProps
   * @param {?object} prevState
   * @param {?object} prevContext
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidUpdate: 'DEFINE_MANY',

  /**
   * Invoked when the component is about to be removed from its parent and have
   * its DOM representation destroyed.
   *
   * Use this as an opportunity to deallocate any external resources.
   *
   * NOTE: There is no `componentDidUnmount` since your component will have been
   * destroyed by that point.
   *
   * @optional
   */
  componentWillUnmount: 'DEFINE_MANY',

  // ==== Advanced methods ====

  /**
   * Updates the component's currently mounted DOM representation.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   * @overridable
   */
  updateComponent: 'OVERRIDE_BASE'

};

/**
 * Mapping from class specification keys to special processing functions.
 *
 * Although these are declared like instance properties in the specification
 * when defining classes using `React.createClass`, they are actually static
 * and are accessible on the constructor instead of the prototype. Despite
 * being static, they must be defined outside of the "statics" key under
 * which all other static methods are defined.
 */
var RESERVED_SPEC_KEYS = {
  displayName: function (Constructor, displayName) {
    Constructor.displayName = displayName;
  },
  mixins: function (Constructor, mixins) {
    if (mixins) {
      for (var i = 0; i < mixins.length; i++) {
        mixSpecIntoComponent(Constructor, mixins[i]);
      }
    }
  },
  childContextTypes: function (Constructor, childContextTypes) {
    if (false) {
      validateTypeDef(Constructor, childContextTypes, 'childContext');
    }
    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
  },
  contextTypes: function (Constructor, contextTypes) {
    if (false) {
      validateTypeDef(Constructor, contextTypes, 'context');
    }
    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
  },
  /**
   * Special case getDefaultProps which should move into statics but requires
   * automatic merging.
   */
  getDefaultProps: function (Constructor, getDefaultProps) {
    if (Constructor.getDefaultProps) {
      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
    } else {
      Constructor.getDefaultProps = getDefaultProps;
    }
  },
  propTypes: function (Constructor, propTypes) {
    if (false) {
      validateTypeDef(Constructor, propTypes, 'prop');
    }
    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
  },
  statics: function (Constructor, statics) {
    mixStaticSpecIntoComponent(Constructor, statics);
  },
  autobind: function () {} };

function validateTypeDef(Constructor, typeDef, location) {
  for (var propName in typeDef) {
    if (typeDef.hasOwnProperty(propName)) {
      // use a warning instead of an invariant so components
      // don't show up in prod but only in __DEV__
       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
    }
  }
}

function validateMethodOverride(isAlreadyDefined, name) {
  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

  // Disallow overriding of base class methods unless explicitly allowed.
  if (ReactClassMixin.hasOwnProperty(name)) {
    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
  }

  // Disallow defining methods more than once unless explicitly allowed.
  if (isAlreadyDefined) {
    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
  }
}

/**
 * Mixin helper which handles policy validation and reserved
 * specification keys when building React classes.
 */
function mixSpecIntoComponent(Constructor, spec) {
  if (!spec) {
    if (false) {
      var typeofSpec = typeof spec;
      var isMixinValid = typeofSpec === 'object' && spec !== null;

      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
    }

    return;
  }

  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;

  var proto = Constructor.prototype;
  var autoBindPairs = proto.__reactAutoBindPairs;

  // By handling mixins before any other properties, we ensure the same
  // chaining order is applied to methods with DEFINE_MANY policy, whether
  // mixins are listed before or after these methods in the spec.
  if (spec.hasOwnProperty(MIXINS_KEY)) {
    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
  }

  for (var name in spec) {
    if (!spec.hasOwnProperty(name)) {
      continue;
    }

    if (name === MIXINS_KEY) {
      // We have already handled mixins in a special case above.
      continue;
    }

    var property = spec[name];
    var isAlreadyDefined = proto.hasOwnProperty(name);
    validateMethodOverride(isAlreadyDefined, name);

    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
      RESERVED_SPEC_KEYS[name](Constructor, property);
    } else {
      // Setup methods on prototype:
      // The following member methods should not be automatically bound:
      // 1. Expected ReactClass methods (in the "interface").
      // 2. Overridden methods (that were mixed in).
      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
      var isFunction = typeof property === 'function';
      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

      if (shouldAutoBind) {
        autoBindPairs.push(name, property);
        proto[name] = property;
      } else {
        if (isAlreadyDefined) {
          var specPolicy = ReactClassInterface[name];

          // These cases should already be caught by validateMethodOverride.
          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;

          // For methods which are defined more than once, call the existing
          // methods before calling the new property, merging if appropriate.
          if (specPolicy === 'DEFINE_MANY_MERGED') {
            proto[name] = createMergedResultFunction(proto[name], property);
          } else if (specPolicy === 'DEFINE_MANY') {
            proto[name] = createChainedFunction(proto[name], property);
          }
        } else {
          proto[name] = property;
          if (false) {
            // Add verbose displayName to the function, which helps when looking
            // at profiling tools.
            if (typeof property === 'function' && spec.displayName) {
              proto[name].displayName = spec.displayName + '_' + name;
            }
          }
        }
      }
    }
  }
}

function mixStaticSpecIntoComponent(Constructor, statics) {
  if (!statics) {
    return;
  }
  for (var name in statics) {
    var property = statics[name];
    if (!statics.hasOwnProperty(name)) {
      continue;
    }

    var isReserved = name in RESERVED_SPEC_KEYS;
    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;

    var isInherited = name in Constructor;
    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
    Constructor[name] = property;
  }
}

/**
 * Merge two objects, but throw if both contain the same key.
 *
 * @param {object} one The first object, which is mutated.
 * @param {object} two The second object
 * @return {object} one after it has been mutated to contain everything in two.
 */
function mergeIntoWithNoDuplicateKeys(one, two) {
  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;

  for (var key in two) {
    if (two.hasOwnProperty(key)) {
      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
      one[key] = two[key];
    }
  }
  return one;
}

/**
 * Creates a function that invokes two functions and merges their return values.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createMergedResultFunction(one, two) {
  return function mergedResult() {
    var a = one.apply(this, arguments);
    var b = two.apply(this, arguments);
    if (a == null) {
      return b;
    } else if (b == null) {
      return a;
    }
    var c = {};
    mergeIntoWithNoDuplicateKeys(c, a);
    mergeIntoWithNoDuplicateKeys(c, b);
    return c;
  };
}

/**
 * Creates a function that invokes two functions and ignores their return vales.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createChainedFunction(one, two) {
  return function chainedFunction() {
    one.apply(this, arguments);
    two.apply(this, arguments);
  };
}

/**
 * Binds a method to the component.
 *
 * @param {object} component Component whose method is going to be bound.
 * @param {function} method Method to be bound.
 * @return {function} The bound method.
 */
function bindAutoBindMethod(component, method) {
  var boundMethod = method.bind(component);
  if (false) {
    boundMethod.__reactBoundContext = component;
    boundMethod.__reactBoundMethod = method;
    boundMethod.__reactBoundArguments = null;
    var componentName = component.constructor.displayName;
    var _bind = boundMethod.bind;
    boundMethod.bind = function (newThis) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      // User is trying to bind() an autobound method; we effectively will
      // ignore the value of "this" that the user is trying to use, so
      // let's warn.
      if (newThis !== component && newThis !== null) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
      } else if (!args.length) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
        return boundMethod;
      }
      var reboundMethod = _bind.apply(boundMethod, arguments);
      reboundMethod.__reactBoundContext = component;
      reboundMethod.__reactBoundMethod = method;
      reboundMethod.__reactBoundArguments = args;
      return reboundMethod;
    };
  }
  return boundMethod;
}

/**
 * Binds all auto-bound methods in a component.
 *
 * @param {object} component Component whose method is going to be bound.
 */
function bindAutoBindMethods(component) {
  var pairs = component.__reactAutoBindPairs;
  for (var i = 0; i < pairs.length; i += 2) {
    var autoBindKey = pairs[i];
    var method = pairs[i + 1];
    component[autoBindKey] = bindAutoBindMethod(component, method);
  }
}

/**
 * Add more to the ReactClass base class. These are all legacy features and
 * therefore not already part of the modern ReactComponent.
 */
var ReactClassMixin = {

  /**
   * TODO: This will be deprecated because state should always keep a consistent
   * type signature and the only use case for this, is to avoid that.
   */
  replaceState: function (newState, callback) {
    this.updater.enqueueReplaceState(this, newState);
    if (callback) {
      this.updater.enqueueCallback(this, callback, 'replaceState');
    }
  },

  /**
   * Checks whether or not this composite component is mounted.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function () {
    return this.updater.isMounted(this);
  }
};

var ReactClassComponent = function () {};
_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

/**
 * Module for creating composite components.
 *
 * @class ReactClass
 */
var ReactClass = {

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  createClass: function (spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function (props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (initialState === undefined && this.getInitialState._isMockFunction) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, spec);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  },

  injection: {
    injectMixin: function (mixin) {
      injectedMixins.push(mixin);
    }
  }

};

module.exports = ReactClass;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(46);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 * This is also accessible via `React.DOM`.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(46);
var ReactPropTypeLocationNames = __webpack_require__(215);
var ReactPropTypesSecret = __webpack_require__(626);

var emptyFunction = __webpack_require__(123);
var getIteratorFn = __webpack_require__(217);
var warning = __webpack_require__(29);

/**
 * Collection of methods that allow declaration and validation of props that are
 * supplied to React components. Example usage:
 *
 *   var Props = require('ReactPropTypes');
 *   var MyArticle = React.createClass({
 *     propTypes: {
 *       // An optional string prop named "description".
 *       description: Props.string,
 *
 *       // A required enum prop named "category".
 *       category: Props.oneOf(['News','Photos']).isRequired,
 *
 *       // A prop named "dialog" that requires an instance of Dialog.
 *       dialog: Props.instanceOf(Dialog).isRequired
 *     },
 *     render: function() { ... }
 *   });
 *
 * A more formal specification of how these methods are used:
 *
 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
 *   decl := ReactPropTypes.{type}(.isRequired)?
 *
 * Each and every declaration produces a function with the same signature. This
 * allows the creation of custom validation functions. For example:
 *
 *  var MyLink = React.createClass({
 *    propTypes: {
 *      // An optional string or URI prop named "href".
 *      href: function(props, propName, componentName) {
 *        var propValue = props[propName];
 *        if (propValue != null && typeof propValue !== 'string' &&
 *            !(propValue instanceof URI)) {
 *          return new Error(
 *            'Expected a string or an URI for ' + propName + ' in ' +
 *            componentName
 *          );
 *        }
 *      }
 *    },
 *    render: function() {...}
 *  });
 *
 * @internal
 */

var ANONYMOUS = '<<anonymous>>';

var ReactPropTypes = {
  array: createPrimitiveTypeChecker('array'),
  bool: createPrimitiveTypeChecker('boolean'),
  func: createPrimitiveTypeChecker('function'),
  number: createPrimitiveTypeChecker('number'),
  object: createPrimitiveTypeChecker('object'),
  string: createPrimitiveTypeChecker('string'),
  symbol: createPrimitiveTypeChecker('symbol'),

  any: createAnyTypeChecker(),
  arrayOf: createArrayOfTypeChecker,
  element: createElementTypeChecker(),
  instanceOf: createInstanceTypeChecker,
  node: createNodeChecker(),
  objectOf: createObjectOfTypeChecker,
  oneOf: createEnumTypeChecker,
  oneOfType: createUnionTypeChecker,
  shape: createShapeTypeChecker
};

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
/*eslint-disable no-self-compare*/
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return x !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}
/*eslint-enable no-self-compare*/

/**
 * We use an Error-like object for backward compatibility as people may call
 * PropTypes directly and inspect their output. However we don't use real
 * Errors anymore. We don't inspect their stack anyway, and creating them
 * is prohibitively expensive if they are created too often, such as what
 * happens in oneOfType() for any type before the one that matched.
 */
function PropTypeError(message) {
  this.message = message;
  this.stack = '';
}
// Make `instanceof Error` still work for returned errors.
PropTypeError.prototype = Error.prototype;

function createChainableTypeChecker(validate) {
  if (false) {
    var manualPropTypeCallCache = {};
  }
  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
    componentName = componentName || ANONYMOUS;
    propFullName = propFullName || propName;
    if (false) {
      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
        var cacheKey = componentName + ':' + propName;
        if (!manualPropTypeCallCache[cacheKey]) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
          manualPropTypeCallCache[cacheKey] = true;
        }
      }
    }
    if (props[propName] == null) {
      var locationName = ReactPropTypeLocationNames[location];
      if (isRequired) {
        if (props[propName] === null) {
          return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
        }
        return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
      }
      return null;
    } else {
      return validate(props, propName, componentName, location, propFullName);
    }
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

function createPrimitiveTypeChecker(expectedType) {
  function validate(props, propName, componentName, location, propFullName, secret) {
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== expectedType) {
      var locationName = ReactPropTypeLocationNames[location];
      // `propValue` being instance of, say, date/regexp, pass the 'object'
      // check, but we can offer a more precise error message here rather than
      // 'of type `object`'.
      var preciseType = getPreciseType(propValue);

      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createAnyTypeChecker() {
  return createChainableTypeChecker(emptyFunction.thatReturns(null));
}

function createArrayOfTypeChecker(typeChecker) {
  function validate(props, propName, componentName, location, propFullName) {
    if (typeof typeChecker !== 'function') {
      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
    }
    var propValue = props[propName];
    if (!Array.isArray(propValue)) {
      var locationName = ReactPropTypeLocationNames[location];
      var propType = getPropType(propValue);
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
    }
    for (var i = 0; i < propValue.length; i++) {
      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
      if (error instanceof Error) {
        return error;
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createElementTypeChecker() {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    if (!ReactElement.isValidElement(propValue)) {
      var locationName = ReactPropTypeLocationNames[location];
      var propType = getPropType(propValue);
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createInstanceTypeChecker(expectedClass) {
  function validate(props, propName, componentName, location, propFullName) {
    if (!(props[propName] instanceof expectedClass)) {
      var locationName = ReactPropTypeLocationNames[location];
      var expectedClassName = expectedClass.name || ANONYMOUS;
      var actualClassName = getClassName(props[propName]);
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createEnumTypeChecker(expectedValues) {
  if (!Array.isArray(expectedValues)) {
     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
    return emptyFunction.thatReturnsNull;
  }

  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    for (var i = 0; i < expectedValues.length; i++) {
      if (is(propValue, expectedValues[i])) {
        return null;
      }
    }

    var locationName = ReactPropTypeLocationNames[location];
    var valuesString = JSON.stringify(expectedValues);
    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
  }
  return createChainableTypeChecker(validate);
}

function createObjectOfTypeChecker(typeChecker) {
  function validate(props, propName, componentName, location, propFullName) {
    if (typeof typeChecker !== 'function') {
      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
    }
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== 'object') {
      var locationName = ReactPropTypeLocationNames[location];
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
    }
    for (var key in propValue) {
      if (propValue.hasOwnProperty(key)) {
        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createUnionTypeChecker(arrayOfTypeCheckers) {
  if (!Array.isArray(arrayOfTypeCheckers)) {
     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
    return emptyFunction.thatReturnsNull;
  }

  function validate(props, propName, componentName, location, propFullName) {
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
        return null;
      }
    }

    var locationName = ReactPropTypeLocationNames[location];
    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
  }
  return createChainableTypeChecker(validate);
}

function createNodeChecker() {
  function validate(props, propName, componentName, location, propFullName) {
    if (!isNode(props[propName])) {
      var locationName = ReactPropTypeLocationNames[location];
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createShapeTypeChecker(shapeTypes) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== 'object') {
      var locationName = ReactPropTypeLocationNames[location];
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
    }
    for (var key in shapeTypes) {
      var checker = shapeTypes[key];
      if (!checker) {
        continue;
      }
      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
      if (error) {
        return error;
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function isNode(propValue) {
  switch (typeof propValue) {
    case 'number':
    case 'string':
    case 'undefined':
      return true;
    case 'boolean':
      return !propValue;
    case 'object':
      if (Array.isArray(propValue)) {
        return propValue.every(isNode);
      }
      if (propValue === null || ReactElement.isValidElement(propValue)) {
        return true;
      }

      var iteratorFn = getIteratorFn(propValue);
      if (iteratorFn) {
        var iterator = iteratorFn.call(propValue);
        var step;
        if (iteratorFn !== propValue.entries) {
          while (!(step = iterator.next()).done) {
            if (!isNode(step.value)) {
              return false;
            }
          }
        } else {
          // Iterator will provide entry [k,v] tuples rather than values.
          while (!(step = iterator.next()).done) {
            var entry = step.value;
            if (entry) {
              if (!isNode(entry[1])) {
                return false;
              }
            }
          }
        }
      } else {
        return false;
      }

      return true;
    default:
      return false;
  }
}

function isSymbol(propType, propValue) {
  // Native Symbol.
  if (propType === 'symbol') {
    return true;
  }

  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
  if (propValue['@@toStringTag'] === 'Symbol') {
    return true;
  }

  // Fallback for non-spec compliant Symbols which are polyfilled.
  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
    return true;
  }

  return false;
}

// Equivalent of `typeof` but with special handling for array and regexp.
function getPropType(propValue) {
  var propType = typeof propValue;
  if (Array.isArray(propValue)) {
    return 'array';
  }
  if (propValue instanceof RegExp) {
    // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return 'object';
  }
  if (isSymbol(propType, propValue)) {
    return 'symbol';
  }
  return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// See `createPrimitiveTypeChecker`.
function getPreciseType(propValue) {
  var propType = getPropType(propValue);
  if (propType === 'object') {
    if (propValue instanceof Date) {
      return 'date';
    } else if (propValue instanceof RegExp) {
      return 'regexp';
    }
  }
  return propType;
}

// Returns class name of the object, if any.
function getClassName(propValue) {
  if (!propValue.constructor || !propValue.constructor.name) {
    return ANONYMOUS;
  }
  return propValue.constructor.name;
}

module.exports = ReactPropTypes;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(81);

var ReactComponent = __webpack_require__(121);
var ReactNoopUpdateQueue = __webpack_require__(122);

var emptyObject = __webpack_require__(124);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = ReactPureComponent;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.4.2';

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(47);

var ReactElement = __webpack_require__(46);

var invariant = __webpack_require__(48);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(47);

var ReactCurrentOwner = __webpack_require__(23);
var REACT_ELEMENT_TYPE = __webpack_require__(214);

var getIteratorFn = __webpack_require__(217);
var invariant = __webpack_require__(48);
var KeyEscapeUtils = __webpack_require__(620);
var warning = __webpack_require__(29);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(218);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(221);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerSanity(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  if (false) {
    var unexpectedKeyCache = {};
  }

  var sanityError;
  try {
    assertReducerSanity(finalReducers);
  } catch (e) {
    sanityError = e;
  }

  return function combination() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    var action = arguments[1];

    if (sanityError) {
      throw sanityError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var i = 0; i < finalReducerKeys.length; i++) {
      var key = finalReducerKeys[i];
      var reducer = finalReducers[key];
      var previousStateForKey = state[key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(key, action);
        throw new Error(errorMessage);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(638);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30)))

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(639);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(222);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(635);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(643);


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(644);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30), __webpack_require__(82)(module)))

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(646);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 647 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(225);
module.exports = __webpack_require__(224);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.07a810f5.js